export interface Person {
  firstName: string;
  lastName: string;
  title: string;
  slug: string;
  dei: boolean;
  category: string;
}

export const people: Person[] = [
  {
    firstName: "Inger",
    lastName: "Aaberg",
    title: "Energy Transition Coordinator",
    slug: "inger-aaberg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lyn",
    lastName: "Abbass",
    title: "Sr Program and Member Specialist",
    slug: "lyn-abbass",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peter Amin",
    lastName: "Abbass",
    title: "Director of Physical Therapy",
    slug: "peter-amin-abbass",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nancy J.",
    lastName: "Abbott",
    title: "Business Service Center Director",
    slug: "nancy-j-abbott",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sherifa R.",
    lastName: "Abdalla",
    title: "Finance Specialist II",
    slug: "sherifa-r-abdalla",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Latishia LaTonya",
    lastName: "Abdellatif",
    title: "Financial Aid Services Assistant IV",
    slug: "latishia-latonya-abdellatif",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dora",
    lastName: "Abdullah",
    title: "Info Tech Area Mgr II",
    slug: "dora-abdullah",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ben",
    lastName: "Abel",
    title: "Southeast Asian Serials Assistant",
    slug: "ben-abel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brittany L.",
    lastName: "Abele",
    title: "Compliance and Risk Specialist",
    slug: "brittany-l-abele",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Elicia F.",
    lastName: "Abella",
    title: "Manager of Visual Merchandising & Customer Engagement",
    slug: "elicia-f-abella",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Annie Allyson",
    lastName: "Abernathy",
    title: "Curatorial Assistant",
    slug: "annie-allyson-abernathy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Armen",
    lastName: "Abrahamian",
    title: "Admissions Counselor",
    slug: "armen-abrahamian",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Joel",
    lastName: "Abramovitz",
    title: "Associate Director of Lifelong Learning",
    slug: "joel-abramovitz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Heridania",
    lastName: "Abreu",
    title: "Administrative Assistant",
    slug: "heridania-abreu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "McKayla",
    lastName: "Accettulla",
    title:
      " Program Associate, Alumni and Volunteer Engagement Data and Metrics",
    slug: "mckayla-accettulla",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Arlyn John",
    lastName: "Ackerman",
    title: "Plant Breeding Coordinator, Breeding Insight",
    slug: "arlyn-john-ackerman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexandra A.",
    lastName: "Ackert-Smith",
    title: "Major Gift Associate, Bowers CIS",
    slug: "alexandra-a-ackert-smith",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mesa",
    lastName: "Ackley-Munson",
    title: "Research Administration Coordinator",
    slug: "mesa-ackley-munson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Emily Elizabeth",
    lastName: "Acomb",
    title: "Milk Plant Worker S07",
    slug: "emily-elizabeth-acomb",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathryn Elena",
    lastName: "Acosta",
    title: "Enrollment Counselor I",
    slug: "kathryn-elena-acosta",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Megan",
    lastName: "Adams",
    title: "Academic Affairs Administrative Assistant, SDS Chair's Assistant",
    slug: "megan-adams",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dana A.",
    lastName: "Adams",
    title: "Milk Plant Worker S07",
    slug: "dana-a-adams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bert",
    lastName: "Adams-Kucik",
    title: "Director, Cornell Fitness",
    slug: "bert-adams-kucik",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "George W",
    lastName: "Adanuty",
    title: "ILR NYC Outreach Communications Specialist",
    slug: "george-w-adanuty",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mary Elizabeth",
    lastName: "Addison",
    title: "Career Services Asst.",
    slug: "mary-elizabeth-addison",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kate",
    lastName: "Addonizio",
    title: "Data & Reporting Project Manager",
    slug: "kate-addonizio",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jackie M.",
    lastName: "Adelewitz",
    title: "Administrative Asst IV",
    slug: "jackie-m-adelewitz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lammi Mohammed",
    lastName: "Adem",
    title: "Advising Dean/Posse Program Manager",
    slug: "lammi-mohammed-adem",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Edward von",
    lastName: "Aderkas",
    title: "Communication and Mobility Access Coordinator",
    slug: "edward-von-aderkas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ana",
    lastName: "Adinolfi",
    title: "Division of Nutritional Sciences-Director of Student Services",
    slug: "ana-adinolfi",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Anthony M.",
    lastName: "Adinolfi",
    title: "Lead Web Designer",
    slug: "anthony-m-adinolfi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Caitlin M.",
    lastName: "Adriance",
    title: "Enrollment Director",
    slug: "caitlin-m-adriance",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Mo",
    lastName: "Afify",
    title: "Sr Director of CCF and FCS/Central UFD",
    slug: "mo-afify",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maheya J",
    lastName: "Afnan",
    title: "Worker Institute Administrative Manager",
    slug: "maheya-j-afnan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christy",
    lastName: "Agnese",
    title:
      " Director, CALS Alumni Affairs & Development and  Director of Development, Cornell Botanic Gardens",
    slug: "christy-agnese",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Francisco J.",
    lastName: "Agosto-Perez",
    title: "Applications Developer III",
    slug: "francisco-j-agosto-perez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Josue",
    lastName: "Aguiluz",
    title: "Enrollment and Admissions Coordinator",
    slug: "josue-aguiluz",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Andrew",
    lastName: "Ahart",
    title: "Mech Maint S11",
    slug: "andrew-ahart",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bredt",
    lastName: "Aiken",
    title: "Mgr Projects I",
    slug: "bredt-aiken",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Paula S.",
    lastName: "Aiken",
    title: "Lead Program Assistant",
    slug: "paula-s-aiken",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Akinfolami Olumide",
    lastName: "Akin-Alamu",
    title: "Web Developer",
    slug: "akinfolami-olumide-akin-alamu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Candace J.",
    lastName: "Akins",
    title: "Managing Editor",
    slug: "candace-j-akins",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Akua",
    lastName: "Akyea",
    title: "Associate Dean for Career Development",
    slug: "akua-akyea",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Orania Hamed",
    lastName: "Al-Bulushi",
    title: "IDP Facilitator",
    slug: "orania-hamed-al-bulushi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aala",
    lastName: "Al-Hashimi",
    title: "Assistant Finance Specialist",
    slug: "aala-al-hashimi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ayesha",
    lastName: "Al-Hashimi",
    title: "Graduate Field Coordinator-SIPS",
    slug: "ayesha-al-hashimi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joanna",
    lastName: "Alario",
    title: "Graduate Field Representative",
    slug: "joanna-alario",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sarah A.",
    lastName: "Albrecht",
    title: "Department Manager",
    slug: "sarah-a-albrecht",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole J.",
    lastName: "Albright",
    title: "Administrative Asst IV",
    slug: "nicole-j-albright",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karelin",
    lastName: "Alburquerque",
    title: "Administrative Assistant",
    slug: "karelin-alburquerque",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Alcaine",
    title: "Associate Director of Graduate Student Services",
    slug: "jennifer-alcaine",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Danielle de",
    lastName: "Alcala",
    title: "Enrollment Counselor II",
    slug: "danielle-de-alcala",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Brad",
    lastName: "Alderman",
    title: "Web Manager",
    slug: "brad-alderman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Thomas F.",
    lastName: "Aldrich",
    title: "Building and Security Coordinator",
    slug: "thomas-f-aldrich",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan F.",
    lastName: "Alevas",
    title:
      " Lecturer Visiting, Program Facilitation Coordinator for HR, Leadership, Law and DEI",
    slug: "susan-f-alevas",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kerri Lee",
    lastName: "Alexander",
    title: "Director of Social Justice and Equity",
    slug: "kerri-lee-alexander",
    dei: true,
    category: "Miscellaneous",
  },
  {
    firstName: "Desiree C",
    lastName: "Alexander",
    title: "Audiovisual Collections Coordinator",
    slug: "desiree-c-alexander",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarina",
    lastName: "Alexander",
    title: "Graphic Designer",
    slug: "sarina-alexander",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nick",
    lastName: "Alexander",
    title: "Events Coordinator, JCB Academic Administration",
    slug: "nick-alexander",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Janiele Melissa",
    lastName: "Ali",
    title: "Enrollment Counselor II",
    slug: "janiele-melissa-ali",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Aziz H",
    lastName: "Ali",
    title: "Admissions Ambassador",
    slug: "aziz-h-ali",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Ati",
    lastName: "Alipour",
    title: "Assistant Ombuds",
    slug: "ati-alipour",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diana",
    lastName: "Allegretti",
    title: "Director for Design and Construction",
    slug: "diana-allegretti",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Harrison Scott",
    lastName: "Allen",
    title: "Finance Specialist III",
    slug: "harrison-scott-allen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sarah",
    lastName: "Allen",
    title: "Manager of Community, IC3",
    slug: "sarah-allen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa Jean",
    lastName: "Allen",
    title: "Web Application Developer",
    slug: "melissa-jean-allen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jermaine",
    lastName: "Allen",
    title: "Financial Aid Counselor II",
    slug: "jermaine-allen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shawna",
    lastName: "Alling",
    title: "Director of Credit, Conferral & Compliance/College Registrar",
    slug: "shawna-alling",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Adam",
    lastName: "Allington",
    title: "Media Relations Specialist",
    slug: "adam-allington",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nancy",
    lastName: "Almann",
    title: "Co-Managing Director, Cornell Blackstone Launchpad",
    slug: "nancy-almann",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Soledad",
    lastName: "Almeida",
    title: "Director, Program Development and Enrollment",
    slug: "soledad-almeida",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Dariana",
    lastName: "Almeyda",
    title: "Digital Communications Associate, Break Through Tech",
    slug: "dariana-almeyda",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Stefanie",
    lastName: "Alnutt",
    title: "Sr. Conference and Event Planner",
    slug: "stefanie-alnutt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle S.",
    lastName: "Alvord",
    title: "Webinar & Communication Coordinator",
    slug: "michelle-s-alvord",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lisa",
    lastName: "Alzo",
    title: "Assistant to the Chair",
    slug: "lisa-alzo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jeff",
    lastName: "Amaral",
    title: "Front End Web Developer",
    slug: "jeff-amaral",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Carolyn Vera",
    lastName: "Ambrose",
    title: "Area Chair Coordinator",
    slug: "carolyn-vera-ambrose",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sumiya",
    lastName: "Amin",
    title: "CALS - Lab Assistant (P. McLeod Lab)",
    slug: "sumiya-amin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mary",
    lastName: "Ammerman",
    title: "HR Associate",
    slug: "mary-ammerman",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Mark H.",
    lastName: "Anbinder",
    title: "Web Communications Manager",
    slug: "mark-h-anbinder",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Amy Darlene",
    lastName: "Andersen",
    title: "Administrative Asst IV",
    slug: "amy-darlene-andersen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine",
    lastName: "Anderson",
    title: "Assoc Vice President",
    slug: "katherine-anderson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "R.J.",
    lastName: "Anderson",
    title: "Communications Manager I",
    slug: "r-j-anderson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Torie Michelle",
    lastName: "Anderson",
    title: "Copywriter and Content Creator",
    slug: "torie-michelle-anderson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kimberly",
    lastName: "Anderson",
    title: "Assistant Director of Campus Sustainability",
    slug: "kimberly-anderson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily M.",
    lastName: "Anderson",
    title:
      " Assistant Director of Administration, Institute of Politics & Global Affairs",
    slug: "emily-m-anderson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ryan",
    lastName: "Anderson",
    title: "A&S Career Development Associate",
    slug: "ryan-anderson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Erica J.",
    lastName: "Anderson",
    title:
      " Executive Staff Assistant to the Director of the Division of Nutritional Sciences",
    slug: "erica-j-anderson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katie",
    lastName: "Anderson",
    title: "Exec Staff Asst II",
    slug: "katie-anderson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Page",
    lastName: "Anderson",
    title: "Senior Investment Accountant",
    slug: "page-anderson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amanda",
    lastName: "Anderson",
    title: "Human Resources Assistant V",
    slug: "amanda-anderson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Eric P.",
    lastName: "Anderson",
    title: "Orchard Worker Hd S10",
    slug: "eric-p-anderson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bernard Harry",
    lastName: "Anderson",
    title: "Reference Assistant",
    slug: "bernard-harry-anderson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joshua",
    lastName: "Anderson",
    title: "Residence Hall Director",
    slug: "joshua-anderson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Blake",
    lastName: "Anderson",
    title: "Assistant Director of Admissions, EMBA/MS in Healthcare Leadership",
    slug: "blake-anderson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jay S.",
    lastName: "Andress",
    title: "Associate Athletics Director, Strength & Conditioning",
    slug: "jay-s-andress",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sara Bailey",
    lastName: "Andress",
    title:
      " AAD Director of Development, Cornell SC Johnson College of Business",
    slug: "sara-bailey-andress",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessica L.",
    lastName: "Andrews",
    title: "Clinic Aide",
    slug: "jessica-l-andrews",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lucas Rodney Mason",
    lastName: "Andrews",
    title: "Security/Special Events Assistant",
    slug: "lucas-rodney-mason-andrews",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Viviana",
    lastName: "Andriola",
    title: "Critic Visiting",
    slug: "viviana-andriola",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dana",
    lastName: "Andruczyk",
    title: "Enrollment Counselor I",
    slug: "dana-andruczyk",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Rajni",
    lastName: "Aneja",
    title: "Managing Director of the CIFS Industry Partnership Program",
    slug: "rajni-aneja",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jody",
    lastName: "Angelo",
    title: "Administrative Asst III",
    slug: "jody-angelo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren Rachel",
    lastName: "Angelone",
    title: "Client Service Representative",
    slug: "lauren-rachel-angelone",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Isabella",
    lastName: "Animadu",
    title: "Enrollment Representative, Casual",
    slug: "isabella-animadu",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Daniel Ribeiro Dos",
    lastName: "Anjos",
    title: "Program Assistant - Emerging Markets Institute",
    slug: "daniel-ribeiro-dos-anjos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Galiba",
    lastName: "Anjum",
    title:
      " Program Assistant- Center for Transformative Action - Christopherson Center, SASA III - CS 3410, Marketing & Communications Technical Asst",
    slug: "galiba-anjum",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jarrett E.",
    lastName: "Anthony",
    title: "Communications Specialist, Internal Communications",
    slug: "jarrett-e-anthony",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lilian Griselda Pagoada",
    lastName: "Antunez",
    title: "Administrative Asst IV",
    slug: "lilian-griselda-pagoada-antunez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julia de",
    lastName: "Aragón",
    title: "Office Coordinator, Offices of the President and Provost",
    slug: "julia-de-arag-n",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Hallie",
    lastName: "ArbitalJacoby",
    title: "Senior Event Coordinator",
    slug: "hallie-arbitaljacoby",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yazmany",
    lastName: "Arboleda",
    title: "Critic Visiting",
    slug: "yazmany-arboleda",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marianne",
    lastName: "Arcangeli",
    title: "Administrative Asst IV",
    slug: "marianne-arcangeli",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anthony J.",
    lastName: "Arcangeli",
    title: "ECE Department & Event Coordinator",
    slug: "anthony-j-arcangeli",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicole Lynn",
    lastName: "Argetsinger",
    title: "Bursar Account Services Representative",
    slug: "nicole-lynn-argetsinger",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Muhammad",
    lastName: "Arif",
    title:
      " Technical Lead for Microsoft Identity Services, Identity Management",
    slug: "muhammad-arif",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Aaron Henry",
    lastName: "Arm",
    title: "Communication Specialist",
    slug: "aaron-henry-arm",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michelle L.",
    lastName: "Armstrong",
    title: "Administrative Assistant AHDC CRT",
    slug: "michelle-l-armstrong",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jason R.",
    lastName: "Arnold",
    title: "DDC Applications Designer",
    slug: "jason-r-arnold",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Melanie Ann",
    lastName: "Arnold",
    title: "Multimedia Specialist I",
    slug: "melanie-ann-arnold",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brian Charles",
    lastName: "Arnold",
    title: "Cataloging Associate, Indonesian",
    slug: "brian-charles-arnold",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Candice L",
    lastName: "Arnold",
    title: "Enrollment Pod Leader",
    slug: "candice-l-arnold",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Amy",
    lastName: "Arntsen",
    title: "College Registrar",
    slug: "amy-arntsen",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Pedro",
    lastName: "Arroyo",
    title: "Receiving & Specialized Acquisitions Unit Supervisor",
    slug: "pedro-arroyo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Arlette Sheyla",
    lastName: "Arroyo",
    title: "eCornell Pod Leader",
    slug: "arlette-sheyla-arroyo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amy Maria",
    lastName: "Arsenault",
    title: "Financial Transaction Representative",
    slug: "amy-maria-arsenault",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michelle",
    lastName: "Artibee",
    title: "Director, Workforce Wellbeing",
    slug: "michelle-artibee",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ghazal Abbasy -",
    lastName: "Asbagh",
    title: "Gensler Visiting Critic",
    slug: "ghazal-abbasy-asbagh",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sanda",
    lastName: "Asbie",
    title: "Medical Technology Supervisor",
    slug: "sanda-asbie",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Beatriz Arruda",
    lastName: "Asfora",
    title: "Associate Director of the Motion Studio",
    slug: "beatriz-arruda-asfora",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leule",
    lastName: "Ashenafi",
    title: "Secrutiy & Visitor Services Associate",
    slug: "leule-ashenafi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samantha E.",
    lastName: "Asker",
    title: "Administrative Assistant, International, University Major Gifts",
    slug: "samantha-e-asker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carolyn C.",
    lastName: "Aslan",
    title: "Senior Associate Director",
    slug: "carolyn-c-aslan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lori",
    lastName: "Asperschlager",
    title: "Research Administration Coordinator",
    slug: "lori-asperschlager",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Milena",
    lastName: "Ataian",
    title: "Slavic Language Ordering Specialist",
    slug: "milena-ataian",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Desmond Kofi",
    lastName: "Atikpui",
    title: "Comp Assistant, IT Assistant",
    slug: "desmond-kofi-atikpui",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Erin E",
    lastName: "Atkins",
    title: "Graduate Field Coordinator",
    slug: "erin-e-atkins",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tim",
    lastName: "Atkins",
    title: "Computer Support",
    slug: "tim-atkins",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shirley",
    lastName: "Atkinson",
    title: "Associate Director",
    slug: "shirley-atkinson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carole E.",
    lastName: "Atkinson",
    title: "Public Svcs Asst IV",
    slug: "carole-e-atkinson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tedrick",
    lastName: "Au",
    title: "Bulletin Fall 2024",
    slug: "tedrick-au",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tom",
    lastName: "Auer",
    title: "Science Product Manager",
    slug: "tom-auer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John",
    lastName: "August",
    title: "Program Director, Partners Program",
    slug: "john-august",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jonathan",
    lastName: "Augustyn",
    title:
      " Senior Associate Director/Visit Experience/Alumni Admissions Engagement",
    slug: "jonathan-augustyn",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Natasha L.",
    lastName: "Aumick",
    title: "Financial Services Manager",
    slug: "natasha-l-aumick",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Keli Baneza",
    lastName: "Auqui",
    title:
      " Administrative Assistant for the Centers for Student Equity, Empowerment, and Belonging",
    slug: "keli-baneza-auqui",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Joselyn J",
    lastName: "Auquilla",
    title:
      " IDP Facilitator, Mobility Aide - Cayuga Medical Center at Ithaca (Lara Parrilla)",
    slug: "joselyn-j-auquilla",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan",
    lastName: "Austic",
    title: "Financial Services Associate",
    slug: "susan-austic",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer",
    lastName: "Austin",
    title: "Director, Skorton Center for Health Initiatives, Mgr Finance III",
    slug: "jennifer-austin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meaghan",
    lastName: "Austin",
    title: "Assistant to the Chair",
    slug: "meaghan-austin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Donald",
    lastName: "Austin",
    title: "Assistant Director of Undergraduate and Graduate Student Services",
    slug: "donald-austin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mason",
    lastName: "Averett",
    title: "Administrative Coordinator",
    slug: "mason-averett",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Garth",
    lastName: "Avery",
    title: "Broadcast Specialist",
    slug: "garth-avery",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Aria Isabel Sickler",
    lastName: "Avery",
    title:
      " Community Engagement Docents at the History Center in Tompkins County (BrierMae Ossont)",
    slug: "aria-isabel-sickler-avery",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christie",
    lastName: "Avgar",
    title: "Assistant Dean, Enrollment and Student Services",
    slug: "christie-avgar",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Krsna N",
    lastName: "Avila",
    title: "Immigration Attorney",
    slug: "krsna-n-avila",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Maria I.",
    lastName: "Avila",
    title: "Talent Acquisition Partner - Technical",
    slug: "maria-i-avila",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Joanne Uy",
    lastName: "Avila",
    title: "Digital Designer III",
    slug: "joanne-uy-avila",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Suzette",
    lastName: "Aviles",
    title: "Major Gift Officer, Cornell Tech",
    slug: "suzette-aviles",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Milani Jade",
    lastName: "Aviles",
    title: "Program Assistant, Upward Bound",
    slug: "milani-jade-aviles",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Gustave",
    lastName: "Axelson",
    title: "Editor IV",
    slug: "gustave-axelson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brandi",
    lastName: "Ayers",
    title: "Service Coordinator",
    slug: "brandi-ayers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tammy M.",
    lastName: "Babcock",
    title:
      " Direct Support/Enterprise Services, Project Management, and Communications",
    slug: "tammy-m-babcock",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gail",
    lastName: "Babcock",
    title: "Director of Administration",
    slug: "gail-babcock",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole",
    lastName: "Babcock",
    title: "Teaching Programs Administrator",
    slug: "nicole-babcock",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Robin E",
    lastName: "Babcock",
    title: "Administrative Asst III",
    slug: "robin-e-babcock",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Opal D.",
    lastName: "Bablington",
    title: "Customer Service & Registration Representative",
    slug: "opal-d-bablington",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kim",
    lastName: "Babuka",
    title: "Senior Director for Workforce Planning and Compensation",
    slug: "kim-babuka",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jared",
    lastName: "Backus",
    title: "The John B. and Ann B. Rogers '45 Defensive Coordinator (Football)",
    slug: "jared-backus",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samantha M",
    lastName: "Bacon",
    title: "Lab Processing Coordinator",
    slug: "samantha-m-bacon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ben",
    lastName: "Badua",
    title: "Creative Content Manager",
    slug: "ben-badua",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jase",
    lastName: "Baese",
    title: "Info Tech Asst Dir I",
    slug: "jase-baese",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anais",
    lastName: "Baez",
    title: "Administrative Assistant",
    slug: "anais-baez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrea L.",
    lastName: "Bahry",
    title: "Administrative Asst III",
    slug: "andrea-l-bahry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lindsay",
    lastName: "Bahureksa",
    title: "Research & Evidence Synthesis Librarian",
    slug: "lindsay-bahureksa",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Solomon Jun",
    lastName: "Baik",
    title: "Stud Acad Serv Asst III (DiStasio), Student Acad Serv Asst III",
    slug: "solomon-jun-baik",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Hannah",
    lastName: "Bailey",
    title: "Associate Director of Development",
    slug: "hannah-bailey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Judy",
    lastName: "Bailey",
    title: "Admissions and Student Services Office and Event Coordinator",
    slug: "judy-bailey",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jessica",
    lastName: "Bailey",
    title:
      " Administrative Assistant to the Assistant Dean for DVM Student Services & Admissions",
    slug: "jessica-bailey",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Amanda L.",
    lastName: "Bailey",
    title: "Accounts Rep V",
    slug: "amanda-l-bailey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kristyn",
    lastName: "Bailey",
    title: "Illustrator",
    slug: "kristyn-bailey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tyler J.",
    lastName: "Bailey",
    title: "Lead Technical Consultant",
    slug: "tyler-j-bailey",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gary J.",
    lastName: "Bain",
    title: "Studio Production Specialist",
    slug: "gary-j-bain",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jonathan",
    lastName: "Baird",
    title: "Applications Developer III",
    slug: "jonathan-baird",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Wendy",
    lastName: "Bakal",
    title: "Executive Staff Assistant II",
    slug: "wendy-bakal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Myles R",
    lastName: "Baker",
    title: "Associate Director of Enrollment",
    slug: "myles-r-baker",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Michael E.",
    lastName: "Baker",
    title: "Director of Information Technologies",
    slug: "michael-e-baker",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Danielle Jeanette",
    lastName: "Baker",
    title: "Financial Reporting Specialist",
    slug: "danielle-jeanette-baker",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marcia",
    lastName: "Baker",
    title: "Administrative Asst III",
    slug: "marcia-baker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristin",
    lastName: "Baker",
    title: "Assistant Director of Nursing, Psychiatry Services",
    slug: "kristin-baker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sherry Machado Santini",
    lastName: "Baker",
    title: "IT Project Manager III",
    slug: "sherry-machado-santini-baker",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Thara",
    lastName: "Baker-Alley",
    title: "Senior PeopleSoft Developer",
    slug: "thara-baker-alley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Robert William",
    lastName: "Balder",
    title: "Gensler Family Sesquicentennial Executive Director",
    slug: "robert-william-balder",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Catherine Elizabeth",
    lastName: "Baldessare",
    title: "Human Resources Associate",
    slug: "catherine-elizabeth-baldessare",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Krystal Patricia",
    lastName: "Baldie",
    title:
      " Legal, Tax, Compliance, Due Diligence and Operational Documentation Specialist",
    slug: "krystal-patricia-baldie",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Stephanie",
    lastName: "Baldwin",
    title: "Robert G. Engel Director of Sorority and Fraternity Life",
    slug: "stephanie-baldwin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Cooper Jay",
    lastName: "Baldwin",
    title: "HR Business Partner, eCornell",
    slug: "cooper-jay-baldwin",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ben",
    lastName: "Balkaya",
    title: "SCE Associate Dean of Administration",
    slug: "ben-balkaya",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mary",
    lastName: "Ball",
    title: "Department Manager",
    slug: "mary-ball",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathy",
    lastName: "Ball",
    title: "Helen Newman Hall Bowling Center Manager",
    slug: "kathy-ball",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Susan E.",
    lastName: "Ball",
    title: "Lifeguard",
    slug: "susan-e-ball",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine",
    lastName: "Ballard",
    title: "Director of Central Support",
    slug: "katherine-ballard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peter A.",
    lastName: "Bamberger",
    title: "Research Director, Smithers Institute",
    slug: "peter-a-bamberger",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Regina E.",
    lastName: "Banfield",
    title: "Direct Support/Infrastructure, Service Support, and Security",
    slug: "regina-e-banfield",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eric J.",
    lastName: "Banfield",
    title: "Manager, Accounts Payable",
    slug: "eric-j-banfield",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Eric F.",
    lastName: "Banford",
    title: "Applications Developer III",
    slug: "eric-f-banford",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Veronica V.",
    lastName: "Banks",
    title: "Sr. Consultant, Data Analysis",
    slug: "veronica-v-banks",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Savannah",
    lastName: "Bao",
    title: "Director, eCornell Masters Programs",
    slug: "savannah-bao",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amelia Tidona",
    lastName: "Barabander",
    title: "AI Program Managing Director, Break Through Tech",
    slug: "amelia-tidona-barabander",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Vladimir",
    lastName: "Baranov",
    title: "Entrepreneur in Residence",
    slug: "vladimir-baranov",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bruce",
    lastName: "Barber",
    title: "Database Administrator",
    slug: "bruce-barber",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Adriana Maria Ferreira",
    lastName: "Barboza",
    title: "Communications Specialist, Physical Systems",
    slug: "adriana-maria-ferreira-barboza",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Erin",
    lastName: "Bard",
    title: "Solution Developer",
    slug: "erin-bard",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kaylin Ashley",
    lastName: "Barefoot",
    title: "CALS - 4H Horse Program Assistant (B. Hughes)",
    slug: "kaylin-ashley-barefoot",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gordon L.",
    lastName: "Barger",
    title: "Senior Director, Benefits Strategy and Initiatives",
    slug: "gordon-l-barger",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kirsten Johnston",
    lastName: "Barker",
    title: "Social Impact Programs Manager",
    slug: "kirsten-johnston-barker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rachel",
    lastName: "Barna",
    title: "Associate Director of Finance & Budget",
    slug: "rachel-barna",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jacob Hiram",
    lastName: "Barnard",
    title: "Access Services Coordinator",
    slug: "jacob-hiram-barnard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mrs Charyl",
    lastName: "Barnes",
    title: "Treasury Associate",
    slug: "mrs-charyl-barnes",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Karen",
    lastName: "Barnes",
    title: "Associate Director for Student Programs and Campaigns",
    slug: "karen-barnes",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "James",
    lastName: "Barnes",
    title: "Endpoint Security Administrator",
    slug: "james-barnes",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lillian",
    lastName: "Barnes",
    title: "Administrative Asst IV",
    slug: "lillian-barnes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shelby",
    lastName: "Barnes",
    title: "Chemical Inventory Specialist",
    slug: "shelby-barnes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ayesha Mazhar",
    lastName: "Barnett",
    title: "Seasonal Advising Associate",
    slug: "ayesha-mazhar-barnett",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Danielle K.",
    lastName: "Barnett",
    title: "Art Direction Specialist",
    slug: "danielle-k-barnett",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kyle",
    lastName: "Barnhart",
    title: "Director of Administration, Supervisor-Cross Unit",
    slug: "kyle-barnhart",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maharsh K",
    lastName: "Barot",
    title:
      " Administrative Assistant Cornell Atkinson Center for Sustainability (Hybrid)",
    slug: "maharsh-k-barot",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Will",
    lastName: "Barr",
    title: "SHP Risk Specialist",
    slug: "will-barr",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mike",
    lastName: "Barre",
    title: "Info Tech Asst Dir I",
    slug: "mike-barre",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "George H.",
    lastName: "Barrera",
    title: "Building Coordinator, Mail Services",
    slug: "george-h-barrera",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Allison",
    lastName: "Barrett",
    title: "Department Manager",
    slug: "allison-barrett",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Derrick",
    lastName: "Barrett",
    title: "Lead Finance",
    slug: "derrick-barrett",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Stephen M.",
    lastName: "Barrett",
    title: "Integration Developer",
    slug: "stephen-m-barrett",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kirsten June",
    lastName: "Barrett",
    title: "Web Developer",
    slug: "kirsten-june-barrett",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Felicia Cherise",
    lastName: "Barrett",
    title: "Taverna Banfi Restaurant Manager",
    slug: "felicia-cherise-barrett",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jackie",
    lastName: "Barrett",
    title: "Associate Director of Leadership Programs",
    slug: "jackie-barrett",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ian T.",
    lastName: "Barrie",
    title: "John T. Oxley Equestrian Center Barn Manager",
    slug: "ian-t-barrie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew Justin",
    lastName: "Barron",
    title: "Telecommunications Officer",
    slug: "matthew-justin-barron",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Breanna",
    lastName: "Barry",
    title: "HR & Payroll Administrator",
    slug: "breanna-barry",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jessie",
    lastName: "Barry",
    title: "Mgr Program",
    slug: "jessie-barry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John",
    lastName: "Barry",
    title: "Salesforce Developer",
    slug: "john-barry",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gary J.",
    lastName: "Bartholf",
    title: "Transportation Service Rep 2",
    slug: "gary-j-bartholf",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Barbara",
    lastName: "Bartholomew",
    title: "Reserves Supervisor",
    slug: "barbara-bartholomew",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Magdalena Kalinka",
    lastName: "Bartishevich",
    title: "Executive Director, Alumni Affairs",
    slug: "magdalena-kalinka-bartishevich",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Melissa Annette",
    lastName: "Bartley",
    title: "Seasonal Admissions Readers",
    slug: "melissa-annette-bartley",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Amanda",
    lastName: "Bartley",
    title: "Senior arXiv Moderation and User Support Specialist",
    slug: "amanda-bartley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brett J.",
    lastName: "Bartman",
    title: "Enrollment Manager",
    slug: "brett-j-bartman",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sebastian",
    lastName: "Bartnik",
    title: "Reiser - AAP Office of Admissions",
    slug: "sebastian-bartnik",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Christina",
    lastName: "Barton",
    title: "Project Associate, Class Programs",
    slug: "christina-barton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karie Jo",
    lastName: "Barwind",
    title: "Chief Research Compliance Officer",
    slug: "karie-jo-barwind",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mira",
    lastName: "Basara",
    title: "Digital Lifecycle Management Specialist",
    slug: "mira-basara",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael Robert",
    lastName: "Basedow",
    title: "Fruit Specialist",
    slug: "michael-robert-basedow",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bhoja Raj",
    lastName: "Basnet",
    title: "Breeding Data Coordinator",
    slug: "bhoja-raj-basnet",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ukana U",
    lastName: "Bassey",
    title: "Intramural Sport Official",
    slug: "ukana-u-bassey",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Golnaz",
    lastName: "Bastani-Charnley",
    title: "AHDC/PDMS Administrative Assistant",
    slug: "golnaz-bastani-charnley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bryan",
    lastName: "Bates",
    title: "Web Design and Production Specialist",
    slug: "bryan-bates",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nirsharisse Neeshi",
    lastName: "Batista",
    title: "Program Assistant, Upward Bound",
    slug: "nirsharisse-neeshi-batista",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Laura",
    lastName: "Batten",
    title: "Director of Strategic Partnerships for Bowers CIS",
    slug: "laura-batten",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jason",
    lastName: "Battersby",
    title: "Finance Specialist III",
    slug: "jason-battersby",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "James M.",
    lastName: "Baughan",
    title: "Golf Course Head Pro & Varsity",
    slug: "james-m-baughan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sharon",
    lastName: "Baum",
    title: "SCL Sr. Director of Budget & Financial Services",
    slug: "sharon-baum",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Vicki",
    lastName: "Baum",
    title: "Continuous Quality Improvement (CQI) Coordinator",
    slug: "vicki-baum",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa",
    lastName: "Bauman",
    title: "Human Resources Generalist, SC Johnson College of Business",
    slug: "melissa-bauman",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Marie-France",
    lastName: "Baveye",
    title: "Research Administration Assistant",
    slug: "marie-france-baveye",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alexandra Paula",
    lastName: "Bayer",
    title: "Multimedia Specialist II",
    slug: "alexandra-paula-bayer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sonja S.",
    lastName: "Baylor",
    title: "Director, Talent Attraction and Recruitment",
    slug: "sonja-s-baylor",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Nora Karp",
    lastName: "Bayly",
    title: "Advising Dean",
    slug: "nora-karp-bayly",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stephen G.",
    lastName: "Bayne",
    title: "Art and Graphic Design Manager",
    slug: "stephen-g-bayne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julie",
    lastName: "Bazan",
    title: "Manager Student Career Services",
    slug: "julie-bazan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mirven",
    lastName: "Bazile",
    title: "Administrative Assistant",
    slug: "mirven-bazile",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Donald M.",
    lastName: "Bazley",
    title: "Multimedia Specialist II",
    slug: "donald-m-bazley",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Beth",
    lastName: "Beach",
    title: "Executive Staff Assistant",
    slug: "beth-beach",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brigid",
    lastName: "Beachler",
    title: "Director, Engaged and Experiential Learning Programs",
    slug: "brigid-beachler",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tammy M.",
    lastName: "Bean",
    title: "Billing Manager",
    slug: "tammy-m-bean",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mrs Telessa",
    lastName: "Bean",
    title: "Program Assistant",
    slug: "mrs-telessa-bean",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patrick Michael",
    lastName: "Beary",
    title: "Senior Director of Strategic Partnerships",
    slug: "patrick-michael-beary",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Richard",
    lastName: "Beattie",
    title: "Courier",
    slug: "richard-beattie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicky",
    lastName: "Beaudoin",
    title: "Instructional Designer - MPH",
    slug: "nicky-beaudoin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Debbie",
    lastName: "Beausejour",
    title:
      " Associate Director for Multicultural Affairs, e-Cornell Course Facilitator",
    slug: "debbie-beausejour",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Zach",
    lastName: "Beauvais",
    title: "Marketing Director",
    slug: "zach-beauvais",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Amanda Joan",
    lastName: "Beck",
    title: "Client Service Representative",
    slug: "amanda-joan-beck",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Anne",
    lastName: "Becker",
    title: "Academic Scheduler and Systems Assistant",
    slug: "anne-becker",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brian Joseph",
    lastName: "Becker",
    title: "Sheet Metal Worker",
    slug: "brian-joseph-becker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lori A.",
    lastName: "Becker",
    title: "Sheet Metal Worker",
    slug: "lori-a-becker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samuel Patrick",
    lastName: "Beckley",
    title: "Emergency Services Specialist",
    slug: "samuel-patrick-beckley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cyndi",
    lastName: "Beckley",
    title: "Academic Records and Student Services Associate",
    slug: "cyndi-beckley",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jocelyn L.",
    lastName: "Becraft",
    title: "Manager Informatics/Data Analytics II",
    slug: "jocelyn-l-becraft",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kathryn",
    lastName: "Bednarsky",
    title: "Case Manager, Clinic to End Tech Abuse (CETA)",
    slug: "kathryn-bednarsky",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jose Perez",
    lastName: "Beduya",
    title: "Writer/Editor & Social Media Coordinator",
    slug: "jose-perez-beduya",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jessica",
    lastName: "Beebe",
    title: "Assistant Director of Graduate Programs",
    slug: "jessica-beebe",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jill Anna",
    lastName: "Beebe",
    title: "Alumni Affairs and Engagement Program Assistant",
    slug: "jill-anna-beebe",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mike",
    lastName: "Beeching",
    title: "Administrative Asst IV",
    slug: "mike-beeching",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Martyn",
    lastName: "Beeny",
    title: "Marketing and Sales Director",
    slug: "martyn-beeny",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Stephanie",
    lastName: "Beery",
    title: "Associate Director for Academic Human Resources",
    slug: "stephanie-beery",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Liana",
    lastName: "Began",
    title: "Marketing Manager",
    slug: "liana-began",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kristin Valentine",
    lastName: "Behnke",
    title: "Innovation Outreach Manager",
    slug: "kristin-valentine-behnke",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kristin L.",
    lastName: "Beierle",
    title: "Assistant Director, Conference and Event Services",
    slug: "kristin-l-beierle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Allyson Marie",
    lastName: "Beiersdorf",
    title:
      " Program Assisant Engagement Initiatives, College & Unit Partnerships, Alumni Career Support",
    slug: "allyson-marie-beiersdorf",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Craig T.",
    lastName: "Beil",
    title: "Breeding Program Lead",
    slug: "craig-t-beil",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyle Matthew-Bucher",
    lastName: "Bekelja",
    title: "Grape IPM Specialist",
    slug: "kyle-matthew-bucher-bekelja",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Neil F.",
    lastName: "Belcher",
    title: "Data Modeler",
    slug: "neil-f-belcher",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Duncan Ames",
    lastName: "Bell",
    title: "Director of Administration",
    slug: "duncan-ames-bell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael",
    lastName: "Bell",
    title: "Equipment Tech IV",
    slug: "michael-bell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kindra C.",
    lastName: "Bell",
    title: "Endocrinology Assistant Supervisor",
    slug: "kindra-c-bell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew D.",
    lastName: "Bell",
    title: "Assistant Registrar, Data Management and Systems",
    slug: "matthew-d-bell",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Rebecca",
    lastName: "Bell",
    title: "Compliance Specialist, IACUC",
    slug: "rebecca-bell",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Ryan Tennyson",
    lastName: "Belle",
    title: "Undergraduate Coordinator",
    slug: "ryan-tennyson-belle",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christine A.",
    lastName: "Bellezza",
    title: "Director of Research Assurance",
    slug: "christine-a-bellezza",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kyle Robert",
    lastName: "Bellinger",
    title: "Fire Compliance Specialist",
    slug: "kyle-robert-bellinger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James",
    lastName: "Bellush",
    title: "Manager, Scientific Scouting",
    slug: "james-bellush",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole",
    lastName: "Beltran",
    title: "Major Gift Associate",
    slug: "nicole-beltran",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brian",
    lastName: "Belyea",
    title: "Head Table Staff/Official",
    slug: "brian-belyea",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anna",
    lastName: "Ben-Shlomo",
    title: "Sustainability Coordinator",
    slug: "anna-ben-shlomo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patience",
    lastName: "Benassi",
    title: "Accounts Representatitve",
    slug: "patience-benassi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rene J.",
    lastName: "Benda",
    title: "Academic Programs Coordinator",
    slug: "rene-j-benda",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michelle M.",
    lastName: "Benedict",
    title: "Associate Vice President, University Treasurer & University Bursar",
    slug: "michelle-m-benedict",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jody Clark",
    lastName: "Benedict",
    title: "Digital Systems Specialist",
    slug: "jody-clark-benedict",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily",
    lastName: "Bengtson",
    title: "JD Financial Aid and Admissions Programs Coordinator",
    slug: "emily-bengtson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Cheryl L.",
    lastName: "Benk",
    title: "Administrative Asst V",
    slug: "cheryl-l-benk",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chris",
    lastName: "Bennett",
    title: "Exec Staff Asst II",
    slug: "chris-bennett",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy M.",
    lastName: "Bennett",
    title: "Director of Finance and Budget",
    slug: "amy-m-bennett",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lynn",
    lastName: "Bennett",
    title: "Financial Transaction Representative",
    slug: "lynn-bennett",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shaun M.",
    lastName: "Bennett",
    title: "Building Care Manager",
    slug: "shaun-m-bennett",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lindsay Renee",
    lastName: "Bennett",
    title: "Graduate Field Coordinator",
    slug: "lindsay-renee-bennett",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tammie L.",
    lastName: "Bennett",
    title: "Client Experience Coordinator",
    slug: "tammie-l-bennett",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Taylor",
    lastName: "Bennett",
    title: "IT Support Assoc II",
    slug: "taylor-bennett",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Isabelle Kathleen",
    lastName: "Bennie",
    title: "ACC Tutor - IYB (Johara Malcolm)",
    slug: "isabelle-kathleen-bennie",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kim",
    lastName: "Benowski",
    title: "Instructional Designer/Developer",
    slug: "kim-benowski",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David",
    lastName: "Benscher",
    title: "Research Supp Spec II",
    slug: "david-benscher",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Debra L.",
    lastName: "Benson",
    title: "Procurement Manager",
    slug: "debra-l-benson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sam",
    lastName: "Benson",
    title: "Assistant Director for Graduate Affairs",
    slug: "sam-benson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Chelsea",
    lastName: "Benson",
    title: "Gifts Officer II",
    slug: "chelsea-benson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth",
    lastName: "Bentz",
    title: "Graduate Field Coordinator",
    slug: "elizabeth-bentz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Emily Anne",
    lastName: "Beran",
    title: "Research and Instruction Librarian, RMC",
    slug: "emily-anne-beran",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Robert",
    lastName: "Berarducci",
    title: "Compliance & Credentialing Specialist",
    slug: "robert-berarducci",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Emily",
    lastName: "Berg",
    title: "Athletic Trainer",
    slug: "emily-berg",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Aislyn Emily Rain",
    lastName: "Berg",
    title: "Cornell Bird Friendly Campus Initiative",
    slug: "aislyn-emily-rain-berg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa",
    lastName: "Berki",
    title: "Generalist Counselor Therapist",
    slug: "lisa-berki",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sally A.",
    lastName: "Berkowitz",
    title: "Sr. Director, Product Management",
    slug: "sally-a-berkowitz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Suzanne Marie",
    lastName: "Berman",
    title: "Administrative Assistant IV",
    slug: "suzanne-marie-berman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacob Alan",
    lastName: "Berman",
    title:
      " Production Associate - The Cherry Arts (Jen Pearcy-Edwards), Student Art/Ent Asst III",
    slug: "jacob-alan-berman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kayleigh",
    lastName: "Bermudez",
    title: "Employer Relations Program Assistant",
    slug: "kayleigh-bermudez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Tre",
    lastName: "Berney",
    title: "Digitization and Conservation Services Director",
    slug: "tre-berney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Simon",
    lastName: "Bernnard",
    title: "TDM and Safety Coordinator",
    slug: "simon-bernnard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alfred J.",
    lastName: "Bernstein",
    title: "Mgr Tech Svcs",
    slug: "alfred-j-bernstein",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Heidi Ingram",
    lastName: "Berrettini",
    title: "CRP Department Manager",
    slug: "heidi-ingram-berrettini",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elena",
    lastName: "Berry",
    title: "Gift Intention Specialist",
    slug: "elena-berry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sierra",
    lastName: "Berry",
    title: "Bulletin 24/25",
    slug: "sierra-berry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katie",
    lastName: "Berwald",
    title: "Circulation/Collection Management Assistant",
    slug: "katie-berwald",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew",
    lastName: "Besemer",
    title: "Head Table Staff/Official",
    slug: "matthew-besemer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brian",
    lastName: "Bessire",
    title: "Executive Director of Marketing",
    slug: "brian-bessire",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ileana",
    lastName: "Betancourt",
    title: "Sales/Marketing Specialist III",
    slug: "ileana-betancourt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sara",
    lastName: "Betancourt",
    title: "Recruiting & Marketing Assistant",
    slug: "sara-betancourt",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michael I.",
    lastName: "Betteken",
    title: "Compliance Manager, IBC, ESCRO, DURC, Hemp",
    slug: "michael-i-betteken",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Isabella Truglio",
    lastName: "Bettencourt",
    title: "AAP- IT solutions Cage Monitor",
    slug: "isabella-truglio-bettencourt",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dianna Lynn",
    lastName: "Betts",
    title: "IT Manager, Collaboration and Utility Services",
    slug: "dianna-lynn-betts",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Robert C.",
    lastName: "Beveridge",
    title: "Audit Manager",
    slug: "robert-c-beveridge",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lori J.",
    lastName: "Beyea-Powers",
    title: "Administrative Asst IV",
    slug: "lori-j-beyea-powers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caroline E.",
    lastName: "Bhakta",
    title: "Assistant Director, Counseling and Outreach",
    slug: "caroline-e-bhakta",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Aditya",
    lastName: "Bhardwaj",
    title: "Mailroom Assistant, Student Acad Serv Asst II",
    slug: "aditya-bhardwaj",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lakshmi R.",
    lastName: "Bhojraj",
    title: "Breazzano Family Executive Director of the Parker Center",
    slug: "lakshmi-r-bhojraj",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Iris",
    lastName: "Bica",
    title: "Business Development & Licensing Associate",
    slug: "iris-bica",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Grace",
    lastName: "Bichler",
    title: "Reproductions Coordinator",
    slug: "grace-bichler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen L.",
    lastName: "Biddinger",
    title: "Payroll Assistant",
    slug: "karen-l-biddinger",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sebastian",
    lastName: "Bidegain",
    title: "MakerLAB Design and Technology Lead",
    slug: "sebastian-bidegain",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michelle Lynn",
    lastName: "Bidwell",
    title: "Botanic Gardens Greenhouse Manager",
    slug: "michelle-lynn-bidwell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dan",
    lastName: "Biechele",
    title: "Purchasing Agent III",
    slug: "dan-biechele",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric Daniel",
    lastName: "Biegler",
    title: "Senior Director, Benefit Services and Administration",
    slug: "eric-daniel-biegler",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ella",
    lastName: "Biehn",
    title: "Undergraduate Coordinator",
    slug: "ella-biehn",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Esta R.",
    lastName: "Bigler",
    title: "Director of Labor & Employment Law Program",
    slug: "esta-r-bigler",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Deb",
    lastName: "Billups",
    title: "Career Planning Facilitator",
    slug: "deb-billups",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Matthew Joseph",
    lastName: "Bilyk",
    title: "Barton Hall Monitor",
    slug: "matthew-joseph-bilyk",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Yuriy",
    lastName: "Bindas",
    title: "Digitization Coordinator",
    slug: "yuriy-bindas",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Terri",
    lastName: "Bird",
    title: "Administrative Assistant, Naval Reserve Officers Training Corps",
    slug: "terri-bird",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samantha Park",
    lastName: "Birecree",
    title: "Associate Athletics Director, Ticketing and Fan Engagement",
    slug: "samantha-park-birecree",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jeff",
    lastName: "Bishop",
    title: "IT Director",
    slug: "jeff-bishop",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christine",
    lastName: "Bishop",
    title: "Assistant to the Chair",
    slug: "christine-bishop",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Natasha",
    lastName: "Bishop",
    title: "Research and Evidence Synthesis Librarian",
    slug: "natasha-bishop",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lisa D.",
    lastName: "Biskup",
    title: "Graduate Coordinator Professional Student Services",
    slug: "lisa-d-biskup",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Todd",
    lastName: "Bittner",
    title: "Director of Natural Areas",
    slug: "todd-bittner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Theo",
    lastName: "Bizimana",
    title: "Urgent Care Counselor",
    slug: "theo-bizimana",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Riley Teleise",
    lastName: "Blaber",
    title: "Admissions Student Serv Asst II",
    slug: "riley-teleise-blaber",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Stacey A.",
    lastName: "Black",
    title: "Maintenance Planner",
    slug: "stacey-a-black",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Philip T.",
    lastName: "Blackman",
    title: "Software Developer",
    slug: "philip-t-blackman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michele",
    lastName: "Blackmore",
    title: "Chair's Assistant, Department of Natural Resources",
    slug: "michele-blackmore",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maggie Marie",
    lastName: "Blackwell",
    title: "Exec Staff Asst II",
    slug: "maggie-marie-blackwell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kate",
    lastName: "Blackwood",
    title: "Writer & Communications Specialist",
    slug: "kate-blackwood",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jim",
    lastName: "Blair",
    title: "CCAT Project Manager",
    slug: "jim-blair",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kristin",
    lastName: "Blake",
    title: "Deputy Director of Admissions",
    slug: "kristin-blake",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Justin D.",
    lastName: "Blake",
    title: "Building Care Manager",
    slug: "justin-d-blake",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher D",
    lastName: "Blake",
    title: "Mason",
    slug: "christopher-d-blake",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adam B.",
    lastName: "Blakeslee",
    title: "Immigration Specialist",
    slug: "adam-b-blakeslee",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Ted",
    lastName: "Blanchard",
    title: "Sr. Manager of Instructional Technologies",
    slug: "ted-blanchard",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brett R.",
    lastName: "Blanchard",
    title: "Senior Web Application Developer Lead",
    slug: "brett-r-blanchard",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Robert R.",
    lastName: "Bland",
    title: "Associate Vice President of Energy and Sustainability",
    slug: "robert-r-bland",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew",
    lastName: "Bleaken",
    title: "Major Gift Officer",
    slug: "andrew-bleaken",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Heather",
    lastName: "Blinn",
    title: "Financial Reporting Specialist",
    slug: "heather-blinn",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Abby Rose",
    lastName: "Blinn",
    title: "Senior Grant Coordinator",
    slug: "abby-rose-blinn",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alison",
    lastName: "Bliss",
    title: "Generalist Counselor Therapist",
    slug: "alison-bliss",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Zora",
    lastName: "Blitz",
    title: "Administrator III",
    slug: "zora-blitz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary",
    lastName: "Blomfield-Brown",
    title: "Radiographer II",
    slug: "mary-blomfield-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kaitlyn Ryan",
    lastName: "Bloomquist",
    title: "Manuscript Processor",
    slug: "kaitlyn-ryan-bloomquist",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle E.",
    lastName: "Bluey",
    title: "Assistant Vice President",
    slug: "danielle-e-bluey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Helaina Jaye",
    lastName: "Blume",
    title: "CPNH Program Manager",
    slug: "helaina-jaye-blume",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Naomi-Erin Agyenim",
    lastName: "Boateng",
    title: "Engaged Ambassador",
    slug: "naomi-erin-agyenim-boateng",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Derrick Christopher",
    lastName: "Bobb",
    title: "Bronin - AAP Student Aide",
    slug: "derrick-christopher-bobb",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kat",
    lastName: "Boboris",
    title: "Community Engagement Manager, arXiv",
    slug: "kat-boboris",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Miguel Angel",
    lastName: "Bocanegra",
    title: "Immigration Project Attorney",
    slug: "miguel-angel-bocanegra",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Ricky",
    lastName: "Boche",
    title:
      " Assistant Dean of Students for Student Support & Advocacy Service (Case Manager)",
    slug: "ricky-boche",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Imani Jasmine",
    lastName: "Bodet",
    title: "Engaged Ambassador Student Manager",
    slug: "imani-jasmine-bodet",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Shakhya D.",
    lastName: "Bodhiwamsa",
    title: "Digital Conversion Specialist",
    slug: "shakhya-d-bodhiwamsa",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elizabeth M",
    lastName: "Bodner",
    title: "Gift Processing Assistant III",
    slug: "elizabeth-m-bodner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Keeley S.",
    lastName: "Boerman",
    title: "Administrator III",
    slug: "keeley-s-boerman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zachary M.",
    lastName: "Boggs",
    title: "Critic Visiting",
    slug: "zachary-m-boggs",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sheena",
    lastName: "Boggs",
    title: "Financial Transaction Representative",
    slug: "sheena-boggs",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer",
    lastName: "Bogumil",
    title: "Sr. Manager of Business Development & Vendor Programs",
    slug: "jennifer-bogumil",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley",
    lastName: "Bohn",
    title: "Unit Communications Coordinator",
    slug: "ashley-bohn",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer Cara",
    lastName: "Bokaer-Smith",
    title: "Senior Associate Director of the Learning Strategies Center",
    slug: "jennifer-cara-bokaer-smith",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nancy",
    lastName: "Bolduc",
    title: "Finance Specialist II",
    slug: "nancy-bolduc",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gena L",
    lastName: "Boling",
    title: "Associate Vice Provost for Enrollment",
    slug: "gena-l-boling",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Michelle",
    lastName: "Bollock-Smith",
    title: "Sponsored Finance Assistant",
    slug: "michelle-bollock-smith",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kathleen",
    lastName: "Bolton",
    title:
      " Associate Director of Stewardship and Donor Relations, Cornell SC Johnson College of Business",
    slug: "kathleen-bolton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ken",
    lastName: "Bolton",
    title:
      " Collection Development Coordinator – Nestlé and Management Libraries",
    slug: "ken-bolton",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christopher Michael",
    lastName: "Bomysoad",
    title: "Director of Finance, Administration and Enterprise Performance",
    slug: "christopher-michael-bomysoad",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alex B.",
    lastName: "Bond",
    title: "Associate Editor",
    slug: "alex-b-bond",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jason A.",
    lastName: "Bond",
    title: "Mech Maint S09",
    slug: "jason-a-bond",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katlyn",
    lastName: "Bond",
    title: "Acquisitions Asst",
    slug: "katlyn-bond",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy",
    lastName: "Bond",
    title: "Digital Content Manager",
    slug: "amy-bond",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sabel",
    lastName: "Bong",
    title: "Assistant Director",
    slug: "sabel-bong",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adriana Lorena Jimenez",
    lastName: "Bonilla",
    title: "Engaged Ambassador",
    slug: "adriana-lorena-jimenez-bonilla",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Staci",
    lastName: "Bonventre",
    title: "Administrative Asst IV",
    slug: "staci-bonventre",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeanne Elizabeth",
    lastName: "Boodley-Buchanan",
    title: "Project Intake Manager",
    slug: "jeanne-elizabeth-boodley-buchanan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Karene T.",
    lastName: "Booker",
    title:
      " Botanic Gardens and American Indian & Indigenous Studies Program (AAIISP) Administrator",
    slug: "karene-t-booker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole Canessa",
    lastName: "Boosembark",
    title: "Director of Planning & Administration",
    slug: "nicole-canessa-boosembark",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Johnathan",
    lastName: "Bootland",
    title: "Associate Director, Occupational Health and Safety",
    slug: "johnathan-bootland",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Miraya Na",
    lastName: "Borah",
    title: "LII 2025",
    slug: "miraya-na-borah",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathi",
    lastName: "Borgmann",
    title: "Communication Spec III",
    slug: "kathi-borgmann",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Danielle",
    lastName: "Boris",
    title: "Studio Director",
    slug: "danielle-boris",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Charles D.",
    lastName: "Bornt",
    title: "Vegetable Crops Specialist",
    slug: "charles-d-bornt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrea",
    lastName: "Bort",
    title: "Health Records Manager/Privacy Officer",
    slug: "andrea-bort",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexis",
    lastName: "Bortle",
    title: "Membership and Marketing Specialist",
    slug: "alexis-bortle",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Pete",
    lastName: "Bosanko",
    title: "IT Manager, Mail & Calendar Services",
    slug: "pete-bosanko",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Janey L.",
    lastName: "Bosch",
    title: "Case Manager, Student Conduct and Community Standards",
    slug: "janey-l-bosch",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ted",
    lastName: "Boscia",
    title: "Senior Director of Strategic Communications",
    slug: "ted-boscia",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Terri",
    lastName: "Boslett",
    title: "SCL Sr. Director of Strategic Financial Planning",
    slug: "terri-boslett",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Casey",
    lastName: "Bosley",
    title: "Bursar Account Services Manager",
    slug: "casey-bosley",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Evy",
    lastName: "Bosschem",
    title: "Manager of Finance & Business Performance",
    slug: "evy-bosschem",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Aldo G",
    lastName: "Botti",
    title: "Enrollment Counselor I",
    slug: "aldo-g-botti",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Devin A.",
    lastName: "Bougie",
    title: "Info Tech Area Mgr II",
    slug: "devin-a-bougie",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Taylor",
    lastName: "Bouraad",
    title: "Assistant Director, Community Engagement",
    slug: "taylor-bouraad",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kelly Lynn",
    lastName: "Bourne",
    title: "Administrative Asst II",
    slug: "kelly-lynn-bourne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chad A.",
    lastName: "Bower",
    title: "Kuali DevOps Administrator",
    slug: "chad-a-bower",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "J",
    lastName: "Bowman",
    title: "Multimedia Specialist IV",
    slug: "j-bowman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Susan D",
    lastName: "Bowman",
    title: "AAD Program Assistant I",
    slug: "susan-d-bowman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Becka",
    lastName: "Bowyer",
    title: "Senior Media Relations Specialist",
    slug: "becka-bowyer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alexis",
    lastName: "Boyce",
    title: "Program Manager",
    slug: "alexis-boyce",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sydney Anne",
    lastName: "Boyd",
    title: "Program Manager, CCA and AAP Strategic Initiatives",
    slug: "sydney-anne-boyd",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie",
    lastName: "Boyd",
    title: "Learning Consultant",
    slug: "stephanie-boyd",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jessica L",
    lastName: "Boynton",
    title: "Finance Specialist III",
    slug: "jessica-l-boynton",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mara Elizabeth",
    lastName: "Braddy",
    title: "Development Discovery Program Assistant",
    slug: "mara-elizabeth-braddy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael Harper",
    lastName: "Bradley",
    title: "Grant and Contract Associate",
    slug: "michael-harper-bradley",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brandon Michael",
    lastName: "Bradley",
    title: "Buying Assistant, CRS Academic Materials",
    slug: "brandon-michael-bradley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Bridgette",
    lastName: "Brady",
    title: "Senior Director Of Transportation and Delivery Services",
    slug: "bridgette-brady",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa Cottrell",
    lastName: "Brady",
    title:
      " Assistant to the Senior Associate Dean and Associate Dean for Academics, Cornell Graduate School",
    slug: "lisa-cottrell-brady",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anne Marie Elizabeth",
    lastName: "Brady",
    title: "Senior Extension Associate, Worker Rights & Equity",
    slug: "anne-marie-elizabeth-brady",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Seth",
    lastName: "Brahler",
    title: "Executive Director of HR Administration and Technology",
    slug: "seth-brahler",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Grace M",
    lastName: "Braider",
    title: "Bulletin Fall 2024",
    slug: "grace-m-braider",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erinn",
    lastName: "Brainard",
    title: "RJEF Administrative Assistant",
    slug: "erinn-brainard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erika",
    lastName: "Bramwell",
    title: "Senior Program Manager, Break Through Tech",
    slug: "erika-bramwell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lauren",
    lastName: "Branchini",
    title: "Title IX Coordinator",
    slug: "lauren-branchini",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Anne",
    lastName: "Brandt",
    title: "Assistant Dean for Communications and Marketing",
    slug: "anne-brandt",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "William R.",
    lastName: "Brangan",
    title: "Comp Oper Supv",
    slug: "william-r-brangan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Breanna Elaine",
    lastName: "Brann",
    title: "Contracts Specialist",
    slug: "breanna-elaine-brann",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jutta H.",
    lastName: "Brann",
    title: "Finance Specialist III",
    slug: "jutta-h-brann",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "J.P.",
    lastName: "Brannan",
    title: "IT Manager, Academic & Support Services",
    slug: "j-p-brannan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Carrieanne Le",
    lastName: "Bras",
    title: "Data Reporting Specialist",
    slug: "carrieanne-le-bras",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Galib",
    lastName: "Braschler",
    title: "Communication Spec III",
    slug: "galib-braschler",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mr Matt",
    lastName: "Braun",
    title: "Assistant Dean for Alumni Affairs & Development",
    slug: "mr-matt-braun",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andrew",
    lastName: "Brauzer",
    title: "Maintenance Planner",
    slug: "andrew-brauzer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lindsey",
    lastName: "Bray",
    title: "Director of Parent and Family Programs",
    slug: "lindsey-bray",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kacey",
    lastName: "Bray",
    title: "Administrative Supervisor",
    slug: "kacey-bray",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan W.",
    lastName: "Brecher",
    title:
      " Director, Employee Relations, Internal Investigations and Employment Law",
    slug: "susan-w-brecher",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Mandi Jean",
    lastName: "Breigle",
    title: "Athletic Trainer",
    slug: "mandi-jean-breigle",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Abby",
    lastName: "Breitstein",
    title: "Speechwriter-Office of the President",
    slug: "abby-breitstein",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ivy",
    lastName: "Breivogel",
    title: "Assistant Director, Office of Spirituality and Meaning-Making",
    slug: "ivy-breivogel",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Patricia M.",
    lastName: "Brenchley",
    title:
      " Assistant to the Chair and to the Director of Finance and Administration",
    slug: "patricia-m-brenchley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Victoria",
    lastName: "Brevetti",
    title: "Asst to the Chair",
    slug: "victoria-brevetti",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Megan",
    lastName: "Brewer",
    title: "Inside Director, SMB",
    slug: "megan-brewer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher",
    lastName: "Brewer",
    title: "Interim Building Care Manager",
    slug: "christopher-brewer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Bricking",
    title: "Compensation/Classification Specialist",
    slug: "jennifer-bricking",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Myrah A.",
    lastName: "Bridwell",
    title: "Editor II - SP",
    slug: "myrah-a-bridwell",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Silvia Cristina",
    lastName: "Briga",
    title: "Multi Media Associate",
    slug: "silvia-cristina-briga",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Karen M.",
    lastName: "Brigham",
    title: "Physical Therapist Assistant",
    slug: "karen-m-brigham",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sue",
    lastName: "Brightly",
    title: "Communications Marketing Specialist",
    slug: "sue-brightly",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lee",
    lastName: "Brink",
    title: "Systems Administrator",
    slug: "lee-brink",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shamsi Beers",
    lastName: "Brinn",
    title: "User Experience Designer, arXiv",
    slug: "shamsi-beers-brinn",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jamie",
    lastName: "Brisbois",
    title: "Manager, Business Development and Licensing",
    slug: "jamie-brisbois",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan C.",
    lastName: "Bristol",
    title: "Finance Specialist II",
    slug: "susan-c-bristol",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Victor de",
    lastName: "Brito",
    title: "Collections Asst IV",
    slug: "victor-de-brito",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caroline E.",
    lastName: "Brockner",
    title: "Administrator VI",
    slug: "caroline-e-brockner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Josh",
    lastName: "Brockner",
    title: "Data Asset Specialist",
    slug: "josh-brockner",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rebecca",
    lastName: "Brommer",
    title: "Urgent Care Counselor",
    slug: "rebecca-brommer",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kate L.",
    lastName: "Bronfenbrenner",
    title: "Director of Labor Education Research",
    slug: "kate-l-bronfenbrenner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Thomas E.",
    lastName: "Brooking",
    title: "Research Supp Spec II",
    slug: "thomas-e-brooking",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David T.",
    lastName: "Brooks",
    title: "Access Control Program Director",
    slug: "david-t-brooks",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "James C.",
    lastName: "Brooks",
    title: "Grant Contract Ofcr I",
    slug: "james-c-brooks",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Emily",
    lastName: "Brousseau",
    title: "Associate Director, Health and Welfare",
    slug: "emily-brousseau",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher David",
    lastName: "Brouwer",
    title: "Editorial Director",
    slug: "christopher-david-brouwer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ryan Michael",
    lastName: "Brown",
    title: "Associate Controller",
    slug: "ryan-michael-brown",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ruby D.",
    lastName: "Brown",
    title: "Senior HR Business Partner.",
    slug: "ruby-d-brown",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Tessa",
    lastName: "Brown",
    title: "Senior Administrator",
    slug: "tessa-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen E.",
    lastName: "Brown",
    title: "Director of Strategic Projects & Planning",
    slug: "karen-e-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cheryl Ann",
    lastName: "Brown",
    title: "Director of Environmental Compliance",
    slug: "cheryl-ann-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hayley M.",
    lastName: "Brown",
    title: "Associate Director, Communications",
    slug: "hayley-m-brown",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Anjanette",
    lastName: "Brown",
    title: "Enrollment and Member Support",
    slug: "anjanette-brown",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Mark A.",
    lastName: "Brown",
    title: "Administrative Asst III",
    slug: "mark-a-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mackenzie",
    lastName: "Brown",
    title: "Tech Svcs Supv I",
    slug: "mackenzie-brown",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nellie J.",
    lastName: "Brown",
    title: "Sr Ext Assoc, Workplace Health",
    slug: "nellie-j-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ali",
    lastName: "Brown",
    title: "Registrar Support Coordinator",
    slug: "ali-brown",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gregory Gardner",
    lastName: "Brown",
    title: "Coordinator, Physical Education",
    slug: "gregory-gardner-brown",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Greg",
    lastName: "Brown",
    title: "Assistant Director of Student Conduct and Community Standards",
    slug: "greg-brown",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nick",
    lastName: "Brown",
    title: "EAMS Coordinator",
    slug: "nick-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Crystal",
    lastName: "Brown",
    title: "Graduate Coordinator",
    slug: "crystal-brown",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jerrica",
    lastName: "Brown",
    title: "BR Administrative Assistant, SM Administrative Assistant",
    slug: "jerrica-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Penny L.",
    lastName: "Brown",
    title: "Administrative Asst III",
    slug: "penny-l-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristin Rene",
    lastName: "Brown",
    title: "Administrative Asst III",
    slug: "kristin-rene-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katie Brendli",
    lastName: "Brown",
    title: "Research & Evaluation Associate",
    slug: "katie-brendli-brown",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Carl W.",
    lastName: "Brown",
    title: "iPOLL Acquisitions Manager",
    slug: "carl-w-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David Owen",
    lastName: "Brown",
    title: "Digital Photographer",
    slug: "david-owen-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexis",
    lastName: "Brubaker",
    title: "Chief Compliance & Privacy Officer",
    slug: "alexis-brubaker",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Wendy J.",
    lastName: "Brundza",
    title: "Client Experience Coordinator",
    slug: "wendy-j-brundza",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicholas Albert",
    lastName: "Bruner",
    title: "Athletics Equipment Lead – Schoellkopf Hall",
    slug: "nicholas-albert-bruner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dustin Michael",
    lastName: "Brunner",
    title: "Emergency Services Specialist",
    slug: "dustin-michael-brunner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca Taylor",
    lastName: "Brutus",
    title: "Publicist",
    slug: "rebecca-taylor-brutus",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nickolaus",
    lastName: "Bryan",
    title: "Director, Enterprise Programs",
    slug: "nickolaus-bryan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brooke Ann",
    lastName: "Bryant",
    title: "Associate Vice President of University Major Gifts",
    slug: "brooke-ann-bryant",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Eric Colin",
    lastName: "Bryant",
    title: "Intellectual Property Officer",
    slug: "eric-colin-bryant",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Ashley",
    lastName: "Bryant",
    title: "Workplace Disability Inclusion Associate",
    slug: "ashley-bryant",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Sarah A",
    lastName: "Bubash",
    title: "Transition Associate",
    slug: "sarah-a-bubash",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nickolas J.",
    lastName: "Bucci",
    title: "Assistant Bursar, Account Services & Support",
    slug: "nickolas-j-bucci",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Catherine M.",
    lastName: "Bucci",
    title:
      " Assistant to the CVM Associate Dean for Diversity and Academic Excellence",
    slug: "catherine-m-bucci",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Peter Anthony",
    lastName: "Bucci",
    title: "Major Gift Officer",
    slug: "peter-anthony-bucci",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jo-Lynn",
    lastName: "Buchanan",
    title: "Assistant Registrar - CALS Professional Master's Program",
    slug: "jo-lynn-buchanan",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "David William",
    lastName: "Buchholz",
    title: "Post Doc Associate",
    slug: "david-william-buchholz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Spring C.",
    lastName: "Buck",
    title: "Knowledge Curator",
    slug: "spring-c-buck",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Allison",
    lastName: "Buck",
    title: "Art Director & Lead Medical Illustrator/Animator",
    slug: "allison-buck",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth M.",
    lastName: "Buck",
    title: "Vegetable Crops Specialist",
    slug: "elizabeth-m-buck",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Max",
    lastName: "Buckholtz",
    title: "Dance Accompanist",
    slug: "max-buckholtz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Merry Riley",
    lastName: "Buckley",
    title: "Assistant Dean for Communication",
    slug: "merry-riley-buckley",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kathryn Ann",
    lastName: "Buckley",
    title: "CVM Wellbeing Program Director",
    slug: "kathryn-ann-buckley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Janna",
    lastName: "Buckwalter",
    title: "Behavioral Health Consultant",
    slug: "janna-buckwalter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karli S.",
    lastName: "Buday",
    title: "Director, Campus Activities",
    slug: "karli-s-buday",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ashley",
    lastName: "Budd",
    title: "Senior Director, Advancement Marketing",
    slug: "ashley-budd",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Norene A.",
    lastName: "Buehner",
    title: "Research Supp Spec I",
    slug: "norene-a-buehner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah",
    lastName: "Buenrostro",
    title: "Associate Project Manager",
    slug: "sarah-buenrostro",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael",
    lastName: "Buffett",
    title: "Director of Catering and Concessions",
    slug: "michael-buffett",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shannon K.",
    lastName: "Buffum",
    title: "Associate General Counsel",
    slug: "shannon-k-buffum",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Brock A.",
    lastName: "Buffum",
    title: "Associate Director, Annual & Reunion Giving",
    slug: "brock-a-buffum",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jane Frances",
    lastName: "Bunker",
    title: "Director of the Cornell University Press",
    slug: "jane-frances-bunker",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katherine E.",
    lastName: "Bunting-Howarth",
    title: "Associate Director/NY Sea Grant",
    slug: "katherine-e-bunting-howarth",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jared",
    lastName: "Buono",
    title: "Director of Hudson Valley Research Lab",
    slug: "jared-buono",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Teresa",
    lastName: "Burch",
    title: "Administrative Assistant, Ag Quad",
    slug: "teresa-burch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Trish",
    lastName: "Burgess",
    title: "Prospect Development Associate",
    slug: "trish-burgess",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth R.",
    lastName: "Burgess",
    title: "Program Assistant II",
    slug: "elizabeth-r-burgess",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Clarice R.",
    lastName: "Burgman",
    title: "Accounts Rep IV",
    slug: "clarice-r-burgman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Taylor Marie",
    lastName: "Burk",
    title: "Administrative Asst IV",
    slug: "taylor-marie-burk",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephen",
    lastName: "Burke",
    title: "Director, Enterprise Services",
    slug: "stephen-burke",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kristen A.",
    lastName: "Burke",
    title:
      " Director of Annual Giving Programs, Cornell SC Johnson College of Business",
    slug: "kristen-a-burke",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessica",
    lastName: "Burley",
    title: "Residence Hall Director",
    slug: "jessica-burley",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kim",
    lastName: "Burlingame",
    title: "Systems Administrator IV",
    slug: "kim-burlingame",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "C.J.",
    lastName: "Burnett",
    title: "Marketing Analytics & Data Reporting Coordinator",
    slug: "c-j-burnett",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jessica L.",
    lastName: "Burnette",
    title: "Human Resources Assistant",
    slug: "jessica-l-burnette",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Cora",
    lastName: "Burns",
    title: "Director of Parent Engagement and Philanthropy",
    slug: "cora-burns",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "O'Shannon",
    lastName: "Burns",
    title: "Program Manager of Sustainable Destination Tourism",
    slug: "o-shannon-burns",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scott",
    lastName: "Burroughs",
    title: "Training and Delivery Lead",
    slug: "scott-burroughs",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Keisha",
    lastName: "Burrow",
    title: "Associate Director",
    slug: "keisha-burrow",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura L.",
    lastName: "Burrows",
    title: "Financial Transaction Representative",
    slug: "laura-l-burrows",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kat",
    lastName: "Burton",
    title: "Administrative Assistant, Donor Relations",
    slug: "kat-burton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mikayla Denise",
    lastName: "Burton",
    title: "Athletic Team Travel Admin Assistant",
    slug: "mikayla-denise-burton",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Stephen",
    lastName: "Buschini",
    title: "Systems Administrator",
    slug: "stephen-buschini",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jenna",
    lastName: "Bush",
    title: "Research Administration Manager",
    slug: "jenna-bush",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andrew",
    lastName: "Bush",
    title: "Mech Maint",
    slug: "andrew-bush",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cindy L.",
    lastName: "Bush",
    title: "Accounting Transaction Specialist",
    slug: "cindy-l-bush",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brennen",
    lastName: "Bush",
    title: "Milk Plant Worker S06",
    slug: "brennen-bush",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa Allison",
    lastName: "Bushlow",
    title: "Senior Director of Class & Reunion Programs",
    slug: "lisa-allison-bushlow",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Gloria",
    lastName: "Busse",
    title: "Real Estate Associate",
    slug: "gloria-busse",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kierra",
    lastName: "Bussey",
    title: "Program Facilitation Coordinator",
    slug: "kierra-bussey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cody Duane-Richard",
    lastName: "Butler",
    title: "Systems Administrator",
    slug: "cody-duane-richard-butler",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Doug",
    lastName: "Butler",
    title: "Sr. IT Support Associate",
    slug: "doug-butler",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christine A.",
    lastName: "Butler",
    title: "Lab Manager, TREx Facility",
    slug: "christine-a-butler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Catherine Rene",
    lastName: "Butterfield",
    title: "Associate Director for Student Employment",
    slug: "catherine-rene-butterfield",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sally Anne",
    lastName: "Butterfield",
    title: "Acquisitions Associate",
    slug: "sally-anne-butterfield",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nicki",
    lastName: "Button",
    title: "Marketing Automation Manager",
    slug: "nicki-button",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Joanne",
    lastName: "Button",
    title: "Inventory System Administrator",
    slug: "joanne-button",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nicholas",
    lastName: "Butts",
    title: "Gift Processing Assistant III",
    slug: "nicholas-butts",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael",
    lastName: "Byrne",
    title: "Creative Lead for Tech, Arts & Culture, Cornell Tech",
    slug: "michael-byrne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ciara",
    lastName: "Cable",
    title: "Associate Director, Web Solutions and User Experience",
    slug: "ciara-cable",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer",
    lastName: "Cahn",
    title: "Major Gift Officer",
    slug: "jennifer-cahn",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marty",
    lastName: "Cain",
    title: "Reference Assistant",
    slug: "marty-cain",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Terry L.",
    lastName: "Cain",
    title: "Accounting Clerk",
    slug: "terry-l-cain",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jamie L.",
    lastName: "Calabris",
    title: "Communication Spec II",
    slug: "jamie-l-calabris",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Steven",
    lastName: "Calco",
    title: "Interim Assistant Director of the Kheel Center",
    slug: "steven-calco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julianne Rose",
    lastName: "Caldarulo",
    title: "Financial Transaction Representative",
    slug: "julianne-rose-caldarulo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kelly",
    lastName: "Caldwell",
    title: "Program Facilitation Manager",
    slug: "kelly-caldwell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alejandro A",
    lastName: "Calixto",
    title: "Director of the New York State Integrated Pest Management Program",
    slug: "alejandro-a-calixto",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jarid Robert",
    lastName: "Calkins",
    title: "Accounting Service Specialist",
    slug: "jarid-robert-calkins",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Becky L.",
    lastName: "Callan",
    title: "IT Support Services Manager",
    slug: "becky-l-callan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Katie",
    lastName: "Callero",
    title: "Dairy Management Specialist",
    slug: "katie-callero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Manuela",
    lastName: "Camayo",
    title: "AAP- IT solutions Cage Monitor",
    slug: "manuela-camayo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lisa",
    lastName: "Cameron-Norfleet",
    title: "Senior Content Strategist",
    slug: "lisa-cameron-norfleet",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christian Anderson",
    lastName: "Camerota",
    title: "Communication Mgr II",
    slug: "christian-anderson-camerota",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Janet Elizabeth",
    lastName: "Camilli",
    title: "HR Generalist III",
    slug: "janet-elizabeth-camilli",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sandra Sofia Mosqueira",
    lastName: "Caminada",
    title: "Evaluation Associate",
    slug: "sandra-sofia-mosqueira-caminada",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "April",
    lastName: "Campanelli",
    title: "Generalist Counselor Therapist",
    slug: "april-campanelli",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary",
    lastName: "Campany",
    title: "Authorities Metadata Librarian",
    slug: "mary-campany",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer L.",
    lastName: "Campbell",
    title: "Senior Director, Strategic Communications",
    slug: "jennifer-l-campbell",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Courtney",
    lastName: "Campbell",
    title: "Director of Development, Johnson Museum",
    slug: "courtney-campbell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scott M.",
    lastName: "Campbell",
    title: "Executive Director of Admissions and Recruitment",
    slug: "scott-m-campbell",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Becca",
    lastName: "Campbell",
    title: "Assistant Director of Undergraduate Advising & Student Services",
    slug: "becca-campbell",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kelly",
    lastName: "Campbell",
    title: "Volunteer Engagement Specialist",
    slug: "kelly-campbell",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ruth",
    lastName: "Campbell",
    title: "Accounts Rep V",
    slug: "ruth-campbell",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ryan",
    lastName: "Campen",
    title: "Assistant Director, Housing Contracts & Assignments",
    slug: "ryan-campen",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jess",
    lastName: "Campitiello",
    title: "Digital Communications Specialist",
    slug: "jess-campitiello",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Cassi",
    lastName: "Canada",
    title:
      " Administrative Assistant to Sr. Assoc. of Academic Affairs & Directors of Master's Programs",
    slug: "cassi-canada",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Allen",
    lastName: "Canady",
    title: "Investigations Manager, Audit Office",
    slug: "allen-canady",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "E. Angela Herrera",
    lastName: "Canfield",
    title: "Director of Undergraduate Admissions",
    slug: "e-angela-herrera-canfield",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "John",
    lastName: "Cannaday",
    title: "Great Lakes Tourism Development Specialist",
    slug: "john-cannaday",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brenda M.",
    lastName: "Canniff",
    title: "Class Programs and Reunion Engagement Officer",
    slug: "brenda-m-canniff",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Maria",
    lastName: "Cannistra",
    title: "Medical Records Auditor",
    slug: "maria-cannistra",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elvis Norberto Coy",
    lastName: "Canto",
    title: "ILR Admissions Diversity Projects Assistant I (Canfield)",
    slug: "elvis-norberto-coy-canto",
    dei: true,
    category: "Admissions",
  },
  {
    firstName: "Sara",
    lastName: "Cantwell",
    title: "Class Programs Engagement Officer",
    slug: "sara-cantwell",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sara",
    lastName: "Capalongo",
    title: "EHS Account Representative and Office Lead",
    slug: "sara-capalongo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christianne M.",
    lastName: "Capalongo",
    title: "Undergraduate Coordinator",
    slug: "christianne-m-capalongo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Monique Anna Elizabeth",
    lastName: "Caraballo",
    title: "Media Relations Coordinator",
    slug: "monique-anna-elizabeth-caraballo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lisa",
    lastName: "Carberry",
    title: "Administrative Assistant, Career & Public Services.",
    slug: "lisa-carberry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matt",
    lastName: "Carcella",
    title: "Senior Director, Diversity & U.S. Regional Alumni Engagement",
    slug: "matt-carcella",
    dei: true,
    category: "Communications",
  },
  {
    firstName: "Teri E.",
    lastName: "Carey",
    title: "Assistant Director of Admissions",
    slug: "teri-e-carey",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Matthew Stephen",
    lastName: "Carey",
    title: "Full Stack Applications Developer",
    slug: "matthew-stephen-carey",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kate",
    lastName: "Carlin",
    title: "Exhibitions Coordinator",
    slug: "kate-carlin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anne E.",
    lastName: "Carlineo",
    title: "HR Administrative Assistant",
    slug: "anne-e-carlineo",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Melissa L.",
    lastName: "Carlisle",
    title: "Senior Director of External Relations",
    slug: "melissa-l-carlisle",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mariana",
    lastName: "Carlito",
    title: "Development Support Ofcr I",
    slug: "mariana-carlito",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Catherine C.",
    lastName: "Carlson",
    title: "Bldg/Facil Coord IV",
    slug: "catherine-c-carlson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jing",
    lastName: "Carlson",
    title: "Assistant to the Wason Curator",
    slug: "jing-carlson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tanner",
    lastName: "Carlson",
    title: "Collection Management Assistant",
    slug: "tanner-carlson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "April L.",
    lastName: "Carlyle",
    title: "Payroll and Student Employment Assistant",
    slug: "april-l-carlyle",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Gerald A",
    lastName: "Carmell",
    title: "Transportation Service Rep 2",
    slug: "gerald-a-carmell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carrie",
    lastName: "Carmenatty",
    title: "Communication Spec II",
    slug: "carrie-carmenatty",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Celeste Janine",
    lastName: "Carmichael",
    title: "Assistant Director for Program Development and Accountability",
    slug: "celeste-janine-carmichael",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Margaret McFadden",
    lastName: "Carney",
    title: "Senior Director / University Architect",
    slug: "margaret-mcfadden-carney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Liz",
    lastName: "Carney",
    title: "Major Gift Associate",
    slug: "liz-carney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sam",
    lastName: "Carney",
    title: "Director for Career Development",
    slug: "sam-carney",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jessica",
    lastName: "Carpenter",
    title: "Administrative Asst III",
    slug: "jessica-carpenter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katie Sue",
    lastName: "Carpenter",
    title: "Director, New York Agriculture in the Classroom",
    slug: "katie-sue-carpenter",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kelli A.",
    lastName: "Carr",
    title: "Administrative Asst IV",
    slug: "kelli-a-carr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jaret Donel",
    lastName: "Carr",
    title: "Lab Processing Assistant II",
    slug: "jaret-donel-carr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyle J.",
    lastName: "Carr",
    title: "On Location Production Specialist",
    slug: "kyle-j-carr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniela Gonzalez",
    lastName: "Carranza",
    title: "Dairy Management Specialist",
    slug: "daniela-gonzalez-carranza",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Suzanne",
    lastName: "Carreiro",
    title: "Medical Leaves Case Management Consultant",
    slug: "suzanne-carreiro",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Amanda Rae",
    lastName: "Carrillo",
    title: "Inside Director, Small and Medium Business",
    slug: "amanda-rae-carrillo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brian",
    lastName: "Carroll",
    title:
      " Senior Associate Director, Financial Aid Business Analysis & Systems",
    slug: "brian-carroll",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Maureen F.",
    lastName: "Carroll",
    title: "Associate Director of Admissions",
    slug: "maureen-f-carroll",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sarah",
    lastName: "Carson",
    title: "Director of Campus Sustainability",
    slug: "sarah-carson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cristina M.",
    lastName: "Carter",
    title: "Administrative Asst V",
    slug: "cristina-m-carter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric Matthew",
    lastName: "Carter",
    title: "Programming Coordinator",
    slug: "eric-matthew-carter",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Laura",
    lastName: "Caruso",
    title: "Assistant Director of Digital Media Strategy",
    slug: "laura-caruso",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jacob Parker",
    lastName: "Carver",
    title: "AOD Coordinator",
    slug: "jacob-parker-carver",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Hannah Parker",
    lastName: "Carver",
    title: "Human Resources Business Partner",
    slug: "hannah-parker-carver",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Tabitha",
    lastName: "Cary",
    title: "Digital Projects Manager",
    slug: "tabitha-cary",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Julie",
    lastName: "Cary",
    title: "Financial Services Reporting Specialist",
    slug: "julie-cary",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tina Louise",
    lastName: "Cary",
    title: "Service Coordinator",
    slug: "tina-louise-cary",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Alexandra Maria",
    lastName: "Casa",
    title: "Breeding Data Curator",
    slug: "alexandra-maria-casa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mark A",
    lastName: "Casasanta",
    title: "Network Tech IV",
    slug: "mark-a-casasanta",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kelly S.",
    lastName: "Case",
    title: "Administrative Asst III",
    slug: "kelly-s-case",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carol",
    lastName: "Casler",
    title: "Undergraduate Student Services Coordinator",
    slug: "carol-casler",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jennifer Patricia",
    lastName: "Casler-Goncalves",
    title: "Associate General Counsel",
    slug: "jennifer-patricia-casler-goncalves",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jessica",
    lastName: "Cassidy",
    title: "Annual Fund Officer III",
    slug: "jessica-cassidy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ilyana",
    lastName: "Castillo",
    title: "Events Coordinator",
    slug: "ilyana-castillo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patricia Fernandez de",
    lastName: "Castro",
    title: "Coord Program II - SP",
    slug: "patricia-fernandez-de-castro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel",
    lastName: "Castro",
    title: "Program Administrative Assistant",
    slug: "daniel-castro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alicia",
    lastName: "Caswell",
    title: "Chair's Assistant, Earth and Atmospheric Science",
    slug: "alicia-caswell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Melissa",
    lastName: "Catanese",
    title: "Critic Visiting",
    slug: "melissa-catanese",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Megan",
    lastName: "Cates",
    title: "Associate Director of Career Management",
    slug: "megan-cates",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nora J.",
    lastName: "Catlin",
    title: "Interim Academic Director",
    slug: "nora-j-catlin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mary",
    lastName: "Catt",
    title: "Communications Director",
    slug: "mary-catt",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michelle",
    lastName: "Caughey",
    title: "Financial Support Representative",
    slug: "michelle-caughey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joseph",
    lastName: "Caughey",
    title: "Accounting Service Specialist",
    slug: "joseph-caughey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amanda Elizabeth",
    lastName: "Caughey",
    title: "Communication Spec II",
    slug: "amanda-elizabeth-caughey",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Cathy",
    lastName: "Caveney",
    title: "Grounds Admin Asst. IV",
    slug: "cathy-caveney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica",
    lastName: "Cavin",
    title: "Administrative Assistant for Campus Activities",
    slug: "jessica-cavin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Caleb Tobias",
    lastName: "Centanni",
    title: "Administrative Assistant",
    slug: "caleb-tobias-centanni",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elena Maria",
    lastName: "Centeno",
    title: "Youth Sports Leader - YMCA",
    slug: "elena-maria-centeno",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Taylor Smith",
    lastName: "Cepeda",
    title: "Accounts Coordinator",
    slug: "taylor-smith-cepeda",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Emma MacClough",
    lastName: "Cerrato",
    title: "Associate Product Manager",
    slug: "emma-macclough-cerrato",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joanna Elizabeth",
    lastName: "Cerro",
    title: "Serials Unit Supervisor",
    slug: "joanna-elizabeth-cerro",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gabriela",
    lastName: "Cestero",
    title: "Managing Director and MSI Partner Relations",
    slug: "gabriela-cestero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anabel Cristina Flores",
    lastName: "Cevallos",
    title: "Energy & Sustainability Administrator",
    slug: "anabel-cristina-flores-cevallos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adam",
    lastName: "Chafee",
    title: "Business Simulation Lab Manager",
    slug: "adam-chafee",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gary S.",
    lastName: "Chaika",
    title: "Database Administrator",
    slug: "gary-s-chaika",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Priyanka",
    lastName: "Chakravarty",
    title: "Assistant Director, PORTENT Center",
    slug: "priyanka-chakravarty",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carrie",
    lastName: "Chalmers",
    title: "Web and Visual Strategy Manager",
    slug: "carrie-chalmers",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bryan",
    lastName: "Chambala",
    title: "Communication Lead - OVP & PFP",
    slug: "bryan-chambala",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Everett Wilcox",
    lastName: "Chambala",
    title:
      " Seasonal Admin Asst - Graduate Legal Studies, Student Athletic Serv Asst I",
    slug: "everett-wilcox-chambala",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Margit",
    lastName: "Chamberlain-Czebiniak",
    title: "Executive Administrative Coordinator",
    slug: "margit-chamberlain-czebiniak",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kayla Marie",
    lastName: "Chamberlain-Hoffman",
    title: "ILR Events Manager",
    slug: "kayla-marie-chamberlain-hoffman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John James",
    lastName: "Chambers",
    title: "Regent Lounge Manager",
    slug: "john-james-chambers",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ethan",
    lastName: "Chan",
    title: "Visiting Critic",
    slug: "ethan-chan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kelly",
    lastName: "Chan",
    title: "Instructional Technology Specialist",
    slug: "kelly-chan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gladys Y.",
    lastName: "Chan",
    title: "Finance Specialist III",
    slug: "gladys-y-chan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Zachary",
    lastName: "Chan",
    title: "BSP Study Group Leader",
    slug: "zachary-chan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Adam L.",
    lastName: "Chandler",
    title: "Director, LTS Automation, Assessment, and Post-Cataloging",
    slug: "adam-l-chandler",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brendan W.",
    lastName: "Chandler",
    title: "Biosafety Specialist I",
    slug: "brendan-w-chandler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan",
    lastName: "Chandler",
    title: "Assistant Registrar for Graduate Programs",
    slug: "susan-chandler",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sean",
    lastName: "Chang",
    title: "Reference Assistant",
    slug: "sean-chang",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alex A.",
    lastName: "Chang",
    title: "Communication Mgr I",
    slug: "alex-a-chang",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nina Trautmann",
    lastName: "Chaopricha",
    title: "Manager, Global Hubs Initiative",
    slug: "nina-trautmann-chaopricha",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patrick Trautmann",
    lastName: "Chaopricha",
    title: "Applications Developer III",
    slug: "patrick-trautmann-chaopricha",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tracy L",
    lastName: "Chapman",
    title: "Assistant Director for Finance and Budget",
    slug: "tracy-l-chapman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Linda",
    lastName: "Charles",
    title: "SSC Financial Management & Reporting Director",
    slug: "linda-charles",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Paul J.",
    lastName: "Charles",
    title: "Technical Services Supervisor II",
    slug: "paul-j-charles",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ellen",
    lastName: "Chase",
    title: "SUCF Capital Planning Manager",
    slug: "ellen-chase",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carlyn",
    lastName: "Chatfield",
    title: "IT Technical Communicator",
    slug: "carlyn-chatfield",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Soubhagya",
    lastName: "Chattopadhyay",
    title: "HR Business Partner",
    slug: "soubhagya-chattopadhyay",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Juan Francisco Saldarriaga",
    lastName: "Chaux",
    title: "Critic Visiting",
    slug: "juan-francisco-saldarriaga-chaux",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brittney L.",
    lastName: "Chavez",
    title: "Custom-Live Associate, Executive Education",
    slug: "brittney-l-chavez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rio",
    lastName: "Chavez",
    title: "AAP- IT solutions Cage Monitor",
    slug: "rio-chavez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Darcy",
    lastName: "Chavez",
    title: "Enrollment Counselor",
    slug: "darcy-chavez",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Vanessa",
    lastName: "Chavez",
    title: "Admissions Officer",
    slug: "vanessa-chavez",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Amy",
    lastName: "Cheatle",
    title: "Instructional Designer",
    slug: "amy-cheatle",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Zara",
    lastName: "Cheek",
    title: "Lifeguard",
    slug: "zara-cheek",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Garry",
    lastName: "Chen",
    title: "Database Administrator",
    slug: "garry-chen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ivy",
    lastName: "Chen",
    title: "Engaged Ambassador (EA), Student Commun Serv Asst II",
    slug: "ivy-chen",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Anne A",
    lastName: "Chen",
    title: "Undergraduate Coordinator & IGCS Program Assistant",
    slug: "anne-a-chen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alan L.",
    lastName: "Chen",
    title: "Pre-Award Specialist",
    slug: "alan-l-chen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Annie",
    lastName: "Cheng",
    title: "Office Manager, WCMC Office",
    slug: "annie-cheng",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Megan",
    lastName: "Cheng",
    title: "CALS -Student Lab Assistant II (Buz Barstow)",
    slug: "megan-cheng",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jess",
    lastName: "Cherry",
    title: "Associate Director, Diversity Alumni Programs",
    slug: "jess-cherry",
    dei: true,
    category: "Miscellaneous",
  },
  {
    firstName: "Sahri",
    lastName: "Chery",
    title: "Assistant Director of Undergraduate Advising",
    slug: "sahri-chery",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Clarence Parkhay",
    lastName: "Cheung",
    title: "House Office Assistant",
    slug: "clarence-parkhay-cheung",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Besines Santana",
    lastName: "Chevalier",
    title:
      " Community Engagement Program Assistant - Center for Transformative Action - URO (Taili Mugambee), Student Admin Asst I",
    slug: "besines-santana-chevalier",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Laura Anca",
    lastName: "Chichisan",
    title: "Design & Marketing Specialist",
    slug: "laura-anca-chichisan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Vincent A.",
    lastName: "Chicone",
    title: "Manufacturing Learning Studio Director",
    slug: "vincent-a-chicone",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa",
    lastName: "Chilson",
    title: "Assistant to the Associate Dean for MBA Programs",
    slug: "lisa-chilson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jocelyne C",
    lastName: "Chin",
    title: "ILR Course Assistant IV (Homrighouse), Student Labor/Facil Asst I",
    slug: "jocelyne-c-chin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jackie",
    lastName: "Chin",
    title: "Intramural Sports Student Supervisor, SASA III - INFO 2310",
    slug: "jackie-chin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Chelsea A",
    lastName: "Chinedo",
    title: "ACC - Fall Creek (Chris Bell)",
    slug: "chelsea-a-chinedo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anita",
    lastName: "Ching-Evans",
    title: "CVM OHR Administrative Assistant",
    slug: "anita-ching-evans",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michelle",
    lastName: "Choi",
    title:
      " Dean's Office Assistant, Student Administrative Assistant, Learning Center Monitor",
    slug: "michelle-choi",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jae",
    lastName: "Choi",
    title: "Bulletin Fall 2024",
    slug: "jae-choi",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Allison Kathryn",
    lastName: "Chorley",
    title: "Community Response Coordinator",
    slug: "allison-kathryn-chorley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Billy",
    lastName: "Chorley",
    title: "Administrative Asst V",
    slug: "billy-chorley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julian M",
    lastName: "Chorney",
    title: "AAP- IT solutions Cage Monitor",
    slug: "julian-m-chorney",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christine M.",
    lastName: "Chouinard",
    title: "Accounts Rep IV",
    slug: "christine-m-chouinard",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Carolyn",
    lastName: "Chow",
    title: "Talent Acquisition Partner",
    slug: "carolyn-chow",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sarah",
    lastName: "Chowdhury",
    title: "Program Administrative Assistant",
    slug: "sarah-chowdhury",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah J.",
    lastName: "Christen",
    title: "Deputy Chief Information Officer",
    slug: "sarah-j-christen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jeff R.",
    lastName: "Christen",
    title: "IT Manager, Data Warehousing and Integrations",
    slug: "jeff-r-christen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Simone Jenifer",
    lastName: "Christian",
    title: "Training Development Specialist",
    slug: "simone-jenifer-christian",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Miranda",
    lastName: "Christiansen",
    title: "Administrative Asst III",
    slug: "miranda-christiansen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Abby",
    lastName: "Christman",
    title: "Assistant Director, Center for Sustainable Global Enterprise",
    slug: "abby-christman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tiffany Ko",
    lastName: "Christopher",
    title: "Director of Development, Discovery",
    slug: "tiffany-ko-christopher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jewelette",
    lastName: "Christopher",
    title: "Major Gift Officer",
    slug: "jewelette-christopher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Whitney",
    lastName: "Christopher",
    title: "Automation Librarian",
    slug: "whitney-christopher",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Miyoko",
    lastName: "Chu",
    title: "Sr Director for Communications",
    slug: "miyoko-chu",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "You Lee",
    lastName: "Chun",
    title: "LTS Ordering Unit Supervisor/Korean Collections Specialist",
    slug: "you-lee-chun",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Seung-Hun",
    lastName: "Chung",
    title: "Research & Policy Development Associate",
    slug: "seung-hun-chung",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Carolina",
    lastName: "Ciampaglia",
    title: "Critic Visiting",
    slug: "carolina-ciampaglia",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David",
    lastName: "Ciarletta",
    title: "Applications Developer III",
    slug: "david-ciarletta",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Israel",
    lastName: "Cidon",
    title: "Director of the Joan & Irwin Jacobs Technion-Cornell Institute",
    slug: "israel-cidon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kristen L.",
    lastName: "Ciferri",
    title: "Assistant Director, SCL Enterprise Summer Programs",
    slug: "kristen-l-ciferri",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Grace",
    lastName: "Cillo",
    title: "Editorial Coordinator",
    slug: "grace-cillo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nicole Lynn",
    lastName: "Cioffi",
    title: "Events Assistant - Literatures in English",
    slug: "nicole-lynn-cioffi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine Elizabeth",
    lastName: "Cioletti",
    title: "Administrative Assistant, Human Centered Design",
    slug: "christine-elizabeth-cioletti",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melanie",
    lastName: "Ciotoli",
    title:
      " Chief of Staff to the VP & Executive Director Organizational Excellence",
    slug: "melanie-ciotoli",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melinda",
    lastName: "Cirri",
    title: "Research Administration Specialist",
    slug: "melinda-cirri",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joel",
    lastName: "Cisne",
    title: "Hotel Systems Manager",
    slug: "joel-cisne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Randall Scott",
    lastName: "Claar",
    title: "Registrar Office Assistant",
    slug: "randall-scott-claar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katie L.",
    lastName: "Clapp",
    title: "Associate Director",
    slug: "katie-l-clapp",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carin",
    lastName: "Clark",
    title: "Executive Staff Assistant",
    slug: "carin-clark",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patty",
    lastName: "Clark",
    title: "Events Manager",
    slug: "patty-clark",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura",
    lastName: "Clark",
    title: "HR Business Partner",
    slug: "laura-clark",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Lisa A.",
    lastName: "Clark",
    title: "Systems Administrator II",
    slug: "lisa-a-clark",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sharon",
    lastName: "Clark",
    title: "Assistant Dean for CALS Human Resources",
    slug: "sharon-clark",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Karen",
    lastName: "Clark",
    title: "Director, Analytics and Enterprise Metrics",
    slug: "karen-clark",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lisa",
    lastName: "Clark",
    title: "Deputy University Registrar",
    slug: "lisa-clark",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Vera Ginell",
    lastName: "Clark",
    title: "Telecommunications Officer",
    slug: "vera-ginell-clark",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Crystal D.",
    lastName: "Clark",
    title: "Finance Specialist II",
    slug: "crystal-d-clark",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jordan Martin",
    lastName: "Clark",
    title: "Associate Director, Volunteer Giving Initiatives",
    slug: "jordan-martin-clark",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle M.",
    lastName: "Clark",
    title: "Building Care Manager",
    slug: "michelle-m-clark",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nora Evanthea",
    lastName: "Clark",
    title: "Executive Education Program Associate",
    slug: "nora-evanthea-clark",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Colleen Patricia",
    lastName: "Clark-Boyer",
    title: "Search and Analytics Specialist",
    slug: "colleen-patricia-clark-boyer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Marin E.",
    lastName: "Clarkberg",
    title: "Associate Vice Provost for Institutional Research and Planning",
    slug: "marin-e-clarkberg",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Virginia Jean",
    lastName: "Clarke",
    title: "Director of Career Services",
    slug: "virginia-jean-clarke",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nicholas S.",
    lastName: "Clarke",
    title: "Material Handler S07",
    slug: "nicholas-s-clarke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jack Alexander",
    lastName: "Clauss",
    title: "(Riccio) Art Studio Monitor",
    slug: "jack-alexander-clauss",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Anne-Marie",
    lastName: "Clavelli",
    title: "Managing Director International Development",
    slug: "anne-marie-clavelli",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria Alejandra Bulla",
    lastName: "Clavijo",
    title: "(Chouman) - AAP Student Academic Service Assistant",
    slug: "maria-alejandra-bulla-clavijo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Adrienne",
    lastName: "Clay",
    title: "Sr. Administrator to the Dean",
    slug: "adrienne-clay",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Beverly Van",
    lastName: "Cleef",
    title: "Community Engagement Officer",
    slug: "beverly-van-cleef",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Shari L.",
    lastName: "Clement",
    title: "Administrative Asst IV",
    slug: "shari-l-clement",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria Claudia",
    lastName: "Clemente",
    title: "Critic Visiting",
    slug: "maria-claudia-clemente",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Vinnie M.",
    lastName: "Clementine",
    title: "Office Coordinator, Student Conduct & Community Standards",
    slug: "vinnie-m-clementine",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Stacy Diane",
    lastName: "Clementson",
    title: "Program Assistant I",
    slug: "stacy-diane-clementson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Antoinette Olivia",
    lastName: "Clemetson",
    title: "Fisheries Specialist",
    slug: "antoinette-olivia-clemetson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Justin B",
    lastName: "Cleveland",
    title: "Corporate Relations Manager",
    slug: "justin-b-cleveland",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christina J.",
    lastName: "Clifford",
    title: "Supervisor, Learning Consultant",
    slug: "christina-j-clifford",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tebbie",
    lastName: "Clift",
    title: "EFNEP Coordinator (Bronx/Manhattan/Staten Island)",
    slug: "tebbie-clift",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dena Jane",
    lastName: "Clink",
    title: "SE Asia Team Leader",
    slug: "dena-jane-clink",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laurie C",
    lastName: "Clink",
    title: "Buying Assistant",
    slug: "laurie-c-clink",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rhonda",
    lastName: "Clouse",
    title: "Senior Administrative Lead",
    slug: "rhonda-clouse",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Elizabeth",
    lastName: "Coakley",
    title: "Greenhouse Grower S05",
    slug: "elizabeth-coakley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sabine",
    lastName: "Coates",
    title: "Editorial Assistant IV",
    slug: "sabine-coates",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Stephen J.",
    lastName: "Cobb",
    title: "Maintenance Planner",
    slug: "stephen-j-cobb",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather",
    lastName: "Cobb",
    title: "Project Administrative Assistant",
    slug: "heather-cobb",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lyndsey Marie",
    lastName: "Cobb-Wilkins",
    title: "Telecommunications Officer",
    slug: "lyndsey-marie-cobb-wilkins",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Victoria R.",
    lastName: "Coe",
    title: "Exec Staff Asst II",
    slug: "victoria-r-coe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren B.",
    lastName: "Coffey",
    title: "Director of Class Programs",
    slug: "lauren-b-coffey",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Bonnie L.",
    lastName: "Coffin",
    title: "Department Finance Specialist",
    slug: "bonnie-l-coffin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Reyna S",
    lastName: "Cohen",
    title: "Research and Policy Development Associate",
    slug: "reyna-s-cohen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Suzanne Amy",
    lastName: "Cohen",
    title:
      " Collection Development Coordinator – Catherwood; Social Sciences Team Lead - CUL",
    slug: "suzanne-amy-cohen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Liat Shira",
    lastName: "Cohen",
    title: "Business Simulation Lab",
    slug: "liat-shira-cohen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Angela",
    lastName: "Coil-Kern",
    title: "Accounts Rep IV",
    slug: "angela-coil-kern",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Scott E.",
    lastName: "Coldren",
    title: "M.Eng. Programs Assistant Director of Student Services",
    slug: "scott-e-coldren",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Curtis Leland",
    lastName: "Cole",
    title: "Vice President and Chief Global Information Officer",
    slug: "curtis-leland-cole",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Abby",
    lastName: "Cole",
    title: "Admissions and Global Study Coordinator",
    slug: "abby-cole",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Virginia A.",
    lastName: "Cole",
    title: "Reference & Digital Services Librarian",
    slug: "virginia-a-cole",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Charmaine M.",
    lastName: "Cole",
    title: "Health Records Representative",
    slug: "charmaine-m-cole",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine Ann",
    lastName: "Cole",
    title: "Lab Processing Assistant III-CRT",
    slug: "katherine-ann-cole",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyra Chanel-Bree",
    lastName: "Coleman",
    title: "Program Assistant, OEEP",
    slug: "kyra-chanel-bree-coleman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nina",
    lastName: "Collavo",
    title: "Graduate Studies & Teaching Coordinator",
    slug: "nina-collavo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eva",
    lastName: "Collier",
    title: "Undergraduate Coordinator",
    slug: "eva-collier",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kathryn B",
    lastName: "Collier",
    title: "Enrollment Counselor",
    slug: "kathryn-b-collier",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jason D",
    lastName: "Collins",
    title: "Energy Project Coordinator",
    slug: "jason-d-collins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caitlin B.",
    lastName: "Collins",
    title: "Director of Alumni Engagement, College of Human Ecology",
    slug: "caitlin-b-collins",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rebecca L.",
    lastName: "Collins",
    title: "Sponsored Finance Assistant",
    slug: "rebecca-l-collins",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Meredith",
    lastName: "Collins",
    title: "Carl Becker House Administrative Coordinator",
    slug: "meredith-collins",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Grace Eleanor",
    lastName: "Collins",
    title: "Email Marketing Specialist",
    slug: "grace-eleanor-collins",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Amy Colleen",
    lastName: "Collins",
    title: "Section Head's Assistant",
    slug: "amy-colleen-collins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laurie J.",
    lastName: "Collinsworth",
    title: "Principal Solutions Architect",
    slug: "laurie-j-collinsworth",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Liz",
    lastName: "Colodny",
    title: "Senior Associate Director, EMBA Career Services",
    slug: "liz-colodny",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mary",
    lastName: "Colomaio",
    title: "GIS and Data Administrator",
    slug: "mary-colomaio",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Denise Smith",
    lastName: "Colon",
    title: "Human Resources Asst V",
    slug: "denise-smith-colon",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jenn",
    lastName: "Colt",
    title: "Head, Automation and Metadata Systems",
    slug: "jenn-colt",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rachel",
    lastName: "Colunio",
    title: "HR Business Partner",
    slug: "rachel-colunio",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michael C.",
    lastName: "Colunio",
    title: "Systems Administrator III",
    slug: "michael-c-colunio",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alexander James",
    lastName: "Colvin",
    title:
      " Kenneth F. Kahn Dean of the School of Industrial and Labor Relations",
    slug: "alexander-james-colvin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Bonnie E.",
    lastName: "Comella",
    title: "Associate Vice Provost for Undergraduate Education",
    slug: "bonnie-e-comella",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Linda M.",
    lastName: "Competillo",
    title: "Admin Asst",
    slug: "linda-m-competillo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deb",
    lastName: "Comstock",
    title: "General Accountant",
    slug: "deb-comstock",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jodi Lynn",
    lastName: "Condzella",
    title: "Community Engagement Officer",
    slug: "jodi-lynn-condzella",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rory Elias",
    lastName: "Confino-Pinzon",
    title: "Admissions Ambassador",
    slug: "rory-elias-confino-pinzon",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Arden Knox",
    lastName: "Conine",
    title: "(Riccio) Art Studio Monitor",
    slug: "arden-knox-conine",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jennifer J.",
    lastName: "Coningsby",
    title: "Associate Director,  HR Services and Transitions Center",
    slug: "jennifer-j-coningsby",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Brenda S.",
    lastName: "Conklin",
    title: "Associate Director of Building Care",
    slug: "brenda-s-conklin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dean L.",
    lastName: "Conklin",
    title: "Mason - GFP",
    slug: "dean-l-conklin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Colette C.",
    lastName: "Conklin",
    title: "Assistant to Associate Dean for Academic Affairs - SHA",
    slug: "colette-c-conklin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Holly G.",
    lastName: "Conklin",
    title: "Equipment Tech V",
    slug: "holly-g-conklin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sara Carter",
    lastName: "Conley",
    title: "Multimedia Specialist I",
    slug: "sara-carter-conley",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Laurie",
    lastName: "Conlon",
    title: "Training and Communication Consultant",
    slug: "laurie-conlon",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Martin A.",
    lastName: "Conlon",
    title: "Mech Vehicle S11",
    slug: "martin-a-conlon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katharine Diane Farnam",
    lastName: "Conolly",
    title: "Assistant Director, Integrated Marketing",
    slug: "katharine-diane-farnam-conolly",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Amanda",
    lastName: "Conover",
    title: "Enrollment Support Specialist",
    slug: "amanda-conover",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Michele",
    lastName: "Conrad",
    title: "Undergraduate Student Services Coordinator",
    slug: "michele-conrad",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "JoAnne Marie",
    lastName: "Conrad",
    title: "Finance Specialist III",
    slug: "joanne-marie-conrad",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sandra Smith",
    lastName: "Conrad",
    title: "Reservations, Maintenance and Billing Coordinator",
    slug: "sandra-smith-conrad",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marissa L.",
    lastName: "Consalvi-Little",
    title: "Administrator III",
    slug: "marissa-l-consalvi-little",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Luis",
    lastName: "Constantino",
    title: "Systems Administrator",
    slug: "luis-constantino",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessica",
    lastName: "Conte",
    title: "Major Gift Officer",
    slug: "jessica-conte",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Matt",
    lastName: "Conway",
    title: "Registrar",
    slug: "matt-conway",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Julie",
    lastName: "Conyer",
    title: "Associate Biosafety Officer",
    slug: "julie-conyer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole A",
    lastName: "Cook",
    title: "Director, Marketing Strategy and Donor Participation",
    slug: "nicole-a-cook",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Connie",
    lastName: "Cook",
    title: "Configuration Consultant",
    slug: "connie-cook",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "LaWanda H.",
    lastName: "Cook",
    title: "Senior Training and Technical Assistance Associate",
    slug: "lawanda-h-cook",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Renee Laree",
    lastName: "Cook",
    title: "Assistant Director for Unrestricted Funds",
    slug: "renee-laree-cook",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Aden",
    lastName: "Cook",
    title: "Generalist Counselor Therapist",
    slug: "aden-cook",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tammy S.",
    lastName: "Cook",
    title: "Building Care Manager",
    slug: "tammy-s-cook",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deborah Lynn Sheridan",
    lastName: "Cook",
    title: "Equipment Coordinator",
    slug: "deborah-lynn-sheridan-cook",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Seena",
    lastName: "Cook",
    title: "Health Records Representative",
    slug: "seena-cook",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Catherine A.",
    lastName: "Cooke",
    title: "Technical Services Assistant",
    slug: "catherine-a-cooke",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brenda L.",
    lastName: "Coolbaugh",
    title: "Chemical Hygiene Officer",
    slug: "brenda-l-coolbaugh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristi",
    lastName: "Cooley",
    title: "IT Manager, Administrative Applications",
    slug: "kristi-cooley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shane D",
    lastName: "Cooper",
    title:
      " Senior Associate Dean for Admissions, Financial Aid, and Student Services",
    slug: "shane-d-cooper",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Alyssa R",
    lastName: "Cooper",
    title: "Major Gift Officer",
    slug: "alyssa-r-cooper",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Paige",
    lastName: "Cooper",
    title: "Web Content Manager",
    slug: "paige-cooper",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Linda",
    lastName: "Copman",
    title: "Development Writer & Communications Specialist",
    slug: "linda-copman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jamie Elizabeth",
    lastName: "Corbett",
    title: "Paralegal",
    slug: "jamie-elizabeth-corbett",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Sam H.",
    lastName: "Corbett",
    title: "Systems Administrator",
    slug: "sam-h-corbett",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jeffery D.",
    lastName: "Corbin",
    title: "Senior Grant and Contract Offi",
    slug: "jeffery-d-corbin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Melanie Greaver",
    lastName: "Cordova",
    title: "Director, Communications & Client Relations",
    slug: "melanie-greaver-cordova",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jude T.",
    lastName: "Corina",
    title: "Accessioning Specialist",
    slug: "jude-t-corina",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nataki",
    lastName: "Corneille",
    title: "Director of Diversity Alumni Programs",
    slug: "nataki-corneille",
    dei: true,
    category: "Miscellaneous",
  },
  {
    firstName: "E. Jacob",
    lastName: "Cornelius",
    title: "Instructional Technology Specialist II",
    slug: "e-jacob-cornelius",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jen",
    lastName: "Cornell",
    title: "SSC Travel & Training Director",
    slug: "jen-cornell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christina",
    lastName: "Cornell",
    title: "HR Services and Transitions Counselor",
    slug: "christina-cornell",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kyle E.",
    lastName: "Cornell",
    title: "Field Coordinator",
    slug: "kyle-e-cornell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Orquidea",
    lastName: "Corporan",
    title: "Senior Investment Accountant and Administrator",
    slug: "orquidea-corporan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Roderick J.",
    lastName: "Cort",
    title: "Mgr Finance III",
    slug: "roderick-j-cort",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lori Lynn",
    lastName: "Cortese",
    title: "Seasonal Admissions Readers",
    slug: "lori-lynn-cortese",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Robert",
    lastName: "Cortez-Rodriguez",
    title: "CVM Classroom & Events AV Support Specialist",
    slug: "robert-cortez-rodriguez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Donna Michele",
    lastName: "Corti",
    title: "Hotel Finance Specialist",
    slug: "donna-michele-corti",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Petra Anne",
    lastName: "Cosgrove",
    title: "Associate Director, Benefits Business Analysis",
    slug: "petra-anne-cosgrove",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Josephine",
    lastName: "Cosmosse",
    title: "AAP - Peer Mentor, Student Labor/Facil Asst II",
    slug: "josephine-cosmosse",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Juan Jaimes",
    lastName: "Costilla",
    title: "Associate Dean of Students, Director of Latinx Student Empowerment",
    slug: "juan-jaimes-costilla",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Linda M.",
    lastName: "Cote",
    title: "Sequencing Technologies Manager",
    slug: "linda-m-cote",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tesa Lynn",
    lastName: "Coton",
    title: "Enrollment Counselor, Team Lead",
    slug: "tesa-lynn-coton",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Cheyenne",
    lastName: "Cotton",
    title: "Administrative Assistant III",
    slug: "cheyenne-cotton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aliyah Mari",
    lastName: "Couch",
    title: "Lifeguard",
    slug: "aliyah-mari-couch",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Emily Anne",
    lastName: "Courson",
    title: "Plant Varieties & Research Materials Associate",
    slug: "emily-anne-courson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Megan C.",
    lastName: "Covey",
    title: "Associate Director of Finance and Budget",
    slug: "megan-c-covey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Grant",
    lastName: "Cowan",
    title: "Marketing Analytics and Data Coordinator",
    slug: "grant-cowan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rebecca Clark",
    lastName: "Cowburn",
    title: "Associate Director, Gift Administration",
    slug: "rebecca-clark-cowburn",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "William",
    lastName: "Cowdery",
    title: "Public Svcs Asst IV",
    slug: "william-cowdery",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher James",
    lastName: "Cowen",
    title: "Executive Vice President/Chief Financial Officer",
    slug: "christopher-james-cowen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michele C.",
    lastName: "Cowen",
    title: "Assistant Director - CALS Human Resources",
    slug: "michele-c-cowen",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Steph",
    lastName: "Cowling-Rich",
    title:
      " Assistant Director, EOP/HEOP, OADI, Student Advising and Engagement",
    slug: "steph-cowling-rich",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Chris",
    lastName: "Cowulich",
    title: "Equipment Tech V",
    slug: "chris-cowulich",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Danielle S.",
    lastName: "Cox",
    title: "Program and Administrative Coordinator",
    slug: "danielle-s-cox",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cheryl A.",
    lastName: "Cox",
    title: "Program Manager, Executive Education",
    slug: "cheryl-a-cox",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Linda J.",
    lastName: "Cox",
    title: "Senior Financial Reporting Specialist",
    slug: "linda-j-cox",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michele Marie",
    lastName: "Coyle",
    title: "Purchasing Assistant",
    slug: "michele-marie-coyle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy Haner",
    lastName: "Coyle",
    title: "Administrative Asst IV",
    slug: "amy-haner-coyle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tina",
    lastName: "Coyne",
    title: "Assistant Director, LGBT Resource Center",
    slug: "tina-coyne",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Jason Paul",
    lastName: "Cragle",
    title: "Senior Project Manager",
    slug: "jason-paul-cragle",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Craig",
    lastName: "Cramer",
    title: "Communication Spec III",
    slug: "craig-cramer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Karen S.",
    lastName: "Crane",
    title: "Financial Transaction Representative",
    slug: "karen-s-crane",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Timothy Michael",
    lastName: "Crawford",
    title: "Statler Hotel Controller",
    slug: "timothy-michael-crawford",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Derek",
    lastName: "Crawford",
    title: "ACRefrig Mech/Plumb",
    slug: "derek-crawford",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tia",
    lastName: "Crawford",
    title: "Seasonal Admissions Readers",
    slug: "tia-crawford",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Courtney A.",
    lastName: "Crawford",
    title: "Administrative Asst IV",
    slug: "courtney-a-crawford",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kassy",
    lastName: "Crawford",
    title: "Network and Systems Services Administrator",
    slug: "kassy-crawford",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Erika",
    lastName: "Crawley",
    title: "Assistant Director of Student Conduct and Community Standards",
    slug: "erika-crawley",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Shana",
    lastName: "Creaney",
    title: "Research Administration Specialist",
    slug: "shana-creaney",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Teresa",
    lastName: "Crisantos-Prudencio",
    title: "IDP Facilitator, Student Admin Asst I",
    slug: "teresa-crisantos-prudencio",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kelly",
    lastName: "Crispell",
    title:
      " Executive Assistant to the Dean of the SC Johnson Graduate School of Management",
    slug: "kelly-crispell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shaquana L.",
    lastName: "Crispell",
    title: "Bldg/Facil Coord IV",
    slug: "shaquana-l-crispell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelli Grace",
    lastName: "Crispo",
    title: "Lab Manager",
    slug: "kelli-grace-crispo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eric M.",
    lastName: "Cronise",
    title: "Assistant Director of Enterprise Network Services",
    slug: "eric-m-cronise",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kristen A",
    lastName: "Crosier",
    title:
      " Assistant to the Associate Dean for Cornell SC Johnson College of Business",
    slug: "kristen-a-crosier",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Natalie",
    lastName: "Cross",
    title: "Program & Enrollment Specialist",
    slug: "natalie-cross",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Elle",
    lastName: "Crossman",
    title: "Residence Hall Director",
    slug: "elle-crossman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Michelle Trillium",
    lastName: "Crow",
    title: "Director - ELSO",
    slug: "michelle-trillium-crow",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brianne L.",
    lastName: "Crowley",
    title: "Research Administration Manager",
    slug: "brianne-l-crowley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ann Marie",
    lastName: "Crowley",
    title: "Acquisitions Funds Manager",
    slug: "ann-marie-crowley",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cynthia",
    lastName: "Crowley",
    title: "Applications Developer III",
    slug: "cynthia-crowley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shannon Joell",
    lastName: "Crull",
    title: "Associate, Medical Leaves",
    slug: "shannon-joell-crull",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Milo Joselito P. Dela",
    lastName: "Cruz",
    title: "Accounts Representative IV",
    slug: "milo-joselito-p-dela-cruz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Isabella",
    lastName: "Csemez",
    title: "Career Services Assistant",
    slug: "isabella-csemez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nicole",
    lastName: "Cuaz",
    title: "Administrative Assistant, Dean's Office",
    slug: "nicole-cuaz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Erin Morimoto",
    lastName: "Cucolo",
    title: "Director of Career Development Programs, Break Through Tech",
    slug: "erin-morimoto-cucolo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sid",
    lastName: "Cuff",
    title: "Assistant Director HRIS Integrations and Data Delivery",
    slug: "sid-cuff",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Victor",
    lastName: "Cuicahua",
    title: "Associate Director, Undocumented/DACA",
    slug: "victor-cuicahua",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Steven Thomas",
    lastName: "Cullen",
    title: "CMS Managing Director",
    slug: "steven-thomas-cullen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brendan Andrew",
    lastName: "Cullen",
    title: "Software Developer",
    slug: "brendan-andrew-cullen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessica",
    lastName: "Cullen",
    title: "Administrative Assistant V",
    slug: "jessica-cullen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary-Lynn",
    lastName: "Cummings",
    title: "Director of Capital and Space Planning",
    slug: "mary-lynn-cummings",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael J.",
    lastName: "Cummings",
    title: "Assistant Dean of Admissions",
    slug: "michael-j-cummings",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jennifer",
    lastName: "Cummings",
    title: "Financial Services Associate",
    slug: "jennifer-cummings",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Anna Catherine",
    lastName: "Cummings",
    title: "Assistant Director (Communications Lead)",
    slug: "anna-catherine-cummings",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Erica",
    lastName: "Cummins",
    title: "Assistant Director, Financial Aid Applications Systems",
    slug: "erica-cummins",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kelly Eileen",
    lastName: "Cunningham",
    title: "Special Counsel to the Dean",
    slug: "kelly-eileen-cunningham",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Shallena",
    lastName: "Cunningham",
    title: "Human Resources Consultant",
    slug: "shallena-cunningham",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Pamela Annette",
    lastName: "Cunningham",
    title: "Administrative Asst IV",
    slug: "pamela-annette-cunningham",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eileen M.",
    lastName: "Cunningham",
    title: "Administrative Asst IV",
    slug: "eileen-m-cunningham",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica",
    lastName: "Cunningham",
    title: "Purchasing Agent",
    slug: "jessica-cunningham",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joseph S.",
    lastName: "Curcio",
    title: "Royalty and Contracts Specialist",
    slug: "joseph-s-curcio",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Darius",
    lastName: "Cureton",
    title: "Area Coordinator",
    slug: "darius-cureton",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ryan Steven",
    lastName: "Curran",
    title: "Director, Annual Operating Budget & Consolidations",
    slug: "ryan-steven-curran",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joan",
    lastName: "Curtiss",
    title: "Administrator V",
    slug: "joan-curtiss",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kat",
    lastName: "Curwin",
    title: "Access Services Assistant",
    slug: "kat-curwin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lizzie",
    lastName: "Cushing",
    title: "Senior Registrar Support Coordinator",
    slug: "lizzie-cushing",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah Jane",
    lastName: "Cushman",
    title: "CPEP Reentry Associate",
    slug: "sarah-jane-cushman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tammy J",
    lastName: "Custer",
    title: "Grant and Contract Officer",
    slug: "tammy-j-custer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tiana",
    lastName: "Cute",
    title: "Medical Coding Coordinator",
    slug: "tiana-cute",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Cutri",
    title: "Web Designer",
    slug: "david-cutri",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "David",
    lastName: "Cutter",
    title: "Senior Landscape Architect",
    slug: "david-cutter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meredith",
    lastName: "Czymmek",
    title: "Accounts Rep V",
    slug: "meredith-czymmek",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cassandra Rae",
    lastName: "D'Amato",
    title: "Assistant Director of Undergraduate Advising",
    slug: "cassandra-rae-d-amato",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stephen",
    lastName: "D'Angelo",
    title: "Manager of Research Communications, Biological Systems",
    slug: "stephen-d-angelo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Carrie Margaret",
    lastName: "D'Aprix",
    title: "Communications & Programming Assistant",
    slug: "carrie-margaret-d-aprix",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Leslie",
    lastName: "D'Arcy",
    title: "Assistant to the Assistant Dean for Alumni Affairs & Development",
    slug: "leslie-d-arcy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cassian",
    lastName: "D'Cunha",
    title: "Research IT Director, CCSS",
    slug: "cassian-d-cunha",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael",
    lastName: "d'Estries",
    title: "Associate Director of IT",
    slug: "michael-d-estries",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kait",
    lastName: "Daciek",
    title: "Administrative Coordinator",
    slug: "kait-daciek",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marina",
    lastName: "Dadashev",
    title: "Senior Director of Career Management",
    slug: "marina-dadashev",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Stephen P.",
    lastName: "Daddona",
    title: "Administrative Asst IV",
    slug: "stephen-p-daddona",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dr Kristin",
    lastName: "Dade",
    title: "Director, OADI/Director of Student Success Programs",
    slug: "dr-kristin-dade",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Albert",
    lastName: "Daghita",
    title: "Network Administrator",
    slug: "albert-daghita",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jeff",
    lastName: "Dahlander",
    title: "Bursar Account Services Representative",
    slug: "jeff-dahlander",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brittany",
    lastName: "Daigle",
    title: "Financial Services Associate",
    slug: "brittany-daigle",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Zoe",
    lastName: "Dake",
    title: "Digital Community Manager for Social Media",
    slug: "zoe-dake",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Darren",
    lastName: "Dale",
    title: "Deputy Technical Director",
    slug: "darren-dale",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Savanah Marie",
    lastName: "Dale",
    title: "CALS - AIISP Tutor",
    slug: "savanah-marie-dale",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kent D.",
    lastName: "Dalpan",
    title: "Systems Administrator",
    slug: "kent-d-dalpan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kate Van",
    lastName: "Dalsem",
    title: "Director, West Coast Engagement",
    slug: "kate-van-dalsem",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alycia Marie",
    lastName: "Dalton",
    title: "Sales Manager",
    slug: "alycia-marie-dalton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Allison N.",
    lastName: "Daly",
    title: "Associate Director of Enrollment",
    slug: "allison-n-daly",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Marc E.",
    lastName: "Daly",
    title: "ACRefrig Mech/Plumb",
    slug: "marc-e-daly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tony",
    lastName: "Damiani",
    title: "IT Manager, Analytics and Reporting",
    slug: "tony-damiani",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Laura E.",
    lastName: "Daniels",
    title: "Director, Cataloging & Metadata Services",
    slug: "laura-e-daniels",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tyla",
    lastName: "Daniels",
    title: "Program Manager, Break Through Tech",
    slug: "tyla-daniels",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brenda Jordan",
    lastName: "Daniels-Tibke",
    title: "TCI Administrator",
    slug: "brenda-jordan-daniels-tibke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James J.",
    lastName: "Dannic",
    title: "UAW Peer Counselor",
    slug: "james-j-dannic",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Karen R.",
    lastName: "Darling",
    title: "Configuration Consultant",
    slug: "karen-r-darling",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Vitaliy",
    lastName: "Darovskikh",
    title: "Chief New Media Officer",
    slug: "vitaliy-darovskikh",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Andrew Joseph",
    lastName: "Darrol",
    title: "Financial Services Manager",
    slug: "andrew-joseph-darrol",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Heather",
    lastName: "Darrow",
    title: "Event/Conference Coord II",
    slug: "heather-darrow",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Perdita",
    lastName: "Das",
    title: "House Assistant Dean - Bethe House",
    slug: "perdita-das",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Anasua M.",
    lastName: "Datta",
    title: "Data Modeler",
    slug: "anasua-m-datta",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tracy Darlene",
    lastName: "Davenport",
    title: "Administrative Asst IV",
    slug: "tracy-darlene-davenport",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kate Louise",
    lastName: "Davenport",
    title: "Administrative Asst IV",
    slug: "kate-louise-davenport",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shannon",
    lastName: "David",
    title: "Associate Director, Budget & Planning",
    slug: "shannon-david",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Megan Julie",
    lastName: "David",
    title: "Assistant University Registrar for Information Services",
    slug: "megan-julie-david",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Berta",
    lastName: "Davidson",
    title: "Service Center Lead",
    slug: "berta-davidson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bonna",
    lastName: "Davidson",
    title: "Administrative Asst IV",
    slug: "bonna-davidson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patrick A.",
    lastName: "Davidson",
    title: "Building Care Manager",
    slug: "patrick-a-davidson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristin A.",
    lastName: "Davis",
    title: "Senior Litigation Paralegal",
    slug: "kristin-a-davis",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Trish",
    lastName: "Davis",
    title: "Assistant Director of IT Change Management",
    slug: "trish-davis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Vicki J.",
    lastName: "Davis",
    title: "Administrative Asst V",
    slug: "vicki-j-davis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Donald T.",
    lastName: "Davis",
    title: "Telecommunications Officer",
    slug: "donald-t-davis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kelly",
    lastName: "Davis",
    title: "PMIS Specialist",
    slug: "kelly-davis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Paul",
    lastName: "Davis",
    title: "IT Project Manager IV",
    slug: "paul-davis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kaleigh N.",
    lastName: "Davis",
    title: "Financial Transaction Representative",
    slug: "kaleigh-n-davis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Matthew",
    lastName: "Davis",
    title: "Financial Aid Counselor",
    slug: "matthew-davis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Pamela",
    lastName: "Davis-Acey",
    title: "Senior, Associate Director of Career Management",
    slug: "pamela-davis-acey",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Liz",
    lastName: "Davis-Frost",
    title: "Mediation and Training Associate",
    slug: "liz-davis-frost",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Sarah",
    lastName: "Day",
    title: "Program Manager for Professional Development",
    slug: "sarah-day",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Christine A.",
    lastName: "Day",
    title: "Financial Services Associate",
    slug: "christine-a-day",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Carrie Marie",
    lastName: "Day",
    title: "Accounts Rep IV",
    slug: "carrie-marie-day",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Deanna Lynne",
    lastName: "Day",
    title: "Professional Development and Training Manager",
    slug: "deanna-lynne-day",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Nigel Peter",
    lastName: "Deakin",
    title: "Day Hall Technical Consultant",
    slug: "nigel-peter-deakin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer S.",
    lastName: "Dean",
    title: "AAD Program Director I",
    slug: "jennifer-s-dean",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "James A.",
    lastName: "Dean",
    title: "Senior Staff Writer",
    slug: "james-a-dean",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lisa M.",
    lastName: "Dean",
    title: "Work Planning & Coordination Specialist",
    slug: "lisa-m-dean",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine A.",
    lastName: "Dean",
    title:
      " Assistant to the Plant Pathology & Plant Microbe Biology Program Leader",
    slug: "christine-a-dean",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christina Ann",
    lastName: "Dean",
    title: "Medical Technology Supervisor-Bacteriology",
    slug: "christina-ann-dean",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Danielle Yvette",
    lastName: "Dean-Manzer",
    title: "Program Assistant for Student Activities & Special Events",
    slug: "danielle-yvette-dean-manzer",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Christy Marie",
    lastName: "Dearden",
    title: "Finance Specialist",
    slug: "christy-marie-dearden",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Stacey F.",
    lastName: "Deaton",
    title: "Rotational Team Lead",
    slug: "stacey-f-deaton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Claude Bernard",
    lastName: "Decastro",
    title: "Big Red Barn Graduate and Professional Student Center Manager",
    slug: "claude-bernard-decastro",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Anne",
    lastName: "DeCecco",
    title: "Senior Research and Policy Development Associate",
    slug: "anne-dececco",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Aimee I.",
    lastName: "Decker",
    title: "IT Project Manager",
    slug: "aimee-i-decker",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Daniel R.",
    lastName: "Decker",
    title: "Lead Maintenance Planner",
    slug: "daniel-r-decker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cortney",
    lastName: "Decker",
    title: "Administrative Asst IV",
    slug: "cortney-decker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deidre L.",
    lastName: "Deeley",
    title: "Assistant to the Director of Utilities Production",
    slug: "deidre-l-deeley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Janice G.",
    lastName: "Degni",
    title: "Field Crops Specialist",
    slug: "janice-g-degni",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melisa",
    lastName: "DeGroot",
    title: "Grants and Communications Manager",
    slug: "melisa-degroot",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Dave",
    lastName: "DeHaan",
    title:
      " Associate Director of Custom Development & Accessibility Compliance",
    slug: "dave-dehaan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gerald T.",
    lastName: "Deis",
    title: "Digital Communications Specialist",
    slug: "gerald-t-deis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Peter",
    lastName: "DelaCuadra",
    title: "Batch Processing & Database Management Specialist",
    slug: "peter-delacuadra",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Aaron",
    lastName: "Delahanty",
    title: "Technology Acceleration and Venture Manager",
    slug: "aaron-delahanty",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Amanda",
    lastName: "DeLee",
    title: "Program Assistant, Alumni Affairs and Devleopment ILR",
    slug: "amanda-delee",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Johanna",
    lastName: "Delgado",
    title: "Senior Administrative Assistant for the Associate Dean for Impact",
    slug: "johanna-delgado",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sandra J.",
    lastName: "Delibero",
    title: "Telephone Receptionist",
    slug: "sandra-j-delibero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily A",
    lastName: "DeLima",
    title:
      " Ithaca Murals Program Assistant - Center for Transformative Action (Caleb Thomas)",
    slug: "emily-a-delima",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anthony",
    lastName: "Dellinger",
    title: "BI Systems Administrator",
    slug: "anthony-dellinger",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rhonda",
    lastName: "Dellinger",
    title: "Registrar Coordinator",
    slug: "rhonda-dellinger",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Anne M.",
    lastName: "DeLong",
    title: "Building Care Manager",
    slug: "anne-m-delong",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristine M.",
    lastName: "DeLuca",
    title: "Director, Cornell Committment Office",
    slug: "kristine-m-deluca",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rodney",
    lastName: "Delyser",
    title: "Organic & Scouting Coordinator",
    slug: "rodney-delyser",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mark",
    lastName: "Dembo",
    title: "Area Director, Enterprise Programs",
    slug: "mark-dembo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Carla",
    lastName: "DeMello",
    title: "Graphic Designer",
    slug: "carla-demello",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Megan",
    lastName: "DeMint",
    title: "New Media Manager",
    slug: "megan-demint",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jilene",
    lastName: "DeMont",
    title: "Audit Manager",
    slug: "jilene-demont",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lydia Mitchell",
    lastName: "Dempsey",
    title: "Project Administrative Assistant",
    slug: "lydia-mitchell-dempsey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thomas S",
    lastName: "Demtsu",
    title: "IT Assistant",
    slug: "thomas-s-demtsu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tracey M.",
    lastName: "DeNardo",
    title: "Head Pharmacist",
    slug: "tracey-m-denardo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Claire Whitney",
    lastName: "Deng",
    title: "Collections Survey Assistant",
    slug: "claire-whitney-deng",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Terri L.",
    lastName: "Denman",
    title: "Finance Specialist III",
    slug: "terri-l-denman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Torrey Kinsley",
    lastName: "Dennis",
    title: "Executive Director of Academic Administration",
    slug: "torrey-kinsley-dennis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lori",
    lastName: "Dennis",
    title: "Financial Services Associate",
    slug: "lori-dennis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sandra A.",
    lastName: "Dennis-Conlon",
    title: "Manager of Finance, Budget and Research Compliance",
    slug: "sandra-a-dennis-conlon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ethan J.",
    lastName: "Dennison",
    title: "Sheet Metal Worker - GFP",
    slug: "ethan-j-dennison",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marti",
    lastName: "Dense",
    title: "Program Administrator",
    slug: "marti-dense",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Grace Corinne",
    lastName: "DePaull",
    title: "Communications Assistant",
    slug: "grace-corinne-depaull",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mark K.",
    lastName: "Depew",
    title: "Major Gifts Officer",
    slug: "mark-k-depew",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Stephanie",
    lastName: "Deppe",
    title: "Communication Spec III",
    slug: "stephanie-deppe",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Andrew Lee",
    lastName: "Deppen",
    title: "Production Manager",
    slug: "andrew-lee-deppen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyriakos N.",
    lastName: "Deriziotis",
    title: "Business Outreach Director",
    slug: "kyriakos-n-deriziotis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Aimee",
    lastName: "Deriziotis",
    title: "Academic HR Generalist",
    slug: "aimee-deriziotis",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Garth A.",
    lastName: "Desnoes",
    title: "Fire Protection Specialist",
    slug: "garth-a-desnoes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Savan C.",
    lastName: "DeSouza",
    title: "Multimedia Specialist",
    slug: "savan-c-desouza",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Stamie Vasiliki",
    lastName: "Despo",
    title: "Executive Director of Leadership Annual Giving",
    slug: "stamie-vasiliki-despo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Aris Dean",
    lastName: "Despo",
    title: "Technology Licensing Professional III",
    slug: "aris-dean-despo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Grace",
    lastName: "DeStefano",
    title: "Athletic Trainer",
    slug: "grace-destefano",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Emily Faye",
    lastName: "Detrick",
    title:
      " Elizabeth Weaver Director of Horticulture of Cornell Botanic Gardens",
    slug: "emily-faye-detrick",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sharon L.",
    lastName: "Detzer",
    title: "AAD Program Director II",
    slug: "sharon-l-detzer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Aharnish",
    lastName: "Dev",
    title:
      " Distance Learning Programs Co-Coordinator - Center for Transformative Action's Prisoner's Express (Gary Fine)",
    slug: "aharnish-dev",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sara Manli",
    lastName: "Devault-Feldman",
    title: "Project Associate for Entrepreneurship Programs",
    slug: "sara-manli-devault-feldman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marc Jeffrey",
    lastName: "Devokaitis",
    title: "Editor II",
    slug: "marc-jeffrey-devokaitis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brenda J.",
    lastName: "DeWitt",
    title: "Administrative Asst III",
    slug: "brenda-j-dewitt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shilpika",
    lastName: "Dhakal",
    title: "Senior Auditor",
    slug: "shilpika-dhakal",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Maina",
    lastName: "Dhital",
    title: "Corporate Relations Coordinator",
    slug: "maina-dhital",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nishi",
    lastName: "Dhupa",
    title:
      " Associate Vice Provost and Executive Director of the Einaudi Center",
    slug: "nishi-dhupa",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rhett",
    lastName: "Dial",
    title: "Major Gift Associate",
    slug: "rhett-dial",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth A",
    lastName: "Diamanduros",
    title: "Enrollment Representative, Casual",
    slug: "elizabeth-a-diamanduros",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Eirva",
    lastName: "Diamessis",
    title: "Senior Manuscript Processor",
    slug: "eirva-diamessis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aviva Elyse",
    lastName: "Diamond",
    title: "Seasonal Admissions Readers",
    slug: "aviva-elyse-diamond",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Nathan",
    lastName: "DiAngelo",
    title: "Maintenance Assistant",
    slug: "nathan-diangelo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brooke",
    lastName: "Dias",
    title: "Executive in Residence",
    slug: "brooke-dias",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Betsy Janice",
    lastName: "Diaz",
    title:
      " Outreach and Communication Assistant - Groundswell (Juliana Quaresma)",
    slug: "betsy-janice-diaz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Liz",
    lastName: "Diaz",
    title: "Senior Research Development Specialist/Limited Submissions Manager",
    slug: "liz-diaz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tammy S",
    lastName: "Dibble",
    title: "Director of HR, Office of the EVP and CFO",
    slug: "tammy-s-dibble",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jamie A.",
    lastName: "Dibble",
    title: "Administrative Asst. IV",
    slug: "jamie-a-dibble",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anthony",
    lastName: "Dicembre",
    title: "Deputy Director, Admissions Strategy & Optimization",
    slug: "anthony-dicembre",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Karima",
    lastName: "Dickerson",
    title: "Enrollment Counselor, Team Lead",
    slug: "karima-dickerson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Andrew",
    lastName: "Dickson",
    title: "Kuali Java Developer",
    slug: "andrew-dickson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Laura",
    lastName: "Diedrickson",
    title: "Administrative Asst IV",
    slug: "laura-diedrickson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jolene",
    lastName: "Dieffenbach",
    title: "Executive Support & Communication Assistant",
    slug: "jolene-dieffenbach",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Vincent Mark",
    lastName: "Dieffenbaugher",
    title: "Grant Coordinator",
    slug: "vincent-mark-dieffenbaugher",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Camila Fuhr",
    lastName: "Diel",
    title: "Office Manager",
    slug: "camila-fuhr-diel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrea L.",
    lastName: "Dietrich",
    title: "Accessible Media Specialist",
    slug: "andrea-l-dietrich",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dianne",
    lastName: "Dietrich",
    title: "Digital Assets Librarian",
    slug: "dianne-dietrich",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elizabeth M.",
    lastName: "DiGiovine",
    title: "Research & Evidence Synthesis Librarian",
    slug: "elizabeth-m-digiovine",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michelle Ann",
    lastName: "Dilbeck",
    title: "Equipment Tech III",
    slug: "michelle-ann-dilbeck",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rebecca",
    lastName: "Dillon",
    title: "Program Manager for Research initiatives",
    slug: "rebecca-dillon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kerry A",
    lastName: "Dillon",
    title: "Plant Records Specialist",
    slug: "kerry-a-dillon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thomas F.",
    lastName: "Dillon",
    title: "Technical Support Professional",
    slug: "thomas-f-dillon",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Francis J.",
    lastName: "DiMarco",
    title: "DJ",
    slug: "francis-j-dimarco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ilana C",
    lastName: "Dimbleby",
    title:
      " Director, Alumni Engagement Initiatives and College and Unit Partnerships",
    slug: "ilana-c-dimbleby",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jessie",
    lastName: "Dimick",
    title: "Manager of E&PM Administration",
    slug: "jessie-dimick",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katerina",
    lastName: "Dimitriadou-Shuster",
    title: "Director of Archival Technical Services",
    slug: "katerina-dimitriadou-shuster",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kamela",
    lastName: "Dino",
    title: "Assistant Director of Admissions",
    slug: "kamela-dino",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Robert P.",
    lastName: "DiPalma",
    title: "Senior Auditor",
    slug: "robert-p-dipalma",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Darren",
    lastName: "Dippolito",
    title: "Sr. Desktop Support Specialist",
    slug: "darren-dippolito",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jillian Nichol",
    lastName: "Ditner",
    title: "Graphic Designer III",
    slug: "jillian-nichol-ditner",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Dhanashree P.",
    lastName: "Dixit",
    title: "Inside Director, Small and Medium Business",
    slug: "dhanashree-p-dixit",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bethany",
    lastName: "Dixon",
    title: "Academic HR Business Partner",
    slug: "bethany-dixon",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rebecca Haskell",
    lastName: "Dlubac",
    title: "Credit Evaluation Coordinator",
    slug: "rebecca-haskell-dlubac",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Michael Patrick",
    lastName: "Doan",
    title: "Assistant Director of Nursing",
    slug: "michael-patrick-doan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Megan",
    lastName: "Dobbin",
    title: "Shared Services Center (SSC) Liaison",
    slug: "megan-dobbin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John",
    lastName: "Dobbins",
    title: "Research Supp Spec IV",
    slug: "john-dobbins",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joshua",
    lastName: "Dobrinsky",
    title: "Administrative Assistant",
    slug: "joshua-dobrinsky",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Graham",
    lastName: "Dobson",
    title: "Info Tech Area Mgr II",
    slug: "graham-dobson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Leah",
    lastName: "Dodd",
    title: "Director of Olin and Uris Libraries",
    slug: "leah-dodd",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anthony",
    lastName: "Dodd",
    title: "Administrative Assistant",
    slug: "anthony-dodd",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jackie J.",
    lastName: "Dodge",
    title: "Finance Specialist II",
    slug: "jackie-j-dodge",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Suzanna",
    lastName: "Dodge",
    title: "Finance Specialist III",
    slug: "suzanna-dodge",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Chelsea",
    lastName: "Dodge",
    title: "Financial Transaction Representative",
    slug: "chelsea-dodge",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Esref",
    lastName: "Dogan",
    title: "Lab Processing Supervisor",
    slug: "esref-dogan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine",
    lastName: "Doktorich",
    title: "Assistant Director, Disability Access Consultant",
    slug: "katherine-doktorich",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Michael Patrick",
    lastName: "Doll",
    title: "Research Administration Assistant",
    slug: "michael-patrick-doll",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alison",
    lastName: "Dollaway",
    title: "Lab Manager",
    slug: "alison-dollaway",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robin S.",
    lastName: "Dollaway",
    title: "Associate Director, Industry Team",
    slug: "robin-s-dollaway",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cátia Pinas",
    lastName: "Dombaxe",
    title: "Grad School Student Admin Asst IV",
    slug: "c-tia-pinas-dombaxe",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tanya",
    lastName: "Dombrovskyy",
    title: "Sponsored Finance Specialist",
    slug: "tanya-dombrovskyy",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kelley J.",
    lastName: "Donaghy",
    title: "Scientific Writer/Editor",
    slug: "kelley-j-donaghy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Dan",
    lastName: "Donahue",
    title: "Fruit Specialist",
    slug: "dan-donahue",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Crystal L.",
    lastName: "Doner",
    title: "Director of Finance and Administration",
    slug: "crystal-l-doner",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Susan H.",
    lastName: "Doney",
    title: "Associate Director of Stewards",
    slug: "susan-h-doney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sonam Topgyal",
    lastName: "Dongtoe",
    title: "Public Services Assistant",
    slug: "sonam-topgyal-dongtoe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sean Edward William",
    lastName: "Donlon",
    title: "Scientific Glassblower",
    slug: "sean-edward-william-donlon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chris Victor",
    lastName: "Donnay",
    title: "Lab Manager",
    slug: "chris-victor-donnay",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Barb",
    lastName: "Donnell",
    title: "Graduate Field Coordinator",
    slug: "barb-donnell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kelly",
    lastName: "Donnelly",
    title: "Administrative Asst III",
    slug: "kelly-donnelly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meghan",
    lastName: "Donnelly",
    title: "PMDS Grants & Contract Coordinator",
    slug: "meghan-donnelly",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marie Kristen",
    lastName: "Donnelly",
    title: "Business Development & Licensing Associate - Life Sciences",
    slug: "marie-kristen-donnelly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christiana Marie",
    lastName: "Donofry",
    title: "Casual Online Learning Technical Student Support",
    slug: "christiana-marie-donofry",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Danielle",
    lastName: "Donovan",
    title: "Union Days Event Planner",
    slug: "danielle-donovan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Zac",
    lastName: "Doob",
    title: "Director of Digital Experience",
    slug: "zac-doob",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tracy R",
    lastName: "Doran",
    title: "EHS Administrative Assistant",
    slug: "tracy-r-doran",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jim",
    lastName: "Doran",
    title: "Tech Svcs Supv II",
    slug: "jim-doran",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Isaac William",
    lastName: "Dorio",
    title: "IDP Facilitator",
    slug: "isaac-william-dorio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ed",
    lastName: "Dormady",
    title: "Senior Technical Specialist",
    slug: "ed-dormady",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Valerie Cross",
    lastName: "Dorn",
    title: "Senior Associate General Counsel",
    slug: "valerie-cross-dorn",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Corrine",
    lastName: "Doron",
    title: "Director of Micro-internships, Break Through Tech",
    slug: "corrine-doron",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Laurie L.",
    lastName: "Dorsey",
    title: "Accounts Administrator",
    slug: "laurie-l-dorsey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shannon",
    lastName: "Dortch",
    title: "Cornell Botanic Gardens Director of Communications & Marketing",
    slug: "shannon-dortch",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jamie J.",
    lastName: "Doss",
    title: "Talent Acquisition Partner",
    slug: "jamie-j-doss",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kevin",
    lastName: "Dossinger",
    title: "AAP IT Cage Coordinator",
    slug: "kevin-dossinger",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Denisha Acacia",
    lastName: "Douglas",
    title: "Dossinger - (AAP) IT Solutions Cage Monitor",
    slug: "denisha-acacia-douglas",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stephan M.",
    lastName: "Douglas-Allen",
    title: "Admissions Officer",
    slug: "stephan-m-douglas-allen",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Anitra M.",
    lastName: "Douglas-McCarthy",
    title: "Assistant Dean for Access and Recruitment",
    slug: "anitra-m-douglas-mccarthy",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Bambi",
    lastName: "Douma",
    title: "Program Facilitation Manager, STEM Programs",
    slug: "bambi-douma",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christina J.",
    lastName: "Dovi",
    title: "Director of Finance & Budget",
    slug: "christina-j-dovi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kelly Ann",
    lastName: "Dowd",
    title: "Stewardship Officer, Individual Stewardship",
    slug: "kelly-ann-dowd",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cindy",
    lastName: "Dowdall",
    title: "Accounting Transaction Specialist",
    slug: "cindy-dowdall",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lynn A.",
    lastName: "Dowling",
    title: "Major Gift Associate",
    slug: "lynn-a-dowling",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Katharine Morgan",
    lastName: "Downey",
    title: "Marketing Communications Coordinator",
    slug: "katharine-morgan-downey",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Angela L.",
    lastName: "Downing",
    title: "Public and Ecosystem Health Department Manager",
    slug: "angela-l-downing",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Garrett Michael",
    lastName: "Downing",
    title: "Undergraduate Coordinator",
    slug: "garrett-michael-downing",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katherine A.",
    lastName: "Doxey",
    title: "Executive Director, Human Resources",
    slug: "katherine-a-doxey",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Alexandria Louise",
    lastName: "Doxtater",
    title: "Advancement Services Records Specialist",
    slug: "alexandria-louise-doxtater",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mariah",
    lastName: "Doyle-Stephenson",
    title: "Administrative Asst IV",
    slug: "mariah-doyle-stephenson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Summer",
    lastName: "Dracup",
    title: "Program Assistant I",
    slug: "summer-dracup",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca Anne",
    lastName: "Drake",
    title: "Sr Telecommunications Coord",
    slug: "rebecca-anne-drake",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nina",
    lastName: "Drake",
    title: "Equity and Disability Specialist",
    slug: "nina-drake",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Mariah Crawford",
    lastName: "Drake",
    title: "Bursar Account Services Representative",
    slug: "mariah-crawford-drake",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ethan Wolf",
    lastName: "Drake",
    title: "(SCL-Route Setter) Student Athletic Serv Asst III",
    slug: "ethan-wolf-drake",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Bintou Majula",
    lastName: "Drammeh",
    title: "Becker House Office Assistant",
    slug: "bintou-majula-drammeh",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sabine Eva-Catherine Paz-Le",
    lastName: "Draoulec",
    title: "CALS - Research/Lab Assistant (Jennifer S Thaler)",
    slug: "sabine-eva-catherine-paz-le-draoulec",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alyssa Ann",
    lastName: "Dray",
    title: "Administrative Asst IV",
    slug: "alyssa-ann-dray",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marie-Anne de Rosier",
    lastName: "Dreher",
    title: "Principal Gifts Officer",
    slug: "marie-anne-de-rosier-dreher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James Douglas",
    lastName: "Dresslaer",
    title: "Entrepreneur in Residence",
    slug: "james-douglas-dresslaer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Benjamin James",
    lastName: "Drew",
    title: "Career Services Coordinator",
    slug: "benjamin-james-drew",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Vasilis",
    lastName: "Drimalitis",
    title: "Gift Associate, Cornell Tech",
    slug: "vasilis-drimalitis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diana",
    lastName: "Drogaris",
    title: "Outreach Coordinator",
    slug: "diana-drogaris",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Colleen Crawford",
    lastName: "Drozd",
    title: "Assistant Director, Volunteer Giving",
    slug: "colleen-crawford-drozd",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Liam",
    lastName: "Du",
    title: "Program Assistant - CTA - NAFSAN (Kim Hines)",
    slug: "liam-du",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tina",
    lastName: "DuBois",
    title: "Exhibition and Events Coordinator",
    slug: "tina-dubois",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Zach",
    lastName: "DuBord",
    title: "Equity and Title IX Investigator",
    slug: "zach-dubord",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Sue",
    lastName: "DuBrava",
    title: "Admissions and Application Coordinator, EMBA Americas",
    slug: "sue-dubrava",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Marc",
    lastName: "Ducharme",
    title: "Communications Coordinator",
    slug: "marc-ducharme",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "April",
    lastName: "Duckworth",
    title: "Enrollment Counselor Specialist",
    slug: "april-duckworth",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Olivia",
    lastName: "Duell",
    title: "Einhorn Center Administrative Assistant",
    slug: "olivia-duell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michelle",
    lastName: "Duguid",
    title:
      " Associate Dean of Diversity, Inclusion and Belonging, Associate Professor of Management and Organizations, Temp Serv Prof Exempt",
    slug: "michelle-duguid",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Joanne A.",
    lastName: "Dunai",
    title: "Program Assistant",
    slug: "joanne-a-dunai",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erica",
    lastName: "Dunayer",
    title: "Compliance Specialist, IACUC",
    slug: "erica-dunayer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cody Rhys",
    lastName: "Duncan",
    title: "Assistant Director, Health Professions Advising",
    slug: "cody-rhys-duncan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jeremy",
    lastName: "Duncan",
    title: "Full Stack Applications Developer",
    slug: "jeremy-duncan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chris",
    lastName: "Dunham",
    title: "Access Services and Administrative Manager",
    slug: "chris-dunham",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Keith",
    lastName: "Dunham",
    title: "Mech Vehicle S09",
    slug: "keith-dunham",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tammy",
    lastName: "Dunlop",
    title: "HR Services and Transitions Counselor",
    slug: "tammy-dunlop",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Brian D.",
    lastName: "Dunn",
    title: "Director, Institute for Compensation Studies Professional Programs",
    slug: "brian-d-dunn",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Shane M.",
    lastName: "Dunn",
    title: "Roof Program Manager",
    slug: "shane-m-dunn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Geoffrey A",
    lastName: "Dunn",
    title: "Announcer",
    slug: "geoffrey-a-dunn",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kimberly Marie",
    lastName: "Dunst",
    title: "Event and Space Use Coordinator",
    slug: "kimberly-marie-dunst",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Emily",
    lastName: "Dunuwila",
    title: "Health Initiatives Coordinator",
    slug: "emily-dunuwila",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Camille Grace",
    lastName: "Dupuis",
    title: "Collections and Public Services Assistant",
    slug: "camille-grace-dupuis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebeccah Jolina",
    lastName: "Durandis",
    title:
      " Student Program Assistant, Diversity Alumni Programs, Special Events",
    slug: "rebeccah-jolina-durandis",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Mouse",
    lastName: "Durgin",
    title: "Assistant for Student Services",
    slug: "mouse-durgin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Heidi Lyn",
    lastName: "Duss",
    title: "Sr. Manager, Program Delivery",
    slug: "heidi-lyn-duss",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tova S.",
    lastName: "Dutcher",
    title: "Finance & Procurement Specialist",
    slug: "tova-s-dutcher",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Bradley James",
    lastName: "Dutcher",
    title: "Building Care Manager",
    slug: "bradley-james-dutcher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melody M.",
    lastName: "Dutton",
    title: "Financial Transaction Representative",
    slug: "melody-m-dutton",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Bethany",
    lastName: "Dvorak",
    title: "Budget and Finance Manager",
    slug: "bethany-dvorak",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Hilarie",
    lastName: "Dyer",
    title: "Communications Administrative Assistant",
    slug: "hilarie-dyer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sarah",
    lastName: "Dykes",
    title: "Sponsored Finance Specialist",
    slug: "sarah-dykes",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Emily Claire",
    lastName: "Dyner",
    title: "Lifeguard",
    slug: "emily-claire-dyner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Philip",
    lastName: "Dzwonczyk",
    title: "Director of Financial Planning & Analysis",
    slug: "philip-dzwonczyk",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elizabeth",
    lastName: "Eagen",
    title: "Project Manager",
    slug: "elizabeth-eagen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John",
    lastName: "Eagle",
    title: "Studio Manager, CEMC",
    slug: "john-eagle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julie Eskay",
    lastName: "Eagle",
    title: "Entrepreneur in Residence",
    slug: "julie-eskay-eagle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alyssa",
    lastName: "Eanniello",
    title: "Payroll Assistant",
    slug: "alyssa-eanniello",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Brittanie",
    lastName: "Earle",
    title: "Community Response Team Supervisor",
    slug: "brittanie-earle",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Evan Fay",
    lastName: "Earle",
    title: "Peter J. Thaler University Archivist",
    slug: "evan-fay-earle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aelita",
    lastName: "Early",
    title: "Assistant Director of Visitor Relations",
    slug: "aelita-early",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Marcia A",
    lastName: "Easley",
    title: "Assistant Dean for Human Resources-College of Human Ecology",
    slug: "marcia-a-easley",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michelle R.",
    lastName: "Eastman",
    title: "Executive Assistant to the University Librarian",
    slug: "michelle-r-eastman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deanna",
    lastName: "Eastwood",
    title: "Finance Specialist",
    slug: "deanna-eastwood",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kevin Michael",
    lastName: "Ebert",
    title: "Merlin Project Coordinator",
    slug: "kevin-michael-ebert",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sandy",
    lastName: "Eccleston",
    title: "Manager of IT Financial Services",
    slug: "sandy-eccleston",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sarah J",
    lastName: "Eck",
    title: "Billing Coordinator",
    slug: "sarah-j-eck",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Benjamin",
    lastName: "Eck",
    title: "User Interface/Exp Spec II",
    slug: "benjamin-eck",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Josh",
    lastName: "Eckenrode",
    title: "Administrative Supervisor",
    slug: "josh-eckenrode",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Mandy",
    lastName: "Economos",
    title: "Administrative Asst III",
    slug: "mandy-economos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Terry L.",
    lastName: "Ector",
    title: "Accounting Transaction Specialist, Student Organizations",
    slug: "terry-l-ector",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sara",
    lastName: "Eddleman",
    title: "Associate Dean of Administration",
    slug: "sara-eddleman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Molly",
    lastName: "Eder",
    title: "Administrative Assistant for the Tatkon Center for New Students",
    slug: "molly-eder",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jessica",
    lastName: "Edmister",
    title: "Strategic Communications Manager",
    slug: "jessica-edmister",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elizabeth A.",
    lastName: "Edmondson",
    title: "Manager of Student Grants and Programs",
    slug: "elizabeth-a-edmondson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Julie",
    lastName: "Edwards",
    title: "Assistant Vice President for Student Health and Wellbeing",
    slug: "julie-edwards",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jessica",
    lastName: "Edwards",
    title: "Executive Assistant to the Dean of Students",
    slug: "jessica-edwards",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Stacey A.",
    lastName: "Edwards",
    title: "Utilities Reliability and Energy Transition Program Manager",
    slug: "stacey-a-edwards",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric J.",
    lastName: "Edwards",
    title: "Controls Systems Manager",
    slug: "eric-j-edwards",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Evan",
    lastName: "Edwards",
    title: "Associate Director/Coordinator for Yield Programs",
    slug: "evan-edwards",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Annette",
    lastName: "Edwards",
    title: "Program Assistant",
    slug: "annette-edwards",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sara R.",
    lastName: "Edwards",
    title: "Program Associate Director",
    slug: "sara-r-edwards",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katie",
    lastName: "Ehemann",
    title: "Human Resources Associate",
    slug: "katie-ehemann",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Carina R.",
    lastName: "Ehrensberger",
    title: "PMIS Specialist",
    slug: "carina-r-ehrensberger",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tonya L.",
    lastName: "Eiklor",
    title: "Assistant Director, FCS HR",
    slug: "tonya-l-eiklor",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kristen",
    lastName: "Eiklor",
    title: "Client Resource Team Service Supervisor",
    slug: "kristen-eiklor",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle L.",
    lastName: "Eiseman",
    title: "Health Impacts Partnership + Program Lead",
    slug: "danielle-l-eiseman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria",
    lastName: "Ejlertsen",
    title: "Compliance Specialist, IACUC",
    slug: "maria-ejlertsen",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Gibran A",
    lastName: "el-Sulayman",
    title: "Project Teams and MEng Assistant",
    slug: "gibran-a-el-sulayman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Charles",
    lastName: "Eldermire",
    title: "Multimedia Specialist II",
    slug: "charles-eldermire",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kellie Marie",
    lastName: "Eldred",
    title: "Grant Contract Ofcr I",
    slug: "kellie-marie-eldred",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jason",
    lastName: "Eldridge",
    title: "IT Support Specialist (Level 2)",
    slug: "jason-eldridge",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christine L",
    lastName: "Elfman",
    title: "Critic Visiting",
    slug: "christine-l-elfman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jacqueline Miranda Rangel",
    lastName: "Elizarraraz",
    title: "Becker House Office Assistant",
    slug: "jacqueline-miranda-rangel-elizarraraz",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Anne Kim",
    lastName: "Eller",
    title: "Director's Assistant",
    slug: "anne-kim-eller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca",
    lastName: "Elliott",
    title: "Associate Director, International Alumni Relations",
    slug: "rebecca-elliott",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Margaret Monroe",
    lastName: "Elliott",
    title: "Advising Dean",
    slug: "margaret-monroe-elliott",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Erica Lynn",
    lastName: "Ellis",
    title: "IT Project Manager",
    slug: "erica-lynn-ellis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Clay Edward",
    lastName: "Ellis",
    title: "Director, Enterprise Programs",
    slug: "clay-edward-ellis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shannon Sullivan",
    lastName: "Ellis",
    title: "UNY I-Corps Node Regional Director",
    slug: "shannon-sullivan-ellis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yvonne Marie",
    lastName: "Ellis",
    title: "Administrative Asst IV",
    slug: "yvonne-marie-ellis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyle",
    lastName: "Ellis",
    title: "Material Handler",
    slug: "kyle-ellis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily Yachinich",
    lastName: "Ellison",
    title: "Associate Director, Fitness Programs",
    slug: "emily-yachinich-ellison",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jessica",
    lastName: "Ellott",
    title: "Project Director, Technical Assistance Partnership for Transition",
    slug: "jessica-ellott",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Steven M.",
    lastName: "Elser",
    title: "Equine Park Team Leader",
    slug: "steven-m-elser",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dan",
    lastName: "Elswit",
    title: "Director of Administrative Applications",
    slug: "dan-elswit",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Makela Jannise",
    lastName: "Elvy",
    title: "Community Garden Leadership Specialist",
    slug: "makela-jannise-elvy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peggy L.",
    lastName: "Emerson",
    title: "Bldg/Facil Coord V - CVM",
    slug: "peggy-l-emerson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Janice L.",
    lastName: "Endresen",
    title: "Communications Editor",
    slug: "janice-l-endresen",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tasha",
    lastName: "Engels",
    title: "CROPPS Program Administrator",
    slug: "tasha-engels",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rachel",
    lastName: "England",
    title: "Administrative Asst IV",
    slug: "rachel-england",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael O.",
    lastName: "Engle",
    title: "Reference & Instruction Librarian",
    slug: "michael-o-engle",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Petros",
    lastName: "Englezos",
    title: "Associate Director of Enrollment",
    slug: "petros-englezos",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Wendy Lee",
    lastName: "English",
    title: "Sr. Mgr., Customer Experience & Support Srvc.",
    slug: "wendy-lee-english",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jana",
    lastName: "English",
    title: "Human Resources Generalist",
    slug: "jana-english",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sheri",
    lastName: "Englund",
    title: "Senior Associate Director of Communication",
    slug: "sheri-englund",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tonya",
    lastName: "Engst",
    title: "Digital Content Editor",
    slug: "tonya-engst",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Catalina Lyn",
    lastName: "Enright",
    title: "Administrative Asst III",
    slug: "catalina-lyn-enright",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren Nicole",
    lastName: "Enriquez",
    title: "WEX",
    slug: "lauren-nicole-enriquez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John",
    lastName: "Entrup",
    title: "Applications Administrator",
    slug: "john-entrup",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jim",
    lastName: "Entwood",
    title: "arXiv Head of Content and User Support",
    slug: "jim-entwood",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Megan",
    lastName: "Epler-Wood",
    title: "Program Lead of Sustainable Destination Tourism",
    slug: "megan-epler-wood",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paula L.",
    lastName: "Epps-Cepero",
    title: "Director of Administration",
    slug: "paula-l-epps-cepero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew Joel",
    lastName: "Epstein",
    title: "Executive-in-Residence",
    slug: "andrew-joel-epstein",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alysia",
    lastName: "Ericsson",
    title: "Business Development Specialist",
    slug: "alysia-ericsson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessa",
    lastName: "Eris",
    title: "Course Reserves Systems & Technology Coordinator",
    slug: "jessa-eris",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Catherine Ann",
    lastName: "Ervay",
    title: "Finance Specialist II",
    slug: "catherine-ann-ervay",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Robert D.",
    lastName: "Ervin",
    title: "Senior Manager, Warehouse, Order Fulfillment & Print Services",
    slug: "robert-d-ervin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jose",
    lastName: "Escoto",
    title: "Deputy Director for Finance and Administration",
    slug: "jose-escoto",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brian C.",
    lastName: "Eshenaur",
    title: "Associate Director Program Wide IPM",
    slug: "brian-c-eshenaur",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Reanna",
    lastName: "Esmail",
    title: "Lead Librarian for Instruction Services",
    slug: "reanna-esmail",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah Miller",
    lastName: "Espinosa",
    title: "Senior Mediation & Arbitration Associate",
    slug: "sarah-miller-espinosa",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Kayla M",
    lastName: "Espinoza",
    title: "Bulletin associate",
    slug: "kayla-m-espinoza",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nancianne",
    lastName: "Esposito",
    title: "Associate Director Career Development, CFEM",
    slug: "nancianne-esposito",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mrs Renee Ann Miller-Mizia",
    lastName: "Esq",
    title: "Executive Director of Corporate Relations",
    slug: "mrs-renee-ann-miller-mizia-esq",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elizabeth J.",
    lastName: "Estabrook",
    title: "Director of Administration, Computer Science",
    slug: "elizabeth-j-estabrook",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jodie L.",
    lastName: "Estes",
    title: "Building Care Manager",
    slug: "jodie-l-estes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mel",
    lastName: "Estrella",
    title: "Residence Hall Director",
    slug: "mel-estrella",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Alexis",
    lastName: "Estrella",
    title: "Admissions Specialist, Break Through Tech",
    slug: "alexis-estrella",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Tamar",
    lastName: "Ettun",
    title: "Teiger Mentor in the Arts",
    slug: "tamar-ettun",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shannon Lindsay",
    lastName: "Eustice",
    title: "Marketing & Communications Assistant",
    slug: "shannon-lindsay-eustice",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ross F.",
    lastName: "Evancoe",
    title: "Principal Gifts Officer",
    slug: "ross-f-evancoe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Haley",
    lastName: "Evanoski",
    title: "Chair’s Assistant",
    slug: "haley-evanoski",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicholas Martin",
    lastName: "Evanoski",
    title: "Sr. Pre-Award Specialist",
    slug: "nicholas-martin-evanoski",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah",
    lastName: "Evans",
    title: "Staff Writer and Correspondence Manager",
    slug: "sarah-evans",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ed C.",
    lastName: "Evans",
    title: "University Compliance Associate Director",
    slug: "ed-c-evans",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Susan M",
    lastName: "Evans",
    title: "Associate Project Manager",
    slug: "susan-m-evans",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "William A.",
    lastName: "Evans",
    title: "Testing and Inspection Manager",
    slug: "william-a-evans",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christine Anne",
    lastName: "Evans",
    title: "Assistant Director of Admissions",
    slug: "christine-anne-evans",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kate",
    lastName: "Evans",
    title: "Mental Health Access & Referral Specialist",
    slug: "kate-evans",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth Jane",
    lastName: "Evans",
    title: "Senior Grant Coordinator",
    slug: "elizabeth-jane-evans",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zachary",
    lastName: "Evans",
    title: "eCornell Student Support Agent",
    slug: "zachary-evans",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Gabriella",
    lastName: "Evergreen",
    title: "Research Data Librarian",
    slug: "gabriella-evergreen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brenda",
    lastName: "Everhart",
    title: "Accounting Clerk",
    slug: "brenda-everhart",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mia Renee Rowe",
    lastName: "Everts",
    title: "Quality Milk Production Services Manager",
    slug: "mia-renee-rowe-everts",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alex T",
    lastName: "Ewanow",
    title: "Administrative Assistant III",
    slug: "alex-t-ewanow",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca Lyn Ten",
    lastName: "Eyck",
    title: "Administrator III",
    slug: "rebecca-lyn-ten-eyck",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gayle",
    lastName: "Fagan",
    title: "Associate Director, Research Development",
    slug: "gayle-fagan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Emily Laurel",
    lastName: "Fairweather",
    title: "Billing Coordinator",
    slug: "emily-laurel-fairweather",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Attilio M. De",
    lastName: "Falco",
    title: "Linux Infrastructure Spec.",
    slug: "attilio-m-de-falco",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily",
    lastName: "Falica",
    title: "Administrative Assistant IV",
    slug: "emily-falica",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexis Cefaratti",
    lastName: "Falise",
    title: "Coord Program II",
    slug: "alexis-cefaratti-falise",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew",
    lastName: "Falise",
    title: "Research Supp Spec I",
    slug: "matthew-falise",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicholas",
    lastName: "Fanelli",
    title: "Associate Project Manager",
    slug: "nicholas-fanelli",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mollie",
    lastName: "Fangue",
    title: "Marketing Analytics and Strategy Lead",
    slug: "mollie-fangue",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Marc R.",
    lastName: "Faris",
    title: "Sr. Manager, Custom Instructional Design",
    slug: "marc-r-faris",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Renee C.",
    lastName: "Farkas",
    title: "Director of Student Programs",
    slug: "renee-c-farkas",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Dustin J",
    lastName: "Farnham",
    title: "Mech Maint S10",
    slug: "dustin-j-farnham",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melanie",
    lastName: "Farnham",
    title: "Academic Review Coordinator",
    slug: "melanie-farnham",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Fran",
    lastName: "Farrell",
    title: "Major Gift Associate and Administrative Team Lead",
    slug: "fran-farrell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ellen",
    lastName: "Farrell",
    title: "Administrative Assistant, North Campus",
    slug: "ellen-farrell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mustafa Ali",
    lastName: "Faruki",
    title: "Critic Visiting",
    slug: "mustafa-ali-faruki",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marcie Suzanne",
    lastName: "Farwell",
    title: "Gordon and Marjorie Osborne Textile Industry Curator",
    slug: "marcie-suzanne-farwell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kayla Marie",
    lastName: "Faucett",
    title: "Program Assistant for China Dual Degree Programs",
    slug: "kayla-marie-faucett",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marlena",
    lastName: "Fauer",
    title: "Critic Visiting",
    slug: "marlena-fauer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Daniel",
    lastName: "Faughn",
    title: "Admissions & Applications Coordinator",
    slug: "daniel-faughn",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Elisabeth",
    lastName: "Faughnan",
    title: "Major Gift Associate",
    slug: "elisabeth-faughnan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tracy",
    lastName: "Faunce",
    title: "eCornell HR Generalist",
    slug: "tracy-faunce",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michelle La",
    lastName: "Fave",
    title: "Benefits Associate, Health and Welfare Benefit Programs",
    slug: "michelle-la-fave",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Zoe",
    lastName: "Favilla",
    title: "Lab Manager -Developmental Moral Psychology Lab",
    slug: "zoe-favilla",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ashley R.",
    lastName: "Fazio",
    title: "Senior Director of Strategic Initiatives",
    slug: "ashley-r-fazio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley",
    lastName: "Fazio",
    title: "Office Assistant",
    slug: "ashley-fazio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Margaret Sophia",
    lastName: "Fear",
    title: "Classroom AV Tester I",
    slug: "margaret-sophia-fear",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Debra Marie",
    lastName: "Federation",
    title: "Dir Cash Mgmt",
    slug: "debra-marie-federation",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer",
    lastName: "Fee",
    title:
      " Assistant Director, Curriculum and Training Development - Skorton Center",
    slug: "jennifer-fee",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Troy",
    lastName: "Feldman",
    title: "Residence Hall Director",
    slug: "troy-feldman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jocelyn Faith",
    lastName: "Feller",
    title: "Financial Transaction Representative",
    slug: "jocelyn-faith-feller",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "June",
    lastName: "Feller",
    title: "Financial Transaction Representative",
    slug: "june-feller",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Robert J.",
    lastName: "Felt",
    title: "Compliance Manager, IACUC",
    slug: "robert-j-felt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Esther W",
    lastName: "Feng",
    title:
      " Associate Dean, Alumni Affairs and Development, College of Arts and Sciences",
    slug: "esther-w-feng",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kailee Lynn",
    lastName: "Fenton",
    title: "Client Experience Coordinator",
    slug: "kailee-lynn-fenton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bill",
    lastName: "Fenwick",
    title: "IT Workflow Systems Specialist",
    slug: "bill-fenwick",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lee",
    lastName: "Fenyes",
    title: "Data Manager",
    slug: "lee-fenyes",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Beatrice",
    lastName: "Fenyes-Gartenberg",
    title: "Communications Coordinator",
    slug: "beatrice-fenyes-gartenberg",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mike",
    lastName: "Ferdinando",
    title: "Software Licensing Service Manager",
    slug: "mike-ferdinando",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Melissa Jane",
    lastName: "Ference",
    title: "Director of Special Projects, Break Through Tech AI",
    slug: "melissa-jane-ference",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bonnie",
    lastName: "Ferguson",
    title: "Administrative Asst V",
    slug: "bonnie-ferguson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kevin",
    lastName: "Ferguson",
    title: "Associate Director of Client Services and Customer Experience",
    slug: "kevin-ferguson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kyle F",
    lastName: "Ferguson",
    title: "Research Administration Assistant",
    slug: "kyle-f-ferguson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kamili",
    lastName: "Fernandez",
    title:
      " Creative Writing Program Co-Coordinator - Center for Transformative Action - Prisoner's Express (Gary Fine)",
    slug: "kamili-fernandez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica Mae",
    lastName: "Fernando",
    title: "Stewardship Officer for Individual and Campaign Stewardship",
    slug: "jessica-mae-fernando",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elanore",
    lastName: "Ferrara",
    title: "Administrative Assistant",
    slug: "elanore-ferrara",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jordan",
    lastName: "Ferrari",
    title: "Assistant Director, SHARE Office",
    slug: "jordan-ferrari",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mary Margaret Laura",
    lastName: "Ferraro",
    title: "Collections Asst IV",
    slug: "mary-margaret-laura-ferraro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eveline V.",
    lastName: "Ferretti",
    title: "Public Programs Administrator",
    slug: "eveline-v-ferretti",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Louanne A.",
    lastName: "Ferri",
    title: "Immunization Compliance Lead",
    slug: "louanne-a-ferri",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lori Ann",
    lastName: "Ferrier",
    title: "Seminar Coordinator",
    slug: "lori-ann-ferrier",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michele L.",
    lastName: "Ferris",
    title: "Enrollment Counselor",
    slug: "michele-l-ferris",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Nicole",
    lastName: "Ferro",
    title: "Administrative Coordinator",
    slug: "nicole-ferro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Therese Bailey",
    lastName: "Fessenden",
    title: "ROTC Support Staff",
    slug: "therese-bailey-fessenden",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Bridget",
    lastName: "Fetsko",
    title: "New Media Specialist",
    slug: "bridget-fetsko",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mark Alexander",
    lastName: "Fetzko",
    title: "Grant Contract Ofcr II",
    slug: "mark-alexander-fetzko",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sam",
    lastName: "Fickel",
    title: "IT Support Associate",
    slug: "sam-fickel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "David L.",
    lastName: "Fielding",
    title: "Dig Lib Software Eng",
    slug: "david-l-fielding",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Caitlin",
    lastName: "Fields",
    title: "Executive Assistant to the Dean, Bowers CIS",
    slug: "caitlin-fields",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Charles Eric",
    lastName: "Fields",
    title: "Bldg/Facil Coord V",
    slug: "charles-eric-fields",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa E.",
    lastName: "Fields",
    title: "IT Technical Support Provider",
    slug: "melissa-e-fields",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Edith",
    lastName: "Fikes",
    title: "Content Strategist",
    slug: "edith-fikes",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jon E.",
    lastName: "Fila",
    title: "Marketing Art Director",
    slug: "jon-e-fila",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Doug",
    lastName: "Fink",
    title: "Tech Svcs Supv I",
    slug: "doug-fink",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gail Elizabeth",
    lastName: "Fink",
    title: "Director - CEMS Program",
    slug: "gail-elizabeth-fink",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Phoebe Quill",
    lastName: "Finkel",
    title: "AAP Print Media Studio Monitor",
    slug: "phoebe-quill-finkel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Moriah",
    lastName: "Finken",
    title: "Program Services Specialist, Executive MBA, Metro",
    slug: "moriah-finken",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sarah Hunley",
    lastName: "Fiorello",
    title: "Communication Spec II",
    slug: "sarah-hunley-fiorello",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brian W.",
    lastName: "Fish",
    title: "Associate Director for Capital Projects",
    slug: "brian-w-fish",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thamora Virginia",
    lastName: "Fishel",
    title: "Associate Director",
    slug: "thamora-virginia-fishel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Claire",
    lastName: "Fisher",
    title: "Program Assistant",
    slug: "claire-fisher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gena Rapisardi",
    lastName: "Fisher",
    title: "Accounting Manager",
    slug: "gena-rapisardi-fisher",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brenda M.",
    lastName: "Fisher",
    title: "Administrator IV",
    slug: "brenda-m-fisher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Calyn",
    lastName: "Fisher",
    title: "Graduate Research Programs Manager",
    slug: "calyn-fisher",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kelly M",
    lastName: "Fiske",
    title: "Gift Processing Assistant III",
    slug: "kelly-m-fiske",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kevin J.",
    lastName: "Fitch",
    title: "Radiation Safety Specialist",
    slug: "kevin-j-fitch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wahiahawi",
    lastName: "Fitch",
    title: "Grant Contract Ofcr I",
    slug: "wahiahawi-fitch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric",
    lastName: "Fitchette",
    title: "Network and Systems Services Administrator",
    slug: "eric-fitchette",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Martha",
    lastName: "Fitzgerald",
    title: "Associate Dean for Communications",
    slug: "martha-fitzgerald",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Padraic",
    lastName: "Fitzgerald",
    title: "Financial Transaction Representative",
    slug: "padraic-fitzgerald",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brenna Eileen",
    lastName: "Fitzgerald",
    title: "Managing Editor - Nka Journal",
    slug: "brenna-eileen-fitzgerald",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sarah L.",
    lastName: "Fitzgerald",
    title: "Budget & Reporting Manager",
    slug: "sarah-l-fitzgerald",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lauren",
    lastName: "Fitzpatrick",
    title: "Prospect Development Associate",
    slug: "lauren-fitzpatrick",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mr Arthur M.",
    lastName: "Fives",
    title: "Mgr Projects",
    slug: "mr-arthur-m-fives",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca",
    lastName: "Flaherty",
    title: "Assistant Director, Volunteer Programs",
    slug: "rebecca-flaherty",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "John J.",
    lastName: "Flaherty",
    title: "Info Tech Area Mgr I",
    slug: "john-j-flaherty",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Paul",
    lastName: "Flahive",
    title: "Event & Space Coordinator",
    slug: "paul-flahive",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Bridget",
    lastName: "Flanigan",
    title: "Director of Nursing",
    slug: "bridget-flanigan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thomas Joseph",
    lastName: "Fleischman",
    title: "Senior Staff Writer/Editor",
    slug: "thomas-joseph-fleischman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Madison McDowell",
    lastName: "Fleischman",
    title: "Radiation Therapist",
    slug: "madison-mcdowell-fleischman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Catie",
    lastName: "Fleming",
    title: "Director of Special Projects and Data Management",
    slug: "catie-fleming",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tiffany C",
    lastName: "Fleming",
    title: "Research Administration Director",
    slug: "tiffany-c-fleming",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Liz",
    lastName: "Flint",
    title: "Director of Human Resources",
    slug: "liz-flint",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Haruna Amie Shogetsu",
    lastName: "Floate",
    title:
      " ITAP Undergraduate Language Consultant, Student Athletic Serv Asst I",
    slug: "haruna-amie-shogetsu-floate",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Chris",
    lastName: "Flood",
    title: "Administrative Asst IV",
    slug: "chris-flood",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melvin",
    lastName: "Flores",
    title: "Inside Regional Director, Enterprise Programs",
    slug: "melvin-flores",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Devin Wayne",
    lastName: "Flores",
    title: "Photography and Video Content Creator",
    slug: "devin-wayne-flores",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Beth",
    lastName: "Flynn-Ferry",
    title: "Executive Director",
    slug: "beth-flynn-ferry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amadou",
    lastName: "Fofana",
    title: "Area Coordinator",
    slug: "amadou-fofana",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Athalie",
    lastName: "Fogal",
    title: "Residence Hall Director",
    slug: "athalie-fogal",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Chris",
    lastName: "Foito",
    title: "Multimedia Assistant V",
    slug: "chris-foito",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Melissa Leigh",
    lastName: "Foley",
    title: "Cornell Local Roads Program Manager",
    slug: "melissa-leigh-foley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew",
    lastName: "Fondeur",
    title: "Multimedia Specialist II",
    slug: "matthew-fondeur",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joshua J.",
    lastName: "Fontanez",
    title: "Assistant to Department Chair",
    slug: "joshua-j-fontanez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Renee L.",
    lastName: "Foote",
    title: "Finance Manager",
    slug: "renee-l-foote",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Matthew",
    lastName: "Foote",
    title: "Athletic Trainer",
    slug: "matthew-foote",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Amy Elizabeth",
    lastName: "Forbes",
    title: "Director, Strategic Custom Programs",
    slug: "amy-elizabeth-forbes",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer",
    lastName: "Forbes",
    title: "Service Center Manager",
    slug: "jennifer-forbes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristen",
    lastName: "Ford",
    title: "Senior Associate Vice President, Alumni Affairs and Development",
    slug: "kristen-ford",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew T.",
    lastName: "Ford",
    title: "Analytics Reporting Lead",
    slug: "andrew-t-ford",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "James S.",
    lastName: "Ford",
    title: "Telecommunications Officer",
    slug: "james-s-ford",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Walt P",
    lastName: "Ford",
    title: "Equipment Tech IV",
    slug: "walt-p-ford",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kathy",
    lastName: "Forker",
    title: "Financial Transaction Representative",
    slug: "kathy-forker",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Peter",
    lastName: "Fornieri",
    title: "Associate Director, Strategic Projects",
    slug: "peter-fornieri",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Heather A.",
    lastName: "Fortenberry",
    title: "Assistant Director for Career Exploration",
    slug: "heather-a-fortenberry",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Catherine Ramirez",
    lastName: "Foss",
    title: "Deputy Director of Advising",
    slug: "catherine-ramirez-foss",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Amy Meldrim",
    lastName: "Foster",
    title:
      " Senior Deputy Athletics Director, Student-Athlete Experience & Senior Woman Administrator (SWA)",
    slug: "amy-meldrim-foster",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Evan",
    lastName: "Foster",
    title: "Director of Digital Marketing",
    slug: "evan-foster",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Bre",
    lastName: "Foster",
    title: "AIISP Administrative Assistant",
    slug: "bre-foster",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edwin B.",
    lastName: "Foster",
    title: "Equipment Fabrication Supervisor",
    slug: "edwin-b-foster",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tyler William",
    lastName: "Fouch",
    title: "JCB Facillities Assistant",
    slug: "tyler-william-fouch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mark G.",
    lastName: "Fowler",
    title: "EH&S IT Systems",
    slug: "mark-g-fowler",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Erin",
    lastName: "Fowler",
    title: "Enrollment Counselor, Team Lead",
    slug: "erin-fowler",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Erika",
    lastName: "Fowler-Decatur",
    title: "Director of Current Programs and Student Services",
    slug: "erika-fowler-decatur",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rebecca",
    lastName: "Fox",
    title: "Digital Strategy Manager",
    slug: "rebecca-fox",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Amy Tamara",
    lastName: "Fox",
    title: "Environment Health & Safety Specialist I",
    slug: "amy-tamara-fox",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patricia A.",
    lastName: "Fox",
    title: "Assistant Book Conservator",
    slug: "patricia-a-fox",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer Rebecca",
    lastName: "Fraboni",
    title: "Financial Transaction Representative",
    slug: "jennifer-rebecca-fraboni",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Peter",
    lastName: "Fraissinet",
    title: "Collections Asst IV",
    slug: "peter-fraissinet",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lindsay",
    lastName: "France",
    title: "Director of Multimedia",
    slug: "lindsay-france",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nicole Christina",
    lastName: "Francik",
    title: "Grant Coordinator",
    slug: "nicole-christina-francik",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily A.",
    lastName: "Franco",
    title: "Director of the SHA/CIA Alliance",
    slug: "emily-a-franco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carl",
    lastName: "Franconi",
    title: "Research Center Manager",
    slug: "carl-franconi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andrea",
    lastName: "Frank",
    title: "Assistant Director, Project Management Office",
    slug: "andrea-frank",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dave",
    lastName: "Frank",
    title: "Classroom and Event Technology Manager",
    slug: "dave-frank",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sheila",
    lastName: "Frank",
    title: "Enrollment Counselor II",
    slug: "sheila-frank",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Eleanor",
    lastName: "Frankel",
    title: "Major Gift Associate",
    slug: "eleanor-frankel",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Frederic",
    lastName: "Franken",
    title: "Business Development Representative, Break Through Tech",
    slug: "frederic-franken",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dixie",
    lastName: "Franklin",
    title: "Administrative Asst III",
    slug: "dixie-franklin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca June",
    lastName: "Franklin-Guild",
    title: "AHDC Bacteriology Supervisor",
    slug: "rebecca-june-franklin-guild",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Charles",
    lastName: "Frankston",
    title: "arXiv Technical Director",
    slug: "charles-frankston",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jan",
    lastName: "Frantz",
    title: "Technical Svcs Asst II",
    slug: "jan-frantz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lauren Anne",
    lastName: "Frederick",
    title: "DEI Administrative Coordinator",
    slug: "lauren-anne-frederick",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Lauren",
    lastName: "Free",
    title: "HR Project Manager",
    slug: "lauren-free",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Lisa",
    lastName: "Freeborn",
    title: "Assistant to the Department Chair - Public and Ecosystem Health",
    slug: "lisa-freeborn",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Samantha",
    lastName: "Freeburn",
    title: "Deputy Title IX Coordinator/Equity and Title IX Investigator",
    slug: "samantha-freeburn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yvonne",
    lastName: "Freeman",
    title: "Ben Admin Coordinator",
    slug: "yvonne-freeman",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jack R.",
    lastName: "French",
    title: "Mech Vehicle S10",
    slug: "jack-r-french",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cathy",
    lastName: "French",
    title: "Applications Developer III",
    slug: "cathy-french",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Meghan",
    lastName: "French",
    title:
      " Senior Director, External Relations and Strategic Planning, Break Through Tech",
    slug: "meghan-french",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Paige J.",
    lastName: "Frey",
    title: "College Registrar",
    slug: "paige-j-frey",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kate",
    lastName: "Freyer",
    title: "Director of Campus Engagement Events for Alumni",
    slug: "kate-freyer",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rafhilene Marlene",
    lastName: "Frias-Sanchez",
    title: "ILR Admissions Social Media Assistant I (Canfield)",
    slug: "rafhilene-marlene-frias-sanchez",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Marina Wencelblat",
    lastName: "Fried",
    title:
      " Senior Associate Director of Admissions for Diversity Outreach and Strategic Partnerships",
    slug: "marina-wencelblat-fried",
    dei: true,
    category: "Admissions",
  },
  {
    firstName: "Talia",
    lastName: "Friedenberg",
    title: "Administrative & Dean’s Assistant",
    slug: "talia-friedenberg",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joan",
    lastName: "Friedman",
    title: "ASQ Managing Editor",
    slug: "joan-friedman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Renee L.",
    lastName: "Frisson",
    title: "Administrative Coordinator",
    slug: "renee-l-frisson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kurt",
    lastName: "Fritjofson",
    title: "Research & Program Administrator",
    slug: "kurt-fritjofson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jonathan A.",
    lastName: "Froehlich",
    title: "Associate Director of Alumni Engagement",
    slug: "jonathan-a-froehlich",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Leah",
    lastName: "Fromm",
    title: "Lifeguard",
    slug: "leah-fromm",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alison",
    lastName: "Fromme",
    title: "Communications Writer",
    slug: "alison-fromme",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sylvie C.",
    lastName: "Froncek",
    title:
      " Associate Director of Cornell Outdoor Education, the Dan Tillemans Director of the Cornell Team and Leadership Center",
    slug: "sylvie-c-froncek",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sara S.",
    lastName: "Frug",
    title: "Executive Director of the Legal Information Institute",
    slug: "sara-s-frug",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Denise",
    lastName: "Frutchey",
    title: "Advancement Services Manager, Customer Service and Partner Support",
    slug: "denise-frutchey",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Cheyanne",
    lastName: "Frutchey",
    title: "Assistant Director of Graduate Admissions",
    slug: "cheyanne-frutchey",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Audrey",
    lastName: "Fu",
    title:
      " Social Media & Outreach Co-Manager - Center for Transformative Action (Kim Hines)",
    slug: "audrey-fu",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Karolina",
    lastName: "Fucikova",
    title: "Learning and Assessment Specialist",
    slug: "karolina-fucikova",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rob de la",
    lastName: "Fuente",
    title: "Senior Director of Donor Relations",
    slug: "rob-de-la-fuente",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shawna J.",
    lastName: "Fulkerson",
    title: "Credit Evaluation Coordinator",
    slug: "shawna-j-fulkerson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Daniel D.",
    lastName: "Furman",
    title: "Sheet Metal Worker - FP",
    slug: "daniel-d-furman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patty Ann",
    lastName: "Gabriel",
    title: "Office & Program Coordinator- Office of Diversity & Inclusion",
    slug: "patty-ann-gabriel",
    dei: true,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Gabriel",
    title: "Major Gift Officer",
    slug: "jennifer-gabriel",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sunil Kumar",
    lastName: "Gaddam",
    title: "Salesforce Administrator",
    slug: "sunil-kumar-gaddam",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Heidi Beth",
    lastName: "Gaensbauer",
    title: "Media Specialist, HTL HLDP General Manager",
    slug: "heidi-beth-gaensbauer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Domenic Andrew",
    lastName: "Gagliano",
    title: "IT Solutions Associate",
    slug: "domenic-andrew-gagliano",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Makayla",
    lastName: "Gagne",
    title: "Data Entry Specialist",
    slug: "makayla-gagne",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lydia",
    lastName: "Gahan",
    title: "Financial Aid Sr. Business Analsyst",
    slug: "lydia-gahan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alfred",
    lastName: "Galang",
    title: "Enrollment Support Representative",
    slug: "alfred-galang",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Lydia Ann",
    lastName: "Galarneau",
    title: "IRB Compliance Assistant",
    slug: "lydia-ann-galarneau",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Natasha Marie",
    lastName: "Galliher",
    title: "Finance Specialist II",
    slug: "natasha-marie-galliher",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Anna",
    lastName: "Gallow",
    title: "Director of Enterprise Marketing and Promotions for SCL",
    slug: "anna-gallow",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Steven C.",
    lastName: "Gallow",
    title: "AV Manager",
    slug: "steven-c-gallow",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Laura",
    lastName: "Gallup",
    title: "Communications Lead",
    slug: "laura-gallup",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Adam",
    lastName: "Galt",
    title: "Fire Protection Tester",
    slug: "adam-galt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric J.",
    lastName: "Galvin",
    title: "Systems Administrator",
    slug: "eric-j-galvin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Vrunda",
    lastName: "Gandhi",
    title: "Manager, IT Audit",
    slug: "vrunda-gandhi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ivan",
    lastName: "Gando",
    title: "Business Development & Licensing Associate",
    slug: "ivan-gando",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren Graham",
    lastName: "Garcia",
    title: "Director, Student & Campus Life & Athletics  Alumni Engagement",
    slug: "lauren-graham-garcia",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Hans C",
    lastName: "Garcia",
    title: "IDP Facilitator, Student Admin Asst II",
    slug: "hans-c-garcia",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Juliana Alexis",
    lastName: "Garcia",
    title: "Counselor Therapist, Latinx Community Liaison",
    slug: "juliana-alexis-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Agustina Abril",
    lastName: "Garcia",
    title: "LII 2025, Student Admin Asst I",
    slug: "agustina-abril-garcia",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jamie",
    lastName: "Gardner",
    title: "Central Sterilization Team Leader",
    slug: "jamie-gardner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle Renee",
    lastName: "Gardner",
    title: "Manager Student Career Services",
    slug: "michelle-renee-gardner",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Julia",
    lastName: "Gardner",
    title: "Assistant Director for Public Services",
    slug: "julia-gardner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kelly",
    lastName: "Gardner",
    title: "Finance Specialist III",
    slug: "kelly-gardner",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Anne",
    lastName: "Gardner",
    title: "Manager, Technical Services",
    slug: "anne-gardner",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brian D",
    lastName: "Gardner",
    title: "Auditorium & AV Specialist",
    slug: "brian-d-gardner",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rhea",
    lastName: "Garen",
    title: "Imaging and Scanning Lab Manager",
    slug: "rhea-garen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nicholas C.",
    lastName: "Gargan",
    title: "Database Administrator",
    slug: "nicholas-c-gargan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mary",
    lastName: "Garin",
    title: "Associate Director of Master's Programs",
    slug: "mary-garin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christopher Thomas",
    lastName: "Garlington",
    title: "Systems Administrator",
    slug: "christopher-thomas-garlington",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bryan",
    lastName: "Garner",
    title: "Digital and Marketing Strategist",
    slug: "bryan-garner",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ian R.",
    lastName: "Garrett",
    title: "Director of Gift Planning",
    slug: "ian-r-garrett",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michael",
    lastName: "Garrett",
    title: "Lighting/Video Supervisor",
    slug: "michael-garrett",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda",
    lastName: "Garris",
    title: "Communications Spec III-SP",
    slug: "amanda-garris",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Susan J.",
    lastName: "Garrison",
    title: "Business Title Cornell Biobank Quality Assurance Manager",
    slug: "susan-j-garrison",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Megan",
    lastName: "Garton",
    title: "Senior Data Associate",
    slug: "megan-garton",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nicholas",
    lastName: "Garuccio",
    title: "Controls Designer",
    slug: "nicholas-garuccio",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Megan L.",
    lastName: "Gatch",
    title: "Deputy Registrar",
    slug: "megan-l-gatch",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Steven Philip",
    lastName: "Gattine",
    title: "Web Editor",
    slug: "steven-philip-gattine",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tom",
    lastName: "Gaube",
    title:
      " Executive Director, Alumni Affairs and Development for Student Campus Life & Athletics and Physical Education",
    slug: "tom-gaube",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Amy",
    lastName: "Gaulke",
    title: "Executive Director of SCL Communications & Marketing",
    slug: "amy-gaulke",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Shailja",
    lastName: "Gaur",
    title: "Program Assistant",
    slug: "shailja-gaur",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lyn Marie",
    lastName: "Gauss",
    title: "Sponsored Finance Specialist",
    slug: "lyn-marie-gauss",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tracy",
    lastName: "Gavich",
    title: "Administrative Manager",
    slug: "tracy-gavich",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ann",
    lastName: "Gay",
    title: "Fire Protection Tester",
    slug: "ann-gay",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nathan Allen",
    lastName: "Gear",
    title: "Pharmacist",
    slug: "nathan-allen-gear",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robin",
    lastName: "Gee",
    title: "Critical Pedagogy and Equity Librarian",
    slug: "robin-gee",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Shirley Rae",
    lastName: "Gehres",
    title: "Benefit Coordinator",
    slug: "shirley-rae-gehres",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Lyndsay A",
    lastName: "Gehring",
    title: "Training and Education Associate",
    slug: "lyndsay-a-gehring",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Abby Christina Hellauer",
    lastName: "Geiger",
    title: "Enterprise Project Manager",
    slug: "abby-christina-hellauer-geiger",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Loreen A.",
    lastName: "Geiger",
    title: "Accounting Transaction Specialist, Student Organizations",
    slug: "loreen-a-geiger",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Yuval",
    lastName: "Gelardin",
    title: "Lifegard",
    slug: "yuval-gelardin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen D.",
    lastName: "Gentile",
    title: "Financial Aid Services Assistant IV",
    slug: "karen-d-gentile",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Emma Grace",
    lastName: "Gentry",
    title: "Telecommunications Officer",
    slug: "emma-grace-gentry",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Beth Hannah",
    lastName: "Gentsch",
    title: "Urgent Care Counselor",
    slug: "beth-hannah-gentsch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maggie",
    lastName: "George",
    title: "Director of Affinity Engagement",
    slug: "maggie-george",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Beal St.",
    lastName: "George",
    title: "Associate Director of CAU, Alumni Travel and Wine Programs",
    slug: "beal-st-george",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle",
    lastName: "George",
    title: "Academic HR Assistant",
    slug: "danielle-george",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Christian",
    lastName: "Geramita",
    title:
      " Clothing Closet Assistant - Catholic Charities of Tompkins County (Michaela Cortright)",
    slug: "christian-geramita",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa",
    lastName: "Gerber",
    title: "Grand Challenges Program Manager",
    slug: "lisa-gerber",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katie",
    lastName: "Gerken",
    title: "Senior Labor Leadership Initiatives Associate",
    slug: "katie-gerken",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Andrew M.",
    lastName: "Germain",
    title: "Sr. Associate Director of Capital Renewal",
    slug: "andrew-m-germain",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joshua A.",
    lastName: "Gerner",
    title: "Assistant Director of Endpoint Services",
    slug: "joshua-a-gerner",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gabriela Castro",
    lastName: "Gessner",
    title: "Director of Assessment and Planning",
    slug: "gabriela-castro-gessner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Liam",
    lastName: "Geva",
    title: "Assistant Director, Nutrition & Health CUCE - NYC",
    slug: "liam-geva",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kayvon",
    lastName: "Ghashghai",
    title: "Applications Developer II",
    slug: "kayvon-ghashghai",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Oana",
    lastName: "Gherman",
    title: "Senior Administrative Assistant, IC3",
    slug: "oana-gherman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Angelique",
    lastName: "Giammarino",
    title: "Platform Director, Cornellians",
    slug: "angelique-giammarino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sara M.",
    lastName: "Gibbons",
    title: "Executive Staff Assistant to Vice President of Budget and Planning",
    slug: "sara-m-gibbons",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jim",
    lastName: "Gibbs",
    title: "Facility Director",
    slug: "jim-gibbs",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Josh",
    lastName: "Giblin",
    title: "Climbing Wall Manager",
    slug: "josh-giblin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "JEDIDIAH",
    lastName: "GIBSON",
    title: "MSLS Assistant Faciliator",
    slug: "jedidiah-gibson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Myles",
    lastName: "Gideon",
    title: "Compliance Manager, IRB",
    slug: "myles-gideon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric Michael",
    lastName: "Giese",
    title: "Administrator VI",
    slug: "eric-michael-giese",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrea",
    lastName: "Gilbert",
    title: "Accounts Rep IV",
    slug: "andrea-gilbert",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gretchen C.",
    lastName: "Gilbert",
    title: "Registrar Coordinator",
    slug: "gretchen-c-gilbert",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "James",
    lastName: "Gill",
    title: "Accounts Representative",
    slug: "james-gill",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kiera Anne",
    lastName: "Gill",
    title: "Undergrad Course Assistant III (Long)",
    slug: "kiera-anne-gill",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shawn",
    lastName: "Gillen",
    title: "Assistant Director, Athletic Communications",
    slug: "shawn-gillen",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Patrick",
    lastName: "Gillespie",
    title: "Communication Specialist II",
    slug: "patrick-gillespie",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elizabeth",
    lastName: "Gillett",
    title: "Major Gift Officer, West Coast",
    slug: "elizabeth-gillett",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie",
    lastName: "Gilligan",
    title: "Events Specialist, Cornell Tech",
    slug: "stephanie-gilligan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laurel",
    lastName: "Gilmer",
    title: "Director of Events",
    slug: "laurel-gilmer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gretchen",
    lastName: "Gilpin",
    title: "Financial Services Manager",
    slug: "gretchen-gilpin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mike",
    lastName: "Gilpin",
    title: "CHESS Managing Director",
    slug: "mike-gilpin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Devaki B.",
    lastName: "Ginde",
    title: "Assistant Director, Strategic Portfolio Management",
    slug: "devaki-b-ginde",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lindsey",
    lastName: "Girodo",
    title: "HR Business Partner",
    slug: "lindsey-girodo",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rebecca",
    lastName: "Givens",
    title: "Design Tech Department Manager",
    slug: "rebecca-givens",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Penny Jean",
    lastName: "Givin",
    title: "Admin. Asst. to the Director",
    slug: "penny-jean-givin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elyssa",
    lastName: "Gladden",
    title: "Procurement Assistant",
    slug: "elyssa-gladden",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julie",
    lastName: "Glanville",
    title: "Health Content Lead",
    slug: "julie-glanville",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Peter H.",
    lastName: "Glanville",
    title: "Associate Director of Marketing Acquisition.",
    slug: "peter-h-glanville",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Linda Beltz",
    lastName: "Glaser",
    title: "News and Media Relations Manager",
    slug: "linda-beltz-glaser",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lindsay Irene",
    lastName: "Glasner",
    title: "Assistant Director, Undergraduate Advising",
    slug: "lindsay-irene-glasner",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Thomas",
    lastName: "Glazier",
    title: "Fire Protection Tester",
    slug: "thomas-glazier",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexis Starr",
    lastName: "Glezen",
    title: "Accounts Assistant",
    slug: "alexis-starr-glezen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mary",
    lastName: "Glick",
    title: "Program and Publications Coordinator",
    slug: "mary-glick",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Susan",
    lastName: "Gloss",
    title: "Program Assistant",
    slug: "susan-gloss",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniela Eshel",
    lastName: "Gloster",
    title: "LII 2025",
    slug: "daniela-eshel-gloster",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kaitlyn Michelle",
    lastName: "Glover",
    title: "Financial Transaction Representative",
    slug: "kaitlyn-michelle-glover",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sean M",
    lastName: "Gnau",
    title: "Web Designer",
    slug: "sean-m-gnau",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Amie Nguyen",
    lastName: "Goble",
    title: "Assistant Registrar",
    slug: "amie-nguyen-goble",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elisabete C.",
    lastName: "Godden",
    title: "Manager of Projects",
    slug: "elisabete-c-godden",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy Marie",
    lastName: "Godert",
    title:
      " Director of the LSC and Executive Director for Academic Student Success Programs",
    slug: "amy-marie-godert",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jeff",
    lastName: "Godowski",
    title: "House Assistant Dean, Flora Rose House",
    slug: "jeff-godowski",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Beth",
    lastName: "Goelzer",
    title: "Director, Customer Experience",
    slug: "beth-goelzer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lizzie",
    lastName: "Goggs",
    title: "Academic Leaves Case Manager",
    slug: "lizzie-goggs",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Graylin Jane",
    lastName: "Gogolak",
    title: "CDP Facilitator",
    slug: "graylin-jane-gogolak",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zaria A",
    lastName: "Goicochea",
    title: "W&J Fall 2024",
    slug: "zaria-a-goicochea",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elise B.",
    lastName: "Gold",
    title: "Senior Communications Director.",
    slug: "elise-b-gold",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Katherine J.",
    lastName: "Goldberg",
    title: "Generalist Counselor Therapist",
    slug: "katherine-j-goldberg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maggie Dayton",
    lastName: "Golden",
    title:
      " Senior Associate Director of Admissions for Strategic Recruitment and Engagement",
    slug: "maggie-dayton-golden",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Andy",
    lastName: "Goldman",
    title: "IT Support Provider",
    slug: "andy-goldman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Neil James",
    lastName: "Goldsmith",
    title: "Undergraduate Admissions Assistant, ILR",
    slug: "neil-james-goldsmith",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Aaron",
    lastName: "Goldweber",
    title: "Senior Director of Communications, Einhorn Center",
    slug: "aaron-goldweber",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rebecca Rich",
    lastName: "Goldweber",
    title: "arXiv Lead Production Editor",
    slug: "rebecca-rich-goldweber",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Steve",
    lastName: "Gollnick",
    title: "Digital Resources Assistant",
    slug: "steve-gollnick",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Angeline",
    lastName: "Gomez",
    title: "Program Coordinator, Inclusion and Belonging & Milstein Summer",
    slug: "angeline-gomez",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Yolanda",
    lastName: "Gonzalez",
    title: "Urban Agriculture Specialist",
    slug: "yolanda-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gabriel Alexander",
    lastName: "Gonzalez",
    title: "Talent Acquisition Partner",
    slug: "gabriel-alexander-gonzalez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ernesto Bordon",
    lastName: "Gonzalez",
    title: "Communications Assistant",
    slug: "ernesto-bordon-gonzalez",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rachael Ann",
    lastName: "Goodfellow",
    title: "Director of Health Professions Advising",
    slug: "rachael-ann-goodfellow",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Christie A",
    lastName: "Goodfellow",
    title: "Program Administrative Assistant",
    slug: "christie-a-goodfellow",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thomas P.",
    lastName: "Goodness",
    title: "Associate Director, State & Foundations Team",
    slug: "thomas-p-goodness",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Merri",
    lastName: "Goodrow",
    title: "Administrator II",
    slug: "merri-goodrow",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gabriel",
    lastName: "Goodwin",
    title: "Systems Administrator",
    slug: "gabriel-goodwin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alec",
    lastName: "Goodwin",
    title: "Research and Policy Development Associate",
    slug: "alec-goodwin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Izzy Marie",
    lastName: "Goodwin",
    title: "Summer Student Coordinator, Student Labor/Facil Asst I",
    slug: "izzy-marie-goodwin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "PATRICK",
    lastName: "GOOLEY",
    title: "Director, Federal Government Programs",
    slug: "patrick-gooley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Conor Milan",
    lastName: "Gordin-Rhone",
    title: "IT Technical Support Provider",
    slug: "conor-milan-gordin-rhone",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eleni Marie",
    lastName: "Gordinier",
    title: "Assistant Director of Student Conduct and Community Standards",
    slug: "eleni-marie-gordinier",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Melinda von",
    lastName: "Gordon",
    title: "Research Administration Lead",
    slug: "melinda-von-gordon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Evelyn",
    lastName: "Gordon",
    title: "Senior Director of Human Resources",
    slug: "evelyn-gordon",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Marie E. Bosley",
    lastName: "Gordon",
    title:
      " Associate University Registrar, Academic Systems and Credit Evaluation Services",
    slug: "marie-e-bosley-gordon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Emma Rose",
    lastName: "Gordon",
    title: "LII 2025",
    slug: "emma-rose-gordon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessie Joann",
    lastName: "Gorges",
    title: "Technical Programs Manager",
    slug: "jessie-joann-gorges",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Andrew A.",
    lastName: "Gossen",
    title: "Executive Director, Communications, Marketing, and Participation",
    slug: "andrew-a-gossen",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rowan Walker",
    lastName: "Gould",
    title: "(SCL-Outfitting) Student Athletic Serv Asst I",
    slug: "rowan-walker-gould",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Karen",
    lastName: "Goulet",
    title: "Executive Assistant and Law Office Manager",
    slug: "karen-goulet",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Tina L.",
    lastName: "Gourley",
    title: "Senior Director, Alumni Volunteer Programs",
    slug: "tina-l-gourley",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Patrick James",
    lastName: "Govang",
    title: "Co-Director, AFRL Mid-Atlantic Hub",
    slug: "patrick-james-govang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeffrey M.",
    lastName: "Grabelsky",
    title: "Co-Director, National Leadership Initiative",
    slug: "jeffrey-m-grabelsky",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher Patrick",
    lastName: "Graber",
    title: "Research Administration Coordinator-Baker Institute",
    slug: "christopher-patrick-graber",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eileen",
    lastName: "Grabosky",
    title: "Director of Administration",
    slug: "eileen-grabosky",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Patti",
    lastName: "Grace",
    title: "Deputy Director, Admissions/Athletics Liaison",
    slug: "patti-grace",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Amanda",
    lastName: "Grace",
    title: "Administrator II",
    slug: "amanda-grace",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Miika James",
    lastName: "Grady",
    title: "Web Designer III",
    slug: "miika-james-grady",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Daniela Nicole",
    lastName: "Graffeo",
    title: "IDP Facilitator",
    slug: "daniela-nicole-graffeo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura",
    lastName: "Graffitti",
    title: "Associate Director of MBA Programs",
    slug: "laura-graffitti",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Phillip",
    lastName: "Graham",
    title: "Manager, Lynah Rink",
    slug: "phillip-graham",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mitchell Jonathan",
    lastName: "Graham",
    title: "Technical Support Provider",
    slug: "mitchell-jonathan-graham",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Patrick M.",
    lastName: "Graham",
    title: "Instructional Tech Spec III",
    slug: "patrick-m-graham",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Traci",
    lastName: "Grainger",
    title: "Associate Director of Budget and Finance",
    slug: "traci-grainger",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Bruce A.",
    lastName: "Granger",
    title: "Mech Vehicle S05",
    slug: "bruce-a-granger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sheila",
    lastName: "Grant",
    title: "Administrative Coordinator for the Board of Trustees",
    slug: "sheila-grant",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle Van-Ess",
    lastName: "Grant",
    title: "Senior Associate Dean of Students",
    slug: "michelle-van-ess-grant",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Brett",
    lastName: "Grant",
    title: "Sponsored Finance Specialist",
    slug: "brett-grant",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Holly",
    lastName: "Grant",
    title: "Program Aide",
    slug: "holly-grant",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ellyn H.",
    lastName: "Grant-Keane",
    title: "Assistant Director of Annual Giving, SCL & Athletics",
    slug: "ellyn-h-grant-keane",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marie H.",
    lastName: "Graves",
    title: "Treasury Associate",
    slug: "marie-h-graves",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Debbie Luk",
    lastName: "Graves",
    title: "Senior Associate Director, MBA Career Services",
    slug: "debbie-luk-graves",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Justin John",
    lastName: "Gravius",
    title: "Director of Communications",
    slug: "justin-john-gravius",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Akida",
    lastName: "Gray",
    title: "HR Assistant",
    slug: "akida-gray",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Julia G.",
    lastName: "Graziano",
    title: "SCE Student Receptionist/Office Assistant, SASA III - INFO 1260",
    slug: "julia-g-graziano",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Joshua",
    lastName: "Grazul",
    title: "Finance & HR Manager",
    slug: "joshua-grazul",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John L.",
    lastName: "Grazul",
    title: "TEM Facility Manager",
    slug: "john-l-grazul",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julie A.",
    lastName: "Greco",
    title: "Senior Communication Specialist",
    slug: "julie-a-greco",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Dana",
    lastName: "Green",
    title: "Development Associate",
    slug: "dana-green",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aalayna Rae",
    lastName: "Green",
    title: "GRA",
    slug: "aalayna-rae-green",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael Roberson",
    lastName: "Greene",
    title: "NORDTECH Partnership Director",
    slug: "michael-roberson-greene",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather",
    lastName: "Greeno",
    title: "Financial Transaction Representative",
    slug: "heather-greeno",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mark",
    lastName: "Greentree",
    title: "Ecommerce and Marketing Specialist",
    slug: "mark-greentree",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristen Ashley",
    lastName: "Gregg",
    title: "Marketing Assistant for CU Press",
    slug: "kristen-ashley-gregg",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Danielle",
    lastName: "Gregg",
    title: "Immigration Specialist",
    slug: "danielle-gregg",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jarred",
    lastName: "Gregg",
    title: "Fire Protection Tester",
    slug: "jarred-gregg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Loganne",
    lastName: "Gregg-Ray",
    title: "Administrative Asst III",
    slug: "loganne-gregg-ray",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jon",
    lastName: "Gregory",
    title: "Associate Director of Annual Giving, Student & Campus Life",
    slug: "jon-gregory",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ashlee",
    lastName: "Gregory",
    title: "Sprinternships Program Managing Director, Break Through Tech",
    slug: "ashlee-gregory",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jen",
    lastName: "Grenier",
    title: "Director, Biotechnology Resource Center Genomics Facility",
    slug: "jen-grenier",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cindy",
    lastName: "Grey",
    title: "Assistant University Registrar, Credit Evaluation Services",
    slug: "cindy-grey",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Callie",
    lastName: "Griffen",
    title: "Central Support Specialist",
    slug: "callie-griffen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Britani",
    lastName: "Griffin",
    title: "Major Gift Officer",
    slug: "britani-griffin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paula Hope",
    lastName: "Griffin",
    title: "Children and Youth Safety Administrator",
    slug: "paula-hope-griffin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelly",
    lastName: "Griffin",
    title: "Financial Transaction Representative",
    slug: "kelly-griffin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kate",
    lastName: "Griffith",
    title:
      " Jean McKelvey-Alice Grant Professor of Labor-Management Relations, Senior Associate Dean for Academic Affairs, Diversity, and Faculty Development, Associate Member of the Cornell Law School Faculty",
    slug: "kate-griffith",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alan",
    lastName: "Griffith",
    title: "Maintenance Manager, Central Energy Plant",
    slug: "alan-griffith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley",
    lastName: "Griffith",
    title: "Engagement and Outreach Coordinator",
    slug: "ashley-griffith",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Donette",
    lastName: "Griffith",
    title: "Administrative Asst II",
    slug: "donette-griffith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Derek",
    lastName: "Griffiths",
    title: "Building/Facility Coordinator",
    slug: "derek-griffiths",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rodney",
    lastName: "Griffiths",
    title: "Mason - GFP",
    slug: "rodney-griffiths",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathryn",
    lastName: "Griffiths",
    title: "Finance Manager",
    slug: "kathryn-griffiths",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tom",
    lastName: "Griffo",
    title: "Inside Director SMB, Enterprise Programs",
    slug: "tom-griffo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie B",
    lastName: "Griggs",
    title: "Enrollment Counselor I",
    slug: "stephanie-b-griggs",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Marianna",
    lastName: "Grigorov",
    title: "Project Coordinator NY Space Grant and NY Space Consortium",
    slug: "marianna-grigorov",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hovik",
    lastName: "Grigoryan",
    title: "Web Archiving Student Admin Assistant",
    slug: "hovik-grigoryan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ella Madeleine",
    lastName: "Grimm",
    title: "(Riccio) Art Studio Monitor",
    slug: "ella-madeleine-grimm",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ann M.",
    lastName: "Griner",
    title: "Financial Services Associate",
    slug: "ann-m-griner",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jacob R",
    lastName: "Grippin",
    title: "Research Facilitator",
    slug: "jacob-r-grippin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christopher J.",
    lastName: "Grippin",
    title: "Data Warehouse Developer",
    slug: "christopher-j-grippin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ian M.",
    lastName: "Grippo",
    title: "Collections Management Assistant",
    slug: "ian-m-grippo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Abigail Nicole",
    lastName: "Grizancic",
    title: "Intramural Sports Student Supervisor",
    slug: "abigail-nicole-grizancic",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Emily",
    lastName: "Groff",
    title: "Assistant Director of Communications",
    slug: "emily-groff",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Laurel",
    lastName: "Gromatsky",
    title: "Program Associate, Discovery Team",
    slug: "laurel-gromatsky",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Xiomara",
    lastName: "Grossett",
    title: "Class and Reunion Engagement Officer",
    slug: "xiomara-grossett",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Gary David",
    lastName: "Grossfeld",
    title: "Executive in Residence",
    slug: "gary-david-grossfeld",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Robert",
    lastName: "Grossi",
    title: "Maintenance Assistant",
    slug: "robert-grossi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristin E. Gutenberger",
    lastName: "Grossman",
    title: "Director of Real Estate",
    slug: "kristin-e-gutenberger-grossman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah Elizabeth Mary",
    lastName: "Grossman",
    title:
      " Editorial Director, SEAP Publications/ Senior Editor, Cornell University Press",
    slug: "sarah-elizabeth-mary-grossman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Meleah",
    lastName: "Grover",
    title: "Administrative Assistant, Brooks School - Centers & Institutes",
    slug: "meleah-grover",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kera",
    lastName: "Groves",
    title: "Program Finance Manager",
    slug: "kera-groves",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lora Kulakowski",
    lastName: "Gruber-Hine",
    title: "Assistant Director, Coordinator of Research",
    slug: "lora-kulakowski-gruber-hine",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ingrid",
    lastName: "Gruener",
    title:
      " Open Borders CoLAB: Data Collection Research/lab Associate, SASA III - INFO 4940",
    slug: "ingrid-gruener",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ethan",
    lastName: "Grundberg",
    title: "Vegetable Crops Specialist",
    slug: "ethan-grundberg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bryson",
    lastName: "Grygier",
    title: "IT Technical Support Provider",
    slug: "bryson-grygier",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alfred",
    lastName: "Guaman",
    title: "Assistant Director, Marketing and Recruitment",
    slug: "alfred-guaman",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Yl",
    lastName: "Guanchez",
    title: "Finance Manager II",
    slug: "yl-guanchez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Justine A.",
    lastName: "Guariglia",
    title: "Principal Gifts Officer",
    slug: "justine-a-guariglia",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jen",
    lastName: "Gudaz",
    title:
      " Senior Associate Director of Athletics, the Robert E. Browning '56 Director of Physical Education and the Helen Newman Director of Recreational Services",
    slug: "jen-gudaz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sherry A.",
    lastName: "Guernsey",
    title: "Executive Director of the Shared Services Center",
    slug: "sherry-a-guernsey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nahum",
    lastName: "Guerra",
    title: "Front Office Manager",
    slug: "nahum-guerra",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Isabel",
    lastName: "Guerrero",
    title: "ILR NYC Receptionist",
    slug: "isabel-guerrero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel",
    lastName: "Guevara",
    title: "Intramural Official",
    slug: "daniel-guevara",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Joseph Michael",
    lastName: "Guidi",
    title: "Accounts Receivable Representative",
    slug: "joseph-michael-guidi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mrs Maria Josephine",
    lastName: "Guidi",
    title: "Sales Manager",
    slug: "mrs-maria-josephine-guidi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ginger P.",
    lastName: "Guidi",
    title: "Graduate Student Service Rep.",
    slug: "ginger-p-guidi",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lingli Ma",
    lastName: "Guilbeau",
    title: "Acquisitions Specialist for Chinese Language Materials",
    slug: "lingli-ma-guilbeau",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jean-Michel",
    lastName: "Guillemin",
    title: "Business Intelligence Architect",
    slug: "jean-michel-guillemin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Isidoro Michan",
    lastName: "Guindi",
    title: "Critic Visiting",
    slug: "isidoro-michan-guindi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michelle",
    lastName: "Guinyard",
    title:
      " Assistant Dean of Students for Student Support & Advocacy Service (Case Manager)",
    slug: "michelle-guinyard",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rachel L.",
    lastName: "Gunderson",
    title: "Senior Instructional Designer.",
    slug: "rachel-l-gunderson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Norma",
    lastName: "Gunn",
    title: "Administrator II",
    slug: "norma-gunn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sadaget S.",
    lastName: "Gurbanova",
    title: "Administrative Asst II",
    slug: "sadaget-s-gurbanova",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chelsea",
    lastName: "Guster",
    title: "Accounts Rep V",
    slug: "chelsea-guster",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mary S.",
    lastName: "Guthrie",
    title: "AAD Development Director",
    slug: "mary-s-guthrie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adrian",
    lastName: "Gutierrez",
    title: "Assistant Director of Admissions",
    slug: "adrian-gutierrez",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Emma",
    lastName: "Gutierrez",
    title: "Natural Areas Steward",
    slug: "emma-gutierrez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Pilar",
    lastName: "Gutierrez",
    title: "(Riccio) Art Studio Monitor",
    slug: "pilar-gutierrez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sophia",
    lastName: "Guy",
    title: "Manager of AIS Project Management & Governance",
    slug: "sophia-guy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Karen",
    lastName: "Guzman",
    title: "Urban Garden Educator",
    slug: "karen-guzman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Allison De",
    lastName: "Guzman",
    title: "Academic Records and Student Services Associate",
    slug: "allison-de-guzman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Aaradhyaa",
    lastName: "Gyawali",
    title: "Business Simulation Lab Asst",
    slug: "aaradhyaa-gyawali",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Serafina",
    lastName: "Ha",
    title: "Administrative Manager",
    slug: "serafina-ha",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Scott Andrew",
    lastName: "Haber",
    title: "Communication Spec III",
    slug: "scott-andrew-haber",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lynne T.",
    lastName: "Haberstock",
    title: "Director of Annual Giving, Cornell Law School",
    slug: "lynne-t-haberstock",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brian",
    lastName: "Hackenjos",
    title: "Equipment Material Handler",
    slug: "brian-hackenjos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wendy J.",
    lastName: "Hackett",
    title: "Contracts Specialist",
    slug: "wendy-j-hackett",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Diana",
    lastName: "Hackett",
    title: "Digital Literacy Librarian",
    slug: "diana-hackett",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Robert G.",
    lastName: "Hadad",
    title: "Vegetable Crops Specialist",
    slug: "robert-g-hadad",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrea",
    lastName: "Haenlin-Mott",
    title: "ADA Coordinator",
    slug: "andrea-haenlin-mott",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Yassi",
    lastName: "Hafezi",
    title: "Project Manager, Single Cell Profiling",
    slug: "yassi-hafezi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael Chief",
    lastName: "Haflett",
    title: "Manager, Audio & Video Technologies",
    slug: "michael-chief-haflett",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Andre",
    lastName: "Hafner",
    title: "Director of AAP IT Solutions",
    slug: "andre-hafner",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jeannine Crouse",
    lastName: "Hagadorn",
    title: "Graduate Field Coordinator",
    slug: "jeannine-crouse-hagadorn",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ray",
    lastName: "Hage",
    title: "Assistant Director for STEP",
    slug: "ray-hage",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Giuliana",
    lastName: "Hage",
    title: "Studio Partnerships Coordinator",
    slug: "giuliana-hage",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Carol Fields",
    lastName: "Hagen",
    title: "Director of Administration",
    slug: "carol-fields-hagen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bridget",
    lastName: "Hagen",
    title: "Marketing Communications Specialist",
    slug: "bridget-hagen",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Chad A.",
    lastName: "Hagstrom",
    title: "Kuali Java Developer",
    slug: "chad-a-hagstrom",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Carine J",
    lastName: "Hails",
    title: "Executive Director, Office of Trusts, Estates and Gift Planning",
    slug: "carine-j-hails",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marshall",
    lastName: "Haim",
    title: "Assistant Director, Athletic Communications",
    slug: "marshall-haim",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lorissa K.",
    lastName: "Haines",
    title: "Research Administration Specialist",
    slug: "lorissa-k-haines",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sky",
    lastName: "Haines",
    title: "Dean's Office Assistant, Learning Center Team Leader",
    slug: "sky-haines",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jerrie",
    lastName: "Haines",
    title: "Program Aide",
    slug: "jerrie-haines",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Justin D.",
    lastName: "Haines",
    title: "Community Engagement Sergeant",
    slug: "justin-d-haines",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah Elizabeth",
    lastName: "Hair",
    title: "Senior Lead, Transactions",
    slug: "sarah-elizabeth-hair",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mats",
    lastName: "Hakansson",
    title: "Design Director",
    slug: "mats-hakansson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeffrey W.",
    lastName: "Hall",
    title: "Senior Associate Director of Athletics, Sports Marketing",
    slug: "jeffrey-w-hall",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Wahieñhawi",
    lastName: "Hall",
    title:
      " Assistant Director of Counseling & Psychological Services- Equity & Inclusion",
    slug: "wahie-hawi-hall",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Graham A.",
    lastName: "Hall",
    title: "IT Project Manager",
    slug: "graham-a-hall",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Hazel M.",
    lastName: "Hall",
    title: "Associate Director of Building Care",
    slug: "hazel-m-hall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shelly R.",
    lastName: "Hall",
    title: "Finance Specialist III",
    slug: "shelly-r-hall",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jonathan L.",
    lastName: "Hall",
    title: "Digital Marketing Manager",
    slug: "jonathan-l-hall",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Will",
    lastName: "Hall",
    title: "Systems Administrator III",
    slug: "will-hall",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Melissa",
    lastName: "Hall",
    title: "Grant Coordinator",
    slug: "melissa-hall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samuel James",
    lastName: "Halligan",
    title: "Equity and Title IX Investigator",
    slug: "samuel-james-halligan",
    dei: true,
    category: "Legal",
  },
  {
    firstName: "Andrew",
    lastName: "Hallowell",
    title: "Bulletin 24/25",
    slug: "andrew-hallowell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chelsea L",
    lastName: "Halstead",
    title: "Director, Cornell Center on the Death Penalty Worldwide",
    slug: "chelsea-l-halstead",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michele",
    lastName: "Hamill",
    title: "Head Conservator",
    slug: "michele-hamill",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Reeve",
    lastName: "Hamilton",
    title: "Assistant Dean of Marketing & Communications",
    slug: "reeve-hamilton",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Diane",
    lastName: "Hamilton",
    title: "Director of SCL Assessment and Analytics",
    slug: "diane-hamilton",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Timothy",
    lastName: "Hamilton",
    title: "Building Care Manager",
    slug: "timothy-hamilton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stacey",
    lastName: "Hamilton",
    title: "Assistant Director, Financial Aid Support Services",
    slug: "stacey-hamilton",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Cyrus",
    lastName: "Hamilton-Ferguson",
    title: "Assistant Director, Disability Access Consultant",
    slug: "cyrus-hamilton-ferguson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jessica",
    lastName: "Hammond",
    title: "Administrative Assistant III",
    slug: "jessica-hammond",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tracy B.",
    lastName: "Hammond",
    title: "Research Administration Coordinator",
    slug: "tracy-b-hammond",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lauren",
    lastName: "Hamre",
    title: "Residential Hall Director",
    slug: "lauren-hamre",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Faith Haeun",
    lastName: "Han",
    title: "Mailroom Assistant",
    slug: "faith-haeun-han",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Richard Byungjin",
    lastName: "Han",
    title: "Bulletin 24/25",
    slug: "richard-byungjin-han",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine",
    lastName: "Han",
    title: "HR Talent and Engagement Associate",
    slug: "christine-han",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Mary Catherine",
    lastName: "Hanchar",
    title: "Chair's Assistant, Department of Ecology and Evolutionary Biology",
    slug: "mary-catherine-hanchar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Holly A.",
    lastName: "Hancharik",
    title: "Administrative Asst IV",
    slug: "holly-a-hancharik",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patrick M",
    lastName: "Hancy",
    title: "Evening and Weekend Supervisor",
    slug: "patrick-m-hancy",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kelly L.",
    lastName: "Hanley",
    title: "Environment Health & Safety Associate",
    slug: "kelly-l-hanley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "L. Rebecca",
    lastName: "Hann",
    title: "Associate Dean for Finance and Administration",
    slug: "l-rebecca-hann",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nicola",
    lastName: "Hanna",
    title: "HR & Payroll Coordinator",
    slug: "nicola-hanna",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ms Pamela J.",
    lastName: "Hanna",
    title: "Undergraduate/Graduate Coordinator",
    slug: "ms-pamela-j-hanna",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Keith",
    lastName: "Hannon",
    title: "Major Gift Officer",
    slug: "keith-hannon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Grant W.",
    lastName: "Hansen",
    title: "Vice President, Enterprise Programs",
    slug: "grant-w-hansen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kelli Bruce",
    lastName: "Hansen",
    title: "Stephen E. and Evalyn Edwards Milman Director, RMC",
    slug: "kelli-bruce-hansen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley",
    lastName: "Hansen",
    title: "Finance Specialist II",
    slug: "ashley-hansen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amber L",
    lastName: "Hanson",
    title: "Loan Servicing and Collections Manager",
    slug: "amber-l-hanson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Janelle L.",
    lastName: "Hanson",
    title: "Administrative Asst IV",
    slug: "janelle-l-hanson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yue",
    lastName: "Hao",
    title: "Evening & Weekend Supervisor",
    slug: "yue-hao",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caroline Eve",
    lastName: "Haradon",
    title: "Principal Gifts Associate",
    slug: "caroline-eve-haradon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dixie",
    lastName: "Harder",
    title: "Finance Specialist",
    slug: "dixie-harder",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michael David",
    lastName: "Harders",
    title: "Inactive Hazardous Waste Site Manager",
    slug: "michael-david-harders",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lori",
    lastName: "Harders",
    title: "Accounts Rep V",
    slug: "lori-harders",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nancy",
    lastName: "Hardesty",
    title: "Administrative Asst",
    slug: "nancy-hardesty",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carla",
    lastName: "Harding",
    title: "Admissions Administrative and Processing Assistant",
    slug: "carla-harding",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sevyn",
    lastName: "Hardy",
    title: "Associate Dean of Students, Individual Behavior and Development",
    slug: "sevyn-hardy",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Erin",
    lastName: "Hargett",
    title: "Financial Aid Counselor I",
    slug: "erin-hargett",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Riris Christiarini",
    lastName: "Harningtyas",
    title: "ILR Graduate Programs Social Media Assistant III (Porter)",
    slug: "riris-christiarini-harningtyas",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ben",
    lastName: "Harper",
    title: "Climate Jobs Associate",
    slug: "ben-harper",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric Paul",
    lastName: "Harrington",
    title: "Director of Occupational & Environmental Health",
    slug: "eric-paul-harrington",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Allyssa",
    lastName: "Harrington",
    title: "Barbara Benioff Friedman `59 Director of Sports Nutrition",
    slug: "allyssa-harrington",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shayla Ruth",
    lastName: "Harrington",
    title: "Access Services and ILL Manager",
    slug: "shayla-ruth-harrington",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Harland",
    lastName: "Harris",
    title: "Configuration Consultant",
    slug: "harland-harris",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kevin F.",
    lastName: "Harris",
    title: "Frank B. Miller Director",
    slug: "kevin-f-harris",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katy",
    lastName: "Harris",
    title: "Associate Athletic Director, Sports Medicine Administration",
    slug: "katy-harris",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer C.",
    lastName: "Harris",
    title: "Administrator IV",
    slug: "jennifer-c-harris",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gennie",
    lastName: "Harris",
    title: "Web Developer",
    slug: "gennie-harris",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lati",
    lastName: "Harris",
    title: "Client Service Representative",
    slug: "lati-harris",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Monique",
    lastName: "Harrison",
    title: "Senior Research & Planning Associate",
    slug: "monique-harrison",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kristina",
    lastName: "Harrison",
    title: "Assistant Director of Experiential Learning",
    slug: "kristina-harrison",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kortney",
    lastName: "Harrison",
    title: "Administrative Asst IV - Medical Records Team Leader",
    slug: "kortney-harrison",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Johnathan G.",
    lastName: "Hart",
    title: "Assistant Manager of Finance",
    slug: "johnathan-g-hart",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Carley",
    lastName: "Hart",
    title: "Director of Corporate Partnerships, Runway Startup Program",
    slug: "carley-hart",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jenn",
    lastName: "Hart",
    title: "Catering Sales Manager",
    slug: "jenn-hart",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joel",
    lastName: "Harter",
    title:
      " Associate Dean of Students, Director of the Office of Spirituality and Meaning-Making and Cornell United Religious Work",
    slug: "joel-harter",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jeremy Francis",
    lastName: "Hartigan",
    title: "Senior Associate Athletics Director, Communications",
    slug: "jeremy-francis-hartigan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Holly McIntyre",
    lastName: "Hartigan",
    title: "Staff Writer",
    slug: "holly-mcintyre-hartigan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "David",
    lastName: "Hartino",
    title: "MAE Instructional Lab Team Lead",
    slug: "david-hartino",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Danielle N. D.",
    lastName: "Hartman",
    title: "Classification/Compensation Associate",
    slug: "danielle-n-d-hartman",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ellen",
    lastName: "Hartman",
    title: "Manager of Internal Communications",
    slug: "ellen-hartman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Susan L.",
    lastName: "Hartman",
    title: "Sr. Project Coordinator",
    slug: "susan-l-hartman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shane Fitzgerald",
    lastName: "Hartman",
    title: "Bldg Coord III",
    slug: "shane-fitzgerald-hartman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Liz",
    lastName: "Hartman",
    title:
      " Assistant Director of Engaged Learning and Entrepreneurial Exploration",
    slug: "liz-hartman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Matthew Joel",
    lastName: "Hartwig",
    title: "Technical Support Provider",
    slug: "matthew-joel-hartwig",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tami",
    lastName: "Hastings",
    title: "Financial Application Support Specialist",
    slug: "tami-hastings",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tim",
    lastName: "Hastings",
    title: "Director, Enterprise Programs",
    slug: "tim-hastings",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kerrigan",
    lastName: "Hastings",
    title: "Administrative Coordinator",
    slug: "kerrigan-hastings",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rose W.",
    lastName: "Hastings",
    title: "Grant & Contract Officer",
    slug: "rose-w-hastings",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joshua Ross",
    lastName: "Hatch",
    title: "Milk Plant Worker S07",
    slug: "joshua-ross-hatch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda C.",
    lastName: "Hatcher",
    title: "Director, Strategic Alumni Engagement Initiatives",
    slug: "amanda-c-hatcher",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lisa W.",
    lastName: "Hatfield",
    title: "VP, Individual Student Enrollment",
    slug: "lisa-w-hatfield",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Steven",
    lastName: "Hatfield",
    title: "Bldg Coord III",
    slug: "steven-hatfield",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Olivia Grace",
    lastName: "Hathaway",
    title: "Major Gift Associate",
    slug: "olivia-grace-hathaway",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Timothy M",
    lastName: "Hatley",
    title: "eCornell Casual Student Support Agent",
    slug: "timothy-m-hatley",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Amanda Melody",
    lastName: "Hauptfleisch",
    title: "Associate Director of Marketing",
    slug: "amanda-melody-hauptfleisch",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Shelly",
    lastName: "Haus",
    title: "Administrative Asst IV",
    slug: "shelly-haus",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Corri",
    lastName: "Haus",
    title: "Financial Transaction Representative",
    slug: "corri-haus",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kaylee",
    lastName: "Havington",
    title: "Accounts Representative",
    slug: "kaylee-havington",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tracy M.",
    lastName: "Havlik",
    title: "EHS Technical Assistant",
    slug: "tracy-m-havlik",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Candy",
    lastName: "Hawker",
    title: "Financial Transaction Representative",
    slug: "candy-hawker",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessica",
    lastName: "Hawkey",
    title: "Program Manager, Incoming Student Programs",
    slug: "jessica-hawkey",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Elizabeth Haven",
    lastName: "Hawley",
    title: "Associate University Librarian for Special Collections",
    slug: "elizabeth-haven-hawley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Deirdre L",
    lastName: "Hay",
    title: "Director, LLM and International Career Services",
    slug: "deirdre-l-hay",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Katie E",
    lastName: "Hayden",
    title: "Training and Education Associate, CJI",
    slug: "katie-e-hayden",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jamie",
    lastName: "Hayden",
    title: "Director of Financial Aid",
    slug: "jamie-hayden",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Caitlin",
    lastName: "Hayes",
    title: "Senior Staff Writer",
    slug: "caitlin-hayes",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Bo L.",
    lastName: "Hayes",
    title: "Supervisor of Field Services",
    slug: "bo-l-hayes",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sarah Elizabeth",
    lastName: "Hayes",
    title: "Interim Program Marketing Lead",
    slug: "sarah-elizabeth-hayes",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Melissa S.",
    lastName: "Hayes",
    title: "Financial Transaction Representative",
    slug: "melissa-s-hayes",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Catheryn",
    lastName: "Hayes",
    title: "Corporate Account Manager",
    slug: "catheryn-hayes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jada Simone",
    lastName: "Haynes",
    title: "Public Services Assistant and Student Supervisor",
    slug: "jada-simone-haynes",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Dan",
    lastName: "Hazlitt",
    title: "IT Manager, Enterprise Applications",
    slug: "dan-hazlitt",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Douglas Patrick",
    lastName: "Hazlitt",
    title: "Integrated Marketing and Online Community Manager",
    slug: "douglas-patrick-hazlitt",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Noël Carolyn",
    lastName: "Heaney",
    title: "Multimedia Specialist II",
    slug: "no-l-carolyn-heaney",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Hathaway Paige",
    lastName: "Heart",
    title:
      " Intramural Sports Student Supervisor, Student Labor/Facil Asst I(SCL-EM)",
    slug: "hathaway-paige-heart",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nicole L",
    lastName: "Heasley",
    title: "Dyson School Registrar & Associate Director of Student Services",
    slug: "nicole-l-heasley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kelly M.",
    lastName: "Heath",
    title: "Administrative Assistant III",
    slug: "kelly-m-heath",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paul",
    lastName: "Heckathorn",
    title: "E-Resources and Serials Assistant",
    slug: "paul-heckathorn",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Annie",
    lastName: "Heckel",
    title: "Electronic Information Technology Accessibility Manager",
    slug: "annie-heckel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Daniela",
    lastName: "Hedwig",
    title: "Elephant Listening Project Team Lead",
    slug: "daniela-hedwig",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shannon C.",
    lastName: "Heffron",
    title: "Enrollment Manager",
    slug: "shannon-c-heffron",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Erwin Thomas",
    lastName: "Heffron",
    title: "Fiscal Office Coordinator, Residential",
    slug: "erwin-thomas-heffron",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "David",
    lastName: "Hegelein",
    title: "Senior Financial Application Support Specialist",
    slug: "david-hegelein",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sharon A.",
    lastName: "Hegelein",
    title: "Admissions Administrative & Processing Assistant",
    slug: "sharon-a-hegelein",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Ryan Soule",
    lastName: "Heichel",
    title: "Finance Specialist III",
    slug: "ryan-soule-heichel",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "William P.",
    lastName: "Heilman",
    title: "Administrative Assistant IV",
    slug: "william-p-heilman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca A.",
    lastName: "Heilman",
    title: "Enrollment Counselor",
    slug: "rebecca-a-heilman",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Stella",
    lastName: "Hein",
    title: "Executive Director of Access and Community Empowerment",
    slug: "stella-hein",
    dei: true,
    category: "Miscellaneous",
  },
  {
    firstName: "Adam Charles",
    lastName: "Heisler",
    title: "Senior Project Manager",
    slug: "adam-charles-heisler",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tamara",
    lastName: "Heiss",
    title: "Administrative Asst III",
    slug: "tamara-heiss",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Holly C.",
    lastName: "Heitzman",
    title: "Executive Director of Development, University Major Gifts",
    slug: "holly-c-heitzman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Keith",
    lastName: "Hejna",
    title: "Assistant Dean, Alumni Affairs and Development",
    slug: "keith-hejna",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael",
    lastName: "Helms",
    title: "Pesticide Safety Education Leader",
    slug: "michael-helms",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scott",
    lastName: "Hemenway",
    title: "HR Services and Transitions Counselor",
    slug: "scott-hemenway",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michelle",
    lastName: "Hemingway",
    title: "Medical Record Specialist",
    slug: "michelle-hemingway",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle",
    lastName: "Hemly",
    title: "Athletic Trainer",
    slug: "danielle-hemly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laurie Cornwall",
    lastName: "Hemmings",
    title: "Assistant Director, IT Communications and Documentation",
    slug: "laurie-cornwall-hemmings",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kristina Rodriguez",
    lastName: "Hendricks",
    title:
      " Sr. Director of Industry Partnerships & Business Development, Break Through Tech",
    slug: "kristina-rodriguez-hendricks",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Randy L.",
    lastName: "Hendrickson",
    title: "Media Asst V",
    slug: "randy-l-hendrickson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kathryn",
    lastName: "Henion",
    title: "Unit Communications Coordinator",
    slug: "kathryn-henion",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brenda L.",
    lastName: "Henley",
    title: "Clinic Aide",
    slug: "brenda-l-henley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deborah Jo",
    lastName: "Henry",
    title: "Administrative Assistant",
    slug: "deborah-jo-henry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ron",
    lastName: "Henry",
    title: "IT Technical Communicator",
    slug: "ron-henry",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lillian E.",
    lastName: "Henry",
    title: "Administrator IV",
    slug: "lillian-e-henry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Masoy M.",
    lastName: "Henry",
    title: "Enrollment Manager",
    slug: "masoy-m-henry",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Tina",
    lastName: "Henry",
    title: "Finance Manager",
    slug: "tina-henry",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brian",
    lastName: "Henry",
    title: "Physical Therapy Assistant",
    slug: "brian-henry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William Richard",
    lastName: "Heptig",
    title: "Project Associate, Upstate New York I-Corps Node",
    slug: "william-richard-heptig",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emma",
    lastName: "Herbst",
    title: "Undergraduate Program Assistant",
    slug: "emma-herbst",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Randall L",
    lastName: "Herko",
    title: "Senior Architect",
    slug: "randall-l-herko",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Katherine Christine",
    lastName: "Herleman",
    title: "Interim Director of Strategic External Engagement & Partnerships",
    slug: "katherine-christine-herleman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Susan J.",
    lastName: "Herman",
    title: "Director, Instructional Design",
    slug: "susan-j-herman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ed",
    lastName: "Herman",
    title: "Applications Developer III",
    slug: "ed-herman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tiffany Abigail",
    lastName: "Hermawan",
    title: "(Dossinger) Student Labor/Facil Asst II",
    slug: "tiffany-abigail-hermawan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sara Xayarath",
    lastName: "Hernandez",
    title: "Associate Dean for Inclusion and Student Engagement",
    slug: "sara-xayarath-hernandez",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Krassimira",
    lastName: "Hernandez",
    title: "Senior Human Resource Business Partner",
    slug: "krassimira-hernandez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Aliyah",
    lastName: "Hernandez",
    title: "Enrollment Pod Leader",
    slug: "aliyah-hernandez",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Richard",
    lastName: "Herold",
    title: "Manager, Request Fulfillment",
    slug: "richard-herold",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Daniel",
    lastName: "Herreros",
    title: "Engaged Ambassador (EA)",
    slug: "daniel-herreros",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie P.",
    lastName: "Herrick",
    title: "IT Project Manager",
    slug: "stephanie-p-herrick",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Delia",
    lastName: "Herrin",
    title: "Associate Director for University Relations",
    slug: "delia-herrin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brenda L.",
    lastName: "Herrling",
    title: "Human Resources Generalist",
    slug: "brenda-l-herrling",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Stephanie",
    lastName: "Herron",
    title: "Senior Director of Advancement",
    slug: "stephanie-herron",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Randy B.",
    lastName: "Hess",
    title: "Purchasing Assistant",
    slug: "randy-b-hess",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dana Anne",
    lastName: "Hesson",
    title: "Assistant Director, Student and Young Alumni Programs",
    slug: "dana-anne-hesson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jeffrey J.",
    lastName: "Hetzel",
    title: "Instructional Technologies Supervisor",
    slug: "jeffrey-j-hetzel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eric",
    lastName: "Hibit",
    title: "Critic Visiting",
    slug: "eric-hibit",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Steven",
    lastName: "Hickey",
    title: "Finance Manager",
    slug: "steven-hickey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mark D.",
    lastName: "Hickey",
    title: "Mailroom Coordinator",
    slug: "mark-d-hickey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elliott",
    lastName: "Hickey",
    title: "Residence Hall Director",
    slug: "elliott-hickey",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Chloe Zina",
    lastName: "Hickman",
    title: "Lifeguard",
    slug: "chloe-zina-hickman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Niaome",
    lastName: "Hickman-Kargoll",
    title: "Section Head’s Assistant SIPS",
    slug: "niaome-hickman-kargoll",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tomisha N",
    lastName: "Hicks",
    title: "Administrative Manager",
    slug: "tomisha-n-hicks",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Betsy J",
    lastName: "Hicks",
    title: "Dairy Management Specialist",
    slug: "betsy-j-hicks",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Craig",
    lastName: "Higgins",
    title: "Associate Dean for Administration, College Business Officer",
    slug: "craig-higgins",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elizabeth",
    lastName: "Higgins",
    title: "Agricultural Business Management Specialist",
    slug: "elizabeth-higgins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bruce",
    lastName: "Higgins",
    title: "Senior Data Delivery Strategist",
    slug: "bruce-higgins",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Callean L",
    lastName: "Hile",
    title: "Undergrad Coordinator",
    slug: "callean-l-hile",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alisha Janelle",
    lastName: "Hill",
    title: "Pharmacist",
    slug: "alisha-janelle-hill",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ken",
    lastName: "Hill",
    title: "Assistant Director, Medical Services",
    slug: "ken-hill",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ann E.",
    lastName: "Hill",
    title: "Plant Accountant",
    slug: "ann-e-hill",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kyeosha",
    lastName: "Hill",
    title: "Senior Financial Reporting Specialist",
    slug: "kyeosha-hill",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Danialle D.",
    lastName: "Hill",
    title: "Event/Conference Coord I",
    slug: "danialle-d-hill",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John E.",
    lastName: "Hill",
    title: "Instructional Tech Spec III",
    slug: "john-e-hill",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Melissa J.",
    lastName: "Hill",
    title: "Assistant Director of Catering and Conference Services",
    slug: "melissa-j-hill",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessie J.",
    lastName: "Hilliker",
    title: "Executive Assistant to the Provost",
    slug: "jessie-j-hilliker",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alysia A.",
    lastName: "Hillyard",
    title: "IT Service Management Lead",
    slug: "alysia-a-hillyard",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bryan",
    lastName: "Hinchliffe",
    title: "Athletic Trainer",
    slug: "bryan-hinchliffe",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Richard",
    lastName: "Hine",
    title: "Systems Administrator III",
    slug: "richard-hine",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tobi",
    lastName: "Hines",
    title: "Assistant Director of Access Services",
    slug: "tobi-hines",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Alyssa Nicole",
    lastName: "Hingre",
    title: "Assistant Registrar",
    slug: "alyssa-nicole-hingre",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jacki",
    lastName: "Hinkle",
    title: "Development Program Assistant",
    slug: "jacki-hinkle",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christopher Charles",
    lastName: "Hinman",
    title: "Course Coordinator",
    slug: "christopher-charles-hinman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mikaela",
    lastName: "Hinterberger",
    title: "Advancement Services Records Specialist",
    slug: "mikaela-hinterberger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Corrie",
    lastName: "Hitchcock",
    title: "Processor",
    slug: "corrie-hitchcock",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Daniel",
    lastName: "Hitchen",
    title: "Communications Assistant IV",
    slug: "daniel-hitchen",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Daniel",
    lastName: "Hiterer",
    title: "Studio Programming Coordinator",
    slug: "daniel-hiterer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caitlin F.",
    lastName: "Hnis",
    title: "Lab Processing Coordinator",
    slug: "caitlin-f-hnis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Catherine Lang",
    lastName: "Ho",
    title: "NYC Deputy Director",
    slug: "catherine-lang-ho",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy",
    lastName: "Hoaglin",
    title: "Graphic Designer",
    slug: "amy-hoaglin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Anya",
    lastName: "Hoaglund",
    title: "Graduate Admissions and Applications Coordinator",
    slug: "anya-hoaglund",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Matthew P",
    lastName: "Hobbs",
    title: "Regional Gift Officer",
    slug: "matthew-p-hobbs",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bonnie S.",
    lastName: "Hockenberry",
    title: "Financial Manager",
    slug: "bonnie-s-hockenberry",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Carol I.",
    lastName: "Hockett",
    title: "Manager of School and Family Programs",
    slug: "carol-i-hockett",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rachael",
    lastName: "Hodgdon",
    title: "Research Safety Specialist",
    slug: "rachael-hodgdon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elisabeth",
    lastName: "Hodgdon",
    title: "Vegetable Crops Specialist",
    slug: "elisabeth-hodgdon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ayla K.",
    lastName: "Hodges",
    title: "Administrative Asst III",
    slug: "ayla-k-hodges",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Babette Rose",
    lastName: "Hodis",
    title: "Cataloging Associate, General",
    slug: "babette-rose-hodis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deborah Anne",
    lastName: "Hodys",
    title: "Deputy General Counsel",
    slug: "deborah-anne-hodys",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Sadie Josephine",
    lastName: "Hoefer",
    title: "CALS - Lab Assistant (L. Rayor Lab)",
    slug: "sadie-josephine-hoefer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christy",
    lastName: "Hoepting",
    title: "Vegetable Crops Specialist",
    slug: "christy-hoepting",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Barbara Jane",
    lastName: "Hoerner",
    title:
      " Director, University Foundation Relations and Corporate Philanthropy",
    slug: "barbara-jane-hoerner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alison Sue",
    lastName: "Hofer",
    title: "Documentation Specialist, arXiv",
    slug: "alison-sue-hofer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rita C.",
    lastName: "Hoffay",
    title: "Finance Specialist IV",
    slug: "rita-c-hoffay",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jill Renee",
    lastName: "Hoffman",
    title: "Assistant to the Department Chair",
    slug: "jill-renee-hoffman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kristine S.",
    lastName: "Hoffmeister",
    title:
      " Director of Alumni Relations & Law School Special Events Coordinator",
    slug: "kristine-s-hoffmeister",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jamie L.A.",
    lastName: "Hoffmier",
    title: "Director, Volunteer Giving Initiatives",
    slug: "jamie-l-a-hoffmier",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ella Rain",
    lastName: "Hogan",
    title:
      " Creative Writing Programs Co-Coordinator - Center for Transformative Action - Prisoner's Express (Gary Fine)",
    slug: "ella-rain-hogan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah Louisa",
    lastName: "Hogben",
    title: "Institutional Equity Investigator",
    slug: "sarah-louisa-hogben",
    dei: true,
    category: "Legal",
  },
  {
    firstName: "Mallory Diane Victoria",
    lastName: "Hohl",
    title: "Urban Garden Educator",
    slug: "mallory-diane-victoria-hohl",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sreang Veng",
    lastName: "Hok",
    title: "Multimedia Specialist I",
    slug: "sreang-veng-hok",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sean",
    lastName: "Holbert",
    title: "Desktop Team Leader",
    slug: "sean-holbert",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Derek Newton",
    lastName: "Holcomb",
    title: "Road Patrol Sergeant",
    slug: "derek-newton-holcomb",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel",
    lastName: "Holcomb",
    title: "Material Handler S05",
    slug: "daniel-holcomb",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle",
    lastName: "Holeck",
    title: "Administrative Asst III",
    slug: "michelle-holeck",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karolina",
    lastName: "Holl",
    title: "Financial Aid Counselor",
    slug: "karolina-holl",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Heather Leigh",
    lastName: "Holland",
    title: "Health Content Assistant",
    slug: "heather-leigh-holland",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa M.",
    lastName: "Holland",
    title: "Reading Room Supv & Sr. Admin Asst",
    slug: "melissa-m-holland",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katie",
    lastName: "Hollenbeck",
    title: "Associate Director, Events Management",
    slug: "katie-hollenbeck",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brenda",
    lastName: "Hollenbeck",
    title: "Associate Director, Prospect Management",
    slug: "brenda-hollenbeck",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Karen S.",
    lastName: "Hollenbeck",
    title: "Research Administration Coordinator",
    slug: "karen-s-hollenbeck",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jennifer E.",
    lastName: "Holleran",
    title: "Administrator IV",
    slug: "jennifer-e-holleran",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Madelynn",
    lastName: "Hollis",
    title: "Assistant Director for Career Development",
    slug: "madelynn-hollis",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tara",
    lastName: "Holm",
    title: "Dept Chairperson",
    slug: "tara-holm",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Erik",
    lastName: "Holmberg",
    title: "Systems Administrator II",
    slug: "erik-holmberg",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ms Polly Endreny",
    lastName: "Holmberg",
    title: "Coord Program II",
    slug: "ms-polly-endreny-holmberg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine",
    lastName: "Holmes",
    title: "Dir Post Doc Studies Program",
    slug: "christine-holmes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "William T.",
    lastName: "Holmes",
    title: "Systems Administrator",
    slug: "william-t-holmes",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "William J.",
    lastName: "Holt",
    title: "Shipping Working Supervisor",
    slug: "william-j-holt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marian Evelynn",
    lastName: "Holt",
    title: "Lab Processing Assistant III",
    slug: "marian-evelynn-holt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mark B.",
    lastName: "Holton",
    title: "Lindseth Director of Cornell Outdoor Education",
    slug: "mark-b-holton",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Donna L.",
    lastName: "Holzbaur",
    title: "Director of Administration",
    slug: "donna-l-holzbaur",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sylvie Rose",
    lastName: "Honig",
    title: "AI Strategist",
    slug: "sylvie-rose-honig",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Robert Ross",
    lastName: "Hoon",
    title: "Senior Associate General Counsel",
    slug: "robert-ross-hoon",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Anna Jessica",
    lastName: "Hooper",
    title: "IDP Facilitator",
    slug: "anna-jessica-hooper",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kristin C.",
    lastName: "Hopkins",
    title:
      " Chief Administrator for the Offices of the President and the Provost",
    slug: "kristin-c-hopkins",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Matt",
    lastName: "Hopkins",
    title: "Advancement Services Records Specialist",
    slug: "matt-hopkins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marshall R.",
    lastName: "Hopkins",
    title: "Graphic Designer",
    slug: "marshall-r-hopkins",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christina M",
    lastName: "Hopkins",
    title: "Interim Windows Servers Lead",
    slug: "christina-m-hopkins",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael",
    lastName: "Hopkins",
    title: "Financial Transaction Representative",
    slug: "michael-hopkins",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Maria S.",
    lastName: "Hopko",
    title: "Administrative Assistant to the Chair",
    slug: "maria-s-hopko",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Salina",
    lastName: "Hoque",
    title: "Compensation/Classification Senior Consultant",
    slug: "salina-hoque",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Keaton",
    lastName: "Horan",
    title:
      " Executive Assistant to the Dean of the Nolan School of Hotel Administration",
    slug: "keaton-horan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andrew",
    lastName: "Horbal",
    title: "Director, Access Services",
    slug: "andrew-horbal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hannah",
    lastName: "Horn",
    title: "Assistant Tax Director",
    slug: "hannah-horn",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amy S.",
    lastName: "Horner",
    title: "Senior Administrator to the VP",
    slug: "amy-s-horner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William E.",
    lastName: "Horning",
    title: "Director, OADI/Director of Student Opportunity Programs",
    slug: "william-e-horning",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kyle Alexander",
    lastName: "Hornyak",
    title: "Stewardship Communication Officer",
    slug: "kyle-alexander-hornyak",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Danielle Michele Vander",
    lastName: "Horst",
    title: "Graduate/Undergraduate Coordinator",
    slug: "danielle-michele-vander-horst",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jolene",
    lastName: "Horton",
    title: "IT Service Support Specialist",
    slug: "jolene-horton",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Toni",
    lastName: "Hoskins",
    title: "Administrative Assistant, Biomedical Sciences",
    slug: "toni-hoskins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anika",
    lastName: "Hossain",
    title: "Administrative Asst IV",
    slug: "anika-hossain",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Greta",
    lastName: "Hotopp",
    title: "Director of Finance and Administration",
    slug: "greta-hotopp",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Aimee",
    lastName: "Houghton",
    title: "Associate Dean for Graduate Legal Studies",
    slug: "aimee-houghton",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Ali",
    lastName: "Houissa",
    title:
      " Curator, Middle East & Islamic Studies & Collection Development Team Lead",
    slug: "ali-houissa",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Paul Augustyn",
    lastName: "Houle",
    title: "Applications Developer III",
    slug: "paul-augustyn-houle",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Arla Quinn",
    lastName: "Hourigan",
    title: "Graduate Education Program Manager",
    slug: "arla-quinn-hourigan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dale W.",
    lastName: "Houseknecht",
    title: "Service Program Mgr., Environmental Resources",
    slug: "dale-w-houseknecht",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Clive D.",
    lastName: "Howard",
    title: "Director of Brand Management",
    slug: "clive-d-howard",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rose",
    lastName: "Howard",
    title: "Assistant to the Director",
    slug: "rose-howard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth Ruth",
    lastName: "Howard",
    title: "Associate Director, Policy Implementation & Quality Management",
    slug: "elizabeth-ruth-howard",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "David J.",
    lastName: "Howe",
    title: "Associate Dean for Finance and Administration",
    slug: "david-j-howe",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Natosha",
    lastName: "Howe",
    title: "Financial Transaction Representative",
    slug: "natosha-howe",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Leonard Allen",
    lastName: "Howe",
    title: "Purchasing Agent II",
    slug: "leonard-allen-howe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Linda Croll",
    lastName: "Howell",
    title: "Senior Director, Employee Experience",
    slug: "linda-croll-howell",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Donna",
    lastName: "Howell",
    title: "Mgr Program",
    slug: "donna-howell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ruth W.",
    lastName: "Howell",
    title: "Associate Project Manager",
    slug: "ruth-w-howell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kerry",
    lastName: "Howell",
    title: "Director, CU Wellness Program",
    slug: "kerry-howell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jay A.",
    lastName: "Howell",
    title: "Sr. Desktop Support Specialist",
    slug: "jay-a-howell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nathan Ross",
    lastName: "Hoyser",
    title: "Mech Vehicle S11",
    slug: "nathan-ross-hoyser",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lori",
    lastName: "Hoyt",
    title: "Manager of Course Administration",
    slug: "lori-hoyt",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katya Renn",
    lastName: "Hrichak",
    title: "Communication Specialist",
    slug: "katya-renn-hrichak",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jessica",
    lastName: "Hsu",
    title: "Executive Assistant to the Dean, Brooks School",
    slug: "jessica-hsu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Susan",
    lastName: "Hu",
    title: "Assistant Director, Smith Family Business Initiative",
    slug: "susan-hu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Suzi",
    lastName: "Huang",
    title: "BSP Study Group Leader",
    slug: "suzi-huang",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Denise Ann",
    lastName: "Hubbard",
    title: "Inventory Coordinator",
    slug: "denise-ann-hubbard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle Ann",
    lastName: "Hubbell",
    title: "Financial Management & User Access Coordinator",
    slug: "michelle-ann-hubbell",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sam Wells",
    lastName: "Huener",
    title: "Conservation Associate",
    slug: "sam-wells-huener",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher",
    lastName: "Hufnagel",
    title: "Senior Director - CALS IT",
    slug: "christopher-hufnagel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Laura",
    lastName: "Hufnagel",
    title: "Executive Assistant to the Dean of Faulty & Research",
    slug: "laura-hufnagel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cicily Strong",
    lastName: "Hughes",
    title: "Coord Program I",
    slug: "cicily-strong-hughes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Heather",
    lastName: "Hughes",
    title: "Communications Manager",
    slug: "heather-hughes",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Richard Graylin",
    lastName: "Hughes",
    title: "Senior New Media Specialist",
    slug: "richard-graylin-hughes",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Karen L",
    lastName: "Hughes",
    title: "Financial Transaction Representative",
    slug: "karen-l-hughes",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Vildana",
    lastName: "Hughes",
    title: "University Lost and Found Coordinator",
    slug: "vildana-hughes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julie Kinder",
    lastName: "Hughes",
    title: "Chair's Assistant",
    slug: "julie-kinder-hughes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kathryn",
    lastName: "Hughes",
    title: "Electronic Monograph Ordering and Receiving Assistant",
    slug: "kathryn-hughes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leigh Ann",
    lastName: "Hughey",
    title: "Anesthesia Tech Assistant",
    slug: "leigh-ann-hughey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Candace",
    lastName: "Hulbert",
    title: "Coord Program I",
    slug: "candace-hulbert",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kevin Jay",
    lastName: "Hull",
    title: "Financial Analytics Specialist",
    slug: "kevin-jay-hull",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jay D.",
    lastName: "Hulslander",
    title: "Kuali Java Developer",
    slug: "jay-d-hulslander",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brandi",
    lastName: "Hulslander",
    title: "Client Experience Coordinator",
    slug: "brandi-hulslander",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scott W.",
    lastName: "Hulslander",
    title: "Registrar Coordinator",
    slug: "scott-w-hulslander",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "A.J.",
    lastName: "Humphrey",
    title: "Contracts Administrator",
    slug: "a-j-humphrey",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Thomas A.",
    lastName: "Hunt",
    title: "Administrative Supervisor for Resource Services",
    slug: "thomas-a-hunt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Olivia",
    lastName: "Hunt",
    title: "Assistant Director,  Tatkon Center for New Students",
    slug: "olivia-hunt",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tina",
    lastName: "Hunt",
    title: "Wellness & Fitness Specialist",
    slug: "tina-hunt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nathan",
    lastName: "Hunter",
    title: "Senior Emergency Manager",
    slug: "nathan-hunter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Helen Elizabeth",
    lastName: "Hunter",
    title: "Financial Transaction Representative",
    slug: "helen-elizabeth-hunter",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michael E.",
    lastName: "Hunter",
    title: "Field Crops IPM Coordinator",
    slug: "michael-e-hunter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen L.",
    lastName: "Husick",
    title: "Director of Payroll",
    slug: "karen-l-husick",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Johanna",
    lastName: "Hussain",
    title: "Bulletin 24/25",
    slug: "johanna-hussain",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Farzan",
    lastName: "Hussainzada",
    title: "LII 2025",
    slug: "farzan-hussainzada",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tyler",
    lastName: "Hust",
    title: "AV Manager",
    slug: "tyler-hust",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jenny",
    lastName: "Hutcherson",
    title: "Dean of Students and Assistant Dean for Student Services",
    slug: "jenny-hutcherson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kendra Odelia",
    lastName: "Hutchins",
    title:
      " Assistant Director of Advising, Biology Learning Communities Coordinator",
    slug: "kendra-odelia-hutchins",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Karen",
    lastName: "Hwa",
    title: "Production Editor",
    slug: "karen-hwa",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Gina Marie",
    lastName: "Hyjek",
    title:
      " Assistant to the AAD Associate Vice Presidents for Colleges and Units",
    slug: "gina-marie-hyjek",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Daniel",
    lastName: "Hyland",
    title: "HR Talent and Employee Engagement Partner",
    slug: "daniel-hyland",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jennifer A.",
    lastName: "Hynes",
    title: "Director, Instructional Design",
    slug: "jennifer-a-hynes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brittany",
    lastName: "Iafrate",
    title: "eCornell Student Support Lead",
    slug: "brittany-iafrate",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Anna",
    lastName: "Ialeggio",
    title: "Critic Visiting",
    slug: "anna-ialeggio",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sara Lynn",
    lastName: "Ianni",
    title: "Executive Director, EMBA Programs",
    slug: "sara-lynn-ianni",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Matthew N.",
    lastName: "Ibeike-jonah",
    title: "Assistant Director, Speech and Debate, Worlds Debate",
    slug: "matthew-n-ibeike-jonah",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dane T. Hendrix",
    lastName: "II",
    title: "Systems Security Consultant",
    slug: "dane-t-hendrix-ii",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Louis Anthony DiPietro",
    lastName: "II",
    title: "Public Relations and Content Specialist",
    slug: "louis-anthony-dipietro-ii",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Charles Lenwood Faison",
    lastName: "II",
    title: "Administrative Asst IV",
    slug: "charles-lenwood-faison-ii",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Charles F Johnson",
    lastName: "II",
    title: "Senior Labor & Employment Law Education Associate",
    slug: "charles-f-johnson-ii",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Kevin D. Mitchell",
    lastName: "II",
    title: "Building Care Manager",
    slug: "kevin-d-mitchell-ii",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kenneth H. Knapp",
    lastName: "II",
    title: "Sheet Metal Worker - GFP",
    slug: "kenneth-h-knapp-ii",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John Paul Massi",
    lastName: "II",
    title: "Academic HR Partner",
    slug: "john-paul-massi-ii",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Denny Totman",
    lastName: "II",
    title: "Technical Program Manager",
    slug: "denny-totman-ii",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "William Bryan Olson",
    lastName: "II",
    title: "Hotel Applications Administrator",
    slug: "william-bryan-olson-ii",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Don Hinshaw",
    lastName: "III",
    title: "Team Leader, Materials Warehouse",
    slug: "don-hinshaw-iii",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Raymond Adam Cebula",
    lastName: "III",
    title: "Program Director, Income and Benefits Program",
    slug: "raymond-adam-cebula-iii",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William L. Reynolds",
    lastName: "III",
    title: "Assistant Equipment Manager",
    slug: "william-l-reynolds-iii",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hugo Cesar",
    lastName: "Ikehara",
    title: "Harris Family Curator of the Arts of the Americas",
    slug: "hugo-cesar-ikehara",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eden",
    lastName: "Imperial",
    title: "Enrollment Counselor Specialist",
    slug: "eden-imperial",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Ashleigh Suzanne",
    lastName: "Imus",
    title: "ASQ Associate Managing Editor",
    slug: "ashleigh-suzanne-imus",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Esther",
    lastName: "In",
    title: "Bulletin associate",
    slug: "esther-in",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Simon",
    lastName: "Ingall",
    title: "Visual Resources Collections Coordinator",
    slug: "simon-ingall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen Anne",
    lastName: "Ingall",
    title: "Financial Transaction Representative",
    slug: "karen-anne-ingall",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lynnsey M",
    lastName: "Ingalls",
    title: "Incident Based Reporting & Clery Administrator",
    slug: "lynnsey-m-ingalls",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Tamara S. B.",
    lastName: "Ingram",
    title: "Associate Director",
    slug: "tamara-s-b-ingram",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carla Marie",
    lastName: "Ingrando",
    title: "Major GIfts Officer IV",
    slug: "carla-marie-ingrando",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Casey Henry",
    lastName: "Inman",
    title: "Finance Specialist III",
    slug: "casey-henry-inman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lynda C.",
    lastName: "Inseque",
    title: "Director of Technology and Venture Initiatives & Engagement",
    slug: "lynda-c-inseque",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ksenia Borisovna",
    lastName: "Ionova",
    title: "Senior Instructional Designer",
    slug: "ksenia-borisovna-ionova",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sue",
    lastName: "Irvine",
    title: "Salesforce Developer",
    slug: "sue-irvine",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Carrie",
    lastName: "Irwin",
    title: "Human Resources Director, Bowers CIS",
    slug: "carrie-irwin",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Katherine",
    lastName: "Isaacs",
    title:
      " Assistant Dean for Human Resources, Jeb E. Broooks School of Public Policy",
    slug: "katherine-isaacs",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Francesco",
    lastName: "Isidori",
    title: "Critic Visiting",
    slug: "francesco-isidori",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Samira",
    lastName: "Islam",
    title: "IDP Facilitator, Student Admin Asst I",
    slug: "samira-islam",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nibras",
    lastName: "Islam",
    title: "Administrative Assistant - Alternate Testing Program",
    slug: "nibras-islam",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Maryam Mahmoud",
    lastName: "Ismail",
    title: "Project Leader, (SDS) Student Commun Serv Asst II",
    slug: "maryam-mahmoud-ismail",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Adam",
    lastName: "Issah",
    title: "Computing Assistant",
    slug: "adam-issah",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Teresa",
    lastName: "Iturriaga",
    title: "Collections Asst V",
    slug: "teresa-iturriaga",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chas B. Porter",
    lastName: "IV",
    title: "Energy Piping Distribution Manager",
    slug: "chas-b-porter-iv",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melina",
    lastName: "Ivanchikova",
    title: "Associate Director of Inclusive Teaching",
    slug: "melina-ivanchikova",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Jennifer Nichole",
    lastName: "Ivison",
    title: "Residence Hall Director",
    slug: "jennifer-nichole-ivison",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Emily",
    lastName: "Ivory",
    title: "Director of Admissions & College Registrar",
    slug: "emily-ivory",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Julian",
    lastName: "Iwasko",
    title: "Program Assistant, Upward Bound, Student Commun Serv Asst II",
    slug: "julian-iwasko",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Susie",
    lastName: "Jackson",
    title: "HR Business Partner",
    slug: "susie-jackson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Darren",
    lastName: "Jackson",
    title: "Affirmative Action Compliance Consultant",
    slug: "darren-jackson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Stephen (Steve) B",
    lastName: "Jackson",
    title: "Senior Management Consultant",
    slug: "stephen-steve-b-jackson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle Lamarre",
    lastName: "Jackson",
    title: "IT Project Manager",
    slug: "michelle-lamarre-jackson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nate Joshua",
    lastName: "Jackson",
    title:
      " Gallery Monitor, (Riccio) AAP - Print Media Studio Monitor_Student Labor/Facil Asst I",
    slug: "nate-joshua-jackson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kaitlyn",
    lastName: "Jackson",
    title: "Policy Associate - SP",
    slug: "kaitlyn-jackson",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Amy Lynn",
    lastName: "Jackson",
    title: "Pre-Award Specialist",
    slug: "amy-lynn-jackson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cheryl A.",
    lastName: "Jacob",
    title: "Administrative Asst IV",
    slug: "cheryl-a-jacob",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lynette Robin",
    lastName: "Jacobs",
    title: "Administrative Asst",
    slug: "lynette-robin-jacobs",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chris",
    lastName: "Jacobsen",
    title:
      " Associate Dean of Alumni Affairs and Development, SC Johnson College of Business",
    slug: "chris-jacobsen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amy",
    lastName: "Jacobson",
    title: "Gift Planning Officer",
    slug: "amy-jacobson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Zachary",
    lastName: "Jacobson",
    title: "Bulletin associates",
    slug: "zachary-jacobson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Katie",
    lastName: "Jacoby",
    title: "Director of Administration",
    slug: "katie-jacoby",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura Ann",
    lastName: "Jacoby",
    title: "Manager, Academic Services",
    slug: "laura-ann-jacoby",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Zachary",
    lastName: "Jacques",
    title: "Director, RAIS",
    slug: "zachary-jacques",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hadassah Ruth",
    lastName: "Jahani",
    title: "Administrative Asst IV",
    slug: "hadassah-ruth-jahani",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brenda",
    lastName: "Jahnke",
    title: "Associate Dean for Marketing & Communications",
    slug: "brenda-jahnke",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Drusilla Bendu",
    lastName: "Jaiah",
    title: "Export Control Associate",
    slug: "drusilla-bendu-jaiah",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Renee M.",
    lastName: "Jakaub",
    title: "Administrative Asst IV",
    slug: "renee-m-jakaub",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kimberly Brett",
    lastName: "Jakobson",
    title: "Mental Health Access & Referral Specialist",
    slug: "kimberly-brett-jakobson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Shannon",
    lastName: "James",
    title: "Configuration Consultant",
    slug: "shannon-james",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jeff",
    lastName: "James",
    title: "Associate Director, Business Development and Licensing",
    slug: "jeff-james",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alan",
    lastName: "James",
    title: "Equipment Tech V",
    slug: "alan-james",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Astrid Camille",
    lastName: "James",
    title:
      " Creative Writing Program Co-Coordinator - Center for Transformative Action - Prisoner's Express (Gary Fine)",
    slug: "astrid-camille-james",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Candyse",
    lastName: "James",
    title:
      " HR Talent Sourcing, Onboarding, and Employee Engagement Lead-Student and Campus Life Human Resources",
    slug: "candyse-james",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Gregory T",
    lastName: "Jameson",
    title: "Bulletin 24/25",
    slug: "gregory-t-jameson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chelsea Grace",
    lastName: "Jamieson",
    title: "AAD Program Assistant I",
    slug: "chelsea-grace-jamieson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephen L",
    lastName: "Janeski",
    title: "System and Strategic Communications Manager",
    slug: "stephen-l-janeski",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer",
    lastName: "Janke",
    title: "Administrative Asst III",
    slug: "jennifer-janke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria",
    lastName: "Jannetto",
    title: "Casual Student Support Agent",
    slug: "maria-jannetto",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Becky",
    lastName: "Jantz",
    title: "Administrative Asst IV",
    slug: "becky-jantz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Connie",
    lastName: "Jarrard",
    title: "Basketball Head Table",
    slug: "connie-jarrard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dzenana",
    lastName: "Javor",
    title: "Finance Specialist III",
    slug: "dzenana-javor",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sophie",
    lastName: "Jean",
    title: "Graduate Office Assistant",
    slug: "sophie-jean",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "John D.",
    lastName: "Jelliff",
    title: "Emergency Services Supervisor",
    slug: "john-d-jelliff",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda",
    lastName: "Jemison",
    title: "Consultant, Health and Welfare Programs",
    slug: "amanda-jemison",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Cassandra",
    lastName: "Jenis",
    title: "Major Gift Associate",
    slug: "cassandra-jenis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Keith G.",
    lastName: "Jenkins",
    title: "GIS/Spatial Data Applications Librarian, Chimesmaster",
    slug: "keith-g-jenkins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sabrina",
    lastName: "Jenner",
    title: "Administrative Assistant",
    slug: "sabrina-jenner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carol",
    lastName: "Jennings",
    title: "Multimedia Specialist II",
    slug: "carol-jennings",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jason",
    lastName: "Jennings",
    title: "Desktop Support Manager",
    slug: "jason-jennings",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kevin James",
    lastName: "Jensen",
    title: "Executive Director of Financial Aid",
    slug: "kevin-james-jensen",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Ingrid M",
    lastName: "Jensen",
    title: "Director of Student Services, Bowers CIS",
    slug: "ingrid-m-jensen",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Karen M.",
    lastName: "Jerkes",
    title: "Lab Processing Assistant III",
    slug: "karen-m-jerkes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Pamela Mattone",
    lastName: "Jerzak",
    title: "Manager of Finance and Budget",
    slug: "pamela-mattone-jerzak",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Helen",
    lastName: "Jessop",
    title: "Accounts Rep IV",
    slug: "helen-jessop",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Urvashi",
    lastName: "Jha",
    title: "Assistant Director of Marketing Analytics",
    slug: "urvashi-jha",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Shinong",
    lastName: "Ji",
    title: "Counselor Therapist, APIDA Community Liaison",
    slug: "shinong-ji",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Shuqing",
    lastName: "Ji",
    title: "Research Supp Spec I",
    slug: "shuqing-ji",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Li",
    lastName: "Jiang",
    title: "Entrepreneur in Residence",
    slug: "li-jiang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Juan Jacobo",
    lastName: "Jimenez",
    title: "Director, International Health Safety and Security",
    slug: "juan-jacobo-jimenez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yi",
    lastName: "Jin",
    title: "Cataloging Associate, Chinese",
    slug: "yi-jin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Curtis R",
    lastName: "Jirsa",
    title: "Info Tech Area Mgr II",
    slug: "curtis-r-jirsa",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jasminy",
    lastName: "Joe",
    title: "Registration Manager",
    slug: "jasminy-joe",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Rebecca",
    lastName: "Joffrey",
    title: "Director of Digital Innovation & Strategy",
    slug: "rebecca-joffrey",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alan",
    lastName: "Joffrey",
    title: "Director of Administration",
    slug: "alan-joffrey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karilyn",
    lastName: "Johanesen",
    title: "Critic Visiting",
    slug: "karilyn-johanesen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Erica Mehan",
    lastName: "Johns",
    title: "Lead for eCommons Institutional Repository Service",
    slug: "erica-mehan-johns",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Travis Christopher",
    lastName: "Johns",
    title: "Audio-Video Support Specialist",
    slug: "travis-christopher-johns",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christopher Michael",
    lastName: "Johns",
    title: "Mann Lending Coordinator",
    slug: "christopher-michael-johns",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christine",
    lastName: "Johnson",
    title: "UAW Benefits Liaison, Interim UAW President",
    slug: "christine-johnson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Len",
    lastName: "Johnson",
    title: "Assistant Dean for Marketing and Communications",
    slug: "len-johnson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tyler",
    lastName: "Johnson",
    title: "Executive Assistant to the Assistant Vice President",
    slug: "tyler-johnson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Becca",
    lastName: "Johnson",
    title: "Enterprise Project Manager",
    slug: "becca-johnson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Quentara",
    lastName: "Johnson",
    title: "Associate Director, Diversity Alumni Programs",
    slug: "quentara-johnson",
    dei: true,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca",
    lastName: "Johnson",
    title: "Gift Planning Officer",
    slug: "rebecca-johnson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Eric A.",
    lastName: "Johnson",
    title: "Manager of Cloud Architecture",
    slug: "eric-a-johnson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael Royce",
    lastName: "Johnson",
    title: "Project Manager",
    slug: "michael-royce-johnson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tammy J.",
    lastName: "Johnson",
    title: "Manager of Projects",
    slug: "tammy-j-johnson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marijane H.",
    lastName: "Johnson",
    title: "Project Manager",
    slug: "marijane-h-johnson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michele L.",
    lastName: "Johnson",
    title: "Administrative Asst III",
    slug: "michele-l-johnson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lynn Marie",
    lastName: "Johnson",
    title: "Cornell Statistical Consulting Unit Director",
    slug: "lynn-marie-johnson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jimmy",
    lastName: "Johnson",
    title: "Conference and Event Planner",
    slug: "jimmy-johnson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew D.",
    lastName: "Johnson",
    title: "Administrative Manager",
    slug: "matthew-d-johnson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew Spencer",
    lastName: "Johnson",
    title: "Multimedia Specialist II",
    slug: "andrew-spencer-johnson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Reese Ariana",
    lastName: "Johnson",
    title: "LII - Wex, Student Athletic Serv Asst I",
    slug: "reese-ariana-johnson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jacob",
    lastName: "Johnson",
    title: "Residence Hall Director",
    slug: "jacob-johnson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Anne Marie",
    lastName: "Johnson",
    title: "Project FeederWatch Assistant",
    slug: "anne-marie-johnson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jamieson P.",
    lastName: "Johnson",
    title: "Multimedia Assistant V",
    slug: "jamieson-p-johnson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Destynee Alexis",
    lastName: "Johnson",
    title: "IT Asst.",
    slug: "destynee-alexis-johnson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Laurie Margaret",
    lastName: "Johnston",
    title: "Senior Director of Staff and Labor Relations",
    slug: "laurie-margaret-johnston",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Laurie",
    lastName: "Johnston",
    title: "Director of Alumni Engagement",
    slug: "laurie-johnston",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Matt",
    lastName: "Johnston",
    title: "Maintenance Planner",
    slug: "matt-johnston",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brenda",
    lastName: "Joly",
    title: "Human Resources Associate",
    slug: "brenda-joly",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Elizabeth",
    lastName: "Jonas",
    title: "Counselor Therapist - International Student Community Liaison",
    slug: "elizabeth-jonas",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Derrick Shawn",
    lastName: "Jones",
    title: "Assistant Director for Identity and Access Management",
    slug: "derrick-shawn-jones",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Morgan Blake",
    lastName: "Jones",
    title: "Administrative Assistant/Receptionist",
    slug: "morgan-blake-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth",
    lastName: "Jones",
    title: "Assistant Director of Research and Programming",
    slug: "elizabeth-jones",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Scott D",
    lastName: "Jones",
    title: "Associate Project Manager",
    slug: "scott-d-jones",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Margaret Ivy",
    lastName: "Jones",
    title: "Administrative Coordinator",
    slug: "margaret-ivy-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel P.",
    lastName: "Jones",
    title: "ACRefrig Mech/Plumb",
    slug: "daniel-p-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Barbara Jeanne",
    lastName: "Jones",
    title: "Administrative Assistant III",
    slug: "barbara-jeanne-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nancy",
    lastName: "Jones",
    title: "Administrative Asst III",
    slug: "nancy-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joy A.",
    lastName: "Jones",
    title: "Building Coordinator",
    slug: "joy-a-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa",
    lastName: "Jones",
    title: "Sr. Director of Program Delivery, Break Through Tech",
    slug: "melissa-jones",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mary Beth",
    lastName: "Jordan",
    title: "Assistant Dean and Director of Human Resources - CVM",
    slug: "mary-beth-jordan",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Lynette",
    lastName: "Jordan",
    title: "Executive Staff Assistant, Deans Office, Cornell Tech",
    slug: "lynette-jordan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tiffany",
    lastName: "Jordan",
    title: "Accounts Representative",
    slug: "tiffany-jordan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessica J",
    lastName: "Jordan",
    title: "Finance & Human Resource Coordinator",
    slug: "jessica-j-jordan",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Steven L.",
    lastName: "Jordan",
    title: "Emergency Services Specialist - Lead",
    slug: "steven-l-jordan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paige Marie",
    lastName: "Jordan",
    title: "Intramural Sports Student Supervisor, Student Athletic Serv Asst I",
    slug: "paige-marie-jordan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Valerie Ann",
    lastName: "Jordan-Mount",
    title: "Finance Administrative Assistant",
    slug: "valerie-ann-jordan-mount",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dayna",
    lastName: "Jorgenson",
    title: "Accounts Rep IV",
    slug: "dayna-jorgenson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cassandre Pierre",
    lastName: "Joseph",
    title: "Director of Workforce Engagement",
    slug: "cassandre-pierre-joseph",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rachel",
    lastName: "Joseph",
    title: "NYC Administrative Director",
    slug: "rachel-joseph",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kwesi",
    lastName: "Joseph",
    title: "Urban Garden Educator",
    slug: "kwesi-joseph",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Menasha A",
    lastName: "Joseph",
    title: "Human Resources Assistant",
    slug: "menasha-a-joseph",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Joan Anne",
    lastName: "Joseph",
    title: "CALS - AIISP Tutor",
    slug: "joan-anne-joseph",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Yolanda",
    lastName: "Josephs",
    title: "HR Services and Transitions Center Counselor",
    slug: "yolanda-josephs",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Tomer",
    lastName: "Joshua",
    title: "Associate Director, Runway and Spinouts",
    slug: "tomer-joshua",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jah'Seek'I",
    lastName: "Joslyn",
    title: "Intramural Supervisor",
    slug: "jah-seek-i-joslyn",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Timothy",
    lastName: "Joyce",
    title: "Insertion Device Support Specialist",
    slug: "timothy-joyce",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mr Michael P. Riley",
    lastName: "Jr",
    title: "Sr. Principal Gifts Officer",
    slug: "mr-michael-p-riley-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John J. Mack",
    lastName: "Jr",
    title: "Director of Strategic SaaS & Business Continuity",
    slug: "john-j-mack-jr",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Curtis Verne Josey",
    lastName: "Jr",
    title: "Associate Director, Analytics & Data Strategy",
    slug: "curtis-verne-josey-jr",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eduardo Gonzalez",
    lastName: "Jr",
    title: "Assistant Director for Diversity, Equity, and Inclusion - CCE",
    slug: "eduardo-gonzalez-jr",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Thomas Paul LaFalce",
    lastName: "Jr",
    title: "Director, Annual Fund Leadership Giving",
    slug: "thomas-paul-lafalce-jr",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Chuck Jessop",
    lastName: "Jr",
    title: "Custom Development Business Support Manager",
    slug: "chuck-jessop-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joseph Anthony Morabito",
    lastName: "Jr",
    title: "Associate Project Manager",
    slug: "joseph-anthony-morabito-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bill R. Leonard",
    lastName: "Jr",
    title: "Department of Transportation Specialist",
    slug: "bill-r-leonard-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James F. Hatch",
    lastName: "Jr",
    title: "Project Maintenance Planner",
    slug: "james-f-hatch-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tanner Leto",
    lastName: "Jr",
    title: "Contracts Lead",
    slug: "tanner-leto-jr",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Pacifico Jude B. Savella",
    lastName: "Jr",
    title: "Administrative Asst II",
    slug: "pacifico-jude-b-savella-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jack D. Wood",
    lastName: "Jr",
    title: "Finance Specialist II",
    slug: "jack-d-wood-jr",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alejandro fransisco Parra",
    lastName: "Jr",
    title: "Cafe Service Worker",
    slug: "alejandro-fransisco-parra-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jodi Anderson",
    lastName: "Jr",
    title:
      " Director of Technological Innovation, Criminal Justice and Employment Initiative",
    slug: "jodi-anderson-jr",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shaun Joseph Doherty",
    lastName: "Jr",
    title: "Energy Transition and Carbon Management Partnerships Lead",
    slug: "shaun-joseph-doherty-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Francis Minh Tran",
    lastName: "Jr",
    title: "Senior PeopleSoft Developer",
    slug: "francis-minh-tran-jr",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jonathan B Roman",
    lastName: "Jr",
    title: "Hazardous Materials Associate",
    slug: "jonathan-b-roman-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Richard C. Gaisser",
    lastName: "Jr",
    title: "Biosafety Specialist",
    slug: "richard-c-gaisser-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert Wayne Spencer",
    lastName: "Jr",
    title: "Mason",
    slug: "robert-wayne-spencer-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Pete Capalongo",
    lastName: "Jr",
    title: "Mason - FP",
    slug: "pete-capalongo-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel Mark Sims",
    lastName: "Jr",
    title: "Transportation Service Rep 2",
    slug: "daniel-mark-sims-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brett Preston",
    lastName: "Jr",
    title: "Administrative Asst IV",
    slug: "brett-preston-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Billy Cote",
    lastName: "Jr",
    title: "Catherwood Access Services Manager",
    slug: "billy-cote-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Allen L. Konz",
    lastName: "Jr",
    title: "Sheet Metal Worker",
    slug: "allen-l-konz-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edwin Dow",
    lastName: "Jr",
    title: "Head Table Staff/Official",
    slug: "edwin-dow-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edward C Butler",
    lastName: "Jr",
    title: "Mech Maint S07",
    slug: "edward-c-butler-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ana Cristina",
    lastName: "Juan-Gomez",
    title: "Art Direction Specialist",
    slug: "ana-cristina-juan-gomez",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elizabeth",
    lastName: "Juaniza-Saso",
    title: "Transition Associate",
    slug: "elizabeth-juaniza-saso",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bill",
    lastName: "Juda",
    title: "Web Developer",
    slug: "bill-juda",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jason",
    lastName: "Judd",
    title: "Executive Director",
    slug: "jason-judd",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kevin",
    lastName: "Judd",
    title: "Web Administrator",
    slug: "kevin-judd",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bonnie",
    lastName: "Judd",
    title: "Pharmacist",
    slug: "bonnie-judd",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexander",
    lastName: "Julian",
    title: "Generalist Counselor Therapist",
    slug: "alexander-julian",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jenny Lee",
    lastName: "June",
    title: "Collections Management Assistant",
    slug: "jenny-lee-june",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel Hyun-Woo",
    lastName: "Jung",
    title:
      " Editorial Assistant - Center for Transformative Action - Lyson Center (Amy Christian)",
    slug: "daniel-hyun-woo-jung",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Emory",
    lastName: "Justice",
    title: "Associate Director - SCL Financial Transaction Center",
    slug: "emory-justice",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Syl",
    lastName: "Kacapyr",
    title: "Associate Director of Marketing & COmmunications",
    slug: "syl-kacapyr",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jessica",
    lastName: "Kaden",
    title: "Law Clerk",
    slug: "jessica-kaden",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Scott William",
    lastName: "Kadir",
    title: "Learning Consultant Assistant",
    slug: "scott-william-kadir",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Margaret",
    lastName: "Kadish-Bruns",
    title: "Senior Administrative Coordinator",
    slug: "margaret-kadish-bruns",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mandy",
    lastName: "Kafka",
    title: "Administrative Asst IV",
    slug: "mandy-kafka",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jason",
    lastName: "Kahabka",
    title: "Associate Dean for Administration",
    slug: "jason-kahabka",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Craig J.",
    lastName: "Kahlke",
    title: "Area Fruit Specialist",
    slug: "craig-j-kahlke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wendy C.",
    lastName: "Kain",
    title: "Research Supp Spec I",
    slug: "wendy-c-kain",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Csilla",
    lastName: "Kajtar",
    title: "Senior Contracts Officer",
    slug: "csilla-kajtar",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "D. Jamie",
    lastName: "Kalousdian",
    title: "Senior Producer",
    slug: "d-jamie-kalousdian",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Erik Geoffrey",
    lastName: "Kalweit",
    title: "Senior Coordinator",
    slug: "erik-geoffrey-kalweit",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Victor",
    lastName: "Kalytyuk",
    title: "ACRefrig Mech/Plumb",
    slug: "victor-kalytyuk",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brian H",
    lastName: "Kam",
    title: "Bulletin 24/25",
    slug: "brian-h-kam",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rabeya",
    lastName: "Kamal",
    title: "Assistant Director, Student Career Management",
    slug: "rabeya-kamal",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Laura M",
    lastName: "Kammermeier",
    title: "Mgr Sales Mktg",
    slug: "laura-m-kammermeier",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alex",
    lastName: "Kamphorst",
    title: "A&S Career Development Associate",
    slug: "alex-kamphorst",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Connie",
    lastName: "Kan",
    title: "Diversity Recruitment and Retention Generalist",
    slug: "connie-kan",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Krishna",
    lastName: "Kandala",
    title: "Executive in Residence",
    slug: "krishna-kandala",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brian",
    lastName: "Kane",
    title: "Advising Dean",
    slug: "brian-kane",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Valerie",
    lastName: "Kane",
    title: "Assistant Registrar for the Johnson Museum",
    slug: "valerie-kane",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lori L.",
    lastName: "Kanellis",
    title: "Senior Tax Associate",
    slug: "lori-l-kanellis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Su Jin",
    lastName: "Kang",
    title: "AAP Art Sculpture Monitor",
    slug: "su-jin-kang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rashmi",
    lastName: "Kanthi",
    title: "Manager, Migrations Program",
    slug: "rashmi-kanthi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alexandra “Lexie”",
    lastName: "Kapilian",
    title: "Bulletin 24/25",
    slug: "alexandra-lexie-kapilian",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristen M.",
    lastName: "Kaplan",
    title: "Associate Director of Enterprise Systems and Data Strategy",
    slug: "kristen-m-kaplan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rob",
    lastName: "Kaplan",
    title: "Physical Therapist",
    slug: "rob-kaplan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Neli",
    lastName: "Karabelova",
    title: "Marketing Manager",
    slug: "neli-karabelova",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Adene",
    lastName: "Karhan",
    title: "Training and Content Development Associate",
    slug: "adene-karhan",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kristin",
    lastName: "Karkutt",
    title: "MSLS Facilitator",
    slug: "kristin-karkutt",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kyle Patricia",
    lastName: "Karnuta",
    title: "Urban Ag Curriculum Development Specialist",
    slug: "kyle-patricia-karnuta",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Emmeline Evans",
    lastName: "Kaser",
    title: "Digital Archivist",
    slug: "emmeline-evans-kaser",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Carlos",
    lastName: "Kaskoun",
    title: "Lifeguard",
    slug: "carlos-kaskoun",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jonah",
    lastName: "Kasnitz",
    title: "Hazardous Materials Associate",
    slug: "jonah-kasnitz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tara",
    lastName: "Kastenhuber",
    title: "Accounts Receivable & Cash Management Coordinator",
    slug: "tara-kastenhuber",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Connie Lee",
    lastName: "Kastenhuber",
    title: "Finance Specialist II",
    slug: "connie-lee-kastenhuber",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ruth",
    lastName: "Katz",
    title: "Sr. Consultant, HR Analytics",
    slug: "ruth-katz",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Trynia",
    lastName: "Kaufman",
    title: "Transition Technical Assistance Associate",
    slug: "trynia-kaufman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michele R.",
    lastName: "Kaufman",
    title: "Accounts Rep V",
    slug: "michele-r-kaufman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Paramjit",
    lastName: "Kaur",
    title: "Enrollment Management Assistant",
    slug: "paramjit-kaur",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Brian T.",
    lastName: "Kay",
    title: "Associate Bursar",
    slug: "brian-t-kay",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michelle Elizabeth",
    lastName: "Kaye",
    title: "Web Design and Production Specialist",
    slug: "michelle-elizabeth-kaye",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kate E",
    lastName: "Keagle",
    title: "Research Administration Assistant",
    slug: "kate-e-keagle",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Colleen M.",
    lastName: "Kearns",
    title: "Team Lead & CALS Grants and Contracts Officer",
    slug: "colleen-m-kearns",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alex Castrillo",
    lastName: "Kearns-Apuya",
    title: "IT Support Associate",
    slug: "alex-castrillo-kearns-apuya",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Casey",
    lastName: "Keech",
    title: "Support Services Coordinator",
    slug: "casey-keech",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Katie",
    lastName: "Keegan",
    title: "Reference Assistant",
    slug: "katie-keegan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Justin",
    lastName: "Keel",
    title: "Program Facilitation Manager, STEM Programs",
    slug: "justin-keel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Omari",
    lastName: "Keeles",
    title: "Director of Diversity, Equity, Inclusion, and Belonging",
    slug: "omari-keeles",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Joshua James",
    lastName: "Keen",
    title: "Deputy Director, Financial Aid Services",
    slug: "joshua-james-keen",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Dan",
    lastName: "Keenan",
    title: "Generalist Counselor Therapist",
    slug: "dan-keenan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Brooke Kelley",
    lastName: "Keeney",
    title: "Senior Managing Editor IV",
    slug: "brooke-kelley-keeney",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Meg",
    lastName: "Keilbach",
    title: "Major Gift Officer, SC Johnson College of Business",
    slug: "meg-keilbach",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ryan",
    lastName: "Keilman",
    title: "Applications Developer II",
    slug: "ryan-keilman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Adi Grabiner",
    lastName: "Keinan",
    title:
      " Associate Vice Provost for Undergraduate Education and Director, Center for Dialogue and Pluralism, eCornell Course Facilitator - DEI IDP",
    slug: "adi-grabiner-keinan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Arthur",
    lastName: "Keith",
    title: "General Manager",
    slug: "arthur-keith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robin L.",
    lastName: "Keith",
    title: "Training Specialist",
    slug: "robin-l-keith",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Shelley",
    lastName: "Keith-Panulla",
    title: "Director of Web & Digital Experience",
    slug: "shelley-keith-panulla",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lara",
    lastName: "Kelingos",
    title: "Managing Editor",
    slug: "lara-kelingos",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Liam",
    lastName: "Kelleher",
    title: "Corporate Account Manager",
    slug: "liam-kelleher",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Natasha",
    lastName: "Keller",
    title: "Events Management and Communications Coordinator",
    slug: "natasha-keller",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Allison",
    lastName: "Keller",
    title: "Administrative Asst V",
    slug: "allison-keller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carolyn",
    lastName: "Keller",
    title: "Teaching Innovation Communication Strategist",
    slug: "carolyn-keller",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Susan Elizabeth",
    lastName: "Kelley",
    title: "Features Editor",
    slug: "susan-elizabeth-kelley",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Conrad L",
    lastName: "Kellogg",
    title: "Collections Management Assistant",
    slug: "conrad-l-kellogg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erin A.",
    lastName: "Kelly",
    title: "Director, International Alumni Relations",
    slug: "erin-a-kelly",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christopher J.",
    lastName: "Kelly",
    title: "Multimedia Designer",
    slug: "christopher-j-kelly",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Dawn M.",
    lastName: "Kelly",
    title: "Administrative Assistant, Principal Gifts",
    slug: "dawn-m-kelly",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brian",
    lastName: "Kelly",
    title: "Director, Technology Licensing, WCMC Office",
    slug: "brian-kelly",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sonja Watkins",
    lastName: "Kelly",
    title: "Senior Alumni Officer",
    slug: "sonja-watkins-kelly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deborah Anne Stayer",
    lastName: "Kelly",
    title: "Marketing Manager",
    slug: "deborah-anne-stayer-kelly",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer Dana Savran",
    lastName: "Kelly",
    title: "Production Editor",
    slug: "jennifer-dana-savran-kelly",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Aidan E.",
    lastName: "Kelly",
    title: "Administrative Asst IV",
    slug: "aidan-e-kelly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Beth Anne",
    lastName: "Kelly",
    title: "Cataloging Associate, Music",
    slug: "beth-anne-kelly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laken Foster",
    lastName: "Kelly",
    title: "Assistant Athletics Director, Fan Engagement",
    slug: "laken-foster-kelly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Josephine",
    lastName: "Kelly",
    title: "Lifeguard",
    slug: "josephine-kelly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Natalie",
    lastName: "Kelsey",
    title: "Public Services Assistant for RMC",
    slug: "natalie-kelsey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kevin D",
    lastName: "Kelvington",
    title: "Hardware Repair Service Manager",
    slug: "kevin-d-kelvington",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cynthia I.",
    lastName: "Kemp",
    title: "Financial Specialist",
    slug: "cynthia-i-kemp",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Katy",
    lastName: "Kempf",
    title: "Undergraduate/Graduate Coordinator",
    slug: "katy-kempf",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tracie Jayne",
    lastName: "Kennedy",
    title: "Executive Staff Assistant III, OVPRI",
    slug: "tracie-jayne-kennedy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joshua Joseph",
    lastName: "Kennedy",
    title: "Manager, Global Hubs Internships and Programs",
    slug: "joshua-joseph-kennedy",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Todd P.",
    lastName: "Kennett",
    title: "The Spirit of '57 Director of Rowing",
    slug: "todd-p-kennett",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Greta",
    lastName: "Kenney",
    title:
      " Senior Associate Dean of Students, Student Support & Advocacy Services",
    slug: "greta-kenney",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Terry",
    lastName: "Kent",
    title: "Major GIfts Ofcr IV",
    slug: "terry-kent",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Margaret L.",
    lastName: "Kent",
    title: "Administrative Asst IV",
    slug: "margaret-l-kent",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brooke Nunley",
    lastName: "Kenworthy",
    title: "(Bowman) - AAP Exhibition Support Position",
    slug: "brooke-nunley-kenworthy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Joanne J.",
    lastName: "Kenyon",
    title: "Web Community Support Specialist",
    slug: "joanne-j-kenyon",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Robert M.",
    lastName: "Kenyon",
    title: "Clark Hall Building Manager",
    slug: "robert-m-kenyon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jason R.",
    lastName: "Kenyon",
    title:
      " Videoconference and Collaborative Technologies System Administrator",
    slug: "jason-r-kenyon",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alison",
    lastName: "Kepic",
    title: "Online Point Solutions, Instructional Designer",
    slug: "alison-kepic",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ivan",
    lastName: "Keresztes",
    title: "Director, NMR Facility",
    slug: "ivan-keresztes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine",
    lastName: "Kerfoot",
    title: "Manager, Gift Compliance & Strategic Initiatives",
    slug: "christine-kerfoot",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Steven M.",
    lastName: "Kern",
    title: "Graphic Designer",
    slug: "steven-m-kern",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wayne Bezner",
    lastName: "Kerr",
    title: "Earth Source Heat Program Manager",
    slug: "wayne-bezner-kerr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brian",
    lastName: "Kerry",
    title: "Scheduling Specialist",
    slug: "brian-kerry",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "David S.",
    lastName: "Keslick",
    title: "Associate Director of Creative Solutions Group",
    slug: "david-s-keslick",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Stacy",
    lastName: "Kesselring",
    title: "Administrative Asst V",
    slug: "stacy-kesselring",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maegan Puzas",
    lastName: "Kessen",
    title: "CALS Assistant Director, Inclusive Academic Advising",
    slug: "maegan-puzas-kessen",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Kevin Michael",
    lastName: "Kessler",
    title: "Building and Security Coordinator",
    slug: "kevin-michael-kessler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren",
    lastName: "Kessler",
    title: "Project Administrative Assistant",
    slug: "lauren-kessler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Annie",
    lastName: "Keville",
    title: "Public Svcs Asst IV",
    slug: "annie-keville",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hazel",
    lastName: "Key",
    title: "Program Assistant for Class, Student and Young Alumni Programs",
    slug: "hazel-key",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Michelle",
    lastName: "Keyser-Speth",
    title: "HR Services and Transitions Counselor",
    slug: "michelle-keyser-speth",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sorayya",
    lastName: "Khan",
    title: "Critic Visiting",
    slug: "sorayya-khan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Hasham Ali",
    lastName: "Khan",
    title: "Program Assistant (PA), Student Acad Serv Asst II",
    slug: "hasham-ali-khan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Matthew R",
    lastName: "Kibbee",
    title: "Evidence Synthesis Coordinator",
    slug: "matthew-r-kibbee",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nadia D.",
    lastName: "Kiechle",
    title: "Associate Director of Stewardship and Donor Relations",
    slug: "nadia-d-kiechle",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Richard",
    lastName: "Kiely",
    title:
      " Associate Vice Provost for Engagement and Land-Grant Affairs, Director of Academic Initiatives, Einhorn Center",
    slug: "richard-kiely",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Meghan Paula",
    lastName: "Kilfeather",
    title: "Assistant Director - A&S Career Development Office",
    slug: "meghan-paula-kilfeather",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lisa",
    lastName: "Kilgore",
    title: "Administrative Asst IV",
    slug: "lisa-kilgore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert J.",
    lastName: "Kilts",
    title: "Health Fee and Purchasing Coordinator",
    slug: "robert-j-kilts",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ray",
    lastName: "Kim",
    title: "Director of Advising",
    slug: "ray-kim",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elaine",
    lastName: "Kim",
    title: "Labor Leadership Programs Associate",
    slug: "elaine-kim",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katie",
    lastName: "Kim",
    title:
      " Artistic Administration Associate - Kitchen Theatre Company (Emily Jackson)",
    slug: "katie-kim",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Seung Yeon",
    lastName: "Kim",
    title: "Digital Designer",
    slug: "seung-yeon-kim",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer Jin",
    lastName: "Kim",
    title: "Sustainability Events Coordinator",
    slug: "jennifer-jin-kim",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren Elizabeth",
    lastName: "Kim",
    title: "Wex",
    slug: "lauren-elizabeth-kim",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shinwoo",
    lastName: "Kim",
    title: "Technical Lead – Digital Preservation",
    slug: "shinwoo-kim",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Han",
    lastName: "Kim",
    title: "Executive in Residence",
    slug: "han-kim",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Valarie M.",
    lastName: "Kimber",
    title: "Administrative Coordinator, Legal Information Institute",
    slug: "valarie-m-kimber",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Tara",
    lastName: "Kimberl",
    title: "Financial Transaction Representative",
    slug: "tara-kimberl",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nancy K.",
    lastName: "Kimble",
    title: "Kuali Java Developer",
    slug: "nancy-k-kimble",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anna",
    lastName: "Kimble",
    title:
      " Associate Director of Annual Giving, CALS and Cornell Botanic Gardens",
    slug: "anna-kimble",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Natalie",
    lastName: "Kimbrough",
    title: "Assistant Director of Communication and Creative Services",
    slug: "natalie-kimbrough",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Liz",
    lastName: "Kinast",
    title: "Gift Planning Ofcr III",
    slug: "liz-kinast",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Vernetta",
    lastName: "Kinchen",
    title: "Director of Administration",
    slug: "vernetta-kinchen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katie",
    lastName: "King",
    title:
      " Associate Vice President, Office of Institutional Equity and Title IX",
    slug: "katie-king",
    dei: true,
    category: "Legal",
  },
  {
    firstName: "Kelli",
    lastName: "King",
    title: "Financial Transaction Representative",
    slug: "kelli-king",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Junelle",
    lastName: "King",
    title: "AHC Marketing & Social Media Specialist",
    slug: "junelle-king",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brandon",
    lastName: "King",
    title: "Administrative Assistant",
    slug: "brandon-king",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karanja",
    lastName: "King",
    title: "Assistant Equipment Manager",
    slug: "karanja-king",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Megan",
    lastName: "King",
    title: "Multimedia Specialist I",
    slug: "megan-king",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer Hall",
    lastName: "King",
    title: "CALS Admissions Counselor",
    slug: "jennifer-hall-king",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Charissa",
    lastName: "King-O'Brien",
    title: "Multimedia Coordinator",
    slug: "charissa-king-o-brien",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mahinder S.",
    lastName: "Kingra",
    title: "Editor in Chief",
    slug: "mahinder-s-kingra",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rhonda Ann",
    lastName: "Kinley",
    title: "Senior Registrar Specialist",
    slug: "rhonda-ann-kinley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Monica Yant",
    lastName: "Kinney",
    title: "Interim Vice President for University Relations",
    slug: "monica-yant-kinney",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jade A.",
    lastName: "Kinsman",
    title: "IT Project Coordinator",
    slug: "jade-a-kinsman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Drew",
    lastName: "Kirby",
    title: "Assistant Director, Regulatory and Program Support",
    slug: "drew-kirby",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ian Douglas",
    lastName: "Kirchner",
    title: "Director of Marketing Optimization",
    slug: "ian-douglas-kirchner",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Margaret Anne",
    lastName: "Kirk",
    title: "Critic Visiting",
    slug: "margaret-anne-kirk",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elizabeth Anne",
    lastName: "Kirk",
    title: "Communications, Grant Funding, and Events Coordinator",
    slug: "elizabeth-anne-kirk",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Staci J.",
    lastName: "Kirkland",
    title: "Major Gifts Associate",
    slug: "staci-j-kirkland",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rachel M.",
    lastName: "Kirschner",
    title: "Chair's Assistant",
    slug: "rachel-m-kirschner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amanda Leigh",
    lastName: "Kirwan",
    title: "Seasonal Admissions Readers",
    slug: "amanda-leigh-kirwan",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jeanne Susan",
    lastName: "Kisacky",
    title: "Grant Contract Ofcr I",
    slug: "jeanne-susan-kisacky",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kate",
    lastName: "Kisner",
    title: "Finance Specialist II",
    slug: "kate-kisner",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rachel Anne",
    lastName: "Kissinger",
    title: "Manager of Projects",
    slug: "rachel-anne-kissinger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rhonda Kay",
    lastName: "Kitch",
    title: "University Registrar",
    slug: "rhonda-kay-kitch",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brooke Ann",
    lastName: "Klausner",
    title: "Studio Administrative Asst",
    slug: "brooke-ann-klausner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacqueline",
    lastName: "Klein",
    title: "Assistant Dean of Graduate Education",
    slug: "jacqueline-klein",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Matt",
    lastName: "Klein",
    title: "Customer Experience Lead",
    slug: "matt-klein",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jo",
    lastName: "Klein",
    title: "Social Science Research and Spatial Data Librarian",
    slug: "jo-klein",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Bonnie Gail",
    lastName: "Klein",
    title: "Assistant Program Director, Tech LLM and NYC Visiting JD Programs",
    slug: "bonnie-gail-klein",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mary-Margaret",
    lastName: "Klempa",
    title:
      " Director of the Office of Sponsored Programs and Proposal Advancement",
    slug: "mary-margaret-klempa",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Holger",
    lastName: "Klinck",
    title: "Program Director",
    slug: "holger-klinck",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mikki",
    lastName: "Klinger",
    title: "Undergraduate Coordinator",
    slug: "mikki-klinger",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Skylar",
    lastName: "Klingfus",
    title: "Women's Ice Hockey Equipment Manager",
    slug: "skylar-klingfus",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nancy E.",
    lastName: "Klotz",
    title: "Senior Associate General Counsel",
    slug: "nancy-e-klotz",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Liz",
    lastName: "Kluz",
    title: "E-Resources Assistant",
    slug: "liz-kluz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jill I.",
    lastName: "Knapp",
    title:
      " Administrative Assistant – Compliance, Student Services and the Student-Athlete Experience",
    slug: "jill-i-knapp",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily J",
    lastName: "Knapp",
    title: "Serials & E-Resources Invoicing Coordinator",
    slug: "emily-j-knapp",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anna Leigh",
    lastName: "Knapp",
    title:
      " Electronics Product Development Specialist for Hardware Entrepreneurship Programs",
    slug: "anna-leigh-knapp",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Richard Joel",
    lastName: "Knepper",
    title: "Director, CAC",
    slug: "richard-joel-knepper",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Urszula",
    lastName: "Knepper",
    title: "Continuations and Acquisitions Associate",
    slug: "urszula-knepper",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lindsey",
    lastName: "Knewstub",
    title: "Deputy Director of Media Relations",
    slug: "lindsey-knewstub",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Genna Elizabeth",
    lastName: "Knight",
    title: "Communications Specialist",
    slug: "genna-elizabeth-knight",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kayla Marie",
    lastName: "Knupfer",
    title: "LII 2025, (SDS) Student Commun Serv Asst II",
    slug: "kayla-marie-knupfer",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jessica",
    lastName: "Ko",
    title: "Sr Data Curator",
    slug: "jessica-ko",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elaine",
    lastName: "Koch",
    title: "Administrative Assistant IV",
    slug: "elaine-koch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Suzanne",
    lastName: "Koehl",
    title: "Seminar/Events Coordinator",
    slug: "suzanne-koehl",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chelsea Claire",
    lastName: "Koelbl",
    title: "Lab Processing Coordinator",
    slug: "chelsea-claire-koelbl",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jesse T.",
    lastName: "Koennecke",
    title: "Director, Acquisitions and E-Resource Licensing Services",
    slug: "jesse-t-koennecke",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stacy Lynn",
    lastName: "Kolar",
    title: "Lab Processing Coordinator",
    slug: "stacy-lynn-kolar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley",
    lastName: "Kole",
    title: "Social Media Coordinator",
    slug: "ashley-kole",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Aaron Joseph",
    lastName: "Kolins",
    title: "Administrative Coordinator",
    slug: "aaron-joseph-kolins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Taylor E.",
    lastName: "Kolniak",
    title: "Athletic Trainer",
    slug: "taylor-e-kolniak",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Saritha",
    lastName: "Komanduru",
    title: "Full Stack Java Developer",
    slug: "saritha-komanduru",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christina",
    lastName: "Konstantinidou",
    title: "Assistant Director of Project Management, CALS OIT",
    slug: "christina-konstantinidou",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lisa M",
    lastName: "Kopp",
    title: "Coord Program II",
    slug: "lisa-m-kopp",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peter B.",
    lastName: "Kopp",
    title: "Annual Fund Officer II",
    slug: "peter-b-kopp",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edward A.",
    lastName: "Koppel",
    title: "Interim Director, Occupational Medicine",
    slug: "edward-a-koppel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Seth Hunter",
    lastName: "Koproski",
    title: "Gift Intention Coordinator",
    slug: "seth-hunter-koproski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tanmai",
    lastName: "Korapala",
    title: "Media & Comm Assistant",
    slug: "tanmai-korapala",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nicholas",
    lastName: "Kordek",
    title: "Finance Specialist II",
    slug: "nicholas-kordek",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gary Alan",
    lastName: "Koretzky",
    title: "Interim Vice Provost for Research",
    slug: "gary-alan-koretzky",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joseph",
    lastName: "Korevec",
    title: "Director,  Enrollment and Admissions",
    slug: "joseph-korevec",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Peter Alexander",
    lastName: "Korolov",
    title: "HRIS Applications Consultant",
    slug: "peter-alexander-korolov",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Beth",
    lastName: "Korson",
    title: "Administrative Asst III",
    slug: "beth-korson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth A.",
    lastName: "Kosalek",
    title: "Executive Director of Finance",
    slug: "elizabeth-a-kosalek",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jason W.",
    lastName: "Koski",
    title: "Multimedia Specialist II",
    slug: "jason-w-koski",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jeffrey R.",
    lastName: "Koski",
    title: "Equipment Tech V",
    slug: "jeffrey-r-koski",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alexander William",
    lastName: "Koski",
    title: "Security and Facility Assistant",
    slug: "alexander-william-koski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brianna",
    lastName: "Kosowitz",
    title: "Director of Recruitment Programs & Administration",
    slug: "brianna-kosowitz",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jan M.",
    lastName: "Kossowski",
    title: "Day Hall Technical Consultant",
    slug: "jan-m-kossowski",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rob",
    lastName: "Kotaska",
    title: "Reference Desk and Map Room Coordinator",
    slug: "rob-kotaska",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacob Robert",
    lastName: "Kotchish",
    title: "Administrative Supervisor, Echols Collection",
    slug: "jacob-robert-kotchish",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Josh",
    lastName: "Kotmel",
    title: "Access Control Systems Administrator",
    slug: "josh-kotmel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nicole C.",
    lastName: "Kotmel",
    title: "Consultant, Benefit Health Plans",
    slug: "nicole-c-kotmel",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Erin L.",
    lastName: "Kotmel",
    title: "Undergraduate Coordinator",
    slug: "erin-l-kotmel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jason",
    lastName: "Kovari",
    title: "Associate University Librarian, Collections and Technical Services",
    slug: "jason-kovari",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Phoebe Lynn",
    lastName: "Kowalewski",
    title: "Atlantic Philanthropies Archivist",
    slug: "phoebe-lynn-kowalewski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eli",
    lastName: "Kozik",
    title: "Assistant Director of Admissions",
    slug: "eli-kozik",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Amanda Lee Williams",
    lastName: "Kozik",
    title: "Associate Director of Graduate Admissions",
    slug: "amanda-lee-williams-kozik",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Matthew D.",
    lastName: "Kozlowski",
    title: "Environmental and Energy Services Group Manager",
    slug: "matthew-d-kozlowski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Pam",
    lastName: "Kozlowski",
    title: "Research Administration Assistant",
    slug: "pam-kozlowski",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mr D",
    lastName: "Krahmer",
    title: "Diversity and Inclusion Reference Librarian",
    slug: "mr-d-krahmer",
    dei: true,
    category: "Miscellaneous",
  },
  {
    firstName: "Scott",
    lastName: "Kramer",
    title: "Parent Giving Officer",
    slug: "scott-kramer",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Whitney",
    lastName: "Kramer",
    title: "ILR Research and Data Librarian",
    slug: "whitney-kramer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ed",
    lastName: "Kratil",
    title: "Building Information Model Program Manager",
    slug: "ed-kratil",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Daniel",
    lastName: "Kratochvil",
    title: "Senior Associate Dean of Academic Affairs",
    slug: "daniel-kratochvil",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Paul A.",
    lastName: "Krause",
    title: "Vice Provost External Education",
    slug: "paul-a-krause",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Thomas",
    lastName: "Krawczyk",
    title: "Research Supp Spec II",
    slug: "thomas-krawczyk",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jesse William",
    lastName: "Kreager",
    title: "Finance Manager",
    slug: "jesse-william-kreager",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Connor Morrison",
    lastName: "Kremmer",
    title: "REAL5320/5321 (Sharpsteen) CA",
    slug: "connor-morrison-kremmer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hayley Rein",
    lastName: "Kresock",
    title: "Subaward Associate",
    slug: "hayley-rein-kresock",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Hadas",
    lastName: "Kress-Gazit",
    title:
      " Associate Dean for Diversity and Academic Affairs, Geoffrey S.M. Hedrick Senior Professor",
    slug: "hadas-kress-gazit",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Peter",
    lastName: "Krieger",
    title: "Senior Director of External Relations and New York City Lead",
    slug: "peter-krieger",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Stephanie",
    lastName: "Krist",
    title: "Public Services Assistant",
    slug: "stephanie-krist",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kate",
    lastName: "Kristof",
    title: "Administrative Manager",
    slug: "kate-kristof",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Dina R.",
    lastName: "Kristof",
    title: "SHA Director of Student Services",
    slug: "dina-r-kristof",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Samantha",
    lastName: "Krivorot",
    title: "Enrollment Counselor II",
    slug: "samantha-krivorot",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Phaedra",
    lastName: "Krizo",
    title: "Casual QA Copy Editor",
    slug: "phaedra-krizo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ellie",
    lastName: "Krumm-Powers",
    title: "Grant Contract Ofcr I",
    slug: "ellie-krumm-powers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeramy A.",
    lastName: "Kruser",
    title: "Systems Administrator",
    slug: "jeramy-a-kruser",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Debbi",
    lastName: "Kruszewski-Warner",
    title: "Executive Director, Advancement Information Systems",
    slug: "debbi-kruszewski-warner",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Charles J.",
    lastName: "Kruzansky",
    title: "Associate Vice President for Government Relations",
    slug: "charles-j-kruzansky",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Erica",
    lastName: "Kryst",
    title: "Executive Director, Cornell Career Services",
    slug: "erica-kryst",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Monica",
    lastName: "Krzyszczyk",
    title: "Assistant Director of Stewardship",
    slug: "monica-krzyszczyk",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyle A.",
    lastName: "Kubick",
    title: "Sr. Director of Budget, Administration and University Licensing",
    slug: "kyle-a-kubick",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Greg",
    lastName: "Kulina",
    title: "Equipment Tech V",
    slug: "greg-kulina",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Vivek Vijay",
    lastName: "Kumar",
    title: "LII Full Stack Developer",
    slug: "vivek-vijay-kumar",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael",
    lastName: "Kuntz",
    title: "Basketball Head Table",
    slug: "michael-kuntz",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Beth",
    lastName: "Kunz",
    title: "Slate Services Manager",
    slug: "beth-kunz",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Karen M.",
    lastName: "Kunz",
    title: "Drafter III",
    slug: "karen-m-kunz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David A.",
    lastName: "Kuo",
    title: "Manager of Technology Services",
    slug: "david-a-kuo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael",
    lastName: "Kuo",
    title: "Project Manager",
    slug: "michael-kuo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yelena Shakhbazovna",
    lastName: "Kurbanova",
    title: "Cataloging Associate, Slavic",
    slug: "yelena-shakhbazovna-kurbanova",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Robert",
    lastName: "Kurcoba",
    title: "Digital Designer III",
    slug: "robert-kurcoba",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nancy Annette Kirby",
    lastName: "Kurjakovic",
    title: "Entrepreneur in Residence",
    slug: "nancy-annette-kirby-kurjakovic",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacob Edward",
    lastName: "Kurtz",
    title: "Research Administration Specialist",
    slug: "jacob-edward-kurtz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicole Lynn",
    lastName: "Kushner",
    title: "Biosafety Specialist I",
    slug: "nicole-lynn-kushner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Beth",
    lastName: "Kutler",
    title: "Associate Director for Medical Services",
    slug: "beth-kutler",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kathryn Diane",
    lastName: "Kvasnica",
    title: "Associate Director of Student Services",
    slug: "kathryn-diane-kvasnica",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jennifer (Hudler)",
    lastName: "Kwiatkowski",
    title: "Director of Development, Student and Campus Life",
    slug: "jennifer-hudler-kwiatkowski",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ethan",
    lastName: "Kwok",
    title: "SSAS Olivia Murray's Student Admin Asst I, Student Admin Asst I",
    slug: "ethan-kwok",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Phoebe",
    lastName: "Kyritsis",
    title: "Business Simulation Lab Asst, MGMT 6030 (Dowell) CA",
    slug: "phoebe-kyritsis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shea Amanda",
    lastName: "Kytomaa",
    title: "Associate Director, Student Experience",
    slug: "shea-amanda-kytomaa",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lyn E.",
    lastName: "LaBar",
    title: "Associate Director of CVM Alumni Affairs",
    slug: "lyn-e-labar",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ellen",
    lastName: "Labbate",
    title: "Acquisitions Assistant",
    slug: "ellen-labbate",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leah E.",
    lastName: "Laben",
    title: "Associate General Counsel",
    slug: "leah-e-laben",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jessica Portillo",
    lastName: "LaBrake",
    title: "Director for External Relations",
    slug: "jessica-portillo-labrake",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ranel M",
    lastName: "Lackner",
    title: "Enrollment Counselor, Team Lead",
    slug: "ranel-m-lackner",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Dana Phillip",
    lastName: "LaCombe",
    title: "Building Care Manager",
    slug: "dana-phillip-lacombe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather Renae",
    lastName: "LaCombe",
    title: "ADR & NCP Program Assistant",
    slug: "heather-renae-lacombe",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Christopher G.",
    lastName: "Ladd",
    title: "Lab Processing Supervisor",
    slug: "christopher-g-ladd",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mrs Marisa",
    lastName: "LaFalce",
    title: "Communications Assistant V",
    slug: "mrs-marisa-lafalce",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ann M.",
    lastName: "LaFave",
    title: "Assistant Dean for Academic Programs and Student Success",
    slug: "ann-m-lafave",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicole",
    lastName: "LaFave",
    title:
      " Director of Diversity & Inclusion, SC Johnson Graduate School of Management",
    slug: "nicole-lafave",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "DaeJaun",
    lastName: "LaFave",
    title: "Customer Service Rep",
    slug: "daejaun-lafave",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jonathan N",
    lastName: "Lafler",
    title: "Course Support Coordinator",
    slug: "jonathan-n-lafler",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Adam Robert",
    lastName: "LaFontaine",
    title: "Financial Services Associate",
    slug: "adam-robert-lafontaine",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Theresa Anne",
    lastName: "Lagasse",
    title: "Mgr Finance I",
    slug: "theresa-anne-lagasse",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jonathan M",
    lastName: "Lagasse",
    title: "Building Manager/Undergraduate Lab Asst.",
    slug: "jonathan-m-lagasse",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maighdlin E",
    lastName: "Lagonegro-Coar",
    title: "Enrollment Counselor I",
    slug: "maighdlin-e-lagonegro-coar",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Eric",
    lastName: "Laine",
    title: "Assistant Director of Graduate Programs",
    slug: "eric-laine",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kim",
    lastName: "Laine",
    title: "arXiv User and Membership Support Specialist",
    slug: "kim-laine",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Samantha",
    lastName: "Laite",
    title: "Coordinator, Jacobs Technion-Cornell Institute",
    slug: "samantha-laite",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Daniel R.",
    lastName: "Lajza",
    title: "Sr Telecommunications Coord",
    slug: "daniel-r-lajza",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elna",
    lastName: "Lalita",
    title: "ILR Course Assistant IV (Villa)",
    slug: "elna-lalita",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lindsay",
    lastName: "LaLonde",
    title: "Executive Assistant to the Office of the CCO",
    slug: "lindsay-lalonde",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Yvette A.",
    lastName: "Lam",
    title: "University Major Gift Officer",
    slug: "yvette-a-lam",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Henry",
    lastName: "Lam",
    title: "Director's Assistant",
    slug: "henry-lam",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sariena Mai",
    lastName: "Lam",
    title: "Account Representative",
    slug: "sariena-mai-lam",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rachael E.",
    lastName: "Lambertson",
    title: "Video Manager",
    slug: "rachael-e-lambertson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer",
    lastName: "LaMendola",
    title: "Administrative Asst V",
    slug: "jennifer-lamendola",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Naomi",
    lastName: "Lamour",
    title: "Assistant Director, Research Administration",
    slug: "naomi-lamour",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christopher Zolton",
    lastName: "Lampman",
    title: "Maintenance Assistant - FP",
    slug: "christopher-zolton-lampman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jim",
    lastName: "Lance",
    title: "Acquisitions Editor",
    slug: "jim-lance",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lucas",
    lastName: "Landaeta",
    title: "Instructional Support Technitian",
    slug: "lucas-landaeta",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marilyn A.",
    lastName: "Landon",
    title: "Finance Specialist III",
    slug: "marilyn-a-landon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lisa Rose",
    lastName: "Landon",
    title: "Administrative Assistant, Office of the University Librarian",
    slug: "lisa-rose-landon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura L.",
    lastName: "Landphair",
    title: "Executive Director of Information Technology",
    slug: "laura-l-landphair",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Peter T.",
    lastName: "Landre",
    title: "Assistant Director for CCE Regional Teams",
    slug: "peter-t-landre",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Becky Kay",
    lastName: "Lane",
    title: "Associate Director for Learning Technologies",
    slug: "becky-kay-lane",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sarah",
    lastName: "Lane",
    title: "Business Librarian",
    slug: "sarah-lane",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alexander Daniel",
    lastName: "Laney",
    title: "Gift Intention Specialist",
    slug: "alexander-daniel-laney",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ksenia",
    lastName: "Lang",
    title: "Administrative Asst IV",
    slug: "ksenia-lang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Connor",
    lastName: "Lang",
    title: "Assistant Director of Creative Video Design & Production",
    slug: "connor-lang",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Vanessa Catherine",
    lastName: "Langdon",
    title: "Digital Web Writer",
    slug: "vanessa-catherine-langdon",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Catalina",
    lastName: "Lange",
    title: "Academic and Event Scheduler",
    slug: "catalina-lange",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kristine S.",
    lastName: "Lange",
    title: "Administrative Assistant",
    slug: "kristine-s-lange",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren Riley",
    lastName: "Langtry",
    title: "Medical Technology Manager I",
    slug: "lauren-riley-langtry",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Hannah Lee",
    lastName: "Langtry",
    title: "Graduate Field & Event Coordinator",
    slug: "hannah-lee-langtry",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tatum Lynn",
    lastName: "Langworthy",
    title: "Administrative Asst II",
    slug: "tatum-lynn-langworthy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marcie",
    lastName: "Lanham",
    title: "Program Lead, Alumni Affairs and Development, Bowers CIS",
    slug: "marcie-lanham",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brandon",
    lastName: "Lanners",
    title: "Executive Director of the Office of Global Learning",
    slug: "brandon-lanners",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tom",
    lastName: "Lanzarone",
    title: "Director, Enterprise Programs",
    slug: "tom-lanzarone",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jeffrey L.",
    lastName: "Lapar",
    title: "Electrical Enterprise Manager",
    slug: "jeffrey-l-lapar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Josh",
    lastName: "LaPenna",
    title: "Director of Utilities Production",
    slug: "josh-lapenna",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anne M.",
    lastName: "LaPointe",
    title: "Dir-Catalyst Discovery/Dev Lab",
    slug: "anne-m-lapointe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Audrey",
    lastName: "Lapointe",
    title: "Grant Contract Associate",
    slug: "audrey-lapointe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brenda L.",
    lastName: "Lapp",
    title: "Systems Administrator III",
    slug: "brenda-l-lapp",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Colette",
    lastName: "Larkin",
    title: "Administrative Asst IV",
    slug: "colette-larkin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jon W",
    lastName: "LaRock",
    title: "Building Coordinator",
    slug: "jon-w-larock",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rhonda L.",
    lastName: "Larry",
    title: "FM Services Coordinator",
    slug: "rhonda-l-larry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anders P.",
    lastName: "Larson",
    title: "Finance Support",
    slug: "anders-p-larson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kaitlyn Elisabeth",
    lastName: "Larson",
    title: "Intramural Sports Student Supervisor",
    slug: "kaitlyn-elisabeth-larson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Theresa",
    lastName: "Laryea",
    title: "Procurement Assistant",
    slug: "theresa-laryea",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rikki Serafina",
    lastName: "Laser",
    title: "Grad School Student Admin Asst IV",
    slug: "rikki-serafina-laser",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Robert J.",
    lastName: "Lasher",
    title: "Sr Field Coord",
    slug: "robert-j-lasher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ken",
    lastName: "Lassey",
    title: "Senior Systems Administrator",
    slug: "ken-lassey",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Andy Scott",
    lastName: "Lasson",
    title: "AAP Epson Print Tech",
    slug: "andy-scott-lasson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chris",
    lastName: "Lastovicka",
    title: "Assistant Director of Digital Strategy",
    slug: "chris-lastovicka",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lindsey",
    lastName: "LaTray",
    title: "Financial Transaction Representative",
    slug: "lindsey-latray",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sara",
    lastName: "LaTrielle",
    title: "Coord Program III",
    slug: "sara-latrielle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brian M",
    lastName: "Latson",
    title: "Material Handler S07",
    slug: "brian-m-latson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lacey",
    lastName: "Lattin",
    title: "Assistant to the Chair",
    slug: "lacey-lattin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Emily",
    lastName: "Lau",
    title:
      " Outreach & Analytics Manager - Center for Transformative Action - NAFSN (Kim Hines)",
    slug: "emily-lau",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Caroline Marie",
    lastName: "Lauer",
    title: "Career Services Asst.",
    slug: "caroline-marie-lauer",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Anne M.",
    lastName: "Laughlin",
    title: "Assistant Dean and Director of Assessment",
    slug: "anne-m-laughlin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Leina Jane Mc",
    lastName: "Laughlin",
    title: "Admissions Student Serv Asst II",
    slug: "leina-jane-mc-laughlin",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Karen M.",
    lastName: "Laun",
    title: "Editor II",
    slug: "karen-m-laun",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Melissa",
    lastName: "Laverack",
    title: "Medical Technology Manager II-Virology",
    slug: "melissa-laverack",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kate",
    lastName: "LaVerne",
    title: "Technical Svcs Asst III",
    slug: "kate-laverne",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lior",
    lastName: "Lavie",
    title: "Ted Moore `71 Director of Sailing",
    slug: "lior-lavie",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Autumn M.",
    lastName: "Lavine",
    title: "NYS 4-H Fair & International Exchange Specialist",
    slug: "autumn-m-lavine",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "R.J.",
    lastName: "Lavine",
    title:
      " Gift Officer for the David M. Einhorn Center for Community Engagement",
    slug: "r-j-lavine",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tim",
    lastName: "Lavis",
    title: "Assistant Director, Learning Strategies Center",
    slug: "tim-lavis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nancy F.",
    lastName: "Law",
    title: "Grant Contract Associate",
    slug: "nancy-f-law",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mark A.",
    lastName: "Lawrence",
    title: "Web & Information Systems Manager",
    slug: "mark-a-lawrence",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Susanna",
    lastName: "Lawson",
    title: "Mgr Sales Mktg",
    slug: "susanna-lawson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jolene M.",
    lastName: "Layton",
    title: "Financial Services Manager",
    slug: "jolene-m-layton",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Quynh-Nhu",
    lastName: "Le",
    title: "Late Night Supervisor",
    slug: "quynh-nhu-le",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Melanie J. Ragin (On",
    lastName: "Leave)",
    title: "Assistant Dean for Inclusion & Academic Excellence",
    slug: "melanie-j-ragin-on-leave",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Jeffrey William",
    lastName: "Leaver",
    title: "Mech Vehicle S05",
    slug: "jeffrey-william-leaver",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aimee Elise",
    lastName: "Leavitt",
    title: "Illustrator",
    slug: "aimee-elise-leavitt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Verdene A.",
    lastName: "Lee",
    title: "Senior Associate Director",
    slug: "verdene-a-lee",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jane C.",
    lastName: "Lee",
    title: "Administrative Manager",
    slug: "jane-c-lee",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Esak",
    lastName: "Lee",
    title: "Nancy and Peter Meinig Family Investigator",
    slug: "esak-lee",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Helen",
    lastName: "Lee",
    title: "Associate Director",
    slug: "helen-lee",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Camille Gynsun",
    lastName: "Lee",
    title: "Manager of Web and Image",
    slug: "camille-gynsun-lee",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Steven Hsiao-Ting",
    lastName: "Lee",
    title: "Systems Administrator IV",
    slug: "steven-hsiao-ting-lee",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sean",
    lastName: "Lee",
    title: "Bulletin Fall 2024",
    slug: "sean-lee",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Clara S",
    lastName: "Lee",
    title: "Project Associate for Entrepreneurship Programs",
    slug: "clara-s-lee",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tooch",
    lastName: "LeFever",
    title: "Assistant for U.S. Regional Alumni Engagement",
    slug: "tooch-lefever",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lisa",
    lastName: "Lefever",
    title: "Collections Assistant for South Asia Collection",
    slug: "lisa-lefever",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Travis Jeffrey",
    lastName: "LeFever",
    title: "Supervising Pharmacist",
    slug: "travis-jeffrey-lefever",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melanie",
    lastName: "Lefkowitz",
    title: "Acting Associate Vice President for Communications",
    slug: "melanie-lefkowitz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer Wholey",
    lastName: "Lehman",
    title: "Marketing Writer",
    slug: "jennifer-wholey-lehman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Amanda Eve",
    lastName: "Leibeck",
    title: "Learning Consultant",
    slug: "amanda-eve-leibeck",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jill Holtzman",
    lastName: "Leichter",
    title: "Editor II",
    slug: "jill-holtzman-leichter",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jenny Christina",
    lastName: "Leijonhufvud",
    title: "Outreach Spaces & Exhibits Coordinator",
    slug: "jenny-christina-leijonhufvud",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "April D.",
    lastName: "Leiter",
    title: "Assistant to the Sr. Associate Dean",
    slug: "april-d-leiter",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ben",
    lastName: "Lem",
    title: "Network Administrator",
    slug: "ben-lem",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gloria",
    lastName: "Lemus-Chavez",
    title: "Administrative Asst IV",
    slug: "gloria-lemus-chavez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nolan",
    lastName: "Lendved",
    title: "Deputy Director, Strategic Communications",
    slug: "nolan-lendved",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michael S.",
    lastName: "Lenetsky",
    title: "Senior Department Manager",
    slug: "michael-s-lenetsky",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa Jervey",
    lastName: "Lennox",
    title: "Assistant Director, Volunteer Giving Initiatives",
    slug: "lisa-jervey-lennox",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Hank De",
    lastName: "Leo",
    title: "Web Accessibility Specialist",
    slug: "hank-de-leo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Marisol De",
    lastName: "Leon",
    title: "Technical Assistance Coordinator",
    slug: "marisol-de-leon",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Omar Orlando",
    lastName: "Leon-Mora",
    title: "AAP- IT Solutions Cage Monitor",
    slug: "omar-orlando-leon-mora",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Julia S.",
    lastName: "Leonard",
    title: "Program Assistant",
    slug: "julia-s-leonard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joyce",
    lastName: "Leonard",
    title: "Administrative Assistant",
    slug: "joyce-leonard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine De",
    lastName: "Leonardis",
    title: "Endocrinology Supervisor",
    slug: "christine-de-leonardis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Donna",
    lastName: "Leong",
    title: "Manager of Workforce Development",
    slug: "donna-leong",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ofer",
    lastName: "Leshed",
    title: "Associate Dean for Administation and Finance",
    slug: "ofer-leshed",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katherine",
    lastName: "Lesser",
    title: "MPH Student Services Coordinator",
    slug: "katherine-lesser",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Irene V.",
    lastName: "Lessmeister",
    title: "Director Admissions",
    slug: "irene-v-lessmeister",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Taylor",
    lastName: "Lester",
    title: "Generalist Counselor Therapist, Athletics & Physical Education",
    slug: "taylor-lester",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jodi Lynn",
    lastName: "Letham",
    title: "Field Crops Specialist",
    slug: "jodi-lynn-letham",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle J.",
    lastName: "Lethbridge",
    title: "Grant Coordinator",
    slug: "danielle-j-lethbridge",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Karen M.",
    lastName: "Levasseur",
    title: "Administrative Asst IV",
    slug: "karen-m-levasseur",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Treva L.",
    lastName: "Levine",
    title: "Administrative Manager",
    slug: "treva-l-levine",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Scott E.",
    lastName: "Levine",
    title: "Art Director",
    slug: "scott-e-levine",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diane",
    lastName: "Levitt",
    title: "Senior Director of K-12 Programs",
    slug: "diane-levitt",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ryann A.",
    lastName: "Levo",
    title: "Assistant Director, Custom Development",
    slug: "ryann-a-levo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elana",
    lastName: "Levy",
    title: "Associate Director for Sorority & Fraternity Life",
    slug: "elana-levy",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Monica",
    lastName: "Lewis",
    title: "Associate Vice President, Colleges and Units",
    slug: "monica-lewis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kay",
    lastName: "Lewis",
    title: "House Assistant Dean, William Keeton House",
    slug: "kay-lewis",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jone'cia",
    lastName: "Lewis",
    title: "Associate Director, Next Generation and Affinity Giving",
    slug: "jone-cia-lewis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Keionda Lei",
    lastName: "Lewis",
    title: "Talent Sourcer",
    slug: "keionda-lei-lewis",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Joshua Andrew",
    lastName: "Lewis",
    title: "Applications Developer III",
    slug: "joshua-andrew-lewis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kelly Lynn",
    lastName: "Lewis",
    title: "Accounts Rep V",
    slug: "kelly-lynn-lewis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rebecca",
    lastName: "Lewis",
    title: "Programs Finance Specialist",
    slug: "rebecca-lewis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sean Hardesty",
    lastName: "Lewis",
    title: "Urban Tech Coordinator",
    slug: "sean-hardesty-lewis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alyvia Ann",
    lastName: "Lewter",
    title: "Assistant, Cornell CALS Land Grant Affairs",
    slug: "alyvia-ann-lewter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alice",
    lastName: "Li",
    title: "Senior Director Center Technology Licensing",
    slug: "alice-li",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ye",
    lastName: "Li",
    title: "Business Title Director, Science and Agriculture Libraries",
    slug: "ye-li",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amy S.",
    lastName: "Li",
    title: "Digital Content Producer",
    slug: "amy-s-li",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Xiaoshan",
    lastName: "Li",
    title: "Systems Administrator",
    slug: "xiaoshan-li",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bruce",
    lastName: "Li",
    title: "Seasonal Admissions Readers",
    slug: "bruce-li",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Marco",
    lastName: "Li",
    title: "Security and Visitor Services Associate",
    slug: "marco-li",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christina",
    lastName: "Liang",
    title:
      " Senior Associate Dean of Students and Director of the Office of Student Conduct and Community Standards",
    slug: "christina-liang",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jenny",
    lastName: "Liao",
    title: "ARC Tutor - Fall Creek (Chris Bell)",
    slug: "jenny-liao",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christine",
    lastName: "Licata",
    title: "Casual Online Learning Technical Support Agent",
    slug: "christine-licata",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Denise E.",
    lastName: "Liddington",
    title: "Administrative Asst IV",
    slug: "denise-e-liddington",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Risa L.",
    lastName: "Lieberwitz",
    title: "Director of the Worker Institute",
    slug: "risa-l-lieberwitz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shari Lynn",
    lastName: "Lighthall",
    title: "Director of Agricultural Education Outreach",
    slug: "shari-lynn-lighthall",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shawn",
    lastName: "Ligocki",
    title: "Applications Developer III",
    slug: "shawn-ligocki",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sarah",
    lastName: "Lillis",
    title: "Sr Telecommunications Coord",
    slug: "sarah-lillis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rebekah Lynn",
    lastName: "Lilly",
    title: "Salesforce Senior Administrator",
    slug: "rebekah-lynn-lilly",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Leon",
    lastName: "Lilly",
    title: "Web Designer",
    slug: "leon-lilly",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Hyun Samuel",
    lastName: "Lim",
    title: "IDP Facilitator",
    slug: "hyun-samuel-lim",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Josh",
    lastName: "Lim",
    title: "Engaged Ambassador",
    slug: "josh-lim",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Celeste Kai-Lee",
    lastName: "Lim-Robinson",
    title: "IDP Facilitator, Business Simulation Lab Asst, AEM 2700 (Stapp) CA",
    slug: "celeste-kai-lee-lim-robinson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Adriana",
    lastName: "Lima",
    title: "Resident Hall Director",
    slug: "adriana-lima",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Susan",
    lastName: "Lin",
    title: "Director of Data, Analytics, and Business Intelligence",
    slug: "susan-lin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Charlotte",
    lastName: "Lin",
    title:
      " (Dossinger) Student Labor/Facil Asst II, Student Labor/Facil Asst II",
    slug: "charlotte-lin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Caidie",
    lastName: "Lin",
    title: "ILR Course Assistant IV (Schmidt), Project LIFE Assistant",
    slug: "caidie-lin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Yun",
    lastName: "Lin",
    title: "Assistant Director of Graduate Admissions",
    slug: "yun-lin",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Meng",
    lastName: "Lin",
    title: "Bioinformatics Coordinator, Breeding Insight Program",
    slug: "meng-lin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chelsea",
    lastName: "Lin",
    title: "IT Asst.",
    slug: "chelsea-lin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sarah J.",
    lastName: "Lincoln",
    title: "Administrative Assistant",
    slug: "sarah-j-lincoln",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristen Louise",
    lastName: "Lind",
    title: "Breeding Insight Training and Communication Lead",
    slug: "kristen-louise-lind",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Richard W.W.",
    lastName: "Lind",
    title: "Basketball Head Table",
    slug: "richard-w-w-lind",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jessie",
    lastName: "Lindberg",
    title: "Finance Specialist II",
    slug: "jessie-lindberg",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jill",
    lastName: "Lindblad",
    title: "Curriculum Lifecycle Management Application Administrator",
    slug: "jill-lindblad",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Magdalen",
    lastName: "Lindeberg",
    title: "Assistant Director",
    slug: "magdalen-lindeberg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Donna Allyn",
    lastName: "Lindsay",
    title: "Director, Enterprise Programs (Texas)",
    slug: "donna-allyn-lindsay",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eric Sean",
    lastName: "Liner",
    title: "Multimedia Specialist II",
    slug: "eric-sean-liner",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michael Martin",
    lastName: "Linhorst",
    title: "NY Metro-Based Local Journalism Attorney",
    slug: "michael-martin-linhorst",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Laura Miriam",
    lastName: "Linke",
    title: "Sr. Reference Specialist",
    slug: "laura-miriam-linke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stacie Marks",
    lastName: "Linsky",
    title: "Seasonal Advising Associate",
    slug: "stacie-marks-linsky",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Cheryl A.",
    lastName: "Lippincott",
    title: "Financial Transaction Representative",
    slug: "cheryl-a-lippincott",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jeremy",
    lastName: "Lippincott",
    title: "Transportation Service Rep 2",
    slug: "jeremy-lippincott",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ty Giovanni",
    lastName: "Lisi",
    title: "Bulletin associate",
    slug: "ty-giovanni-lisi",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jeannette L.",
    lastName: "Little",
    title: "Executive Assistant",
    slug: "jeannette-l-little",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deborah J.",
    lastName: "Littlejohn",
    title: "Financial Analytics Specialist",
    slug: "deborah-j-littlejohn",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Felix",
    lastName: "Litvinsky",
    title: "Managing Director, Blackstone LaunchPad",
    slug: "felix-litvinsky",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Claire Schwartz",
    lastName: "Litwin",
    title: "Seasonal Admissions Readers",
    slug: "claire-schwartz-litwin",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Yifan",
    lastName: "Liu",
    title: "Photography Assistant",
    slug: "yifan-liu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kitty",
    lastName: "Liu",
    title: "Editorial Director, Comstock Publishing Associates",
    slug: "kitty-liu",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Eadie",
    lastName: "Liu",
    title: "ACC Tutor - Ithaca Youth Bureau (Johara Malcolm)",
    slug: "eadie-liu",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Wei",
    lastName: "Liu",
    title: "Financial Transaction Representative",
    slug: "wei-liu",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Irene",
    lastName: "Liu",
    title: "Communication Spec III",
    slug: "irene-liu",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nada",
    lastName: "Liu",
    title: "Classroom AV Tester I",
    slug: "nada-liu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rachel Dorothy",
    lastName: "Liu",
    title: "Career Services Asst., AEM 2240 (Addoum) CA",
    slug: "rachel-dorothy-liu",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Allister",
    lastName: "Liu",
    title: "Applications Developer III",
    slug: "allister-liu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Courtney Lynn",
    lastName: "Livecchi",
    title: "4-H Program Support Specialist",
    slug: "courtney-lynn-livecchi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Noa",
    lastName: "Livernois",
    title: "Gift Processing Assistant III",
    slug: "noa-livernois",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lejdina",
    lastName: "Lluga",
    title: "Program Administrative Assistant",
    slug: "lejdina-lluga",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brandy M.",
    lastName: "Lobdell",
    title: "Integrations and Data Delivery Consultant",
    slug: "brandy-m-lobdell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Renee",
    lastName: "Lobdell",
    title: "Human Resources Representative",
    slug: "renee-lobdell",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rigel Frederick",
    lastName: "Lochner",
    title: "CLASSE Safety Lead",
    slug: "rigel-frederick-lochner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cynthia",
    lastName: "Lockwood",
    title: "Associate Director of Building Care",
    slug: "cynthia-lockwood",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chris",
    lastName: "Lockwood",
    title: "Application Specialist",
    slug: "chris-lockwood",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kelly",
    lastName: "Lockwood",
    title: "Assistant to the Chair",
    slug: "kelly-lockwood",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sally J.",
    lastName: "Lockwood",
    title: "Electronic Resources Specialist",
    slug: "sally-j-lockwood",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Barbara J.",
    lastName: "Lockwood",
    title: "Administrative Asst III",
    slug: "barbara-j-lockwood",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dawn McKenney",
    lastName: "Lodor",
    title: "Point of Sale Data Entry Specialist",
    slug: "dawn-mckenney-lodor",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jenny",
    lastName: "Loeffelman",
    title: "Assistant Vice President, Student and Campus Life",
    slug: "jenny-loeffelman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Michael",
    lastName: "Loeffelman",
    title: "Summer Experience Funding Program Associate",
    slug: "michael-loeffelman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Samantha Jean",
    lastName: "Loew",
    title: "Administrator VI",
    slug: "samantha-jean-loew",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Fredrika Louise",
    lastName: "Loew",
    title: "Technical Services Archivist",
    slug: "fredrika-louise-loew",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bill S.",
    lastName: "Loftus",
    title: "Director of Administration",
    slug: "bill-s-loftus",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anthony",
    lastName: "Loinaz",
    title: "Events Coordinator",
    slug: "anthony-loinaz",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Dianne Marie",
    lastName: "Lombard",
    title:
      " Assistant Director of Admissions- International & Communications Lead",
    slug: "dianne-marie-lombard",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kara M.",
    lastName: "Lombardi",
    title: "Assistant Dean for Student Experience and Wellbeing",
    slug: "kara-m-lombardi",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tony",
    lastName: "Lombardo",
    title: "Access Control System Administrator",
    slug: "tony-lombardo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lauryn Elizabeth",
    lastName: "Long",
    title: "Senior Auditor",
    slug: "lauryn-elizabeth-long",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kristy L.",
    lastName: "Long",
    title: "Curriculum Assistant and Building Coordinator",
    slug: "kristy-l-long",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Meegs",
    lastName: "Longacre",
    title: "MFA Program & Communications Coordinator",
    slug: "meegs-longacre",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Daniel",
    lastName: "Longaker",
    title: "Director of Health Informatics",
    slug: "daniel-longaker",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Andrew",
    lastName: "Lonsky",
    title: "Regional Gift Officer",
    slug: "andrew-lonsky",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Roy Alan",
    lastName: "Loomis",
    title: "Financial Transaction Representative",
    slug: "roy-alan-loomis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christopher A.",
    lastName: "Loomis",
    title: "Assistant Preparator",
    slug: "christopher-a-loomis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sara A. Van",
    lastName: "Looy",
    title: "EARN Project Coordinator & YTI Administrative Lead",
    slug: "sara-a-van-looy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen Michelle",
    lastName: "Loparco",
    title: "Law School Events Manager",
    slug: "karen-michelle-loparco",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Carson",
    lastName: "Lopez",
    title: "Human Resources Asst V",
    slug: "carson-lopez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Alyssa",
    lastName: "Lopez",
    title: "Assistant Director of Graduate Programs",
    slug: "alyssa-lopez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sergio Alonso",
    lastName: "Lopez",
    title: "Intramural Sport Official, SASA III - CS 2800",
    slug: "sergio-alonso-lopez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Azucena Campos",
    lastName: "Lopez",
    title: "Print and Electronic Monograph Ordering and Receiving Assistant",
    slug: "azucena-campos-lopez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Philip A.",
    lastName: "Lorer",
    title: "Building Care Manager",
    slug: "philip-a-lorer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary B",
    lastName: "Lorson",
    title: "Academic Content Editor, Academic Affairs and External Relations",
    slug: "mary-b-lorson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mark",
    lastName: "Lory-Moran",
    title: "Lab Manager",
    slug: "mark-lory-moran",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "June M.",
    lastName: "Losurdo",
    title: "Sr Major Gift Officer",
    slug: "june-m-losurdo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gissela Mera",
    lastName: "Lourido",
    title: "Administrative Manager",
    slug: "gissela-mera-lourido",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jason Palmer",
    lastName: "Loux",
    title: "Full-stack Software Developer and API Specialist",
    slug: "jason-palmer-loux",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Marla",
    lastName: "Love",
    title: "Robert W. and Elizabeth C. Staley Dean of Students",
    slug: "marla-love",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Phanomvan",
    lastName: "Love",
    title: "Associate Director of Finance and Budget",
    slug: "phanomvan-love",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nichole",
    lastName: "Lovejoy",
    title: "Financial Services Associate",
    slug: "nichole-lovejoy",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer Lea",
    lastName: "Lovell",
    title: "Administrative Coordinator",
    slug: "jennifer-lea-lovell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine",
    lastName: "Lovely",
    title: "Vice President and Chief Human Resources Officer",
    slug: "christine-lovely",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sandra Lynn",
    lastName: "Lowe",
    title: "Financial Transaction Representative",
    slug: "sandra-lynn-lowe",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Hannah",
    lastName: "Loy",
    title: "Assistant Director, Annual Giving Communication",
    slug: "hannah-loy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brian",
    lastName: "Lu",
    title: "Admissions Counselor",
    slug: "brian-lu",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jerry",
    lastName: "Lu",
    title: "Classroom AV Tester I, Student Admin Asst I",
    slug: "jerry-lu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michele",
    lastName: "Luc",
    title: "Training Coordinator",
    slug: "michele-luc",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Julie",
    lastName: "Lucas",
    title: "Admissions Assistant",
    slug: "julie-lucas",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "C.",
    lastName: "Lucas",
    title: "Wellness Community Outreach Specialist",
    slug: "c-lucas",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Taiya",
    lastName: "Luce",
    title: "Director of Visitor Relations",
    slug: "taiya-luce",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lucille May",
    lastName: "Luce",
    title: "Administrative Asst III",
    slug: "lucille-may-luce",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie Lynn",
    lastName: "Lucero",
    title: "MSLS Facilitator",
    slug: "stephanie-lynn-lucero",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andrew Peter",
    lastName: "Lucia",
    title: "Critic Visiting",
    slug: "andrew-peter-lucia",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Casey",
    lastName: "Lucier",
    title: "Senior Director of Events Management",
    slug: "casey-lucier",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle",
    lastName: "Lucio",
    title: "CCSS Administrative Coordinator",
    slug: "michelle-lucio",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Yalverton",
    lastName: "Luckain",
    title: "Assoc. Director for Contract and Finance",
    slug: "yalverton-luckain",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ryan",
    lastName: "Luebke",
    title: "Associate Director, Business Development and Licensing",
    slug: "ryan-luebke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Johanna",
    lastName: "Lugo",
    title: "Events Coordinator, Climate Jobs Institute",
    slug: "johanna-lugo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hendrik M. Stoops",
    lastName: "Lugo",
    title: "AAP Art Sculpture Monitor",
    slug: "hendrik-m-stoops-lugo",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Cara Lynn",
    lastName: "Lujan",
    title: "Client Service Representative",
    slug: "cara-lynn-lujan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John P",
    lastName: "Lukach",
    title: "Associate Athletics Director, Video Production and Recruiting",
    slug: "john-p-lukach",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Pablo Castillo",
    lastName: "Luna",
    title: "Critic Visiting",
    slug: "pablo-castillo-luna",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Margie",
    lastName: "Lund",
    title: "Vegetable Crops Specialist",
    slug: "margie-lund",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wenjing",
    lastName: "Luo",
    title: "Teaching and Learning Specialist",
    slug: "wenjing-luo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicholas D.",
    lastName: "Luongo",
    title: "Web Designer II",
    slug: "nicholas-d-luongo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shannon",
    lastName: "Lupo",
    title: "Administrative Asst V",
    slug: "shannon-lupo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sam",
    lastName: "Lupowitz",
    title: "Media Development Manager",
    slug: "sam-lupowitz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Megan Lee",
    lastName: "Lussier",
    title: "Administrator II",
    slug: "megan-lee-lussier",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diane Elizabeth",
    lastName: "Lussier",
    title: "Finance Specialist II",
    slug: "diane-elizabeth-lussier",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Chelle S.",
    lastName: "Lust",
    title: "Office Coordinator",
    slug: "chelle-s-lust",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Francis",
    lastName: "Lutkenhouse",
    title: "Inputting & Receiving Specialist",
    slug: "francis-lutkenhouse",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kaitlyn Ann",
    lastName: "Lutz",
    title: "Dairy Management Specialist",
    slug: "kaitlyn-ann-lutz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathy",
    lastName: "Lynch",
    title: "Finance Specialist III",
    slug: "kathy-lynch",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sean",
    lastName: "Lynch",
    title: "Sr I&C Tech",
    slug: "sean-lynch",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Theresa",
    lastName: "Lynch",
    title: "Human Resources Associate",
    slug: "theresa-lynch",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Donna",
    lastName: "Lynch-Cunningham",
    title: "Assistant Dean of Human Resources",
    slug: "donna-lynch-cunningham",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Amy M.",
    lastName: "Lyndaker",
    title: "Lab Manager, BRC Epigenomics Facility",
    slug: "amy-m-lyndaker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle",
    lastName: "Lyon",
    title: "Director, Budget and Finance",
    slug: "michelle-lyon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kevin",
    lastName: "Lyon",
    title: "Senior Administrative Manager",
    slug: "kevin-lyon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric M",
    lastName: "Lyon",
    title: "ACRefrig Mech/Plumb",
    slug: "eric-m-lyon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Graig",
    lastName: "Lyon",
    title: "Athletics Equipment Lead- Bartels Hall",
    slug: "graig-lyon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joseph Jeffrey",
    lastName: "Lyons",
    title: "Director, Campaign Management",
    slug: "joseph-jeffrey-lyons",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Wayva",
    lastName: "Lyons",
    title:
      " Assistant Director of Admissions and Coordinator of Indigenous Student Outreach",
    slug: "wayva-lyons",
    dei: true,
    category: "Admissions",
  },
  {
    firstName: "Hongnan",
    lastName: "Ma",
    title: "Director International Development Asia",
    slug: "hongnan-ma",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jie",
    lastName: "Ma",
    title: "Applications Developer III",
    slug: "jie-ma",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dan",
    lastName: "Maas",
    title: "Director of Emergency Management & Business Continuity",
    slug: "dan-maas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Connie",
    lastName: "Mabry",
    title: "Administrator III",
    slug: "connie-mabry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sandy",
    lastName: "MacArthur",
    title: "Purchasing Assistant",
    slug: "sandy-macarthur",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth M.",
    lastName: "MacBride",
    title: "Marketing Automation Director",
    slug: "elizabeth-m-macbride",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kathy",
    lastName: "MacCheyne",
    title: "Fire Compliance Specialist",
    slug: "kathy-maccheyne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeff S.",
    lastName: "MacDonald",
    title: "Audio-Visual Project Specialist",
    slug: "jeff-s-macdonald",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Adam",
    lastName: "MacDonald",
    title: "Project Associate for Entrepreneurship Programs",
    slug: "adam-macdonald",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine K",
    lastName: "MacDowell",
    title: "Senior Administrative Assistant",
    slug: "katherine-k-macdowell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anthony M.",
    lastName: "Macera",
    title: "Mason",
    slug: "anthony-m-macera",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristin D.",
    lastName: "MacHenry",
    title: "Secretary of the Corporation",
    slug: "kristin-d-machenry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jenny",
    lastName: "Machette",
    title: "Immigration Specialist / Student Services Associate",
    slug: "jenny-machette",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sherri L.",
    lastName: "Mackey",
    title: "Administrative Asst IV",
    slug: "sherri-l-mackey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jen",
    lastName: "Maclaughlin",
    title: "Director of Career Development, Arts & Sciences",
    slug: "jen-maclaughlin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Bridget",
    lastName: "MacRae",
    title: "Sr. Compliance Specialist COI & RECR",
    slug: "bridget-macrae",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Ben",
    lastName: "Maddox",
    title: "Chief Information Officer",
    slug: "ben-maddox",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lauren Lisette",
    lastName: "Madrigal",
    title: "IDP Facilitator",
    slug: "lauren-lisette-madrigal",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Courtney",
    lastName: "MaeRose",
    title: "Generalist Counselor Therapist",
    slug: "courtney-maerose",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jackie",
    lastName: "Magagnosc",
    title: "Cataloging & Continuations Management Librarian",
    slug: "jackie-magagnosc",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Raven Ashley",
    lastName: "Magill",
    title: "IT Technical Communicator",
    slug: "raven-ashley-magill",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Peter A.",
    lastName: "Magnus",
    title: "Desktop Services Manager",
    slug: "peter-a-magnus",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tami J.",
    lastName: "Magnus",
    title: "Administrator VI",
    slug: "tami-j-magnus",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah",
    lastName: "Magnus-Sharpe",
    title: "Director, Public Relations and Communications",
    slug: "sarah-magnus-sharpe",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Pria",
    lastName: "Mahadevan",
    title: "Research and Policy Development Associate",
    slug: "pria-mahadevan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen",
    lastName: "Mahalo",
    title: "Associate Vice President and University Controller",
    slug: "karen-mahalo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nicholas Ray",
    lastName: "Mahan",
    title: "Immigration Specialist",
    slug: "nicholas-ray-mahan",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Melissa L.",
    lastName: "Mahannah",
    title: "Finance and Budget Representative",
    slug: "melissa-l-mahannah",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kailey S",
    lastName: "Mahar",
    title: "Assistant Registrar",
    slug: "kailey-s-mahar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Adam R.",
    lastName: "Mahnke",
    title: "Access Control Systems Project Manager",
    slug: "adam-r-mahnke",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kristine",
    lastName: "Mahoney",
    title: "Senior Director of Strategic Initiatives and Academic Integration",
    slug: "kristine-mahoney",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jaclyn E.",
    lastName: "Mahoney",
    title: "Flow Technologies Manager, BRC Flow Cytometry Facility",
    slug: "jaclyn-e-mahoney",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emma",
    lastName: "Mahy",
    title:
      " Production Associate - The Cherry Arts (Jen Pearcy-Edwards), CALS Student Curator",
    slug: "emma-mahy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer Ann",
    lastName: "Mailey",
    title: "Director of Admissions",
    slug: "jennifer-ann-mailey",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Alexa",
    lastName: "Maille",
    title: "Interim 4-H Program Leader, CCE",
    slug: "alexa-maille",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ava",
    lastName: "Mailloux",
    title: "Access Services Assistant",
    slug: "ava-mailloux",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carrie L.",
    lastName: "Maine",
    title: "Administrative Asst IV",
    slug: "carrie-l-maine",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kevin S.",
    lastName: "Maine",
    title: "Emergency Light / Fire Extinguisher Inspector",
    slug: "kevin-s-maine",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lori M.",
    lastName: "Maine",
    title: "Administrative and Course Coordinator",
    slug: "lori-m-maine",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Craig S.",
    lastName: "Mains",
    title: "Evening & Weekend Supervisor",
    slug: "craig-s-mains",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Yvonne D.",
    lastName: "Mainville",
    title: "Accounting Transaction Specialist",
    slug: "yvonne-d-mainville",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Annalisa",
    lastName: "Maione",
    title: "Administrative Director - AAP Rome Program",
    slug: "annalisa-maione",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Giselle",
    lastName: "Maira",
    title: "Pre-Award Specialist",
    slug: "giselle-maira",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jennifer",
    lastName: "Majka",
    title:
      " Director of Diversity and Inclusion, The Charles H. Dyson School of Applied Economics and Management, Visiting Lecturer",
    slug: "jennifer-majka",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Heidi S.",
    lastName: "Makela",
    title: "Sr Product Manager",
    slug: "heidi-s-makela",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kelly",
    lastName: "Makosch",
    title: "Associate Director of Development",
    slug: "kelly-makosch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brian A",
    lastName: "Maley",
    title: "Evaluation Coordinator",
    slug: "brian-a-maley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael",
    lastName: "Maley",
    title: "Major Gift Officer",
    slug: "michael-maley",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elizabeth Claire",
    lastName: "Maloney",
    title: "Sr Field Coord",
    slug: "elizabeth-claire-maloney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mr Kevin E.",
    lastName: "Maloney",
    title: "Research Supp Spec III",
    slug: "mr-kevin-e-maloney",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brian",
    lastName: "Maltzan",
    title: "arXiv Backend Python Developer",
    slug: "brian-maltzan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Katerina",
    lastName: "Malysheva",
    title: "Administrative Asst V",
    slug: "katerina-malysheva",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Valerie",
    lastName: "Malzer",
    title: "Research & Evaluation Associate",
    slug: "valerie-malzer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael",
    lastName: "Mancuso",
    title: "Prospect Development Associate",
    slug: "michael-mancuso",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Max",
    lastName: "Mandeville",
    title: "Sr. Conference/Event Planner",
    slug: "max-mandeville",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew",
    lastName: "Mandych",
    title: "Applications Developer III",
    slug: "matthew-mandych",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Timothy John",
    lastName: "Manheim",
    title: "Emergency Light / Fire Extinguisher Inspector",
    slug: "timothy-john-manheim",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Todd A.",
    lastName: "Maniscalco",
    title: "Assistant Director, Academic and Collaboration Services",
    slug: "todd-a-maniscalco",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chris",
    lastName: "Manly",
    title: "Assistant Director of Cloud and Infrastructure Services",
    slug: "chris-manly",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stacie",
    lastName: "Mann",
    title: "Finance Specialist II",
    slug: "stacie-mann",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Leo Thomas",
    lastName: "Mann",
    title: "Production Associate - The Cherry Arts (Jen Pearcy-Edwards)",
    slug: "leo-thomas-mann",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kaitlyn",
    lastName: "Mann",
    title: "Initiative Coordinator, Smith Family Business Initiative",
    slug: "kaitlyn-mann",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marina Alexandria",
    lastName: "Mann",
    title: "Research Administration Assistant",
    slug: "marina-alexandria-mann",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kevin J.",
    lastName: "Mannella",
    title: "Director of Finance and Administration",
    slug: "kevin-j-mannella",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Benjamin David",
    lastName: "Maracle",
    title: "Communications Assistant V",
    slug: "benjamin-david-maracle",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ryan",
    lastName: "Marchenese",
    title: "Assistant Director of Undergraduate Advising",
    slug: "ryan-marchenese",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Brenda",
    lastName: "Marchewka",
    title: "Administrative Asst IV",
    slug: "brenda-marchewka",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa M.",
    lastName: "Marciniak",
    title: "Enrollment Director",
    slug: "lisa-m-marciniak",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Heather",
    lastName: "Marcotte",
    title: "Director of Admissions",
    slug: "heather-marcotte",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Debra",
    lastName: "Marcus",
    title: "Senior Director, Break Through Tech Computing Programs",
    slug: "debra-marcus",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dylan James",
    lastName: "Margeit",
    title: "Assistant Supervisor",
    slug: "dylan-james-margeit",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Liesl Schaper",
    lastName: "Margolin",
    title: "Quality Assurance Program Manager",
    slug: "liesl-schaper-margolin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Teather M.",
    lastName: "Maricle",
    title: "HR Services and Transitions Counselor",
    slug: "teather-m-maricle",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Marc D.",
    lastName: "Marinchak",
    title: "Maintenance Planner",
    slug: "marc-d-marinchak",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hayley",
    lastName: "Marino",
    title:
      " Mobility Aide - Cayuga Medical Center at Ithaca (Lara Parrilla), Student Admin Asst I",
    slug: "hayley-marino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Polly M.",
    lastName: "Marion",
    title: "Administrative Assistant V",
    slug: "polly-m-marion",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Risa Y",
    lastName: "Mark",
    title: "Lab Manager",
    slug: "risa-y-mark",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amber",
    lastName: "Markus",
    title: "Financial Security Access Specialist",
    slug: "amber-markus",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Melanie",
    lastName: "Markusic",
    title:
      " Department Administrator–Office of the Vice Provost for International Affairs",
    slug: "melanie-markusic",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Abigail Abbett",
    lastName: "Marnell",
    title: "Administrative Assistant, AAD Law",
    slug: "abigail-abbett-marnell",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Eric",
    lastName: "Maroney",
    title: "Administrative Asst IV",
    slug: "eric-maroney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Josie",
    lastName: "Maroney",
    title: "New York Agriculture in the Classroom Admin Assistant",
    slug: "josie-maroney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Colleen Bracken",
    lastName: "Marotta",
    title: "Major Gift Officer",
    slug: "colleen-bracken-marotta",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Laura",
    lastName: "Marquez",
    title: "Cornell Museum of Vertebrates Collections Assistant",
    slug: "laura-marquez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Annette S.",
    lastName: "Marquis",
    title: "Advancement Services Data Processor",
    slug: "annette-s-marquis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa M.",
    lastName: "Marsh",
    title: "Sponsored Finance Specialist",
    slug: "lisa-m-marsh",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Crystal Bertou",
    lastName: "Marsh",
    title: "Assistant Director, Alumni Engagement Communications",
    slug: "crystal-bertou-marsh",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Scott",
    lastName: "Marshall",
    title: "Building Coordinator - ILR School",
    slug: "scott-marshall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heidi",
    lastName: "Marshall",
    title: "Academic Affairs Coordinator",
    slug: "heidi-marshall",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Donna M.",
    lastName: "Marshall",
    title: "Assistant Equipment Manager",
    slug: "donna-m-marshall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brenda J.",
    lastName: "Marston",
    title: "Curator of the Human Sexuality Collection",
    slug: "brenda-j-marston",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Bob",
    lastName: "Marteal",
    title: "Web Design and Development Manager",
    slug: "bob-marteal",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Reina",
    lastName: "Martin",
    title: "Director of Creative Solutions Group",
    slug: "reina-martin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lynn P.",
    lastName: "Martin",
    title: "Administrator V",
    slug: "lynn-p-martin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Florence",
    lastName: "Martin",
    title: "Administrative Assistant",
    slug: "florence-martin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca",
    lastName: "Martin",
    title: "IT Purchasing Specialist",
    slug: "rebecca-martin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessica Levin",
    lastName: "Martinez",
    title: "Director of the Herbert F. Johnson Museum of Art",
    slug: "jessica-levin-martinez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mario",
    lastName: "Martinez",
    title: "Associate Director of Data Governance",
    slug: "mario-martinez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alan M",
    lastName: "Martinez",
    title: "Gift Accountant",
    slug: "alan-m-martinez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alan",
    lastName: "Martinez",
    title: "Sustainable Finance Lead – Sr. Manager, Strategic Partnerships",
    slug: "alan-martinez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Henry Flores",
    lastName: "Martinez",
    title: "Mobility Aide - Cayuga Medical Center at Ithaca (Lara Parrilla)",
    slug: "henry-flores-martinez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peter",
    lastName: "Martinez",
    title: "Batch Proc & E-Res Mgmt Spec",
    slug: "peter-martinez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Drew",
    lastName: "Martini",
    title: "Director, Learning Design and Delivery Organization",
    slug: "drew-martini",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mary Beth",
    lastName: "Martini-Lyons",
    title: "Administrative Manager",
    slug: "mary-beth-martini-lyons",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nadia",
    lastName: "Martins",
    title: "Administrative Assistant III",
    slug: "nadia-martins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leah R",
    lastName: "Marx",
    title:
      " Administrative Assistant, Institute for African Development and Latin American Studies",
    slug: "leah-r-marx",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joel",
    lastName: "Mashanic",
    title: "Sheet Metal Worker",
    slug: "joel-mashanic",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Holly Anne",
    lastName: "Mason",
    title: "Administrative Asst II",
    slug: "holly-anne-mason",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adrienne S.",
    lastName: "Mason",
    title: "CALS Administrative Director",
    slug: "adrienne-s-mason",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gene",
    lastName: "Masters",
    title: "Technology Licensing Professional III",
    slug: "gene-masters",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Saraphina Catherine",
    lastName: "Masters",
    title: "Coordinator of Student Engagement & Public Programs",
    slug: "saraphina-catherine-masters",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sherri",
    lastName: "Masterson",
    title:
      " Administrative Services Coordinator and Assistant to the University Registrar",
    slug: "sherri-masterson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Greg",
    lastName: "Mastin",
    title: "Integrations and Data Delivery Consultant",
    slug: "greg-mastin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cindy",
    lastName: "Mata",
    title: "Coordinator, Career Management Team",
    slug: "cindy-mata",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Caitlin Donaldson",
    lastName: "Mathes",
    title: "Administrative Supervisor, Music and Fine Arts Libraries",
    slug: "caitlin-donaldson-mathes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jennifer L.",
    lastName: "Mathewson",
    title: "Quality Assurance Coordinator",
    slug: "jennifer-l-mathewson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cynthia Jean",
    lastName: "Mathys",
    title: "Project Manager",
    slug: "cynthia-jean-mathys",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peggy",
    lastName: "Matta",
    title: "Clery Act Compliance/Access Control Program Administrator",
    slug: "peggy-matta",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Dana",
    lastName: "Matthews",
    title: "Assistant Director of Marketing Communications",
    slug: "dana-matthews",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Caitlin Ryan",
    lastName: "Matthewson",
    title: "Major Gift Officer",
    slug: "caitlin-ryan-matthewson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Clara Rose",
    lastName: "Matton",
    title: "Nutritionist",
    slug: "clara-rose-matton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Indica Ayn",
    lastName: "Mattson",
    title: "Rare Materials Cataloger",
    slug: "indica-ayn-mattson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nichole",
    lastName: "Maughan",
    title: "Diagnostic Chemist",
    slug: "nichole-maughan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew C",
    lastName: "Maul",
    title: "Head Table Staff/Official",
    slug: "andrew-c-maul",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rhoda",
    lastName: "Maurer",
    title: "Greenhouse Mgr",
    slug: "rhoda-maurer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel Erhovwosere",
    lastName: "Max-Onakpoya",
    title: "IT Solutions Cage Monitor",
    slug: "daniel-erhovwosere-max-onakpoya",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alexandra L",
    lastName: "Maxian",
    title: "Marketing Project Coordinator",
    slug: "alexandra-l-maxian",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Becky Zehr",
    lastName: "Maxson",
    title: "Deputy Director for Compliance and Policy",
    slug: "becky-zehr-maxson",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Dina E.",
    lastName: "Maxwell",
    title: "Project Manager, Marketing and Management Communications",
    slug: "dina-e-maxwell",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Marcus Michael",
    lastName: "May",
    title: "Accounts Coordinator",
    slug: "marcus-michael-may",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Maddie",
    lastName: "May",
    title: "Graphic Designer",
    slug: "maddie-may",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Domonique Natalya",
    lastName: "May",
    title: "Dispatcher S07",
    slug: "domonique-natalya-may",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa Ann",
    lastName: "Maybury",
    title: "Receiving & Documents Supervisor",
    slug: "lisa-ann-maybury",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marie",
    lastName: "Maynard",
    title: "HR Project Manager",
    slug: "marie-maynard",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jennifer",
    lastName: "Mayo",
    title: "Senior Director of External Relations",
    slug: "jennifer-mayo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brandon",
    lastName: "Mazen",
    title: "Administrative Assistant (Dean's Office), Learning Center Monitor",
    slug: "brandon-mazen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Romanus",
    lastName: "Mbapah",
    title:
      " Administrative Assistant, AAD Cornell SC Johnson College of Business",
    slug: "romanus-mbapah",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeff",
    lastName: "McCaffrey",
    title: "Senior Associate Director, Office of Undergraduate Biology",
    slug: "jeff-mccaffrey",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stacey Marie",
    lastName: "McCall",
    title: "Community Response Coordinator",
    slug: "stacey-marie-mccall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan Marie",
    lastName: "McCann",
    title: "Creative Services Project Manager",
    slug: "susan-marie-mccann",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meghan",
    lastName: "McCarthy",
    title: "MSLS Assistant Facilitator",
    slug: "meghan-mccarthy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Denise Marie",
    lastName: "McCarthy",
    title: "Info Tech Service Desk Level 1 Manager",
    slug: "denise-marie-mccarthy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Todd",
    lastName: "McCarthy",
    title: "Program Director, Executive MBA-Americas",
    slug: "todd-mccarthy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kristin",
    lastName: "McCartney",
    title: "Office Lead, Student Disability Services",
    slug: "kristin-mccartney",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Connor",
    lastName: "McCartney",
    title: "Financial Services Associate",
    slug: "connor-mccartney",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Apikanya",
    lastName: "McCarty",
    title: "Cataloging Associate, Thai",
    slug: "apikanya-mccarty",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joseph",
    lastName: "McCaskill",
    title: "ACRefrig MEch/Plumb JP",
    slug: "joseph-mccaskill",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alison Jo",
    lastName: "McCauley",
    title: "Web Developer",
    slug: "alison-jo-mccauley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rhonda",
    lastName: "McCelland",
    title: "Program Administrative Assistant",
    slug: "rhonda-mccelland",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jane",
    lastName: "McClellan",
    title: "IT Portfolio & Project Manager",
    slug: "jane-mcclellan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily",
    lastName: "McClintock",
    title: "Mental Health Access & Referral Specialist",
    slug: "emily-mcclintock",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Forrest Kale",
    lastName: "McCloud",
    title: "Fire Protection Tester",
    slug: "forrest-kale-mccloud",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carlos Eduardo",
    lastName: "McCluskey",
    title: "Director of Alumni Affairs",
    slug: "carlos-eduardo-mccluskey",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ginny",
    lastName: "McCollom",
    title: "Program Assistant, Grand Challenges/CEMS",
    slug: "ginny-mccollom",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Allison",
    lastName: "McComb",
    title: "Program Delivery Specialist I",
    slug: "allison-mccomb",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mandolyn Grace",
    lastName: "McConaha",
    title: "Creative Services Director",
    slug: "mandolyn-grace-mcconaha",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Pat",
    lastName: "McConn",
    title: "Finance Specialist III",
    slug: "pat-mcconn",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kevin J.",
    lastName: "McCord",
    title: "Administrative Asst IV",
    slug: "kevin-j-mccord",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "LaTivia",
    lastName: "McCowan",
    title: "Residence Hall Director",
    slug: "lativia-mccowan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Peter",
    lastName: "McCracken",
    title: "Acquisitions & E-Resource Strategy Librarian",
    slug: "peter-mccracken",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dan",
    lastName: "McCray",
    title: "Director of Labor Relations Programs",
    slug: "dan-mccray",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Wyatt",
    lastName: "McCullagh",
    title: "Assistant Registrar",
    slug: "wyatt-mccullagh",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Angaleen",
    lastName: "McCullen",
    title: "Director of Community Response Team",
    slug: "angaleen-mccullen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Isabelle Margaret",
    lastName: "McDonald",
    title: "Teaching Programs Coordinator",
    slug: "isabelle-margaret-mcdonald",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lucy L",
    lastName: "McDonald",
    title: "Project Administrative Assistant",
    slug: "lucy-l-mcdonald",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brittany Michelle",
    lastName: "McDowell",
    title: "Gift Accountant Coordinator",
    slug: "brittany-michelle-mcdowell",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kat",
    lastName: "McEldowney",
    title: "Account Support Coordinator",
    slug: "kat-mceldowney",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Laurie",
    lastName: "McEvoy",
    title: "Senior IT Support Lead",
    slug: "laurie-mcevoy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Leah Rae",
    lastName: "McEwen",
    title: "Chemistry Librarian",
    slug: "leah-rae-mcewen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Veronica",
    lastName: "McFall",
    title: "Director, Northeast Corridor Engagement",
    slug: "veronica-mcfall",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Letty",
    lastName: "McFall",
    title: "Utility Mapper",
    slug: "letty-mcfall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stanley A.",
    lastName: "McFall",
    title: "Equipment Tech V",
    slug: "stanley-a-mcfall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley",
    lastName: "McFarland",
    title: "Livestock Specialist",
    slug: "ashley-mcfarland",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Monica",
    lastName: "McGavin",
    title: "Academic Planning Project Manager",
    slug: "monica-mcgavin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Julie",
    lastName: "McGee",
    title: "Assistant Registrar, College of Human Ecology",
    slug: "julie-mcgee",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mindy",
    lastName: "McGill-Carlison",
    title: "Sr. Pre-Award Specialist",
    slug: "mindy-mcgill-carlison",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mara",
    lastName: "McGinnis",
    title: "Executive Director, Communications and Marketing",
    slug: "mara-mcginnis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "William Barry",
    lastName: "McGrane",
    title: "Community Response Coordinator",
    slug: "william-barry-mcgrane",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Amy Lynne",
    lastName: "McHerron",
    title: "Finance Specialist II",
    slug: "amy-lynne-mcherron",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christian",
    lastName: "McIntire",
    title: "Senior Director, Break Through Tech AI Programs",
    slug: "christian-mcintire",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Scott",
    lastName: "McKee",
    title: "Administrative Assistant",
    slug: "scott-mckee",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lencia",
    lastName: "McKee",
    title: "Research Data Librarian",
    slug: "lencia-mckee",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kathy E.",
    lastName: "McKee",
    title: "Assistant Director for Talent and Engagement",
    slug: "kathy-e-mckee",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Bruce Wayne",
    lastName: "McKee",
    title: "Systems Administrator III",
    slug: "bruce-wayne-mckee",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kellie A.",
    lastName: "McKee",
    title: "Billing Coordinator",
    slug: "kellie-a-mckee",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kumiko",
    lastName: "McKee",
    title: "Cataloging Associate, Japanese",
    slug: "kumiko-mckee",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brittany",
    lastName: "McKeldin",
    title: "Associate Director, Human Resources",
    slug: "brittany-mckeldin",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Mary Elizabeth",
    lastName: "McKellar",
    title: "DVM Curriculum Manager and Instructional Designer",
    slug: "mary-elizabeth-mckellar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Matthew",
    lastName: "Mckeon",
    title: "Transportation Service Rep 2",
    slug: "matthew-mckeon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristen",
    lastName: "McKnight",
    title: "Administrative Asst IV",
    slug: "kristen-mcknight",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Megan",
    lastName: "McKown",
    title: "Medical Technology Supervisor-COAG",
    slug: "megan-mckown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chloe",
    lastName: "McLaren",
    title: "Metadata Projects Librarian",
    slug: "chloe-mclaren",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kai",
    lastName: "McLaughlin",
    title: "Development Associate",
    slug: "kai-mclaughlin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chris",
    lastName: "McLaughlin",
    title: "Fire Protection System Associate",
    slug: "chris-mclaughlin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew N.",
    lastName: "McLaughlin",
    title: "Associate Director of Outdoor Programs, Cornell Outdoor Education",
    slug: "andrew-n-mclaughlin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Karen A.",
    lastName: "McLean",
    title: "Assistant Director HRIS Configurations",
    slug: "karen-a-mclean",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Julie",
    lastName: "McLean",
    title: "Program Manager",
    slug: "julie-mclean",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Phoebe Julia",
    lastName: "McLendon",
    title: "HR Administrative Assistant",
    slug: "phoebe-julia-mclendon",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Colleen M.",
    lastName: "McLinn",
    title: "Associate Dean for Professional Development",
    slug: "colleen-m-mclinn",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cailyn Skylar",
    lastName: "McMahon",
    title: "Administrative Course Coordinator",
    slug: "cailyn-skylar-mcmahon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jayden Ali",
    lastName: "McMillan",
    title: "Intramural Supervisor, Career Services Asst.",
    slug: "jayden-ali-mcmillan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Betsy",
    lastName: "McMullin",
    title: "Senior Invested Funds Accountant",
    slug: "betsy-mcmullin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rachel",
    lastName: "McNabb",
    title: "Administrative Assistant, Roper Center",
    slug: "rachel-mcnabb",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robin",
    lastName: "McNabb",
    title: "Grant and Contract Accounts Representative",
    slug: "robin-mcnabb",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Adrian J.",
    lastName: "McNairn",
    title: "Assistant Director, BRC Genomics Facility",
    slug: "adrian-j-mcnairn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dylan Richard",
    lastName: "McNally",
    title: "Director of Program Delivery",
    slug: "dylan-richard-mcnally",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John V.",
    lastName: "McNally",
    title: "Sprint Head Table Crew",
    slug: "john-v-mcnally",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Renea L.",
    lastName: "McNeill",
    title: "Client Experience Coordinator",
    slug: "renea-l-mcneill",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bernie",
    lastName: "McNinch",
    title: "Administrative Asst IV",
    slug: "bernie-mcninch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shawn T.",
    lastName: "McNinch",
    title: "Purchasing Specialist",
    slug: "shawn-t-mcninch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel Patrick",
    lastName: "McSweeney",
    title: "Associate Director of Employer Development",
    slug: "daniel-patrick-mcsweeney",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Billy",
    lastName: "Meade",
    title: "Manager of Fleet Services",
    slug: "billy-meade",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah",
    lastName: "Meadows",
    title: "Info Tech Area Mgr II",
    slug: "sarah-meadows",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shane Mikhail",
    lastName: "Medina",
    title: "Research Administrator",
    slug: "shane-mikhail-medina",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Silvia A.",
    lastName: "Medina",
    title: "Senior Web Application Developer",
    slug: "silvia-a-medina",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Annelise",
    lastName: "Medina",
    title: "Casual Enrollment Counselor, e-Cornell",
    slug: "annelise-medina",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Bridget E.",
    lastName: "Meeds",
    title: "Assistant Director, BPP Alumni Affairs & Development",
    slug: "bridget-e-meeds",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lindsay",
    lastName: "Meehan",
    title: "Marketing and Communications Assistant",
    slug: "lindsay-meehan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kathleen",
    lastName: "Meehan",
    title: "Assistant Director of Safety and Security",
    slug: "kathleen-meehan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kirsten",
    lastName: "Meekins",
    title: "eCornell Student Support Agent",
    slug: "kirsten-meekins",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Susan H.",
    lastName: "Mehringer",
    title: "CAC Associate Director, Consulting",
    slug: "susan-h-mehringer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Vidish Pranav",
    lastName: "Mehta",
    title: "CTL Practicant",
    slug: "vidish-pranav-mehta",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura Nicole Vander",
    lastName: "Meiden",
    title: "Research & Planning Associate",
    slug: "laura-nicole-vander-meiden",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David Joseph",
    lastName: "Meidlinger",
    title: "Web Developer",
    slug: "david-joseph-meidlinger",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lynandrea",
    lastName: "Mejia",
    title: "Administrative Asst III",
    slug: "lynandrea-mejia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Santiago",
    lastName: "Mejia",
    title: "Equine Surgeon - Ruffian",
    slug: "santiago-mejia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Debra E.",
    lastName: "Melanson",
    title: "Associate Project Manager",
    slug: "debra-e-melanson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Natalie",
    lastName: "Melas",
    title: "Assoc Prof, Comparative Litera",
    slug: "natalie-melas",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Annie",
    lastName: "Melella",
    title: "IT Project Manager",
    slug: "annie-melella",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Raelene Lynette",
    lastName: "Mellott",
    title: "Contract Manager",
    slug: "raelene-lynette-mellott",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Dean",
    lastName: "Meloney",
    title: "Director of Academic Affairs",
    slug: "dean-meloney",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Darius",
    lastName: "Melvin",
    title: "Assistant Director for Centerwide Engagement and Partnerships",
    slug: "darius-melvin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kathy Ann",
    lastName: "Mendall",
    title: "Assistant Director of Events, Cornell Tech",
    slug: "kathy-ann-mendall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lizeth Jaimez",
    lastName: "Mendoza",
    title: "Alumni Affairs Coordinator, Northeast Corridor",
    slug: "lizeth-jaimez-mendoza",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Aurelia",
    lastName: "Mensh",
    title: "Director of Human Resources",
    slug: "aurelia-mensh",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Gregory",
    lastName: "Menzenski",
    title: "Assistant Director, Enterprise Data Services",
    slug: "gregory-menzenski",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rebecca",
    lastName: "Menzer",
    title: "Assistant Director, Corporate and Foundation Research Relations",
    slug: "rebecca-menzer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hailey",
    lastName: "Menzi",
    title: "Equipment Tech III",
    slug: "hailey-menzi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jordan A.",
    lastName: "Mercado",
    title: "Procurement Agent",
    slug: "jordan-a-mercado",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelly",
    lastName: "Merchan",
    title: "Manager of Research Communications, Societal Systems",
    slug: "kelly-merchan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Amy E.",
    lastName: "Mercogliano",
    title: "General Accountant",
    slug: "amy-e-mercogliano",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christopher",
    lastName: "Meredith",
    title: "Sr Field Coord",
    slug: "christopher-meredith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ruth E.",
    lastName: "Merle-Doyle",
    title: "Work/Life Program Manager",
    slug: "ruth-e-merle-doyle",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Robert D.",
    lastName: "Merlo",
    title: "Inside Lead Director, Enterprise Programs",
    slug: "robert-d-merlo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tonya",
    lastName: "Merritt",
    title: "Financial Transaction Representative",
    slug: "tonya-merritt",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rebecca A.",
    lastName: "Merritt",
    title: "Document Archivist/Vault Manag",
    slug: "rebecca-a-merritt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tim",
    lastName: "Merritt",
    title: "Systems Administrator",
    slug: "tim-merritt",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Leslie",
    lastName: "Messina",
    title: "Enrollment Counselor II",
    slug: "leslie-messina",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Callie",
    lastName: "Messmer",
    title: "Instructional Designer, Custom Programs",
    slug: "callie-messmer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lexi L.",
    lastName: "Mest",
    title: "Payroll Assistant",
    slug: "lexi-l-mest",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Mihir",
    lastName: "Meswani",
    title: "Senior Investment Officer",
    slug: "mihir-meswani",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Susan",
    lastName: "Meyer",
    title: "Graduate Field/Undergraduate Coordinator",
    slug: "susan-meyer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah A",
    lastName: "Meyer",
    title: "Grow-NY Project Associate",
    slug: "sarah-a-meyer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leslie",
    lastName: "Meyerhoff",
    title: "Director of Administration, ORIE",
    slug: "leslie-meyerhoff",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily Rose",
    lastName: "Meyers",
    title: "Access Services Assistant",
    slug: "emily-rose-meyers",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jenn",
    lastName: "Michael",
    title: "Senior Director Student Services",
    slug: "jenn-michael",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jodi Marie",
    lastName: "Michael",
    title: "Emergency Light/Fire Extinguisher Inspector",
    slug: "jodi-marie-michael",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brinna",
    lastName: "Michael",
    title: "Visual Resources Metadata Librarian",
    slug: "brinna-michael",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie",
    lastName: "Michalec",
    title: "Accounts Rep V",
    slug: "stephanie-michalec",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer",
    lastName: "Middaugh-Sayers",
    title: "Assistant for U.S. Regional Engagement Programs",
    slug: "jennifer-middaugh-sayers",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Robert Frank",
    lastName: "Miegl",
    title:
      " Associate Director of University Corporate and Foundation Relations",
    slug: "robert-frank-miegl",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rob",
    lastName: "Miettunen",
    title: "Associate Director of Instructional & Collaborative Technologies",
    slug: "rob-miettunen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer",
    lastName: "Migliore",
    title: "Transition Associate",
    slug: "jennifer-migliore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vicky L.",
    lastName: "Mikula",
    title: "Assistant Director, Enterprise Applications",
    slug: "vicky-l-mikula",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Taylor Marie",
    lastName: "Mikula",
    title: "IT Project Manager",
    slug: "taylor-marie-mikula",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Zach",
    lastName: "Milicic",
    title: "HR Services and Transitions Counselor",
    slug: "zach-milicic",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sarah",
    lastName: "Milicic",
    title: "Administrative Asst IV",
    slug: "sarah-milicic",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Theresa Elizabeth",
    lastName: "Milks",
    title: "Gift Processing Assistant IV",
    slug: "theresa-elizabeth-milks",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dianne",
    lastName: "Miller",
    title: "Senior Director Federal Relations",
    slug: "dianne-miller",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Andrew Martin",
    lastName: "Miller",
    title: "Senior Investment Officer, Risk and Portfolio Analytics",
    slug: "andrew-martin-miller",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Laura Jane Schelhas",
    lastName: "Miller",
    title:
      " Executive Assistant to the Vice Provost for Undergraduate Education",
    slug: "laura-jane-schelhas-miller",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jane M.",
    lastName: "Miller",
    title: "Dual Career/Engagement Consultant",
    slug: "jane-m-miller",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Amanda",
    lastName: "Miller",
    title: "Regional Director, Enterprise Programs",
    slug: "amanda-miller",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Maranda",
    lastName: "Miller",
    title: "Career Education Specialist",
    slug: "maranda-miller",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Coreen",
    lastName: "Miller",
    title: "Director of Integrated Marketing",
    slug: "coreen-miller",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Diane J.",
    lastName: "Miller",
    title: "Associate Director",
    slug: "diane-j-miller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Donald",
    lastName: "Miller",
    title: "Research Supp Spec I",
    slug: "donald-miller",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Chorben E",
    lastName: "Miller",
    title: "Associate Product Manager",
    slug: "chorben-e-miller",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Linda Rae Habetler",
    lastName: "Miller",
    title: "Assessment Librarian",
    slug: "linda-rae-habetler-miller",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ellen T",
    lastName: "Miller",
    title: "Research and Administrative Manager",
    slug: "ellen-t-miller",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Colleen",
    lastName: "Miller",
    title: "Deputy Director of Financial Aid",
    slug: "colleen-miller",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "K.",
    lastName: "Miller",
    title:
      " Assistant University Registrar, Academic Technology, Planning & Design",
    slug: "k-miller",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Angela",
    lastName: "Miller",
    title: "K-12 Programs Assistant",
    slug: "angela-miller",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Emily M.",
    lastName: "Miller",
    title: "CALS Alumni Affairs and Development Coordinator",
    slug: "emily-m-miller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Colton Kendrick",
    lastName: "Miller",
    title: "ACRefrig Mech/Plumb",
    slug: "colton-kendrick-miller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katelyn",
    lastName: "Miller",
    title: "Field Crops Specialist",
    slug: "katelyn-miller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Donna",
    lastName: "Miller",
    title: "Administrative Asst IV",
    slug: "donna-miller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hannah Ruth",
    lastName: "Miller",
    title: "Managing Editor",
    slug: "hannah-ruth-miller",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kevin D",
    lastName: "Miller",
    title: "Enrollment Counselor II",
    slug: "kevin-d-miller",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Tiffany Marie",
    lastName: "Miller",
    title: "Vocational Rehabilitation Associate",
    slug: "tiffany-marie-miller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Felicity Kate",
    lastName: "Miller",
    title: "Assistant to the Senior Director of Programs",
    slug: "felicity-kate-miller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Glenna",
    lastName: "Miller",
    title: "Late Night Supervisor",
    slug: "glenna-miller",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Christian J.",
    lastName: "Miller",
    title: "ILR Research Librarian",
    slug: "christian-j-miller",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sara J.",
    lastName: "Miller",
    title: "Administrator III",
    slug: "sara-j-miller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William A.",
    lastName: "Miller",
    title: "Research Supp Spec II",
    slug: "william-a-miller",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alexa Iris",
    lastName: "Miller",
    title: "(Riccio) Art Studio Monitor",
    slug: "alexa-iris-miller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher",
    lastName: "Miller",
    title: "Gifts Officer II",
    slug: "christopher-miller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paula",
    lastName: "Miller",
    title: "Assistant Registrar",
    slug: "paula-miller",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Roger Dale",
    lastName: "Miller",
    title: "Pre-Award Specialist",
    slug: "roger-dale-miller",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Samantha",
    lastName: "Miller",
    title: "Assistant Director, Need Analysis and Packaging",
    slug: "samantha-miller",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Liz",
    lastName: "Millhollen",
    title: "Associate Director, Upward Bound",
    slug: "liz-millhollen",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mary Margaret",
    lastName: "Millick",
    title: "AAD Program Assistant",
    slug: "mary-margaret-millick",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Renee A.",
    lastName: "Milligan",
    title: "Assistant Director of MEng Programs",
    slug: "renee-a-milligan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Grennan J",
    lastName: "Milliken",
    title: "Climate Jobs Associate",
    slug: "grennan-j-milliken",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen S.",
    lastName: "Milmeister",
    title: "Enrollment Counselor I",
    slug: "karen-s-milmeister",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Cara",
    lastName: "Milne",
    title: "Graduate Field Administrator",
    slug: "cara-milne",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cindy",
    lastName: "Milner",
    title: "Nutritionist",
    slug: "cindy-milner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Corey",
    lastName: "Milnes",
    title: "Director, Enterprise Programs",
    slug: "corey-milnes",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shalini",
    lastName: "Mimani",
    title: "Associate Vice President, Cornell Tech Campus & Northeast Corridor",
    slug: "shalini-mimani",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer A",
    lastName: "Mimno",
    title: "Director for M.Eng. Programs Admissions and Recruitment",
    slug: "jennifer-a-mimno",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Isabel",
    lastName: "Mina",
    title: "(Todd) AAP- Photo Lab Monitor",
    slug: "isabel-mina",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sheri L.",
    lastName: "Minarski",
    title: "Director of Administration",
    slug: "sheri-l-minarski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jon",
    lastName: "Minarski",
    title: "Senior Project Coordinator",
    slug: "jon-minarski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erica",
    lastName: "Miner",
    title: "Assistant Director of Graduate Admissions",
    slug: "erica-miner",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Nathan J.",
    lastName: "Miner",
    title: "Circulation/Collection Management Assistant",
    slug: "nathan-j-miner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nahla",
    lastName: "Minges",
    title: "Event Manager",
    slug: "nahla-minges",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maya",
    lastName: "Minter",
    title: "Project Associate for Entrepreneurship Programs",
    slug: "maya-minter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Romano",
    lastName: "Miojevic",
    title: "Tech Svcs Supv II",
    slug: "romano-miojevic",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "India",
    lastName: "Miraglia",
    title: "Acquisitions Assistant",
    slug: "india-miraglia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kenneth Michael",
    lastName: "Miranda",
    title: "Chief Investment Officer",
    slug: "kenneth-michael-miranda",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shukria",
    lastName: "Mirzaie",
    title: "Manuscript Processing Student Assisant - ATS",
    slug: "shukria-mirzaie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aditya",
    lastName: "Misra",
    title: "Vice President and Chief Risk Officer",
    slug: "aditya-misra",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sarah",
    lastName: "Missen",
    title: "Athletic Trainer",
    slug: "sarah-missen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mark James",
    lastName: "Miszewski",
    title: "Senior PeopleSoft Developer",
    slug: "mark-james-miszewski",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Heather L.",
    lastName: "Mitchell",
    title: "Workflow Coordinator",
    slug: "heather-l-mitchell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tamika Danielle",
    lastName: "Mitchell",
    title: "Seasonal Admissions Readers",
    slug: "tamika-danielle-mitchell",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Fati",
    lastName: "Mixha",
    title: "SFBI Admin Asst, PIHE Assistant",
    slug: "fati-mixha",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Reina",
    lastName: "Miyake",
    title: "Administrative Assistant",
    slug: "reina-miyake",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alyssa",
    lastName: "Miyamoto",
    title: "Intramural Sports Student Supervisor, Student Athletic Serv Asst I",
    slug: "alyssa-miyamoto",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Alyse C.",
    lastName: "Mizia",
    title: "Administrative Assistant, Sorority & Fraternity Life",
    slug: "alyse-c-mizia",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Liisa S.",
    lastName: "Mobley",
    title: "Head of Continuation Workflow Group",
    slug: "liisa-s-mobley",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christopher",
    lastName: "Mobley",
    title: "Wilson Lab Administrative Assistant",
    slug: "christopher-mobley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sean Patrick",
    lastName: "Moeller",
    title: "Associate Dean of Staff and Academic Administration",
    slug: "sean-patrick-moeller",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joyel D",
    lastName: "Moeller",
    title: "Compliance Specialist",
    slug: "joyel-d-moeller",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Debra Lynn",
    lastName: "Moesch",
    title: "Assistant Director",
    slug: "debra-lynn-moesch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy L.",
    lastName: "Moesch",
    title: "Assistant to the Chair",
    slug: "amy-l-moesch",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Theresa",
    lastName: "Mohabir-Pennella",
    title: "NYC Outreach Communications and Marketing Lead",
    slug: "theresa-mohabir-pennella",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Fawad",
    lastName: "Mohammadi",
    title: "Reference Assistant",
    slug: "fawad-mohammadi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kiran",
    lastName: "Mohammadi-Williams",
    title: "Collections As Data Librarian",
    slug: "kiran-mohammadi-williams",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ameen F.",
    lastName: "Moheed",
    title: "Assistant Director, IT Systems, Security and Support",
    slug: "ameen-f-moheed",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bronwyn J. Q.",
    lastName: "Mohlke",
    title: "Digital Conversion Coordinator",
    slug: "bronwyn-j-q-mohlke",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer",
    lastName: "Moiseff",
    title: "Medical Technology Manager I",
    slug: "jennifer-moiseff",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kundan",
    lastName: "Moktan",
    title: "Plant Research Growth Facility Supervisor",
    slug: "kundan-moktan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel",
    lastName: "Molczyk",
    title: "Senior Web Application Developer",
    slug: "daniel-molczyk",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lauren",
    lastName: "Molino",
    title: "Graphic Designer",
    slug: "lauren-molino",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Diana Elizabeth",
    lastName: "Moller",
    title: "Diversity, Equity and Inclusion Specialist III",
    slug: "diana-elizabeth-moller",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Danielle L.",
    lastName: "Molsee",
    title: "Enrollment Support Representative",
    slug: "danielle-l-molsee",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Leslie",
    lastName: "Molyneaux",
    title: "Buying Assistant",
    slug: "leslie-molyneaux",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sean",
    lastName: "Mongan",
    title: "IT Service Desk Support/IT Provisioning and Support",
    slug: "sean-mongan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily",
    lastName: "Monroe",
    title: "HR Business Partner and Analytics",
    slug: "emily-monroe",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Toni",
    lastName: "Monroe",
    title: "Archiving Assistant",
    slug: "toni-monroe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Velvet L.",
    lastName: "Monroe",
    title: "Applications Developer III",
    slug: "velvet-l-monroe",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kent",
    lastName: "Monroe",
    title: "Web Content Manager",
    slug: "kent-monroe",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Maria E.",
    lastName: "Montesano",
    title: "Program Manager",
    slug: "maria-e-montesano",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shelby Elizabeth",
    lastName: "Montgomery",
    title: "Senior Grant and Contract Officer",
    slug: "shelby-elizabeth-montgomery",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Colin J",
    lastName: "Montgomery",
    title: "Transition Associate",
    slug: "colin-j-montgomery",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kevin",
    lastName: "Mooney",
    title: "Assistant Director, Cash Management",
    slug: "kevin-mooney",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cara Elizabeth",
    lastName: "Mooney",
    title: "Learning Consultant, Integrations",
    slug: "cara-elizabeth-mooney",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dr Nicki Webber",
    lastName: "Moore",
    title: "The Meakem & Smith Director of Athletics & Physical Education",
    slug: "dr-nicki-webber-moore",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Teresa Ausherman",
    lastName: "Moore",
    title: "Accounts Rep",
    slug: "teresa-ausherman-moore",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mark",
    lastName: "Moore",
    title: "Director, Federal Government and Military Programs",
    slug: "mark-moore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Veronica A.",
    lastName: "Moore",
    title: "Senior Program Assistant",
    slug: "veronica-a-moore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle",
    lastName: "Moore",
    title: "Administrative Asst IV, Major Gifts",
    slug: "danielle-moore",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Pamela",
    lastName: "Moore",
    title: "Administrative Asst IV",
    slug: "pamela-moore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole Lynn",
    lastName: "Moore",
    title: "Customer Service Representative",
    slug: "nicole-lynn-moore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Manoj",
    lastName: "Moorjani",
    title: "Senior PeopleSoft Developer",
    slug: "manoj-moorjani",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John Michael",
    lastName: "Moorse",
    title: "Administrative Assistant to the Director's Office",
    slug: "john-michael-moorse",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacob",
    lastName: "Morales",
    title: "ILR Course Assistant IV (Fitchette)",
    slug: "jacob-morales",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Carl F.",
    lastName: "Moravec",
    title: "Senior Production Controller",
    slug: "carl-f-moravec",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Martin",
    lastName: "Moravek",
    title: "IT Infrastructure and Desktop Support Manager",
    slug: "martin-moravek",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Corrie",
    lastName: "Moreau",
    title:
      " Senior Associate Dean of Access and Community Empowerment, Martha N. and John C. Moser Professor of Arthropod Biosystematics and Biodiversity, Professor",
    slug: "corrie-moreau",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Debra",
    lastName: "Morey",
    title: "Asst. Director of Administration/Sr. Asst. Registrar",
    slug: "debra-morey",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alina Guerrero",
    lastName: "Morgade",
    title: "Marketing Cloud Administrator",
    slug: "alina-guerrero-morgade",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Matthew C.",
    lastName: "Morgan",
    title: "Administrative Coordinator",
    slug: "matthew-c-morgan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Camilla Marie",
    lastName: "Morgan",
    title: "Senior Director of Admissions, Cornell Executive MBA Americas",
    slug: "camilla-marie-morgan",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Lauren D.",
    lastName: "Morgenstern",
    title: "Associate Director, Class Programs",
    slug: "lauren-d-morgenstern",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jason John",
    lastName: "Morisette",
    title: "Art and Animation Manager",
    slug: "jason-john-morisette",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Morley",
    title: "Marketing Specialist",
    slug: "jennifer-morley",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer D.",
    lastName: "Morrill",
    title: "Gift Processing Assistant III",
    slug: "jennifer-d-morrill",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cyndi",
    lastName: "Morris",
    title: "HR Business Partner",
    slug: "cyndi-morris",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Giles",
    lastName: "Morris",
    title: "Assistant Dean of Communications",
    slug: "giles-morris",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jim",
    lastName: "Morris",
    title: "SVP, Enterprise Programs",
    slug: "jim-morris",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Morris",
    title: "Audit Director",
    slug: "jennifer-morris",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michael A.",
    lastName: "Morris",
    title: "Assistant to the Director",
    slug: "michael-a-morris",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maureen",
    lastName: "Morris",
    title: "Lead Librarian for Liaison Services",
    slug: "maureen-morris",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ashley",
    lastName: "Morris",
    title: "Aquatic Invasive Species Coordinator",
    slug: "ashley-morris",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jim",
    lastName: "Morris-Knower",
    title: "Research & Evidence Synthesis Librarian",
    slug: "jim-morris-knower",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David",
    lastName: "Morrison",
    title: "Enterprise Application System Developer",
    slug: "david-morrison",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kentaro Mita",
    lastName: "Morrison",
    title: "Associate Product Manager",
    slug: "kentaro-mita-morrison",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ann L.",
    lastName: "Morse",
    title: "Executive Director of Communications and Marketing",
    slug: "ann-l-morse",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michelle",
    lastName: "Morse",
    title: "Administrative Asst V",
    slug: "michelle-morse",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda",
    lastName: "Morse",
    title:
      " Administrative Assistant, Bowers CIS (Admin. Support and Special Projects)",
    slug: "amanda-morse",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan A.",
    lastName: "Morse",
    title: "Purchasing Agent III",
    slug: "susan-a-morse",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scott David",
    lastName: "Morse",
    title: "Maintenance Planner",
    slug: "scott-david-morse",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Traci L.",
    lastName: "Morse",
    title: "Scheinman Institute Program Lead",
    slug: "traci-l-morse",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Roger T.",
    lastName: "Morse",
    title: "Pilot Plant Manager",
    slug: "roger-t-morse",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heidi",
    lastName: "Morton",
    title: "M.Eng. Career Services Coordinator",
    slug: "heidi-morton",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Zaina Khalid",
    lastName: "Mosalam",
    title: "Intramural Official",
    slug: "zaina-khalid-mosalam",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Amanda",
    lastName: "Moser",
    title: "Recruiting Manager & Associate Director, Career Management Center",
    slug: "amanda-moser",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kambrya Blake",
    lastName: "Mosier",
    title: "Administrative Asst IV",
    slug: "kambrya-blake-mosier",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jannica",
    lastName: "Moskal",
    title: "Assistant Director, MEng Programs",
    slug: "jannica-moskal",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Justina",
    lastName: "Mosley",
    title: "Resource Navigator - Cayuga Medical Center (Lara Parrilla)",
    slug: "justina-mosley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cindy",
    lastName: "Mosqueda",
    title: "Senior Associate Director",
    slug: "cindy-mosqueda",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cora G.",
    lastName: "Moss",
    title: "Administrative and Events Coordinator",
    slug: "cora-g-moss",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Benjamin F.",
    lastName: "Moss",
    title: "Senior Instructional Designer",
    slug: "benjamin-f-moss",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christopher T.",
    lastName: "Mott",
    title: "R5 Manager",
    slug: "christopher-t-mott",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacquelyn",
    lastName: "Mouillesseaux",
    title:
      " Consultant Dual Career, Relocation and Bridge to Employment Program",
    slug: "jacquelyn-mouillesseaux",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Billi",
    lastName: "Mouillesseaux",
    title:
      " Assistant to the Associate Dean for Research and Graduate Education",
    slug: "billi-mouillesseaux",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Hannah",
    lastName: "Moyal",
    title: "DFE Workforce Support Specialist",
    slug: "hannah-moyal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael M.",
    lastName: "Moyer",
    title: "Associate Vice President, Principal Gifts",
    slug: "michael-m-moyer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kimberly Anne",
    lastName: "Moyer",
    title: "Financial Services Manager",
    slug: "kimberly-anne-moyer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mnumzana Franklin",
    lastName: "Moyo",
    title: "IT Asst.",
    slug: "mnumzana-franklin-moyo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Zorica",
    lastName: "Mrdjen",
    title: "Building Care Manager",
    slug: "zorica-mrdjen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dragan",
    lastName: "Mrdjen",
    title: "Building Care Manager",
    slug: "dragan-mrdjen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacob",
    lastName: "Mroczek",
    title: "Brand and Creative Specialist",
    slug: "jacob-mroczek",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lars A",
    lastName: "Mudrak",
    title: "Finance Specialist III",
    slug: "lars-a-mudrak",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Micere",
    lastName: "Mugweru",
    title: "Product Team Admin Assistant",
    slug: "micere-mugweru",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shohrat",
    lastName: "Muhamov",
    title: "Salesforce Developer",
    slug: "shohrat-muhamov",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Marine",
    lastName: "Mukashambo",
    title: "Project Manager",
    slug: "marine-mukashambo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ben Karanja",
    lastName: "Mukeku",
    title: "IT Asst",
    slug: "ben-karanja-mukeku",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sharon L.",
    lastName: "Mullen",
    title: "Administrative Asst IV",
    slug: "sharon-l-mullen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle",
    lastName: "Mullen-Pearce",
    title: "Casual Accounts Rep V",
    slug: "michelle-mullen-pearce",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shayna Marie",
    lastName: "Muller",
    title: "Multimedia Specialist I",
    slug: "shayna-marie-muller",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kathleen M",
    lastName: "Mulligan",
    title: "Director, Labor Leadership Development Programs",
    slug: "kathleen-m-mulligan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Erin S.",
    lastName: "Mulrooney",
    title: "Associate Dean for Administration",
    slug: "erin-s-mulrooney",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jessica del",
    lastName: "Mundo",
    title: "Associate Director of Development",
    slug: "jessica-del-mundo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather Lynn",
    lastName: "Muniz",
    title: "Assistant to the Chair of Biomedical Sciences",
    slug: "heather-lynn-muniz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maks",
    lastName: "Muno",
    title: "Web Applications Developer",
    slug: "maks-muno",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Trisica",
    lastName: "Munroe",
    title: "Director of Administration",
    slug: "trisica-munroe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael John",
    lastName: "Munroe",
    title: "Orchard Worker Hd S10",
    slug: "michael-john-munroe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karla Lee",
    lastName: "Munroe",
    title: "Administrative Assistant AHDC Endocrinology",
    slug: "karla-lee-munroe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda Noelle",
    lastName: "Munson",
    title: "Program Assistant",
    slug: "amanda-noelle-munson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Areya",
    lastName: "Muraca",
    title: "Marketing Designer",
    slug: "areya-muraca",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Fred",
    lastName: "Muratori",
    title: "Collection Development Lead Librarian for Olin/Uris",
    slug: "fred-muratori",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alice E.",
    lastName: "Murdock",
    title: "Accounts Coordinator",
    slug: "alice-e-murdock",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Erick Kithinji",
    lastName: "Muriungi",
    title: "Project Life Assistant, SASA III - STSCI 2000",
    slug: "erick-kithinji-muriungi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Katie",
    lastName: "Muro",
    title: "Graduate Admissions Specialist",
    slug: "katie-muro",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Alyson",
    lastName: "Murphy",
    title: "Youth Protection Manager",
    slug: "alyson-murphy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew M.",
    lastName: "Murphy",
    title: "Water Filter Plant Manager",
    slug: "andrew-m-murphy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary Kathleen",
    lastName: "Murphy",
    title: "Production Editor",
    slug: "mary-kathleen-murphy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Frank V.",
    lastName: "Murphy",
    title: "NE-CAT Director",
    slug: "frank-v-murphy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Darren",
    lastName: "Murphy",
    title: "Human Resources Representative",
    slug: "darren-murphy",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ellen Ann",
    lastName: "Murphy",
    title:
      " Associate Director, International & Masters Programs Career Services",
    slug: "ellen-ann-murphy",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Heather Elyse",
    lastName: "Murray",
    title:
      " Local Journalism Project Managing Attorney and Associate Director, First Amendment Clinic",
    slug: "heather-elyse-murray",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Olivia K.",
    lastName: "Murray",
    title: "Office Coordinator, Student Support & Advocacy Services",
    slug: "olivia-k-murray",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Markette H.",
    lastName: "Murray-Pierce",
    title: "Instructional Production Specialist",
    slug: "markette-h-murray-pierce",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Adam",
    lastName: "Murtland",
    title: "Associate Director, Multimedia",
    slug: "adam-murtland",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lindsey",
    lastName: "Murtland",
    title: "Director, Volunteer Training and Leadership Development",
    slug: "lindsey-murtland",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adrian",
    lastName: "Musat",
    title: "Infomation Specialist",
    slug: "adrian-musat",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Bri",
    lastName: "Muscente",
    title: "Human Resources Associate",
    slug: "bri-muscente",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kimberly Kristen",
    lastName: "Muse",
    title: "Administrative Coordinator",
    slug: "kimberly-kristen-muse",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shannon",
    lastName: "Musgrove",
    title:
      " Associate Director for Student Empowerment, First-Generation & Low-Income Student Support",
    slug: "shannon-musgrove",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Joy",
    lastName: "Mushabac",
    title: "Generalist Counselor Therapist",
    slug: "joy-mushabac",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brooke Amanda",
    lastName: "Musmacker",
    title: "Undergraduate Experience Coordinator",
    slug: "brooke-amanda-musmacker",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Pauline Thecla",
    lastName: "Muto",
    title: "Assistant General Counsel",
    slug: "pauline-thecla-muto",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Sarah Degen",
    lastName: "Muzio",
    title: "Event/Conference Coord II",
    slug: "sarah-degen-muzio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Harleigh Kim",
    lastName: "Myerovich",
    title: "Access Services Assistant",
    slug: "harleigh-kim-myerovich",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Heather M.",
    lastName: "Myers",
    title: "Financial Transaction Representative",
    slug: "heather-m-myers",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Swe Swe",
    lastName: "Myint",
    title: "Cataloging Associate & Gifts Coordinator",
    slug: "swe-swe-myint",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cory J.",
    lastName: "Myler",
    title: "Generalist Counselor Therapist",
    slug: "cory-j-myler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "April Hope",
    lastName: "Myles",
    title: "Assistant University Registrar, Compliance",
    slug: "april-hope-myles",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Prabhakaran",
    lastName: "Nagarajan",
    title: "eCornell Chief Technology Officer",
    slug: "prabhakaran-nagarajan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nazmun",
    lastName: "Nahar",
    title: "ILR Course Assistant IV (MacDowell)",
    slug: "nazmun-nahar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michelle",
    lastName: "Nair",
    title: "Research Spaces Coordinator/Building Supervisor",
    slug: "michelle-nair",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Charles",
    lastName: "Nakamura",
    title: "Programs Finance Specialist",
    slug: "charles-nakamura",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michelle M.",
    lastName: "Nardi",
    title: "Executive Staff Assistant to Chief Investment Officer",
    slug: "michelle-m-nardi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dennis",
    lastName: "Nardi",
    title: "Endpoint Infrastructure Architect",
    slug: "dennis-nardi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michelle Elizabeth",
    lastName: "Nardi",
    title: "Nutrition Program Manager",
    slug: "michelle-elizabeth-nardi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kara M",
    lastName: "Nash",
    title: "Dispatcher S07",
    slug: "kara-m-nash",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "MacLain",
    lastName: "Naumann",
    title: "Assistant Director, Speech Program",
    slug: "maclain-naumann",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Natalia S.",
    lastName: "Navas",
    title: "Labor Leadership Programs Associate",
    slug: "natalia-s-navas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "JP",
    lastName: "Nawn",
    title: "Collections Management Assistant",
    slug: "jp-nawn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Irina V.",
    lastName: "Naydich",
    title: "Web Developer",
    slug: "irina-v-naydich",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anton",
    lastName: "Nazarenko",
    title: "Riccio - AAP Print Media Studio Monitor",
    slug: "anton-nazarenko",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Geneva Marie Hidalgo",
    lastName: "Nazario",
    title: "Administrator II",
    slug: "geneva-marie-hidalgo-nazario",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dawn",
    lastName: "Ndubuisi-Ike",
    title: "Becker House Office Assistant, Student Acad Serv Asst III",
    slug: "dawn-ndubuisi-ike",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Eisha",
    lastName: "Neely",
    title: "Research Services Librarian",
    slug: "eisha-neely",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Bonalyn",
    lastName: "Nelsen",
    title: "Business Management Specialist",
    slug: "bonalyn-nelsen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zoe",
    lastName: "Nelson",
    title: "Associate Director for State Government Relations",
    slug: "zoe-nelson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "David Keith",
    lastName: "Nelson",
    title: "IT Project Coordinator",
    slug: "david-keith-nelson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Natalee L.",
    lastName: "Nelson",
    title: "Office Manager",
    slug: "natalee-l-nelson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel C.",
    lastName: "Nemeth-Neumann",
    title: "Co-Director, Student Services & Advising",
    slug: "daniel-c-nemeth-neumann",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Dimitrios J",
    lastName: "Nerantzinis",
    title: "EMI Research Asst",
    slug: "dimitrios-j-nerantzinis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mehria",
    lastName: "Nessar",
    title: "Enrollment Counselor II",
    slug: "mehria-nessar",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Catherine",
    lastName: "Netland",
    title: "Coordinator for Bird Safety",
    slug: "catherine-netland",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert Paul",
    lastName: "Neuman",
    title: "Technical Assistant",
    slug: "robert-paul-neuman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael",
    lastName: "Neville",
    title: "IT Support Specialist (Level 2)",
    slug: "michael-neville",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cheryl Ann",
    lastName: "Neville",
    title: "Financial Transaction Representative",
    slug: "cheryl-ann-neville",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Susette",
    lastName: "Newberry",
    title: "Reference and Instruction Librarian",
    slug: "susette-newberry",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Melissa Rose",
    lastName: "Newcomb",
    title: "Staff Writer",
    slug: "melissa-rose-newcomb",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Isaac Dennis",
    lastName: "Newcomb",
    title: "A/V Design Assistant",
    slug: "isaac-dennis-newcomb",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sarah Grace",
    lastName: "Newcomb",
    title: "Career Services Asst., HADM 1198 (Gaulke) CA",
    slug: "sarah-grace-newcomb",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Brad",
    lastName: "Newhouse",
    title: "Director, Project Management",
    slug: "brad-newhouse",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Justin R.",
    lastName: "Newhouse",
    title: "Finance Specialist II",
    slug: "justin-r-newhouse",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Angela M",
    lastName: "Newkirk",
    title: "Benefits Associate, Health & Welfare Benefit Programs",
    slug: "angela-m-newkirk",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Susan E.",
    lastName: "Newman",
    title: "Project and Events Associate",
    slug: "susan-e-newman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Craig",
    lastName: "Newton",
    title: "Managing Director, Legal Information Institute",
    slug: "craig-newton",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Donna L.",
    lastName: "Newton",
    title: "Administrative Manager",
    slug: "donna-l-newton",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jayde Alexis",
    lastName: "Newton",
    title: "Client Service Representative",
    slug: "jayde-alexis-newton",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ying Shan",
    lastName: "Ng",
    title: "REAL 5370 (Danks Burke) CA",
    slug: "ying-shan-ng",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Minhchan Dinh",
    lastName: "Nguyen",
    title: "Engaged Ambassador",
    slug: "minhchan-dinh-nguyen",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lynda",
    lastName: "Nguyen",
    title: "Climate Jobs Associate",
    slug: "lynda-nguyen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert David",
    lastName: "Nicholl",
    title: "Registrar Support Specialist",
    slug: "robert-david-nicholl",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Heather L.",
    lastName: "Nichols",
    title: "Dir, Admissions Relations",
    slug: "heather-l-nichols",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jade Fuller",
    lastName: "Nichols",
    title: "Garner - AAP Student Administrative Assistant",
    slug: "jade-fuller-nichols",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kate",
    lastName: "Nicholson",
    title:
      " HR Services and Transitions Center Counselor, PiTech Director of Programs and Partnerships",
    slug: "kate-nicholson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Brandee F.",
    lastName: "Nicholson",
    title: "Associate Director of Residential Education",
    slug: "brandee-f-nicholson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Carol A.",
    lastName: "Nickerson",
    title: "Medical Leaves Case Management Consultant",
    slug: "carol-a-nickerson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Laurie Elaine",
    lastName: "Nicoson",
    title: "CFC Office Assistant",
    slug: "laurie-elaine-nicoson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William James",
    lastName: "Niebel",
    title: "Managing Attorney, Tenants Advocacy Program",
    slug: "william-james-niebel",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "John W.",
    lastName: "Niederbuhl",
    title: "Communications & Programming Coordinator",
    slug: "john-w-niederbuhl",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Cristina",
    lastName: "Nieves",
    title: "Residence Hall Director",
    slug: "cristina-nieves",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Yang",
    lastName: "Ning",
    title: "Assoc Prof",
    slug: "yang-ning",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sumit Narayan",
    lastName: "Niogi",
    title: "Dir Acad",
    slug: "sumit-narayan-niogi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katrina",
    lastName: "Nobles",
    title: "Director of Conflict Programs",
    slug: "katrina-nobles",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrea",
    lastName: "Nocentini",
    title: "Coord Program I",
    slug: "andrea-nocentini",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren Nicole",
    lastName: "Noll",
    title:
      " AAP- IT solutions Cage Monitor, Reiser - AAP Office of Admissions Tour Guide",
    slug: "lauren-nicole-noll",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jill N.",
    lastName: "Nordberg",
    title: "Administrator II",
    slug: "jill-n-nordberg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelsie",
    lastName: "Norek",
    title: "Sr Data Curator",
    slug: "kelsie-norek",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Patrick",
    lastName: "Norris",
    title: "Assistant Director, Annual Giving Programs and Reunion",
    slug: "patrick-norris",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William",
    lastName: "Noseworthy",
    title: "Cataloging Associate, Vietnamese",
    slug: "william-noseworthy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Martin J.",
    lastName: "Novak",
    title: "Research Supp Spec III",
    slug: "martin-j-novak",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stephen Robert",
    lastName: "Nowak",
    title: "Business Development and Licensing Associate",
    slug: "stephen-robert-nowak",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dana",
    lastName: "Nowakowski",
    title: "Career Associate for Professional Readiness and Pre- Law/Pre-Grad",
    slug: "dana-nowakowski",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kate M.",
    lastName: "Nowlan",
    title: "Administrative Asst IV",
    slug: "kate-m-nowlan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andy",
    lastName: "Noyes",
    title: "Communications Coordinator",
    slug: "andy-noyes",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Audrey Marie",
    lastName: "Nugent",
    title: "Account Representative",
    slug: "audrey-marie-nugent",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kaylyn Nicole",
    lastName: "Nugent",
    title: "Purchasing Agent II",
    slug: "kaylyn-nicole-nugent",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Nutt",
    title: "Senior Staff Writer",
    slug: "david-nutt",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ikechi",
    lastName: "Nwankwo",
    title: "Senior Director of Executive MBA Admissions",
    slug: "ikechi-nwankwo",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Brittany Jordan",
    lastName: "Ny",
    title: "Accounts Rep V",
    slug: "brittany-jordan-ny",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christine",
    lastName: "Nye",
    title: "Associate Dean of Students, Group Behavior and Development",
    slug: "christine-nye",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Chris",
    lastName: "O'Brien",
    title: "Assistant Director HR Project Management",
    slug: "chris-o-brien",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Thomas F.",
    lastName: "O'Brien",
    title: "Telecommunications Officer",
    slug: "thomas-f-o-brien",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christine",
    lastName: "O'Brien",
    title: "Assistant Director of Admissions, EMBA Metro NY",
    slug: "christine-o-brien",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Alina",
    lastName: "O'Connor",
    title: "External Relations Officer IV",
    slug: "alina-o-connor",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Danielle Kay",
    lastName: "O'Connor",
    title: "Undergraduate Coordinator",
    slug: "danielle-kay-o-connor",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joy E. M.",
    lastName: "O'Connor",
    title: "Physical Therapist",
    slug: "joy-e-m-o-connor",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tara Grace",
    lastName: "O'Donnell",
    title: "AAP - Architecture Student Administrative Assistant (Sopp)",
    slug: "tara-grace-o-donnell",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Amanda",
    lastName: "O'Donnell",
    title: "Director of Virtual Site Program, Break Through Tech",
    slug: "amanda-o-donnell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Maeve",
    lastName: "O'Hara",
    title: "Instructional Production Specialist",
    slug: "maeve-o-hara",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Annie",
    lastName: "O'Hara",
    title: "Associate Learning Consultant",
    slug: "annie-o-hara",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michael P.",
    lastName: "O'Hare",
    title: "Specimen Preparator",
    slug: "michael-p-o-hare",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erin L.",
    lastName: "O'Keefe",
    title: "Undergraduate & Financial Coordinator",
    slug: "erin-l-o-keefe",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Grace",
    lastName: "O'Malley",
    title: "(Dossinger) - AAP IT Solutions Cage Monitor",
    slug: "grace-o-malley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kitty",
    lastName: "O'Neil",
    title: "Ag Climate Resiliency Specialist",
    slug: "kitty-o-neil",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael H",
    lastName: "O'Neill",
    title: "Associate Director for Digital Engagement",
    slug: "michael-h-o-neill",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Casey Flynn",
    lastName: "O'Neill",
    title: "LII - Wex",
    slug: "casey-flynn-o-neill",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Alexandra",
    lastName: "O'Neill",
    title: "Reference & Map Room Assistant/Student Supervisor",
    slug: "alexandra-o-neill",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tina M.",
    lastName: "O'Shea",
    title: "Administrative and Accounts Assistant",
    slug: "tina-m-o-shea",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Chad E.",
    lastName: "O'Shea",
    title: "Graphic Designer",
    slug: "chad-e-o-shea",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Thomas J.",
    lastName: "O'Toole",
    title: "Executive Director of Public Affairs Programming",
    slug: "thomas-j-o-toole",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Erin",
    lastName: "Oates",
    title: "Director, CALS Office of Pre-Award Services",
    slug: "erin-oates",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "William Luis",
    lastName: "Oates",
    title: "Graphic Designer",
    slug: "william-luis-oates",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Catheryn Cree",
    lastName: "Obern",
    title: "Director for Europe Int'l MG",
    slug: "catheryn-cree-obern",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cora",
    lastName: "Oberst",
    title: "Exec Staff Asst II",
    slug: "cora-oberst",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Francisco Padilla",
    lastName: "Obregon",
    title: "Applications Developer III",
    slug: "francisco-padilla-obregon",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anton",
    lastName: "Ochoa",
    title: "SDS Testing Coordinator, Disability Accommodations",
    slug: "anton-ochoa",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Angela E.",
    lastName: "Ochterski",
    title: "Administrative Asst III",
    slug: "angela-e-ochterski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Olivia Tirenioluwa",
    lastName: "Odukale",
    title: "Human Resoruces Student Admin Asst II",
    slug: "olivia-tirenioluwa-odukale",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Teresa Y",
    lastName: "Oh",
    title: "Gift Revenue Coordinator",
    slug: "teresa-y-oh",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sue",
    lastName: "Oh",
    title: "Lab Processing Assistant III",
    slug: "sue-oh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jens David",
    lastName: "Ohlin",
    title: "Allan R. Tessler Dean of the Cornell Law School",
    slug: "jens-david-ohlin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Olivia Claire",
    lastName: "Ohlsten",
    title: "Grant Coordinator",
    slug: "olivia-claire-ohlsten",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nic Olatunde",
    lastName: "Oke",
    title: "CDP Facilitator",
    slug: "nic-olatunde-oke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adaeze Ijeoma",
    lastName: "Okorie",
    title: "Health Initiatives Coordinator",
    slug: "adaeze-ijeoma-okorie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Olcott",
    title: "Finance Specialist III",
    slug: "jennifer-olcott",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lauren",
    lastName: "Oldham",
    title: "Applications Developer III",
    slug: "lauren-oldham",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kristen",
    lastName: "Olevnik",
    title: "Financial Transaction Representative",
    slug: "kristen-olevnik",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sarah",
    lastName: "Oliveira",
    title: "Human Resources Associate",
    slug: "sarah-oliveira",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Dani",
    lastName: "Oliveira",
    title: "Executive Staff Assistant to the Dean",
    slug: "dani-oliveira",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Chad M.",
    lastName: "Oliveiri",
    title: "VP, Curriculum Development",
    slug: "chad-m-oliveiri",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tim",
    lastName: "Olivieri",
    title: "Director, Prospect Development",
    slug: "tim-olivieri",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Clay",
    lastName: "Olney",
    title: "Systems Administrator",
    slug: "clay-olney",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kathleen Marie",
    lastName: "Olsen",
    title: "ACRefrig Mech/Plumb - GFP",
    slug: "kathleen-marie-olsen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Todd C.",
    lastName: "Olson",
    title: "Systems Administrator",
    slug: "todd-c-olson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joan M",
    lastName: "Olson",
    title: "Human Resources Asst V",
    slug: "joan-m-olson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Melinda",
    lastName: "Oltz",
    title: "Administrative and Project Coordinator",
    slug: "melinda-oltz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Logan A.",
    lastName: "Oltz",
    title: "Financial Transaction Representative",
    slug: "logan-a-oltz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gbolade",
    lastName: "Olusanya",
    title: "SCE Student Office Assistant, Student Athletic Serv Asst I",
    slug: "gbolade-olusanya",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Azra",
    lastName: "Omanovic",
    title: "Grant Coordinator",
    slug: "azra-omanovic",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dipo Kehinde",
    lastName: "Omokanwaye",
    title: "SCE Student Receptionist/Office Assistant",
    slug: "dipo-kehinde-omokanwaye",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tade Temitayo",
    lastName: "Omoniwa",
    title: "Intramural Sport Official",
    slug: "tade-temitayo-omoniwa",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Chijioke Kizito",
    lastName: "Onah",
    title: "GRA",
    slug: "chijioke-kizito-onah",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah",
    lastName: "ONeil",
    title: "Financial Aid Counselor (II)",
    slug: "sarah-oneil",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Richard Nwakire",
    lastName: "Onyejuruwa",
    title: "Senior Assistant Director of Admissions",
    slug: "richard-nwakire-onyejuruwa",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Timothy J.",
    lastName: "Oonk",
    title: "Major Gift Officer, SC Johnson College of Business",
    slug: "timothy-j-oonk",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Hillary Delaney",
    lastName: "Opperman",
    title: "Human Resources Associate",
    slug: "hillary-delaney-opperman",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Gabrielle",
    lastName: "Orcutt",
    title: "Assistant to the Department Chair of Astronomy",
    slug: "gabrielle-orcutt",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Courtney Van",
    lastName: "Order",
    title: "Associate Project Manager",
    slug: "courtney-van-order",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessica",
    lastName: "Oren-Detweiler",
    title: "Office Assistant, Office of Institutional Equity and Title IX",
    slug: "jessica-oren-detweiler",
    dei: true,
    category: "Miscellaneous",
  },
  {
    firstName: "Megan Noel",
    lastName: "Organ",
    title:
      " Executive Assistant to the Dean of the SC Johnson College of Business",
    slug: "megan-noel-organ",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cole Phillip",
    lastName: "Orick",
    title: "Inside Director, Corporate Programs",
    slug: "cole-phillip-orick",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rodney A.",
    lastName: "Orme",
    title: "Senior Academic Records Specialist",
    slug: "rodney-a-orme",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kristin Van",
    lastName: "Ormer",
    title: "Assistant Director, Parent Engagement & Philanthropy",
    slug: "kristin-van-ormer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "John Daniel Camacho",
    lastName: "Orona",
    title: "Bulletin Fall 2024",
    slug: "john-daniel-camacho-orona",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Stephanie",
    lastName: "Orphan",
    title: "arXiv Program Director",
    slug: "stephanie-orphan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jennifer",
    lastName: "Orr",
    title: "Finance Specialist II",
    slug: "jennifer-orr",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jonelle",
    lastName: "Orsaio",
    title: "Graduate Admissions & Onboarding Coordinator",
    slug: "jonelle-orsaio",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Azucena Elizabeth",
    lastName: "Ortega",
    title: "Program Assistant/Events Coordinator",
    slug: "azucena-elizabeth-ortega",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nubia",
    lastName: "Ortega",
    title: "eCornell Casual Student Support Agent",
    slug: "nubia-ortega",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Benjamin A.",
    lastName: "Ortiz",
    title: "Collection Specialist, Cornell Hip Hop Collection",
    slug: "benjamin-a-ortiz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cierra L",
    lastName: "Ortiz",
    title: "Program Delivery Specialist I",
    slug: "cierra-l-ortiz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rocio",
    lastName: "Ortiz",
    title: "Administrative Assistant",
    slug: "rocio-ortiz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Abbey",
    lastName: "Ortu",
    title: "Principal Gifts Associate",
    slug: "abbey-ortu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carrie",
    lastName: "Osborn",
    title: "Vehicle Account Representative",
    slug: "carrie-osborn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Allie",
    lastName: "Osborne",
    title: "Research Administration Assistant",
    slug: "allie-osborne",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ashley",
    lastName: "Osburn",
    title: "Senior Web Designer",
    slug: "ashley-osburn",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Melissa",
    lastName: "Osgood",
    title: "Bowers CIS Director of Communications",
    slug: "melissa-osgood",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Yusuke",
    lastName: "Oshimizu",
    title: "Advancement Services Records Specialist",
    slug: "yusuke-oshimizu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kimberly",
    lastName: "Osmani",
    title:
      " Program Director, Transition and Postsecondary Vocational Advancement",
    slug: "kimberly-osmani",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ryan James",
    lastName: "Ossit",
    title: "Grant Coordinator",
    slug: "ryan-james-ossit",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric Van",
    lastName: "Ostenbridge",
    title: "Senior Grant and Contract Officer",
    slug: "eric-van-ostenbridge",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "John Phillip",
    lastName: "Ostlund",
    title: "Critic Visiting",
    slug: "john-phillip-ostlund",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ryan",
    lastName: "Ostrander",
    title: "Desktop Support Specialist",
    slug: "ryan-ostrander",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gina",
    lastName: "Oswald",
    title: "Vocational Rehabilitation Associate",
    slug: "gina-oswald",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scott D.",
    lastName: "Otey",
    title: "Purchasing Agent III",
    slug: "scott-d-otey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tom J.",
    lastName: "Ottaviano",
    title: "Business & Economics Librarian",
    slug: "tom-j-ottaviano",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lyam",
    lastName: "Ouattara",
    title: "Undergrad Course Assistant III (Long)",
    slug: "lyam-ouattara",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joseph N.",
    lastName: "Outzen",
    title: "Enrollment Counselor II",
    slug: "joseph-n-outzen",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "James Lewis",
    lastName: "Overhiser",
    title: "PARADIM Director of Outreach and Education",
    slug: "james-lewis-overhiser",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katrina Marie",
    lastName: "Overton",
    title: "PhD Graduate Field Coordinator",
    slug: "katrina-marie-overton",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ali",
    lastName: "Owens",
    title: "Director, Finance",
    slug: "ali-owens",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ann",
    lastName: "Owens",
    title: "Administrative Asst III",
    slug: "ann-owens",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cecilia",
    lastName: "Oyediran",
    title: "Senior Cannabis Workforce Initiative Associate",
    slug: "cecilia-oyediran",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sebnem",
    lastName: "Ozkan",
    title: "Director of Global Hubs.",
    slug: "sebnem-ozkan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tyler John",
    lastName: "Pachai",
    title: "Enrollment Counselor I",
    slug: "tyler-john-pachai",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Amelia",
    lastName: "Pacht",
    title: "Assistant Director of Public Engagement, Urban Tech Hub",
    slug: "amelia-pacht",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Maggie",
    lastName: "Paciga",
    title: "Recruiting & Marketing Coordinator",
    slug: "maggie-paciga",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Iris",
    lastName: "Packman",
    title: "Senior Research & Policy Development Associate",
    slug: "iris-packman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joleen",
    lastName: "Padbury",
    title: "Research Administration Coordinator",
    slug: "joleen-padbury",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Susan Green",
    lastName: "Pado",
    title: "Administrative Coordinator, Student Law Journals",
    slug: "susan-green-pado",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jae",
    lastName: "Paek",
    title: "Enterprise Applications Integration Lead",
    slug: "jae-paek",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ioanna",
    lastName: "Pagani",
    title: "Bioinformatics/Biostatistics Specialist",
    slug: "ioanna-pagani",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kellie A.",
    lastName: "Page",
    title: "Associate Dean of Administration and Finance for Bowers CIS",
    slug: "kellie-a-page",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dustin",
    lastName: "Page",
    title: "Accounts Rep IV",
    slug: "dustin-page",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Julie A.",
    lastName: "Pagliaro",
    title: "Payroll Tax Specialist",
    slug: "julie-a-pagliaro",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dianys Nicole Padró",
    lastName: "Pagán",
    title: "Seasonal Admissions Readers",
    slug: "dianys-nicole-padr-pag-n",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Atmika Ashok",
    lastName: "Pai",
    title: "Urban Tech Coordinator",
    slug: "atmika-ashok-pai",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Julie L.",
    lastName: "Paige",
    title: "Director, Co-ops and Off-Campus Living",
    slug: "julie-l-paige",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mary",
    lastName: "Paige",
    title: "Finance Assistant",
    slug: "mary-paige",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jean M.",
    lastName: "Pajerek",
    title: "Director for Information Management",
    slug: "jean-m-pajerek",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cynthia R.",
    lastName: "Pakkala",
    title: "Administrative Assistant IV",
    slug: "cynthia-r-pakkala",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rohan",
    lastName: "Palacios",
    title: "Training & Education Support Specialist",
    slug: "rohan-palacios",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alexander",
    lastName: "Palacios",
    title: "Public Services Assistant",
    slug: "alexander-palacios",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adam P.",
    lastName: "Palcich",
    title: "Technology Strategist/Senior Applications Developer",
    slug: "adam-p-palcich",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cassie",
    lastName: "Palladino",
    title: "HR Project & Initiatives Specialist",
    slug: "cassie-palladino",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Nick",
    lastName: "Palladino",
    title: "Applications Developer III",
    slug: "nick-palladino",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Youngsun",
    lastName: "Palmer",
    title: "Communication Spec II",
    slug: "youngsun-palmer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elissa",
    lastName: "Palmer",
    title: "Grant Coordinator",
    slug: "elissa-palmer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen M.",
    lastName: "Palmeri",
    title: "Administrative Asst IV",
    slug: "karen-m-palmeri",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Margarite R.",
    lastName: "Palmeri-Cornwell",
    title: "Administrative Services Coord",
    slug: "margarite-r-palmeri-cornwell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sydney",
    lastName: "Paluch",
    title: "Residence Hall Director",
    slug: "sydney-paluch",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ed",
    lastName: "Panar",
    title: "Critic Visiting",
    slug: "ed-panar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sumitra Prasad",
    lastName: "Pandit",
    title: "SCE Student Receptionist/Office Assistant",
    slug: "sumitra-prasad-pandit",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sandra Roma",
    lastName: "Paniccia",
    title: "Director of Brand Messaging",
    slug: "sandra-roma-paniccia",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jaime",
    lastName: "Panos",
    title:
      " Associate Dean of Students for Student Support & Advocacy Service – Crisis Response",
    slug: "jaime-panos",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Michelle A.",
    lastName: "Paolillo",
    title: "Digital Lifecycle Services Manager",
    slug: "michelle-a-paolillo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dayna",
    lastName: "Papaleo",
    title: "Copy Editor",
    slug: "dayna-papaleo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Emily Autumn",
    lastName: "Pape",
    title: "Sustainability Coordinator-FCS, Student Labor/Facil Asst I(SCL-EM)",
    slug: "emily-autumn-pape",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peter D.",
    lastName: "Paradise",
    title: "Associate Dean of Finance and Administration",
    slug: "peter-d-paradise",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marisa Joanne",
    lastName: "Paradise",
    title: "Administrative Asst V",
    slug: "marisa-joanne-paradise",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ananda",
    lastName: "Paramasivam",
    title: "Info Tech Asst Dir II",
    slug: "ananda-paramasivam",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Veronica",
    lastName: "Parchesky",
    title: "IT Service Manager",
    slug: "veronica-parchesky",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Heather L.",
    lastName: "Parente",
    title: "Sr. Director of Finance and Budget",
    slug: "heather-l-parente",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Taylor",
    lastName: "Parente",
    title: "Event/Conference Coordinator",
    slug: "taylor-parente",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Niti",
    lastName: "Parikh",
    title: "Director, Learning Spaces and MakerLABS",
    slug: "niti-parikh",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Frank O.",
    lastName: "Parish",
    title: "Project Manager",
    slug: "frank-o-parish",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa",
    lastName: "Parish",
    title: "Project Architect",
    slug: "lisa-parish",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Troy Jay-Alexander",
    lastName: "Parish",
    title: "Events/Office Coordinator",
    slug: "troy-jay-alexander-parish",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Pamela",
    lastName: "Parish",
    title: "Commercial Binding Assistant",
    slug: "pamela-parish",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew Wujin Sava",
    lastName: "Park",
    title: "Investment Officer",
    slug: "andrew-wujin-sava-park",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lyn",
    lastName: "Park",
    title: "Accounts Rep III",
    slug: "lyn-park",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "William B.",
    lastName: "Parken",
    title: "Applications Developer II",
    slug: "william-b-parken",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Susan E.",
    lastName: "Parker",
    title:
      " Executive Support, Office of the Vice President for Student & Campus Life",
    slug: "susan-e-parker",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Benjamin",
    lastName: "Parker",
    title: "Assistant Director of Student Services, Cornell Public Health",
    slug: "benjamin-parker",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Samantha Rae",
    lastName: "Parker",
    title: "Communications Assistant",
    slug: "samantha-rae-parker",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "John A",
    lastName: "Parker",
    title: "Integration Developer",
    slug: "john-a-parker",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Adam Scott",
    lastName: "Parker",
    title: "ACRefrig Mech/Plumb",
    slug: "adam-scott-parker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth E.",
    lastName: "Parker",
    title: "Technical Services Archivist",
    slug: "elizabeth-e-parker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adam L.",
    lastName: "Parker",
    title: "Bldg Coord II, Biotech Conference Room Asst.",
    slug: "adam-l-parker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy C.",
    lastName: "Parmley",
    title: "Associate Director for HR Administration and Technology",
    slug: "amy-c-parmley",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Bernadette",
    lastName: "Parr",
    title: "Director Admissions",
    slug: "bernadette-parr",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Elizabeth",
    lastName: "Parr",
    title: "Associate Director of Administration",
    slug: "elizabeth-parr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jamie",
    lastName: "Parris",
    title: "Communications Strategist",
    slug: "jamie-parris",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Beth",
    lastName: "Parrott",
    title: "Director of Student Disability Services",
    slug: "beth-parrott",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Douglas J",
    lastName: "Parry",
    title: "IT Security Program Manager",
    slug: "douglas-j-parry",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Amelia K.",
    lastName: "Parseghian",
    title: "Finance Specialist III",
    slug: "amelia-k-parseghian",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Emily Louise",
    lastName: "Parsons",
    title: "Department Manager",
    slug: "emily-louise-parsons",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa",
    lastName: "Parsons",
    title: "Analytics Lead Developer",
    slug: "lisa-parsons",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Julie",
    lastName: "Paschal",
    title: "External Education Coordinator",
    slug: "julie-paschal",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lindsey Elizabeth",
    lastName: "Pashow",
    title: "Agricultural Business Development and Marketing Specialist",
    slug: "lindsey-elizabeth-pashow",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robin T.",
    lastName: "Pasiak",
    title: "Assistant Supervisor AHDC Histopathology",
    slug: "robin-t-pasiak",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Renee Elizabeth",
    lastName: "Passeri",
    title: "Intellectual Property Assistant",
    slug: "renee-elizabeth-passeri",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Toral Dhiru",
    lastName: "Patel",
    title: "Senior Consultant, Inclusion and Belonging",
    slug: "toral-dhiru-patel",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Rajeshri Shah",
    lastName: "Patel",
    title: "Immigration Project Attorney",
    slug: "rajeshri-shah-patel",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Francesca",
    lastName: "Patrizi",
    title: "Critic Visiting",
    slug: "francesca-patrizi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sangita Rani",
    lastName: "Patro",
    title: "Java - Full Stack Developer",
    slug: "sangita-rani-patro",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dustin",
    lastName: "Patte",
    title: "Assistant Manager, Merrill Family Sailing Center",
    slug: "dustin-patte",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Monica",
    lastName: "Patten",
    title: "Assistant Registrar, Cornell Tech",
    slug: "monica-patten",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jen",
    lastName: "Patterson",
    title: "DVM Curriculum Coordinator",
    slug: "jen-patterson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kelly Anne",
    lastName: "Patterson",
    title: "Administrative Asst IV-Business Office",
    slug: "kelly-anne-patterson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah",
    lastName: "Pattison",
    title: "Associate Director, Academic Programs",
    slug: "sarah-pattison",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Donivan",
    lastName: "Patwell",
    title: "Kuali DevOps Administrator",
    slug: "donivan-patwell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lisa",
    lastName: "Patz",
    title: "Director of Human Resources",
    slug: "lisa-patz",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Lara A",
    lastName: "Patz",
    title: "M.Eng. Programs Marketing and Recruiting Coordinator",
    slug: "lara-a-patz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kimberly M.",
    lastName: "Paul",
    title: "Event/Conference Coord II",
    slug: "kimberly-m-paul",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alan K.",
    lastName: "Pauling",
    title: "Research Supp Spec III",
    slug: "alan-k-pauling",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jennifer",
    lastName: "Pawlewicz",
    title: "Business Outreach Specialist",
    slug: "jennifer-pawlewicz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lianna",
    lastName: "Pawloski",
    title: "Sponsored Finance Specialist",
    slug: "lianna-pawloski",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sarah",
    lastName: "Pawlowski",
    title: "Email Marketing Specialist",
    slug: "sarah-pawlowski",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Heather",
    lastName: "Payeur",
    title: "Enrollment Counselor II",
    slug: "heather-payeur",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Brittany LaShon",
    lastName: "Paylor",
    title: "Services Coordinator",
    slug: "brittany-lashon-paylor",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher M.",
    lastName: "Payne",
    title: "Senior Director, Cornell Health",
    slug: "christopher-m-payne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Annette M.",
    lastName: "Payne",
    title: "Administrative Asst IV",
    slug: "annette-m-payne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley",
    lastName: "Payne",
    title: "Administrative Asst IV",
    slug: "ashley-payne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thomas J.",
    lastName: "Payne",
    title: "Network Tech IV",
    slug: "thomas-j-payne",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joni",
    lastName: "Payne",
    title: "Lab Processing Assistant II",
    slug: "joni-payne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tracey L.",
    lastName: "Peabody",
    title: "Sr. Mail Processor",
    slug: "tracey-l-peabody",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dawne Francine",
    lastName: "Peacock",
    title: "Director of International Programs",
    slug: "dawne-francine-peacock",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sage",
    lastName: "Peake",
    title: "Director of Human Resources and Talent Management",
    slug: "sage-peake",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jane M.",
    lastName: "Pealo",
    title: "Mgr of Finance & Administratn",
    slug: "jane-m-pealo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer L.",
    lastName: "Peaslee",
    title: "Wildlife Program and Communications Coordinator",
    slug: "jennifer-l-peaslee",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Hannah Sue",
    lastName: "Peck",
    title: "Undergraduate/M.Eng Coordinator",
    slug: "hannah-sue-peck",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kathi Colen",
    lastName: "Peck",
    title: "Outreach Manager",
    slug: "kathi-colen-peck",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "David A.",
    lastName: "Peck",
    title: "Technology Buyer",
    slug: "david-a-peck",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kelsey L.",
    lastName: "Peebles",
    title: "Custom-Live Associate, Executive Education",
    slug: "kelsey-l-peebles",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alex L",
    lastName: "Peffley",
    title: "Senior Director of Players Personnel",
    slug: "alex-l-peffley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William Daniel",
    lastName: "Pegg",
    title: "Director of Intellectual Property",
    slug: "william-daniel-pegg",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Melissa",
    lastName: "Peguero",
    title: "Business Accounts Coordinator",
    slug: "melissa-peguero",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Taylor",
    lastName: "Pelcher",
    title: "DFE Workforce Support Specialist",
    slug: "taylor-pelcher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Antonia",
    lastName: "Pellegrini",
    title: "Health Initiatives Coordinator",
    slug: "antonia-pellegrini",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole",
    lastName: "Pellegrino",
    title: "Executive Director of MBA Programs",
    slug: "nicole-pellegrino",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Josh",
    lastName: "Pelrine",
    title: "Applications Developer III",
    slug: "josh-pelrine",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Adam Gregory",
    lastName: "Pence",
    title: "Associate General Counsel",
    slug: "adam-gregory-pence",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Kenneth J.",
    lastName: "Pendell",
    title: "Infrastructure Applications Administrator",
    slug: "kenneth-j-pendell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Catherine C.",
    lastName: "Pendleton",
    title: "ROTC Support Staff",
    slug: "catherine-c-pendleton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samantha",
    lastName: "Pennell",
    title: "HR Senior Business Partner",
    slug: "samantha-pennell",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kristin A.",
    lastName: "Pennock",
    title: "CVM Director of Student and Financial Planning",
    slug: "kristin-a-pennock",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "David H",
    lastName: "Pennock",
    title: "Bldg/Facil Coord V",
    slug: "david-h-pennock",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher T.",
    lastName: "Peppel",
    title: "Cataloging Associate. Rare Materials",
    slug: "christopher-t-peppel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Will",
    lastName: "Percarpio",
    title: "Major Gift Associate",
    slug: "will-percarpio",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Meghan",
    lastName: "Peregord",
    title: "Community Response Coordinator",
    slug: "meghan-peregord",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura",
    lastName: "Perez",
    title: "ILR NYC Outreach Marketing Specialist",
    slug: "laura-perez",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ricardo A.",
    lastName: "Perez",
    title: "Gift Accountant",
    slug: "ricardo-a-perez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "SHAUDY",
    lastName: "PEREZ",
    title: "Enrollment Counselor I",
    slug: "shaudy-perez",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Anda",
    lastName: "Perianu",
    title: "Reis Tennis Center Manager",
    slug: "anda-perianu",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Stephen Mark",
    lastName: "Perina",
    title: "Graphic Designer",
    slug: "stephen-mark-perina",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Catherine",
    lastName: "Perkins",
    title: "Director, Market and Channel Development",
    slug: "catherine-perkins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessamyn",
    lastName: "Perlus",
    title: "Senior Associate Director and Career Exploration Unit Manager",
    slug: "jessamyn-perlus",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jake",
    lastName: "Perno",
    title: "Project Manager",
    slug: "jake-perno",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alisha Marie",
    lastName: "Perrault",
    title: "Team Travel Coordinator",
    slug: "alisha-marie-perrault",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Reece Camden",
    lastName: "Perrin",
    title: "Perennial Crops Steward",
    slug: "reece-camden-perrin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mark A.",
    lastName: "Perry",
    title: "Chief Audit Executive",
    slug: "mark-a-perry",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kevin",
    lastName: "Perry",
    title: "Director of the Tatkon Center for New Students",
    slug: "kevin-perry",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Baz",
    lastName: "Perry",
    title: "DINNERS Project Manager",
    slug: "baz-perry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shannon L.",
    lastName: "Perry",
    title: "Enrollment Manager",
    slug: "shannon-l-perry",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Khalialah N.",
    lastName: "Perry",
    title: "Enrollment Counselor",
    slug: "khalialah-n-perry",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jennifer Lin",
    lastName: "Perry",
    title: "Access Specialist",
    slug: "jennifer-lin-perry",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Scott",
    lastName: "Pesner",
    title: "Director of Engagement",
    slug: "scott-pesner",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Serge",
    lastName: "Petchenyi",
    title: "Multimedia Manager",
    slug: "serge-petchenyi",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Collins",
    lastName: "Peters",
    title: "Sr. Program Assistant - Academic Affairs",
    slug: "collins-peters",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David Warne",
    lastName: "Peters",
    title: "Lifeguard - YMCA of Ithaca & Tompkins County (Katie Prasek)",
    slug: "david-warne-peters",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paige Elizabeth",
    lastName: "Peters",
    title: "CALS - AIISP Student Office Assistant",
    slug: "paige-elizabeth-peters",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jeffrey W.",
    lastName: "Petersen",
    title: "Southeast Asia Librarian",
    slug: "jeffrey-w-petersen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Colin",
    lastName: "Peterson",
    title: "Southeast Asia Program Manager",
    slug: "colin-peterson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather K.",
    lastName: "Peterson",
    title: "Administrative Asst IV",
    slug: "heather-k-peterson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie",
    lastName: "Peterson",
    title: "Enrollment Representative, Casual",
    slug: "stephanie-peterson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Timothy Rex",
    lastName: "Petriwsky",
    title: "Access Control Systems Project Manager",
    slug: "timothy-rex-petriwsky",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Warren",
    lastName: "Petrofsky",
    title: "Associate Dean for Administration - CAS",
    slug: "warren-petrofsky",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Olga G.",
    lastName: "Petrova",
    title: "Program Assistant I",
    slug: "olga-g-petrova",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Petruzzo",
    title: "Athletic Trainer",
    slug: "jennifer-petruzzo",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kaitlyn",
    lastName: "Petryszyn",
    title: "Athletic Trainer",
    slug: "kaitlyn-petryszyn",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Janice",
    lastName: "Pfaff",
    title: "Information Management Assistant",
    slug: "janice-pfaff",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alexandra Hunterdon",
    lastName: "Pfeifer",
    title: "CCMR Administrative and Project Coordinator",
    slug: "alexandra-hunterdon-pfeifer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Claire",
    lastName: "Pfeiffer",
    title: "S&TS Administrative Assistant",
    slug: "claire-pfeiffer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paw",
    lastName: "Pha",
    title: "Circulation/Collection Management Assistant",
    slug: "paw-pha",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dr Elizabeth A. Bihn",
    lastName: "PhD",
    title: "Produce Safety Alliance Director",
    slug: "dr-elizabeth-a-bihn-phd",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julie A.",
    lastName: "Phelps",
    title: "Senior Director of Research and Innovation Finance and Budget",
    slug: "julie-a-phelps",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Debbie L.",
    lastName: "Philip",
    title: "Senior Director, Executive Human Resources",
    slug: "debbie-l-philip",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Laura",
    lastName: "Phillips",
    title:
      " Assistant to the Associate Dean, Alumni Affairs and Development, Law School",
    slug: "laura-phillips",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gail",
    lastName: "Phillips",
    title: "Project Manager",
    slug: "gail-phillips",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David Randolph",
    lastName: "Phillips",
    title: "Applications Developer III",
    slug: "david-randolph-phillips",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Urszula",
    lastName: "Piasta-Mansfield",
    title: "Assistant Director of Recruitment and Access",
    slug: "urszula-piasta-mansfield",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Natasha",
    lastName: "Piechota",
    title: "Events Assistant",
    slug: "natasha-piechota",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diane",
    lastName: "Pierce",
    title: "Director, Advancement Services",
    slug: "diane-pierce",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emmanuel Franklin-Scott",
    lastName: "Pierce",
    title: "Grant Contract Ofcr II",
    slug: "emmanuel-franklin-scott-pierce",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erin",
    lastName: "Pierce",
    title: "Annual Fund Officer II",
    slug: "erin-pierce",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nicole S",
    lastName: "Pierpont",
    title: "Accounts Rep IV",
    slug: "nicole-s-pierpont",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dannemart",
    lastName: "Pierre",
    title:
      " Associate Dean of Students for Student Empowerment, Director of First-Generation and Low-Income Student Support",
    slug: "dannemart-pierre",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Stephanie Ann",
    lastName: "Pierson",
    title: "Bldg/Facil Coord V",
    slug: "stephanie-ann-pierson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kim",
    lastName: "Pietro",
    title: "Assistant Dean of Alumni Affairs and Development",
    slug: "kim-pietro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Natalya",
    lastName: "Pikulik",
    title: "Batch Processing & Database Management Specialist",
    slug: "natalya-pikulik",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Megan",
    lastName: "Pillar",
    title: "Communications Specialist, Societal Systems",
    slug: "megan-pillar",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jaroslaw",
    lastName: "Pillardy",
    title: "Director, BRC Bioinformatics Facility",
    slug: "jaroslaw-pillardy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Debra Y.",
    lastName: "Pils",
    title: "Scheduling Manager/President’s Office",
    slug: "debra-y-pils",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael",
    lastName: "Pinnisi",
    title: "Graduate Field Coordinator / Accounts Coordinator",
    slug: "michael-pinnisi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tramaine L",
    lastName: "Pinnock",
    title: "Program Facilitation Manager  Business Management, Marketing & Law",
    slug: "tramaine-l-pinnock",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mia Esperanza",
    lastName: "Pinto",
    title:
      " ILR Conference Center Event Staff I (Chamberlain-Hoffman), Student Athletic Serv Asst I, HADM 4300 (Stanley) CA",
    slug: "mia-esperanza-pinto",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Guillaume",
    lastName: "Pirard",
    title: "Interim Director of the Violin/Viola Studio",
    slug: "guillaume-pirard",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Matt D",
    lastName: "Pitcher",
    title: "Senior Auditor",
    slug: "matt-d-pitcher",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amanda Reilly",
    lastName: "Pitman",
    title: "Grow-NY Project Associate",
    slug: "amanda-reilly-pitman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jared M.",
    lastName: "Pittman",
    title: "Associate General Counsel",
    slug: "jared-m-pittman",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Michele",
    lastName: "Pittman",
    title: "Senior Account Representative",
    slug: "michele-pittman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Don F.",
    lastName: "Pizarro",
    title: "Client Experience Team Leader",
    slug: "don-f-pizarro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julie Ann",
    lastName: "Pizzuti",
    title: "Major Gift Officer",
    slug: "julie-ann-pizzuti",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lisa",
    lastName: "Placanica",
    title: "Senior Managing Director, CTL@WCM",
    slug: "lisa-placanica",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gabriel R.",
    lastName: "Plaine",
    title: "Info Tech Area Mgr II",
    slug: "gabriel-r-plaine",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Leslie M.",
    lastName: "Planck",
    title: "Accounts Rep IV",
    slug: "leslie-m-planck",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Angela Belle",
    lastName: "Platt",
    title: "Accounts Rep IV",
    slug: "angela-belle-platt",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mark A.",
    lastName: "Pluchino",
    title: "Senior Director CALS Office of Budget and Finance",
    slug: "mark-a-pluchino",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Andrea L.",
    lastName: "Poag",
    title: "Assistant Dean for Student Experience",
    slug: "andrea-l-poag",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Thomas",
    lastName: "Poelling",
    title: "Finance and HR Coordinator",
    slug: "thomas-poelling",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "John Dunbar",
    lastName: "Pollak",
    title: "Research Supp Spec I",
    slug: "john-dunbar-pollak",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tim",
    lastName: "Pollard",
    title: "Analytics and Reporting Developer",
    slug: "tim-pollard",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anna E.",
    lastName: "Pollock",
    title:
      " Director, Cornell's Adult University, Alumni Travel and Wine Programs for Alumni Engagement Initiatives",
    slug: "anna-e-pollock",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Laurie Y.",
    lastName: "Pompa",
    title: "Informatics Coordinator",
    slug: "laurie-y-pompa",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dimitri William",
    lastName: "Ponirakis",
    title: "Applications Developer III",
    slug: "dimitri-william-ponirakis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Zoe Learner",
    lastName: "Ponterio",
    title: "SPIF Data Manager",
    slug: "zoe-learner-ponterio",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tyler J.",
    lastName: "Poole",
    title:
      " Assistant Director, Marketing and Communications to Assistant Director, Branding and Creative",
    slug: "tyler-j-poole",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Danielle Marie",
    lastName: "Poole",
    title: "Financial Reporting Specialist",
    slug: "danielle-marie-poole",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jay",
    lastName: "Porter",
    title: "Strategic Sourcing Manager",
    slug: "jay-porter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marissa",
    lastName: "Porter",
    title: "Director of Graduate Enrollment and Student Services",
    slug: "marissa-porter",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Nadine D.",
    lastName: "Porter",
    title: "Associate Director",
    slug: "nadine-d-porter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda",
    lastName: "Porter",
    title: "Area Chair Coordinator",
    slug: "amanda-porter",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rylee",
    lastName: "Porter",
    title: "Financial Aid Counselor I",
    slug: "rylee-porter",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Andrea R.",
    lastName: "Potochniak",
    title: "Editorial Manager",
    slug: "andrea-r-potochniak",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rachael",
    lastName: "Potter",
    title: "IT Project Manager",
    slug: "rachael-potter",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Maria",
    lastName: "Potter",
    title: "Assistant to the Directors",
    slug: "maria-potter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ian",
    lastName: "Potter",
    title:
      " Social Media Ambassador, Alumni Affairs & Development, Student Athletic Serv Asst I",
    slug: "ian-potter",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jay",
    lastName: "Potter",
    title: "Digital Designer II",
    slug: "jay-potter",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Holly C.",
    lastName: "Potter",
    title: "Administrative Asst III",
    slug: "holly-c-potter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica Lewis",
    lastName: "Potter",
    title: "Associate Director, Student Financial Aid Services",
    slug: "jessica-lewis-potter",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elizabeth M.",
    lastName: "Potts",
    title: "Administrative Asst V",
    slug: "elizabeth-m-potts",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brandon",
    lastName: "Powell",
    title: "Sr. Director, Finance and Administration",
    slug: "brandon-powell",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brett Michael",
    lastName: "Powell",
    title: "Associate Director",
    slug: "brett-michael-powell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vanessa Claire",
    lastName: "Powell",
    title: "Administrative Asst IV",
    slug: "vanessa-claire-powell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hugh D.",
    lastName: "Powell",
    title: "Editor IV",
    slug: "hugh-d-powell",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jen",
    lastName: "Powers",
    title: "Medical Technology Manager II",
    slug: "jen-powers",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lisa LeFever",
    lastName: "Powers",
    title: "Collections Asst III",
    slug: "lisa-lefever-powers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Haeñhyanoñhna Joseph",
    lastName: "Powless",
    title: "Program Assistant I",
    slug: "hae-hyano-hna-joseph-powless",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Pratt",
    title: "Inside Director, Enterprise Programs",
    slug: "jennifer-pratt",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chelsea N.",
    lastName: "Pratt",
    title: "Audience Development and Marketing Coordinator",
    slug: "chelsea-n-pratt",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Victoria",
    lastName: "Preble",
    title: "Program Assistant, Career Management Center",
    slug: "victoria-preble",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Abigail",
    lastName: "Prentiss",
    title: "Administrative Asst III",
    slug: "abigail-prentiss",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cory L",
    lastName: "Pressl",
    title: "Assistant Director of Admissions",
    slug: "cory-l-pressl",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Shelley Elizabeth",
    lastName: "Preston",
    title: "Communications and Marketing Specialist",
    slug: "shelley-elizabeth-preston",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lynne",
    lastName: "Preston",
    title: "Advancement Services Receipting Specialist",
    slug: "lynne-preston",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Margaret",
    lastName: "Price",
    title: "Manager, Academic Engagement Programs",
    slug: "margaret-price",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dylan Michael",
    lastName: "Price",
    title:
      " Career Services Asst., NBA 3000 (Rother) CA, HADM6145 (Greenberg) CA",
    slug: "dylan-michael-price",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Abby",
    lastName: "Priehs",
    title: "Director Residential Life",
    slug: "abby-priehs",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Hannah Joy",
    lastName: "Priestley",
    title: "Access and Referral Specialist",
    slug: "hannah-joy-priestley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lyndsi",
    lastName: "Prignon",
    title: "Director Human Resources - FCS",
    slug: "lyndsi-prignon",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ellen Gallin",
    lastName: "Procida",
    title: "Director of Labor Management Programs, Public Sector",
    slug: "ellen-gallin-procida",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Karen J.",
    lastName: "Prosser",
    title: "Director of Administration",
    slug: "karen-j-prosser",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kaitlin",
    lastName: "Provost",
    title: "Associate Director of Marketing and Messaging",
    slug: "kaitlin-provost",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Raena",
    lastName: "Prude",
    title: "Biobank Collection & Accessioning Coordinator",
    slug: "raena-prude",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joseph",
    lastName: "Prue",
    title: "ACRefrig Mech/Plumb",
    slug: "joseph-prue",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robyn",
    lastName: "Pryor",
    title: "Director, Federal Government and Military Programs",
    slug: "robyn-pryor",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacob",
    lastName: "Pucci",
    title: "Marketing and Communications Coordinator",
    slug: "jacob-pucci",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Marcella Patrice",
    lastName: "Purcell",
    title: "Co-Director, Student Services & Advising",
    slug: "marcella-patrice-purcell",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Haley Jo",
    lastName: "Purdy",
    title: "Registrar’s Office Assistant",
    slug: "haley-jo-purdy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sophia Marie",
    lastName: "Pushlar",
    title:
      " CALS - Undergraduate Research - Lab of Freshwater Ecology (Meredith A. Holgerson)",
    slug: "sophia-marie-pushlar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brigitta A.",
    lastName: "Putnam",
    title: "Associate Director, Physical Education",
    slug: "brigitta-a-putnam",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Erin",
    lastName: "Pyrek",
    title: "Research Administrator",
    slug: "erin-pyrek",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mar",
    lastName: "Pérez",
    title: "Senior Case Coordinator",
    slug: "mar-p-rez",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Cindy",
    lastName: "Qiao",
    title: "Strategic Partnerships Relationship Manager",
    slug: "cindy-qiao",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Margaret A.",
    lastName: "Quaassdorff",
    title: "Dairy Management Specialist",
    slug: "margaret-a-quaassdorff",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa De-Graft",
    lastName: "Quainoo",
    title:
      " Editorial Assistant - Center for Transformative Action - Lyson Center (Amy Christian)",
    slug: "lisa-de-graft-quainoo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Carole A.",
    lastName: "Quealy",
    title: "Assistant to the Associate VP, Alumni Affairs",
    slug: "carole-a-quealy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tiffany",
    lastName: "Quen",
    title: "(Chouman) - AAP Student Academic Service Assistant",
    slug: "tiffany-quen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tammy L.",
    lastName: "Quick",
    title: "Gift Processor",
    slug: "tammy-l-quick",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Saah Nue",
    lastName: "Quigee",
    title: "Public Services Assistant",
    slug: "saah-nue-quigee",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maureen",
    lastName: "Quillinan",
    title: "Computer Prod Control",
    slug: "maureen-quillinan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Thom",
    lastName: "Quinn",
    title: "Bldg/Facil Coordinator V",
    slug: "thom-quinn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peter Edward",
    lastName: "Quinn",
    title: "YTI Multimedia Producer",
    slug: "peter-edward-quinn",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Hannah",
    lastName: "Quintana",
    title: "Associate Director, Regional Volunteer Giving",
    slug: "hannah-quintana",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "McKenna Jlynn",
    lastName: "Raade",
    title: "CALS - AIISP Ambassador II (Leslie Logan)",
    slug: "mckenna-jlynn-raade",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Maxwell Merrill",
    lastName: "Race",
    title:
      " AAD Program Assistant, Student & Young Alumni Programs and Affinity Programs",
    slug: "maxwell-merrill-race",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lori",
    lastName: "Radcliff-Woods",
    title: "Administrative Assistant III",
    slug: "lori-radcliff-woods",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samantha",
    lastName: "Radloff",
    title: "Executive Assistant",
    slug: "samantha-radloff",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael",
    lastName: "Radzik",
    title: "Assistant Director, ILR Technology Services and IT Security",
    slug: "michael-radzik",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Hari",
    lastName: "Raghavan",
    title: "Director of AI Studio",
    slug: "hari-raghavan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Randi",
    lastName: "Rainbow",
    title: "Info Tech Asst Dir II",
    slug: "randi-rainbow",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Javier",
    lastName: "Ramirez",
    title: "Executive Manager, National Mediation and Conciliation Service",
    slug: "javier-ramirez",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Victor Manuel",
    lastName: "Ramos",
    title: "Assistant Equipment Manager",
    slug: "victor-manuel-ramos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristin",
    lastName: "Ramsay",
    title: "OVPIA Project Coordinator",
    slug: "kristin-ramsay",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katherine",
    lastName: "Rancruel",
    title: "Dean of Students Office Coordinator",
    slug: "katherine-rancruel",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kevin",
    lastName: "Randall",
    title: "Mech Maint S07",
    slug: "kevin-randall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda Kate",
    lastName: "Randolph",
    title: "Associate Director of Enrollment Compliance",
    slug: "amanda-kate-randolph",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Lucinda",
    lastName: "Randolph-Benjamin",
    title: "Family & 4-H Youth Development",
    slug: "lucinda-randolph-benjamin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chuck",
    lastName: "Raniewicz",
    title: "Network Administrator/Sound En",
    slug: "chuck-raniewicz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stephanie",
    lastName: "Rankin",
    title:
      " Senior Associate Director, Foundation Relations and Corporate Philanthropy",
    slug: "stephanie-rankin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Rankine",
    title: "Assistant Director, Information Technology",
    slug: "david-rankine",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Angelina",
    lastName: "Rappa",
    title: "Todd - AAP Photo Lab Monitor, AAP Epson Print Tech",
    slug: "angelina-rappa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tim",
    lastName: "Rappold",
    title: "Mgr Finance I",
    slug: "tim-rappold",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lynn Charles",
    lastName: "Rathbun",
    title: "Lab Manager",
    slug: "lynn-charles-rathbun",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kehan",
    lastName: "Rattani",
    title: "Bulletin 24/25",
    slug: "kehan-rattani",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emma",
    lastName: "Raub",
    title: "Electronic Resources Librarian and Licensing Coordinator",
    slug: "emma-raub",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cassidy",
    lastName: "Raut",
    title: "IT Support Associate",
    slug: "cassidy-raut",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michaely",
    lastName: "Rave",
    title: "Client Service Rep- Ruffian Clinic",
    slug: "michaely-rave",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily Elizabeth",
    lastName: "Ravet",
    title: "Center Coordinator",
    slug: "emily-elizabeth-ravet",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jillian",
    lastName: "Ray",
    title: "Classification/Compensation Specialist",
    slug: "jillian-ray",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Spence",
    lastName: "Ray",
    title: "Director, K-12 Equity Lab",
    slug: "spence-ray",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Carol K.",
    lastName: "Raymond",
    title: "Accounts Rep IV",
    slug: "carol-k-raymond",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rachel",
    lastName: "Raymond",
    title: "Financial Transaction Representative",
    slug: "rachel-raymond",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Aima",
    lastName: "Raza",
    title:
      " Administrative Assistant - Center for Transformative Action - NAFSN (Kim Hines)",
    slug: "aima-raza",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Abha",
    lastName: "Razdan-Huckoo",
    title: "Associate Director for Staff Selection & Development",
    slug: "abha-razdan-huckoo",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Natalie Charry",
    lastName: "Razera",
    title: "Open Borders CoLAB: Data Collection Research/Lab Associate",
    slug: "natalie-charry-razera",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katherine",
    lastName: "Reagan",
    title: "Ernest Stern Curator, Rare Books & Manuscripts",
    slug: "katherine-reagan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lea Marie",
    lastName: "Reagan",
    title:
      " NIH FIRST Administrative Coordinator - Academic Affairs and Faculty Development and Diversity",
    slug: "lea-marie-reagan",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Sheila M.",
    lastName: "Reakes",
    title: "Director of Annual Giving",
    slug: "sheila-m-reakes",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Paul L.",
    lastName: "Redfern",
    title: "External Relations Officer V",
    slug: "paul-l-redfern",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sandra",
    lastName: "Redfield",
    title: "Administrative Asst III",
    slug: "sandra-redfield",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amie L.",
    lastName: "Redko",
    title: "Research Supp Spec I",
    slug: "amie-l-redko",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Zachary Michael",
    lastName: "Reed",
    title: "Mech Vehicle S11",
    slug: "zachary-michael-reed",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily Jeanne",
    lastName: "Reed",
    title: "Administrative Asst III",
    slug: "emily-jeanne-reed",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mr Marcus Warren",
    lastName: "Reed",
    title: "Access Services and Administrative Manager",
    slug: "mr-marcus-warren-reed",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kate",
    lastName: "Reed",
    title: "Applications Developer III",
    slug: "kate-reed",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tara",
    lastName: "Reed",
    title: "MPS Coordinator",
    slug: "tara-reed",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paige L",
    lastName: "Reeves",
    title:
      " Assistant to the Executive Director, Communication, Marketing, and Participation",
    slug: "paige-l-reeves",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Madison",
    lastName: "Reeves",
    title: "Casual Student Support Agent",
    slug: "madison-reeves",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Stephanie Katherine Giglio",
    lastName: "Reich",
    title: "Intellectual Property and Governance Assistant",
    slug: "stephanie-katherine-giglio-reich",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Michele S.",
    lastName: "Reichert",
    title: "Financial Analytics Specialist",
    slug: "michele-s-reichert",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Judson",
    lastName: "Reid",
    title: "Harvest New York Team Leader and Urban Agriculture Coordinator",
    slug: "judson-reid",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Beau Nicholas Norman",
    lastName: "Reid",
    title: "Production Associate - The Cherry Arts (Jen Pearcy-Edwards)",
    slug: "beau-nicholas-norman-reid",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edwin J.",
    lastName: "Reidel",
    title: "Phenomics Coordinator",
    slug: "edwin-j-reidel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ellen L",
    lastName: "Reilley",
    title: "Financial Transaction Representative",
    slug: "ellen-l-reilley",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nathan",
    lastName: "Reimer",
    title: "EAM Application Specialist",
    slug: "nathan-reimer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kate M",
    lastName: "Reiter",
    title: "Cunningham Assistant Director for Student Project Teams",
    slug: "kate-m-reiter",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Savannah",
    lastName: "Relos",
    title: "Assistant Technical Director",
    slug: "savannah-relos",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rachel",
    lastName: "Remite",
    title: "Financial Transaction Representative",
    slug: "rachel-remite",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Vivian",
    lastName: "Ren",
    title: "CALS - Social Media Assistant",
    slug: "vivian-ren",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Gennaro",
    lastName: "Rendino",
    title: "Entrepreneur in Residence",
    slug: "gennaro-rendino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erica A.",
    lastName: "Reniff",
    title: "FCS HR Generalist",
    slug: "erica-a-reniff",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Gianni",
    lastName: "Renna",
    title: "Event Technical Support Service Manager",
    slug: "gianni-renna",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Allyson Michelle",
    lastName: "Repholz",
    title: "Technical Coordinator",
    slug: "allyson-michelle-repholz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ace",
    lastName: "Repka",
    title: "Grant and Contract Officer",
    slug: "ace-repka",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Bethany",
    lastName: "Resnick",
    title: "Assistant Director for K-12 Programs",
    slug: "bethany-resnick",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stephanie M.",
    lastName: "Resue",
    title: "Assistant Director of Data and Systems",
    slug: "stephanie-m-resue",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elan Nathaniel",
    lastName: "Reuven",
    title: "Technical Services Coordinator",
    slug: "elan-nathaniel-reuven",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Armands Osvalds",
    lastName: "Revelins",
    title: "Assistant Director of Forensics",
    slug: "armands-osvalds-revelins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jen Delos",
    lastName: "Reyes",
    title: "Associate Dean for Diversity and Equity, Prof Assoc",
    slug: "jen-delos-reyes",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Dante",
    lastName: "Reyes",
    title: "Capital Planning Senior Project Manager",
    slug: "dante-reyes",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessica",
    lastName: "Reynolds",
    title: "HR Policy and Compliance Consultant",
    slug: "jessica-reynolds",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Darrell A.",
    lastName: "Reynolds",
    title: "Associate Director of Asset Management.",
    slug: "darrell-a-reynolds",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Emily",
    lastName: "Reynolds",
    title: "Assistant to the Chair & Communications Coordinator",
    slug: "emily-reynolds",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kathryn Christine",
    lastName: "Reynolds",
    title: "Product Manager",
    slug: "kathryn-christine-reynolds",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Laura L",
    lastName: "Reynolds",
    title: "Financial Transaction Representative",
    slug: "laura-l-reynolds",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Maddie",
    lastName: "Reynolds",
    title: "Outreach and Information Services Librarian",
    slug: "maddie-reynolds",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jessica Arlene",
    lastName: "Reynolds",
    title: "Client Service Representative",
    slug: "jessica-arlene-reynolds",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Renee",
    lastName: "Reynolds",
    title: "Assistant Director, Student Services",
    slug: "renee-reynolds",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Alicia",
    lastName: "Rhodes",
    title: "Accounts Coordinator",
    slug: "alicia-rhodes",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tyler",
    lastName: "Rhorick",
    title: "Director, Studio Programming",
    slug: "tyler-rhorick",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Fabiano Dal",
    lastName: "Ri",
    title: "Post Doctoral Associate",
    slug: "fabiano-dal-ri",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alexandre Almeida-Fernandes",
    lastName: "Ribeiro",
    title: "Building Care Manager",
    slug: "alexandre-almeida-fernandes-ribeiro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aurora",
    lastName: "Ricardo",
    title: "Administrative Asst IV",
    slug: "aurora-ricardo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brittnie Leigh Hamlin",
    lastName: "Riccardi",
    title: "Senior Student Services Specialist",
    slug: "brittnie-leigh-hamlin-riccardi",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rachel S",
    lastName: "Ricci",
    title: "Sr. Manager of Course Administration",
    slug: "rachel-s-ricci",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christina",
    lastName: "Rice",
    title: "Purchasing Agent II",
    slug: "christina-rice",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jenna",
    lastName: "Rice",
    title: "Program Assistant for Entrepreneurship Programs",
    slug: "jenna-rice",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Damon",
    lastName: "Rich",
    title: "Critic Visiting",
    slug: "damon-rich",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erica",
    lastName: "Richards",
    title: "Associate Director, U.S. Regional Alumni Engagement",
    slug: "erica-richards",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jordan Leigh",
    lastName: "Richards",
    title:
      " Program Assistant - Ithaca Children's Garden (Trey Ramsey), Communication Assistant DEIB",
    slug: "jordan-leigh-richards",
    dei: true,
    category: "Communications",
  },
  {
    firstName: "Emily",
    lastName: "Richards",
    title: "Sales Coordinator",
    slug: "emily-richards",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kari",
    lastName: "Richards",
    title: "Admissions & Application Coordinator- Forte & Consortium Lead",
    slug: "kari-richards",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Scott M.",
    lastName: "Richardson",
    title: "Fire Protection Specialist",
    slug: "scott-m-richardson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joe",
    lastName: "Richardson",
    title: "IT Support Provider",
    slug: "joe-richardson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kirsten",
    lastName: "Richardson",
    title: "Program Manager, Breeding Insight",
    slug: "kirsten-richardson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dana E.",
    lastName: "Richter",
    title: "Research Supp Spec III",
    slug: "dana-e-richter",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amber Lyn",
    lastName: "Richter",
    title: "Sr. Conference/Event Planner",
    slug: "amber-lyn-richter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "T. Daniel",
    lastName: "Richter",
    title: "Security Systems Coordinator",
    slug: "t-daniel-richter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thea Victoria",
    lastName: "Riddick",
    title: "Administrative Assistant, Cornell Career Services",
    slug: "thea-victoria-riddick",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marianne E.",
    lastName: "Ridley",
    title: "Assistant to the Dean",
    slug: "marianne-e-ridley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Missy",
    lastName: "Riker",
    title: "Administrative Asst V",
    slug: "missy-riker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan",
    lastName: "Riley",
    title: "Deputy Director of Community Relations",
    slug: "susan-riley",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ana",
    lastName: "Riley",
    title: "HR Services and Transitions Center Counselor",
    slug: "ana-riley",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Christopher J.",
    lastName: "Riley",
    title: "Sr. Department Manager",
    slug: "christopher-j-riley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle",
    lastName: "Riley",
    title: "Financial Transaction Representative",
    slug: "danielle-riley",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ben",
    lastName: "Rinaldi",
    title: "Telecommunications Officer",
    slug: "ben-rinaldi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Paul A",
    lastName: "Rinaldi",
    title: "eCornell Student Services Assistant, Casual",
    slug: "paul-a-rinaldi",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Katherine",
    lastName: "Rincon",
    title: "Senior Administrative Assistant to the Associate Deans",
    slug: "katherine-rincon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alfredo Gutierrez",
    lastName: "Rios",
    title: "Marketing Assistant for the CU Press",
    slug: "alfredo-gutierrez-rios",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Courtney",
    lastName: "Riseborough",
    title: "Case Manager, Clinic to End Tech Abuse (CETA)",
    slug: "courtney-riseborough",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica Shuler",
    lastName: "Ristow",
    title: "Major Gift Associate",
    slug: "jessica-shuler-ristow",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessica Rose",
    lastName: "Ritchie",
    title:
      " Visitor Services Assistant - Paleontological Research Institution, Student Commun Serv Asst II",
    slug: "jessica-rose-ritchie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tricia",
    lastName: "Ritterbusch",
    title: "Assistant Dean of Communications",
    slug: "tricia-ritterbusch",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tiffany",
    lastName: "Rivera",
    title: "Enrollment Support Representative",
    slug: "tiffany-rivera",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Andrew",
    lastName: "Rizos",
    title: "Program Delivery Specialist I",
    slug: "andrew-rizos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karli Marion",
    lastName: "Rizzo",
    title: "Biobank Marketing and Communications Manager",
    slug: "karli-marion-rizzo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tony",
    lastName: "Roach",
    title: "Director of Administration",
    slug: "tony-roach",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyle Dwayne",
    lastName: "Roach",
    title: "Financial Services Associate",
    slug: "kyle-dwayne-roach",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christina Lynn",
    lastName: "Roarke",
    title:
      " Deputy Director of Financial Aid, Graduate and Professional Student Services",
    slug: "christina-lynn-roarke",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Janette M.",
    lastName: "Robbins",
    title: "Accounts Rep V",
    slug: "janette-m-robbins",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rue",
    lastName: "Roberson",
    title: "Integration Developer",
    slug: "rue-roberson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Leigh",
    lastName: "Robert",
    title: "Application Specialist",
    slug: "leigh-robert",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "LeeAnn",
    lastName: "Roberts",
    title:
      " Bowers CIS, Director for Diversity, Equity, Inclusion, and Belonging",
    slug: "leeann-roberts",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Lauren",
    lastName: "Roberts",
    title: "Director of Communications",
    slug: "lauren-roberts",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michael",
    lastName: "Roberts",
    title: "Senior Project Coordinator",
    slug: "michael-roberts",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zoe Eve",
    lastName: "Roberts",
    title: "Technical Product Manager",
    slug: "zoe-eve-roberts",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Daniel J.",
    lastName: "Robertson",
    title: "Sr. Research & Planning Assoc.",
    slug: "daniel-j-robertson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lori L.",
    lastName: "Robertson",
    title: "Int'l & Transfer Processor",
    slug: "lori-l-robertson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Shawna",
    lastName: "Robertson",
    title: "Administrative Assistant",
    slug: "shawna-robertson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carley Sabrina",
    lastName: "Robinson",
    title: "Coord Program I",
    slug: "carley-sabrina-robinson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Philip",
    lastName: "Robinson",
    title: "Director of Software Development",
    slug: "philip-robinson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sarah Winter",
    lastName: "Robinson",
    title: "Associate Director, Advancement Marketing",
    slug: "sarah-winter-robinson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Amy L.",
    lastName: "Robinson",
    title: "Director of Client and Family Giving",
    slug: "amy-l-robinson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kate Jennifer",
    lastName: "Robinson",
    title: "Administrative Asst IV",
    slug: "kate-jennifer-robinson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ralph B.",
    lastName: "Robinson",
    title: "Info Tech Area Mgr I",
    slug: "ralph-b-robinson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Callan",
    lastName: "Robinson",
    title: "Assistant Director of Admissions and Transfer Coordinator",
    slug: "callan-robinson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jennifer",
    lastName: "Robinson",
    title: "Accounts Rep IV",
    slug: "jennifer-robinson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Hillary Anne",
    lastName: "Robinson",
    title: "Human Resources Assistant",
    slug: "hillary-anne-robinson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Matt L",
    lastName: "Robinson",
    title: "Sr. Pre-Award Specialist",
    slug: "matt-l-robinson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jordan",
    lastName: "Roblyer",
    title: "Assistant Director of Graduate Enrollment Communications",
    slug: "jordan-roblyer",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Brianne M",
    lastName: "Rockefeller",
    title: "Research & Innovation Post Award (RePAT) Team Lead",
    slug: "brianne-m-rockefeller",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christina",
    lastName: "Rockwell",
    title: "Assistant Registrar",
    slug: "christina-rockwell",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Myriah B.",
    lastName: "Rockwell",
    title: "Enrollment Counselor, Team Lead",
    slug: "myriah-b-rockwell",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Erin",
    lastName: "Rodger",
    title: "Communications Specialist IV",
    slug: "erin-rodger",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Gemma Francisca",
    lastName: "Rodrigues",
    title:
      " Ames Director of Education and Curator of the Global Arts of Africa",
    slug: "gemma-francisca-rodrigues",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Karina Faveri",
    lastName: "Rodrigues",
    title: "CLASSE Safety Associate",
    slug: "karina-faveri-rodrigues",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erin M.",
    lastName: "Rodriguez",
    title: "Associate Director of Admissions",
    slug: "erin-m-rodriguez",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Aaron",
    lastName: "Rodriguez",
    title: "Manager of Hotel Training",
    slug: "aaron-rodriguez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scott",
    lastName: "Rodriguez",
    title: "Sr. Desktop Support Specialist",
    slug: "scott-rodriguez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Pura Ruth",
    lastName: "Rodriguez",
    title: "Research Administration Assistant",
    slug: "pura-ruth-rodriguez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Casandra Camilla",
    lastName: "Rodriguez",
    title: "Event Service & Marketing Manager",
    slug: "casandra-camilla-rodriguez",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Max",
    lastName: "Rodriguez",
    title: "Associate Director of Budget and Finance",
    slug: "max-rodriguez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "John William",
    lastName: "Roemer",
    title: "CALS - Undergraduate Research/Lab Assistant (T. Bauerle Lab)",
    slug: "john-william-roemer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joe",
    lastName: "Rogan",
    title: "Director of Development",
    slug: "joe-rogan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erika M.",
    lastName: "Rogan",
    title: "Assistant Director, Strength and Conditioning",
    slug: "erika-m-rogan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Robin",
    lastName: "Roger",
    title: "Assistant Dean of Communications",
    slug: "robin-roger",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christine",
    lastName: "Rogers",
    title: "Senior Director for Environment, Health, and Safety",
    slug: "christine-rogers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meg",
    lastName: "Rogers",
    title:
      " Executive Assistant to the Director of Athletics & Physical Education",
    slug: "meg-rogers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chris",
    lastName: "Rogers",
    title: "Senior Director of Administration",
    slug: "chris-rogers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa",
    lastName: "Rogers",
    title: "Events and Marketing Coordinator",
    slug: "lisa-rogers",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Dylon Thomas",
    lastName: "Rogers",
    title: "Administrative Assistant, Centers & Programs",
    slug: "dylon-thomas-rogers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa S.",
    lastName: "Rogers",
    title: "Accounts Rep V",
    slug: "lisa-s-rogers",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Peter L.",
    lastName: "Rogoff",
    title: "eCornell Director, Enterprise Programs",
    slug: "peter-l-rogoff",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rachel",
    lastName: "Rohwer",
    title: "Gift Planning Officer",
    slug: "rachel-rohwer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alex Christopher",
    lastName: "Rokkos",
    title: "Lifeguard",
    slug: "alex-christopher-rokkos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Margaret Ann",
    lastName: "Rolfe",
    title: "Administrative Manager",
    slug: "margaret-ann-rolfe",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Marie",
    lastName: "Roller",
    title: "ECE Department & Event Coordinator",
    slug: "marie-roller",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Steven Michael",
    lastName: "Rollins",
    title: "Mason",
    slug: "steven-michael-rollins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ann",
    lastName: "Rollo",
    title: "Executive Director of Communications",
    slug: "ann-rollo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kelly Ann",
    lastName: "Rolon",
    title: "Assistant to the Assistant Dean, AAD AAP",
    slug: "kelly-ann-rolon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "John D.",
    lastName: "Romag",
    title: "Database Administrator",
    slug: "john-d-romag",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joann M.",
    lastName: "Roman",
    title: "Finance Manager",
    slug: "joann-m-roman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Barbara S.",
    lastName: "Romano",
    title: "Executive Director of Conference and Event Services",
    slug: "barbara-s-romano",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thomas W.",
    lastName: "Romantic",
    title: "Senior Director of Procurement Services",
    slug: "thomas-w-romantic",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "SHARI",
    lastName: "ROMAR",
    title: "Communications Specialist/Science Writer (Plant Science)",
    slug: "shari-romar",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Cinta",
    lastName: "Romay",
    title: "Project Manager, Buckler Lab",
    slug: "cinta-romay",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ange",
    lastName: "Romeo-Hall",
    title: "Director of Editorial, Design, and Production",
    slug: "ange-romeo-hall",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ted Andrew",
    lastName: "Romer",
    title: "Building Coordinator",
    slug: "ted-andrew-romer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Fermin",
    lastName: "Romero",
    title: "Infrastructure and Application Development Manager",
    slug: "fermin-romero",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nicolas Martin",
    lastName: "Romero",
    title: "Work Planning & Coordination Specialist",
    slug: "nicolas-martin-romero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ally",
    lastName: "Rooks",
    title: "Applications Systems Assistant II",
    slug: "ally-rooks",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John",
    lastName: "Rooney",
    title: "Area Director, Enterprise Programs",
    slug: "john-rooney",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Peter S.",
    lastName: "Roorda",
    title: "Sr Mech Maint",
    slug: "peter-s-roorda",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rick",
    lastName: "Roper",
    title: "Safety Program Manager",
    slug: "rick-roper",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jin",
    lastName: "Roper",
    title: "Budget & Reporting Specialist",
    slug: "jin-roper",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Heather M.",
    lastName: "Rorick",
    title: "Assistant University Registrar, Academic Scheduling",
    slug: "heather-m-rorick",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tonya Y.",
    lastName: "Rose",
    title: "Assistant Director, Records Processing",
    slug: "tonya-y-rose",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Lisa",
    lastName: "Rose",
    title: "Director of Human Resources",
    slug: "lisa-rose",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Bailey Alexis",
    lastName: "Rose",
    title: "Senior Administrative Assistant",
    slug: "bailey-alexis-rose",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erika",
    lastName: "Rose",
    title: "Manager of Budget, Finance, and Research Compliance",
    slug: "erika-rose",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alan",
    lastName: "Rose",
    title: "Data Analytics Developer",
    slug: "alan-rose",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bernard A.",
    lastName: "Rose",
    title: "Sr I&C Tech",
    slug: "bernard-a-rose",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kevin Carl",
    lastName: "Rose",
    title: "Transportation Service Rep 2",
    slug: "kevin-carl-rose",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julianna Katherine",
    lastName: "Rose",
    title: "CALS - Research/Lab Assistant (J. Russell-Anelli Lab)",
    slug: "julianna-katherine-rose",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eleanor Lois",
    lastName: "Rosenberg",
    title: "Administrative Asst III",
    slug: "eleanor-lois-rosenberg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tiffanie",
    lastName: "Rosenberger",
    title: "Research Administrator",
    slug: "tiffanie-rosenberger",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ilyssa",
    lastName: "Rosenzweig",
    title: "Manager of Industry Partnerships, Break Through Tech",
    slug: "ilyssa-rosenzweig",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jani M.",
    lastName: "Ross",
    title: "Associate Director of Stewards",
    slug: "jani-m-ross",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scott",
    lastName: "Ross",
    title: "Info Tech Asst Dir I",
    slug: "scott-ross",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gavin",
    lastName: "Ross",
    title: "IDP Facilitator, HADM 1198 (Gaulke) CA",
    slug: "gavin-ross",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tatiyana",
    lastName: "Ross",
    title: "Residence Hall Director",
    slug: "tatiyana-ross",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jodi",
    lastName: "Rotach",
    title: "FRU Office Coordinator",
    slug: "jodi-rotach",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katerina",
    lastName: "Roth",
    title: "CTL Practicant",
    slug: "katerina-roth",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "E, Jassely",
    lastName: "Rotolo",
    title: "Community Interpreter",
    slug: "e-jassely-rotolo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dan",
    lastName: "Rotyliano",
    title: "Associate Director, Benefit Services",
    slug: "dan-rotyliano",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jennifer",
    lastName: "Rouin",
    title: "Major Gifts Officer, College of Agriculture and Life Science",
    slug: "jennifer-rouin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyle",
    lastName: "Rouleau",
    title: "Bldg/Facil Coord IV",
    slug: "kyle-rouleau",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Donna J",
    lastName: "Rounds",
    title: "Associate Director, Business Development and Licensing",
    slug: "donna-j-rounds",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cassidy",
    lastName: "Rourke",
    title: "Assistant Director, Career Management Center",
    slug: "cassidy-rourke",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Aaron",
    lastName: "Rovitz",
    title: "Cinema Manager",
    slug: "aaron-rovitz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Corilyn",
    lastName: "Rowbotham",
    title: "Hotel Income Auditor",
    slug: "corilyn-rowbotham",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Bob",
    lastName: "Rowe",
    title: "Advanced Technical Support (Level 2) Manager",
    slug: "bob-rowe",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Suzana",
    lastName: "Rowe",
    title: "Academic Review Coordinator",
    slug: "suzana-rowe",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Catie",
    lastName: "Rowe",
    title: "Professional Development Coordinator",
    slug: "catie-rowe",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Cheryl M.",
    lastName: "Rowland",
    title: "Collections Asst III",
    slug: "cheryl-m-rowland",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert",
    lastName: "Roy",
    title: "ROTC Support Staff",
    slug: "robert-roy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vonda K.",
    lastName: "Royce",
    title: "Finance Specialist II",
    slug: "vonda-k-royce",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer K",
    lastName: "Royer-Barnett",
    title: "Project Coordinator",
    slug: "jennifer-k-royer-barnett",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca Ann",
    lastName: "Rozek",
    title: "Online Point Solutions Program Manager",
    slug: "rebecca-ann-rozek",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bradley",
    lastName: "Rozelle",
    title: "Heating Plant Manager",
    slug: "bradley-rozelle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah",
    lastName: "Rubenstein-Gillis",
    title: "Generalist Counselor Therapist, Cornell Tech",
    slug: "sarah-rubenstein-gillis",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sonia Rana",
    lastName: "Rucker",
    title: "AVP of Inclusion and Belonging",
    slug: "sonia-rana-rucker",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Lauren Elizabeth",
    lastName: "Rudolph",
    title: "Athletic Trainer",
    slug: "lauren-elizabeth-rudolph",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shawn",
    lastName: "Ruebel",
    title: "Human Resources Associate",
    slug: "shawn-ruebel",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Katherine",
    lastName: "Ruelan",
    title: "CDP Facilitator",
    slug: "katherine-ruelan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Roxanne",
    lastName: "Ruffalo",
    title: "Accounts Rep IV",
    slug: "roxanne-ruffalo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "John",
    lastName: "Ruffing",
    title: "Director of Intercampus IT Integration",
    slug: "john-ruffing",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Marianna Isabella",
    lastName: "Ruggiero",
    title: "Interpreter",
    slug: "marianna-isabella-ruggiero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kaitlyn Danielle",
    lastName: "Ruhf",
    title: "Associate Director, Campaign Communication",
    slug: "kaitlyn-danielle-ruhf",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jeffrey",
    lastName: "Ruiz",
    title: "Intramural Sports Student Supervisor",
    slug: "jeffrey-ruiz",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Julie Ann",
    lastName: "Rummings",
    title: "Instructional Tech Spec III",
    slug: "julie-ann-rummings",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Josh",
    lastName: "Rumpff",
    title: "Instructional Designer/Developer",
    slug: "josh-rumpff",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Phillip",
    lastName: "Rusher",
    title: "Administrative Manager",
    slug: "phillip-rusher",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "RuthAnn",
    lastName: "Rushmer",
    title: "Outreach Executive Administrative Assistant",
    slug: "ruthann-rushmer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tom S.",
    lastName: "Rushmer",
    title: "Associate Managing Editor",
    slug: "tom-s-rushmer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Teresa",
    lastName: "Rusinek",
    title: "Vegetable Crops Specialist",
    slug: "teresa-rusinek",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer Lynn",
    lastName: "Ruske",
    title: "Inside Director, Corporate Programs",
    slug: "jennifer-lynn-ruske",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ann Julienne",
    lastName: "Russ",
    title: "Director of Stewardship and Proposal Development",
    slug: "ann-julienne-russ",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amy J.",
    lastName: "Russ",
    title: "Executive Director of Principal Gifts",
    slug: "amy-j-russ",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nerissa",
    lastName: "Russell",
    title: "Dept Chairperson - Anthropology",
    slug: "nerissa-russell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Chance",
    lastName: "Russell",
    title: "Gift Accountant Specialist",
    slug: "chance-russell",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer Marie",
    lastName: "Russell",
    title: "Administrative Asst IV",
    slug: "jennifer-marie-russell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather Millar",
    lastName: "Russell",
    title: "Administrative Manager",
    slug: "heather-millar-russell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Corinne M.",
    lastName: "Russell",
    title: "Accounts Representative V",
    slug: "corinne-m-russell",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Heidi J",
    lastName: "Russell",
    title: "Executive Master of Human Resources Management (EMHRM) Coordinator",
    slug: "heidi-j-russell",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kelly Michaela",
    lastName: "Russell",
    title: "Security & Visitor Services Associate",
    slug: "kelly-michaela-russell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meredith",
    lastName: "Rutherford",
    title: "Sustainability Manager",
    slug: "meredith-rutherford",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Timothy",
    lastName: "Ryan",
    title: "University Fire Marshal",
    slug: "timothy-ryan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rick",
    lastName: "Ryan",
    title: "Manager of Research Communications, Physical Systems",
    slug: "rick-ryan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Gretchen",
    lastName: "Ryan",
    title: "Administrator VI, Chimesmaster",
    slug: "gretchen-ryan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Molly Catherine",
    lastName: "Ryan",
    title:
      " Cornell Cinema Director, Student Acad Serv Asst III-AEW, Student Acad Serv Asst II",
    slug: "molly-catherine-ryan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole Audrey",
    lastName: "Ryan",
    title: "Academic Services Assistant",
    slug: "nicole-audrey-ryan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David E.",
    lastName: "Ryan",
    title: "Building Coordinator & Sr. Preparator",
    slug: "david-e-ryan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David William",
    lastName: "Ryan",
    title: "Undergraduate/Graduate Field Coordinator",
    slug: "david-william-ryan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amanda Kathleen",
    lastName: "Ryan",
    title: "Associate Video Producer II",
    slug: "amanda-kathleen-ryan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Shawn Gordon",
    lastName: "Ryder",
    title: "Assistant Registrar",
    slug: "shawn-gordon-ryder",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Lauren A.",
    lastName: "Ryder",
    title: "Major Gifts Officer, College of Agriculture and Life Sciences",
    slug: "lauren-a-ryder",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Laura",
    lastName: "Sabatini",
    title: "Graduate Field Coordinator",
    slug: "laura-sabatini",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Carrie L",
    lastName: "Sabin",
    title: "Enrollment Counselor II",
    slug: "carrie-l-sabin",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Karen Joy",
    lastName: "Sacayanan",
    title: "Enrollment Counselor I",
    slug: "karen-joy-sacayanan",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Raj",
    lastName: "Sachdev",
    title: "MSLS Assistant Facilitator",
    slug: "raj-sachdev",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kevin M.",
    lastName: "Sackett",
    title:
      " Associate Dean of Alumni Affairs and Development, Cornell Law School",
    slug: "kevin-m-sackett",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Safiullah",
    lastName: "Safdariyan",
    title: "Business Simulation Lab Asst",
    slug: "safiullah-safdariyan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Basil Awni",
    lastName: "Safi",
    title:
      " Executive Director of the David M. Einhorn Center for Community Engagement",
    slug: "basil-awni-safi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ivan",
    lastName: "Sagel",
    title: "Merrill Family Sailing Center Manager",
    slug: "ivan-sagel",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Carolann J.",
    lastName: "Saggese",
    title: "Mgr Finance III",
    slug: "carolann-j-saggese",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elizabeth Ann",
    lastName: "Saggese",
    title: "Education Administrative Asst.",
    slug: "elizabeth-ann-saggese",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christopher W.",
    lastName: "Salay",
    title: "Mech Vehicle S11",
    slug: "christopher-w-salay",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kendra Anne",
    lastName: "Saldana",
    title: "Associate Director of Campaign Management",
    slug: "kendra-anne-saldana",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Krista",
    lastName: "Saleet",
    title: "Director of SCL Career Initiatives and Employment Experiences",
    slug: "krista-saleet",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Fouad",
    lastName: "Saleet",
    title:
      " Assistant Dean for External Education, Jack G. Clarke Executive Director of International and Comparative Legal Studies",
    slug: "fouad-saleet",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tony",
    lastName: "Salerno",
    title: "IT Service Manager",
    slug: "tony-salerno",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cathy",
    lastName: "Salino",
    title: "Financial Systems Lead",
    slug: "cathy-salino",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Freddie",
    lastName: "Salley",
    title: "Recruiter, eCornell",
    slug: "freddie-salley",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Bill",
    lastName: "Salone",
    title: "Accounts Rep IV",
    slug: "bill-salone",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Maggie",
    lastName: "Salvato",
    title: "Administrative Assistant III",
    slug: "maggie-salvato",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nora Sullivan",
    lastName: "Salvatore",
    title: "Associate General Counsel",
    slug: "nora-sullivan-salvatore",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Lauren Amy",
    lastName: "Salzman",
    title: "Coord Program II",
    slug: "lauren-amy-salzman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Bon",
    lastName: "Sam",
    title: "Financial Transaction Representative Lead",
    slug: "bon-sam",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jasmine Nicole Nour",
    lastName: "Samadi",
    title: "CTL Practicant",
    slug: "jasmine-nicole-nour-samadi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ana Karina",
    lastName: "Samaniego",
    title: "AAP- IT Solutions Cage Monitor",
    slug: "ana-karina-samaniego",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Wendy",
    lastName: "Samples",
    title: "Administrative Assistant, Centers & Programs",
    slug: "wendy-samples",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sara E.",
    lastName: "Sampson",
    title:
      " Executive Staff Assistant to the Office of the Vice President for Alumni Affairs and Development",
    slug: "sara-e-sampson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily M.",
    lastName: "Sampson",
    title: "Internal Programs and Human Resources Manager",
    slug: "emily-m-sampson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kevin C.",
    lastName: "Samson",
    title: "Asset Program Manager",
    slug: "kevin-c-samson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Katrina Erica",
    lastName: "Samuda",
    title: "Program Assistant - Ithaca Children's Garden (Trey Ramsey)",
    slug: "katrina-erica-samuda",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Derina S.",
    lastName: "Samuel",
    title: "Associate Director of Graduate Student Development",
    slug: "derina-s-samuel",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Michael",
    lastName: "Samuelian",
    title:
      " Founding Director of the Urban Tech Hub, Campus Planning and Sustainability",
    slug: "michael-samuelian",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Asha",
    lastName: "Sanaker",
    title: "Administrative Asst IV",
    slug: "asha-sanaker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kayleigh",
    lastName: "Sandford",
    title: "Data Associate",
    slug: "kayleigh-sandford",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shannon",
    lastName: "Sands",
    title: "Illustrator",
    slug: "shannon-sands",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Devin",
    lastName: "Sanera",
    title: "Business Librarian",
    slug: "devin-sanera",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rhienna",
    lastName: "Sanger",
    title: "Accounts Rep IV",
    slug: "rhienna-sanger",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tracy",
    lastName: "Sangprakarn",
    title: "Assistant Director of Nursing",
    slug: "tracy-sangprakarn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brinda Vijaya",
    lastName: "Sankar",
    title: "Nutrition and Health Outreach Specialist",
    slug: "brinda-vijaya-sankar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Orlay DeJesus",
    lastName: "Santa",
    title: "MTEI Coordinator",
    slug: "orlay-dejesus-santa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura Beth",
    lastName: "Santacrose",
    title: "Associate Director of the Skorton Center for Health Initiatives",
    slug: "laura-beth-santacrose",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Karen",
    lastName: "Santamaria",
    title: "Client Service Representative",
    slug: "karen-santamaria",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dianne M.",
    lastName: "Santana",
    title: "Processor",
    slug: "dianne-m-santana",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lex Enrico",
    lastName: "Santi",
    title: "Generalist Counselor Therapist",
    slug: "lex-enrico-santi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Renee Lee",
    lastName: "Santoro",
    title: "Data Curator",
    slug: "renee-lee-santoro",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rafael Jose Cagampang delos",
    lastName: "Santos",
    title: "ACT for Youth Evaluation Assistant",
    slug: "rafael-jose-cagampang-delos-santos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joseph",
    lastName: "Saponaro",
    title: "Sr. Application Developer",
    slug: "joseph-saponaro",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sue",
    lastName: "Sappington",
    title: "Program Assistant",
    slug: "sue-sappington",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kayla",
    lastName: "Sardella",
    title: "Financial Aid Counselor",
    slug: "kayla-sardella",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nikita",
    lastName: "Sarkar",
    title: "Director, Custom Live and International Programs",
    slug: "nikita-sarkar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kurt",
    lastName: "Sarsfield",
    title: "CROPPS Managing Director",
    slug: "kurt-sarsfield",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Louise S.",
    lastName: "Sarup",
    title: "Associate Director, Business Development and Licensing",
    slug: "louise-s-sarup",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joseph",
    lastName: "Satterly",
    title: "C2C and Delivery Services Manager",
    slug: "joseph-satterly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sabina",
    lastName: "Sattler",
    title: "Program Director, Cornell Executive MBA Metro NY Program",
    slug: "sabina-sattler",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Beth",
    lastName: "Saulnier",
    title: "Editor in Chief, Cornellians",
    slug: "beth-saulnier",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Cynthia",
    lastName: "Saunders-Cheatham",
    title: "Associate Dean of Student Services",
    slug: "cynthia-saunders-cheatham",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jennifer M.",
    lastName: "Saville",
    title: "Accounts Rep IV",
    slug: "jennifer-m-saville",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Chris",
    lastName: "Savino",
    title: "Finance Specialist IV",
    slug: "chris-savino",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Robi M.",
    lastName: "Savon",
    title: "Payroll Assistant",
    slug: "robi-m-savon",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Melanie Ann",
    lastName: "Savransky",
    title: "Communications Specialist, Internal Communications",
    slug: "melanie-ann-savransky",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Natalie",
    lastName: "Sawyer",
    title: "Accounts Receivable Coordinator",
    slug: "natalie-sawyer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jackie",
    lastName: "Sayegh",
    title: "Manager,  Institute of African Development",
    slug: "jackie-sayegh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Annika",
    lastName: "Sayles",
    title: "Accounts Coordinator",
    slug: "annika-sayles",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christie Marie",
    lastName: "Sayre",
    title: "Research Administration Coordinator",
    slug: "christie-marie-sayre",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mario R. Miranda",
    lastName: "Sazo",
    title: "Area Fruit Specialist",
    slug: "mario-r-miranda-sazo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joe",
    lastName: "Sbrocco",
    title: "Financial Transaction Representative",
    slug: "joe-sbrocco",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joseph S.",
    lastName: "Scaffido",
    title: "Director of University Events & Summer Programs",
    slug: "joseph-s-scaffido",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jennifer",
    lastName: "Scaglia",
    title: "Accounts Rep V",
    slug: "jennifer-scaglia",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Loree",
    lastName: "Scaglione",
    title: "IT Service Support Specialist",
    slug: "loree-scaglione",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Angela",
    lastName: "Scaglione-Houghtling",
    title: "Accounts Rep IV",
    slug: "angela-scaglione-houghtling",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lexi",
    lastName: "Scanlon",
    title: "Climate Jobs Associate",
    slug: "lexi-scanlon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chris",
    lastName: "Scarlata",
    title: "Athletic Trainer",
    slug: "chris-scarlata",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ian Michael",
    lastName: "Schachner",
    title: "Senior Associate Director of Admissions",
    slug: "ian-michael-schachner",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Melanie",
    lastName: "Schacht",
    title: "Enrollment Counselor, Team Lead",
    slug: "melanie-schacht",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Laura",
    lastName: "Schad",
    title: "Bowers CIS Program Manager for Research Initiatives",
    slug: "laura-schad",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Neil Adam",
    lastName: "Schaffer",
    title: "Sr. Desktop Support Specialist",
    slug: "neil-adam-schaffer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brigitt",
    lastName: "Schaffner",
    title: "Card Access Coordinator",
    slug: "brigitt-schaffner",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "David C.",
    lastName: "Schaffner",
    title: "Stockkeeper III",
    slug: "david-c-schaffner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert",
    lastName: "Scharf",
    title: "Director, Praxis Center for Venture Development",
    slug: "robert-scharf",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda Kate",
    lastName: "Schaufler",
    title: "Administrative Asst II",
    slug: "amanda-kate-schaufler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James Alan",
    lastName: "Schechter",
    title: "Precollege Studies Program Director",
    slug: "james-alan-schechter",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michelle Lynn",
    lastName: "Scheffel",
    title: "Communications Assistant V",
    slug: "michelle-lynn-scheffel",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Stephanie",
    lastName: "Schehr",
    title: "Service Coordinator",
    slug: "stephanie-schehr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joanne L.",
    lastName: "Schessl",
    title: "Finance Manager",
    slug: "joanne-l-schessl",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Andrew",
    lastName: "Schiavi",
    title: "ACRefrig Mech/Plumb",
    slug: "andrew-schiavi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jade",
    lastName: "Schiffer",
    title: "Financial Services Representative",
    slug: "jade-schiffer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Leslie",
    lastName: "Schill",
    title: "Director, University Planning",
    slug: "leslie-schill",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kyle",
    lastName: "Schillace",
    title: "Associate Director, Campus Activities",
    slug: "kyle-schillace",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jessica R P",
    lastName: "Schillmoeller",
    title: "Customer Service Manager",
    slug: "jessica-r-p-schillmoeller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca S.",
    lastName: "Schimenti",
    title: "College Registrar",
    slug: "rebecca-s-schimenti",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Arianna",
    lastName: "Schindle",
    title: "Training and Organizational Development Associate",
    slug: "arianna-schindle",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Holly",
    lastName: "Schlesser",
    title: "Enrollment Counselor, Team Lead",
    slug: "holly-schlesser",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Michael",
    lastName: "Schlossberg",
    title: "Sr. Application Developer",
    slug: "michael-schlossberg",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Random McCutcheon",
    lastName: "Schlosser",
    title: "Material Handler S07",
    slug: "random-mccutcheon-schlosser",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kimberly Maselli",
    lastName: "Schmelzinger",
    title: "Director of Finance for CU Press",
    slug: "kimberly-maselli-schmelzinger",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christopher J.",
    lastName: "Schmidt",
    title: "Director of Clery Compliance",
    slug: "christopher-j-schmidt",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Christina",
    lastName: "Schmidt",
    title: "CALS Director of Curriculum Development and Instructional Support",
    slug: "christina-schmidt",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brandon",
    lastName: "Schmitt",
    title: "Fire Protection Tester",
    slug: "brandon-schmitt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mark H.",
    lastName: "Schmitz",
    title:
      " Associate Director of Finance & Administration and Sr. Administrative Manager",
    slug: "mark-h-schmitz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Daniel E",
    lastName: "Schmohe",
    title: "Football Line Crew",
    slug: "daniel-e-schmohe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susie",
    lastName: "Schneider",
    title: "Interim Executive Director of Enrollment Management",
    slug: "susie-schneider",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Julie",
    lastName: "Schnepel",
    title: "Assistant Director, U.S.-RILM Office",
    slug: "julie-schnepel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kimberly",
    lastName: "Scholl",
    title: "Writing and Academic Support Specialist",
    slug: "kimberly-scholl",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sophia",
    lastName: "Scholl",
    title: "Generalist Counselor Therapist",
    slug: "sophia-scholl",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sebi Leith",
    lastName: "Schonfeld",
    title: "(SCL-Wall) Student Commun Serv Asst II",
    slug: "sebi-leith-schonfeld",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mark C.",
    lastName: "Schott",
    title: "Field Services Lead",
    slug: "mark-c-schott",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelsey Lynn",
    lastName: "Schreiber",
    title: "CIDER Programs Manager",
    slug: "kelsey-lynn-schreiber",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ryan",
    lastName: "Schreiber",
    title: "Assistant Director of Career Management Center",
    slug: "ryan-schreiber",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Cristi",
    lastName: "Schroeder",
    title: "Enrollment Counselor II",
    slug: "cristi-schroeder",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Trevor Philip",
    lastName: "Schul",
    title: "Development Administrative Assistant at Cornell Tech",
    slug: "trevor-philip-schul",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole Ann",
    lastName: "Schuler",
    title: "Enrollment Team Lead",
    slug: "nicole-ann-schuler",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Will",
    lastName: "Schultze",
    title: "IT Service Management Specialist",
    slug: "will-schultze",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sarah Louise",
    lastName: "Schupp",
    title:
      " Assistant Director for Enrollment Marketing and Digital Communications",
    slug: "sarah-louise-schupp",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Whitney",
    lastName: "Schwander",
    title: "Course Coordinator",
    slug: "whitney-schwander",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Steven",
    lastName: "Schwartz",
    title: "Project Manager, Production",
    slug: "steven-schwartz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Suzanne M.",
    lastName: "Schwartz",
    title: "Stacks Management/Student Supervisor",
    slug: "suzanne-m-schwartz",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Julia",
    lastName: "Schwartz",
    title: "Administrative Assistant",
    slug: "julia-schwartz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher L",
    lastName: "Schwarz",
    title: "Custom Programs IDA",
    slug: "christopher-l-schwarz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael",
    lastName: "Scott",
    title: "Events and Emergency Planning Lieutenant",
    slug: "michael-scott",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Camryn Brooke",
    lastName: "Scott",
    title: "Career Services Asst, Communications Center",
    slug: "camryn-brooke-scott",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Michelle L.",
    lastName: "Scott-Pierce",
    title: "Associate Director of EFNEP",
    slug: "michelle-l-scott-pierce",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mark",
    lastName: "Scoville",
    title: "Business Development Manager",
    slug: "mark-scoville",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Donald E.",
    lastName: "Scutt",
    title: "Football Line Crew",
    slug: "donald-e-scutt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Justin",
    lastName: "Sczepanski",
    title: "ACRefrig Mech/Plumb Apprentice",
    slug: "justin-sczepanski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dominik James",
    lastName: "Seamon",
    title: "Mech Vehicle S11",
    slug: "dominik-james-seamon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John",
    lastName: "Searle",
    title: "Material Handler S07",
    slug: "john-searle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Suzanne R.",
    lastName: "Sears",
    title: "EHS Technical Assistant",
    slug: "suzanne-r-sears",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Blake",
    lastName: "Sears",
    title: "Emergency Services Representative",
    slug: "blake-sears",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ronald E.",
    lastName: "Seccia",
    title: "Director of Information Technology",
    slug: "ronald-e-seccia",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stephanie A.",
    lastName: "Sechler",
    title: "Senior Associate General Counsel",
    slug: "stephanie-a-sechler",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Carolyn",
    lastName: "Sedgwick-Ludwin",
    title: "Gifts Officer II",
    slug: "carolyn-sedgwick-ludwin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cynthia L.",
    lastName: "Sedlacek",
    title: "Dir of Data Admin & Reporting",
    slug: "cynthia-l-sedlacek",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kathryn R.",
    lastName: "Seely",
    title: "Director of Brand Visuals",
    slug: "kathryn-r-seely",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Maria Fernanda De Oliveira",
    lastName: "Segura",
    title: "Intramural Sports Student Supervisor",
    slug: "maria-fernanda-de-oliveira-segura",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Peter",
    lastName: "Selby",
    title: "Applications Developer III",
    slug: "peter-selby",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elizabeth",
    lastName: "Seldin",
    title: "Administrative Assistant III",
    slug: "elizabeth-seldin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robin E.",
    lastName: "Selensky",
    title: "Enrollment Counselor I",
    slug: "robin-e-selensky",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Norah",
    lastName: "Selig",
    title: "Director of Data Strategy & Enterprise Systems",
    slug: "norah-selig",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rebecca S.",
    lastName: "Sellen",
    title: "Financial Services Associate",
    slug: "rebecca-s-sellen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tera",
    lastName: "Sellers",
    title: "Enrollment Manager",
    slug: "tera-sellers",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Erin",
    lastName: "Sember-Chase",
    title: "Diversity and Inclusion Learning Consultant",
    slug: "erin-sember-chase",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Eduardo Merchan",
    lastName: "Sempertegui",
    title: "Web Applications Developer",
    slug: "eduardo-merchan-sempertegui",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kathy",
    lastName: "Sendrowski",
    title: "Accounts Representative III",
    slug: "kathy-sendrowski",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tessa",
    lastName: "Senel",
    title: "Assistant Director of Admissions, SC Johnson College of Business",
    slug: "tessa-senel",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Tim",
    lastName: "Senft",
    title: "Digital Communications Director",
    slug: "tim-senft",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Meghan",
    lastName: "Serdock",
    title: "Senior Project Manager",
    slug: "meghan-serdock",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Veronica",
    lastName: "Sergeeva",
    title: "Mailroom Assistant",
    slug: "veronica-sergeeva",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah L.",
    lastName: "Seroussi",
    title: "Info Tech Area Mgr II",
    slug: "sarah-l-seroussi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Logan",
    lastName: "Serp",
    title: "Program Assistant, The Cornell Commitment",
    slug: "logan-serp",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kaitlyn Marie",
    lastName: "Serrao",
    title: "Media Relations Specialist",
    slug: "kaitlyn-marie-serrao",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sarah Loretta",
    lastName: "Serrianne",
    title: "Administrative Asst II",
    slug: "sarah-loretta-serrianne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle",
    lastName: "Servedio",
    title: "Note Taking Support and Assistive Equipment Coordinator",
    slug: "danielle-servedio",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ryan",
    lastName: "Sexton",
    title: "Director of Student Services & Graduate School Registrar",
    slug: "ryan-sexton",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Bethlehem Kiflemariam",
    lastName: "Seyoum",
    title:
      " Data Base Management - Center for Transformative Action - Prisoner's Express (Gary Fine), Student Admin Asst I",
    slug: "bethlehem-kiflemariam-seyoum",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Celeste",
    lastName: "Shaffer",
    title: "Financial Transaction Representative",
    slug: "celeste-shaffer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kelli",
    lastName: "Shaffner",
    title: "Regional Gift Officer",
    slug: "kelli-shaffner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Charmi Hetalkumar",
    lastName: "Shah",
    title: "Full Stack Developer",
    slug: "charmi-hetalkumar-shah",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sameer",
    lastName: "Shaik",
    title: "Senior PeopleSoft Developer",
    slug: "sameer-shaik",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ahmed",
    lastName: "Shamim",
    title: "Academic Programs Coordinator",
    slug: "ahmed-shamim",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jason M",
    lastName: "Shan",
    title: "Mailroom Assistant",
    slug: "jason-m-shan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patrick F.",
    lastName: "Shanahan",
    title: "eHub Coordinator",
    slug: "patrick-f-shanahan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Alan M.",
    lastName: "Sharafi",
    title: "Prospect Development Associate",
    slug: "alan-m-sharafi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Damien",
    lastName: "Sharp",
    title: "Strategic Communications & Media Relations Specialist",
    slug: "damien-sharp",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Cay C.",
    lastName: "Sharp",
    title: "Administrative Coordinator- Flora Rose House",
    slug: "cay-c-sharp",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Vicky Lyn",
    lastName: "Sharp",
    title: "Administrative Asst",
    slug: "vicky-lyn-sharp",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tania M.",
    lastName: "Sharpsteen",
    title:
      " Assistant Director for Student Services, Baker Program in Real Estate",
    slug: "tania-m-sharpsteen",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kelsey",
    lastName: "Shaulis",
    title: "Financial Transaction Representative",
    slug: "kelsey-shaulis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Troy B.",
    lastName: "Shaver",
    title: "Coordinator of OKU Course Reserves",
    slug: "troy-b-shaver",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amanda Soule",
    lastName: "Shaw",
    title: "Associate Dean of Administration",
    slug: "amanda-soule-shaw",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Leslie",
    lastName: "Shaw",
    title: "Senior Research",
    slug: "leslie-shaw",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ania",
    lastName: "Shcherenkov",
    title: "Finance Specialist III",
    slug: "ania-shcherenkov",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Aaron M",
    lastName: "Shear",
    title: "Asset Program Manager",
    slug: "aaron-m-shear",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kevin",
    lastName: "Shearer",
    title: "Manager, Desktop Support",
    slug: "kevin-shearer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elizabeth",
    lastName: "Shedd",
    title: "Assistant Director, International Services",
    slug: "elizabeth-shedd",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James F",
    lastName: "Sheehan",
    title: "Administrative Assistant III",
    slug: "james-f-sheehan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shawna Kay",
    lastName: "Sheehy",
    title: "Financial Services Associate",
    slug: "shawna-kay-sheehy",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mx Mel",
    lastName: "Sheffield",
    title: "Front Office Assistant",
    slug: "mx-mel-sheffield",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathy Ann",
    lastName: "Sheils",
    title: "Credit Card Programs Administrator",
    slug: "kathy-ann-sheils",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Daniel",
    lastName: "Sheire",
    title: "Multimedia Specialist II",
    slug: "daniel-sheire",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christina Marie",
    lastName: "Sheley",
    title: "Associate University Librarian for Public Services",
    slug: "christina-marie-sheley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Greg",
    lastName: "Shelley",
    title: "Senior Director of Sports Leadership and Mental Conditioning",
    slug: "greg-shelley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Savanna",
    lastName: "Shelnutt",
    title: "Ag Climate Resiliency Specialist",
    slug: "savanna-shelnutt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edward",
    lastName: "Sheridan",
    title: "Finance Specialist III",
    slug: "edward-sheridan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Molly Marie",
    lastName: "Sheridan",
    title: "Multimedia Specialist",
    slug: "molly-marie-sheridan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Anne Marie",
    lastName: "Sheridan",
    title: "Program Administrative Assistant",
    slug: "anne-marie-sheridan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Natalie A.",
    lastName: "Sheridan",
    title: "Public Svcs Asst V",
    slug: "natalie-a-sheridan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marissa M.",
    lastName: "Sherman",
    title:
      " Administrative Assistant, Alumni Engagement for the College of Arts & Sciences",
    slug: "marissa-m-sherman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "J",
    lastName: "Shermeta",
    title: "Associate University Architect",
    slug: "j-shermeta",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patrick D.",
    lastName: "Sherry",
    title: "Building Care Manager",
    slug: "patrick-d-sherry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katelynne S.",
    lastName: "Sherwood",
    title: "Administrative Asst",
    slug: "katelynne-s-sherwood",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrea L.",
    lastName: "Sherwood",
    title: "Assistant to the Associate Dean for Finance and Administration",
    slug: "andrea-l-sherwood",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessica",
    lastName: "Sherwood",
    title: "Sponsored Finance Specialist",
    slug: "jessica-sherwood",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Fei",
    lastName: "Shi",
    title: "ECE Accounts Representative",
    slug: "fei-shi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Fionna",
    lastName: "Shi",
    title: "SSAS Olivia Murray's Student Admin Asst I",
    slug: "fionna-shi",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Michelle M.",
    lastName: "Shields",
    title: "Technology Licensing Professional I",
    slug: "michelle-m-shields",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Laura Marie",
    lastName: "Shields",
    title: "Telecommunications Officer",
    slug: "laura-marie-shields",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ellen",
    lastName: "Shields",
    title: "Admissions Administrative and Processing Assistant",
    slug: "ellen-shields",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Amira",
    lastName: "Shimin",
    title:
      " Docents and Tour Guide at the History Center in Tompkins County (BrierMae Ossont)",
    slug: "amira-shimin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexis",
    lastName: "Shimon",
    title: "Managing Editor, Cornell East Asia Program",
    slug: "alexis-shimon",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jae Yun",
    lastName: "Shin",
    title: "Critic Visiting",
    slug: "jae-yun-shin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lianne Yeawon",
    lastName: "Shin",
    title: "Intramural Supervisor",
    slug: "lianne-yeawon-shin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sue",
    lastName: "Shipman",
    title: "Associate Director of Human Resources",
    slug: "sue-shipman",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "David P.",
    lastName: "Shirk",
    title: "Manager of Storage, Backup, and Servers",
    slug: "david-p-shirk",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stacey",
    lastName: "Shirk",
    title: "Administrator IV",
    slug: "stacey-shirk",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jo",
    lastName: "Shoemaker",
    title: "Office Coordinator",
    slug: "jo-shoemaker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tamara M.",
    lastName: "Shollenberger",
    title: "HR Generalist IV",
    slug: "tamara-m-shollenberger",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Yong",
    lastName: "Shon",
    title: "Integration Developer",
    slug: "yong-shon",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kristi Leigh",
    lastName: "Shorter",
    title: "Area Coordinator",
    slug: "kristi-leigh-shorter",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lilu KC",
    lastName: "Shrestha",
    title: "Administrative Assistant III",
    slug: "lilu-kc-shrestha",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jon",
    lastName: "Shu",
    title: "Associate Director, CCMR",
    slug: "jon-shu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carrie",
    lastName: "Shugarts",
    title: "Assistant to the Dean & Senate Committee Coordinator",
    slug: "carrie-shugarts",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Emma",
    lastName: "Shults",
    title: "Mgr Finance II",
    slug: "emma-shults",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kristi",
    lastName: "Shults",
    title: "Global HR Director",
    slug: "kristi-shults",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Angela Renee",
    lastName: "Shurtleff",
    title: "Employer Connections Specialist",
    slug: "angela-renee-shurtleff",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Yelena",
    lastName: "Shuster",
    title: "Assistant to the Associate Dean, CALS AAD",
    slug: "yelena-shuster",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christina L.",
    lastName: "Shutts",
    title: "Trust Administrator",
    slug: "christina-l-shutts",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Wendy Sue",
    lastName: "Sicina",
    title: "Assistant Director of Nursing",
    slug: "wendy-sue-sicina",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Fred Van",
    lastName: "Sickle",
    title: "Vice President for Alumni Affairs and Development",
    slug: "fred-van-sickle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily Ann",
    lastName: "Sickmon",
    title: "Dispatcher S07",
    slug: "emily-ann-sickmon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elke",
    lastName: "Siegel",
    title: "Dept Chairperson",
    slug: "elke-siegel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jim",
    lastName: "Sierotnik",
    title: "Fiscal Office Coordinator, Outreach",
    slug: "jim-sierotnik",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Karen T",
    lastName: "Siewert",
    title: "Director, Human Capital Development Programs",
    slug: "karen-t-siewert",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Cheri R.",
    lastName: "Sigmund",
    title: "Assistant to the Directors",
    slug: "cheri-r-sigmund",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeffrey A.",
    lastName: "Silber",
    title: "Senior Director, Sponsored Financial Services",
    slug: "jeffrey-a-silber",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Louise S.",
    lastName: "Silberling",
    title: "Editorial Assistant IV",
    slug: "louise-s-silberling",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Bethany",
    lastName: "Silfer",
    title: "Administrative Supervisor Acce",
    slug: "bethany-silfer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erin",
    lastName: "Sill",
    title: "Salesforce Administrator",
    slug: "erin-sill",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Vicki S.",
    lastName: "Sill",
    title: "Finance Specialist III",
    slug: "vicki-s-sill",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Diana R.",
    lastName: "Silva",
    title: "Production Coordinator",
    slug: "diana-r-silva",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Francisco J.",
    lastName: "Silva",
    title: "Mech Maint S07",
    slug: "francisco-j-silva",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emma R",
    lastName: "Silverblatt",
    title: "Critic Visiting",
    slug: "emma-r-silverblatt",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tony M.",
    lastName: "Simione",
    title: "University Major Gifts Officer",
    slug: "tony-m-simione",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather J.",
    lastName: "Simkin",
    title: "Administrative Asst III",
    slug: "heather-j-simkin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ludgarda R",
    lastName: "Simmonds",
    title: "Senior Research and Planning Associate",
    slug: "ludgarda-r-simmonds",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kim M.",
    lastName: "Simmons",
    title: "Financial Transaction Representative",
    slug: "kim-m-simmons",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Julie E.",
    lastName: "Simmons-Lynch",
    title: "Program Manager",
    slug: "julie-e-simmons-lynch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vicky A.",
    lastName: "Simon",
    title: "Research Supp Spec II",
    slug: "vicky-a-simon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Laurissa",
    lastName: "Simon",
    title: "Human Resources Associate",
    slug: "laurissa-simon",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Charles M.",
    lastName: "Simon",
    title: "Sr. Desktop Support Specialist",
    slug: "charles-m-simon",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anna",
    lastName: "Simonak",
    title:
      " Administrative Assistant to the Associate Dean and Director of Development",
    slug: "anna-simonak",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hannah",
    lastName: "Simonetta",
    title: "Communications Coordinator",
    slug: "hannah-simonetta",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lauren",
    lastName: "Simpson",
    title: "Major Gift Associate",
    slug: "lauren-simpson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelly L.",
    lastName: "Sinclair",
    title: "Financial Services Associate",
    slug: "kelly-l-sinclair",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kayla Biren",
    lastName: "Singer",
    title: "Career Services Asst.",
    slug: "kayla-biren-singer",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sheila",
    lastName: "Singh",
    title: "Generalist Counselor Therapist",
    slug: "sheila-singh",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "James",
    lastName: "Singleton",
    title: "Data Warehouse Developer",
    slug: "james-singleton",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John P.",
    lastName: "Sinnott",
    title: "Industrial Programs Manager",
    slug: "john-p-sinnott",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David Andrew",
    lastName: "Sipe",
    title: "Building Care Manager",
    slug: "david-andrew-sipe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carrie L",
    lastName: "Sipe",
    title: "Administrative Coordinator, William Keeton House",
    slug: "carrie-l-sipe",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Veronica",
    lastName: "Sirotic",
    title: "Senior Program Manager, Break Through Tech",
    slug: "veronica-sirotic",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cooper Ross",
    lastName: "Sirwatka",
    title: "Equal Opportunity Program Director",
    slug: "cooper-ross-sirwatka",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Christine Demko",
    lastName: "Sislak",
    title: "Grant Contract Ofcr I",
    slug: "christine-demko-sislak",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Taylor",
    lastName: "Sitko",
    title: "Knowledge Manager",
    slug: "taylor-sitko",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessica Lynn",
    lastName: "Siurano",
    title: "FCS Financial Reporting Specialist",
    slug: "jessica-lynn-siurano",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Paul",
    lastName: "Skiera",
    title: "Director, Instructional Design",
    slug: "paul-skiera",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shannon Jane",
    lastName: "Slack",
    title: "Access Services and Stacks Coordinator",
    slug: "shannon-jane-slack",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jamie L. A.",
    lastName: "Slater",
    title: "Department Manager",
    slug: "jamie-l-a-slater",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bailey Michele",
    lastName: "Slater",
    title: "Pharmacist",
    slug: "bailey-michele-slater",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tina M.",
    lastName: "Slater",
    title: "Graduate Field Coordinator",
    slug: "tina-m-slater",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mark",
    lastName: "Slattery",
    title: "Assistant Director of Nursing",
    slug: "mark-slattery",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Barbara",
    lastName: "Sledziona",
    title: "Bldg Coord II",
    slug: "barbara-sledziona",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Natalie",
    lastName: "Sloane",
    title: "Communication Spec II",
    slug: "natalie-sloane",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Paula M.",
    lastName: "Slocum",
    title: "Administrative Assistant",
    slug: "paula-m-slocum",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scotti",
    lastName: "Slocum",
    title: "Building Care Manager",
    slug: "scotti-slocum",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cynthia Nicole",
    lastName: "Slocum",
    title: "Client Experience Coordinator",
    slug: "cynthia-nicole-slocum",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dinnie",
    lastName: "Sloman",
    title: "Administrator V",
    slug: "dinnie-sloman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tyler Jordan",
    lastName: "Slonecki",
    title: "Biosoftware Coordinator",
    slug: "tyler-jordan-slonecki",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "LaTisha",
    lastName: "Slowe-McCloud",
    title: "Sponsored Funds Account Representative",
    slug: "latisha-slowe-mccloud",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jamie Lynn",
    lastName: "Slusser",
    title: "Pre-Award Specialist",
    slug: "jamie-lynn-slusser",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Robin Bradford",
    lastName: "Smail",
    title: "Digital User Experience Strategist",
    slug: "robin-bradford-smail",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Judith A.",
    lastName: "Small",
    title: "Einaudi Center Administrator",
    slug: "judith-a-small",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Peter J.",
    lastName: "Smallidge",
    title: "State Exten Forester",
    slug: "peter-j-smallidge",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cooper M",
    lastName: "Smith",
    title: "Director, Contract Management",
    slug: "cooper-m-smith",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jeffrey John",
    lastName: "Smith",
    title: "Senior Investment Officer",
    slug: "jeffrey-john-smith",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Wendy",
    lastName: "Smith",
    title: "Senior Director of Human Resources for Research & Innovation",
    slug: "wendy-smith",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Bobbi Lynn",
    lastName: "Smith",
    title: "Gift Processing Administrator",
    slug: "bobbi-lynn-smith",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alison Rose",
    lastName: "Smith",
    title: "Director of Development",
    slug: "alison-rose-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brett",
    lastName: "Smith",
    title: "Associate Director, Gift Acknowledgments",
    slug: "brett-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erik A",
    lastName: "Smith",
    title: "Field Crops Specialist",
    slug: "erik-a-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kenneth M.",
    lastName: "Smith",
    title: "Administrative Server, Systems and Special Projects Manager",
    slug: "kenneth-m-smith",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elodie E.",
    lastName: "Smith",
    title: "Digital Communications Director",
    slug: "elodie-e-smith",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Henry",
    lastName: "Smith",
    title: "Communications Specialist, Biological Systems",
    slug: "henry-smith",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brenda K.",
    lastName: "Smith",
    title: "Associate Director and Research Center Project Manager",
    slug: "brenda-k-smith",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Holly J.",
    lastName: "Smith",
    title: "Chief of Security and Visitor Servies",
    slug: "holly-j-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gabrielle Christina",
    lastName: "Smith",
    title:
      " Assistant Director, Student Success Programs and OADI, Program Innovation",
    slug: "gabrielle-christina-smith",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Joshua Eli",
    lastName: "Smith",
    title: "Coordinator of Accessible Media and Technology",
    slug: "joshua-eli-smith",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessica",
    lastName: "Smith",
    title: "Financial Transaction Representative",
    slug: "jessica-smith",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gregory J.",
    lastName: "Smith",
    title: "CALS Facility Coordinator",
    slug: "gregory-j-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shane R.",
    lastName: "Smith",
    title: "Video Producer, On-Location",
    slug: "shane-r-smith",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Amanda",
    lastName: "Smith",
    title: "Enrollment Counselor II",
    slug: "amanda-smith",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Iain Patrick",
    lastName: "Smith",
    title: "LII - WEX",
    slug: "iain-patrick-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ethan J.",
    lastName: "Smith",
    title: "Assistant Golf Professional",
    slug: "ethan-j-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Angela M.",
    lastName: "Smith",
    title: "Finance Specialist III",
    slug: "angela-m-smith",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer L.",
    lastName: "Smith",
    title: "Administrative Asst IV",
    slug: "jennifer-l-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bradford",
    lastName: "Smith",
    title: "Career Services Director, Break Through Tech",
    slug: "bradford-smith",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Maria",
    lastName: "Smith",
    title: "Communications Assistant IV",
    slug: "maria-smith",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jacob M.",
    lastName: "Snell",
    title: "Manager, Executive Technical Support",
    slug: "jacob-m-snell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Karen Lynn",
    lastName: "Snover-Clift",
    title: "Director, Plant Disease Diagno",
    slug: "karen-lynn-snover-clift",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robin Jolene",
    lastName: "Snowden",
    title: "Bldg/Facil Coord IV",
    slug: "robin-jolene-snowden",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathleen Mary",
    lastName: "Snyder",
    title: "Special Events Mgr. for the Pr",
    slug: "kathleen-mary-snyder",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chloe",
    lastName: "Snyder",
    title: "Events & Main Office Coordinator",
    slug: "chloe-snyder",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tracey L.",
    lastName: "Snyder",
    title: "Music Catalog and Instruction Librarian",
    slug: "tracey-l-snyder",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen Lynn",
    lastName: "Snyder",
    title: "Administrative Asst IV",
    slug: "karen-lynn-snyder",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine",
    lastName: "Snyder",
    title: "Office Assistant",
    slug: "katherine-snyder",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Casey Allen",
    lastName: "Snyder",
    title: "Milk Plant Worker S09",
    slug: "casey-allen-snyder",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Benjamin",
    lastName: "Sobel",
    title: "Post Doctoral Associate",
    slug: "benjamin-sobel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Hunter Louis",
    lastName: "Sobel",
    title: "Visitor Services and Gallery/Building Assistant",
    slug: "hunter-louis-sobel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jay Kennedy",
    lastName: "Sobers",
    title:
      " Live Exhibits Assistant - Sciencenter (Sierra Coathup), Student Admin Asst I",
    slug: "jay-kennedy-sobers",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sarah Heavens",
    lastName: "Soda",
    title: "Administrative Assistant III",
    slug: "sarah-heavens-soda",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nancy",
    lastName: "Sohlbreck",
    title: "Administrative Assistant",
    slug: "nancy-sohlbreck",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary Jane",
    lastName: "Solino",
    title: "Senior Sales and Account Manager (NYC Region)",
    slug: "mary-jane-solino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paulina Velazquez",
    lastName: "Solis",
    title: "Critic Visiting",
    slug: "paulina-velazquez-solis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katherine",
    lastName: "Solis-Fonte",
    title: "Administrative Manager",
    slug: "katherine-solis-fonte",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joe",
    lastName: "Solomon",
    title: "Associate Project Manager",
    slug: "joe-solomon",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Janna Ray",
    lastName: "Solomon",
    title: "GSS Lab Manager",
    slug: "janna-ray-solomon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Divya Susan",
    lastName: "Solomon",
    title: "Post Doctoral Associate",
    slug: "divya-susan-solomon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Melanie L.",
    lastName: "Solomon",
    title: "Registrar Coordinator",
    slug: "melanie-l-solomon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lori J.",
    lastName: "Sonken",
    title: "Communication and Program Manager",
    slug: "lori-j-sonken",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer",
    lastName: "Soprano",
    title: "Employer Relations Specialist",
    slug: "jennifer-soprano",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "David",
    lastName: "Sorensen",
    title: "Emergency Services Specialist",
    slug: "david-sorensen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ester",
    lastName: "Soriano",
    title: "Business Relationship Manager",
    slug: "ester-soriano",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Scott M.",
    lastName: "Sorrentino",
    title: "Manager of Systems Support",
    slug: "scott-m-sorrentino",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emma",
    lastName: "Sosebee",
    title: "Public Services Assistant",
    slug: "emma-sosebee",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Delta",
    lastName: "Southi",
    title: "Advancement Services Records Specialist",
    slug: "delta-southi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hanna Valpuri",
    lastName: "Sovero",
    title: "Web Designer II",
    slug: "hanna-valpuri-sovero",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lynda",
    lastName: "Sovocool",
    title: "Associate Director of Administration",
    slug: "lynda-sovocool",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Avalon Hoek",
    lastName: "Spaans",
    title: "Assistant Director of Research",
    slug: "avalon-hoek-spaans",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andy",
    lastName: "Spaccio",
    title: "Info Tech Asst Dir I",
    slug: "andy-spaccio",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mia",
    lastName: "Spada",
    title: "Events Specialist",
    slug: "mia-spada",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joseph Raymond",
    lastName: "Spada",
    title: "IT Support Associate",
    slug: "joseph-raymond-spada",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Allessandra",
    lastName: "Spada",
    title: "Grant Coordinator",
    slug: "allessandra-spada",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joseph Cedric",
    lastName: "Spak",
    title:
      " CAS- BIOMG 3300 Academic Services Assistant (Kevin Siegenthaler), SASA III - STSCI 2100, AEM 2210 (Szpiro) CA",
    slug: "joseph-cedric-spak",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Deborah A",
    lastName: "Sparling",
    title: "Financial Transaction Representative",
    slug: "deborah-a-sparling",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer",
    lastName: "Spearing",
    title: "Administrative Assistant II",
    slug: "jennifer-spearing",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chelsea Dvorak",
    lastName: "Specht",
    title:
      " Associate Dean and Secretary of the University Faculty, Associate Director of Diversity, Equity and Inclusion for SIPS, Professor of Plant Biodiversity/Phylodiversity",
    slug: "chelsea-dvorak-specht",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Chelsea Jade",
    lastName: "Speer",
    title: "Paralegal",
    slug: "chelsea-jade-speer",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Brittany M",
    lastName: "Spence",
    title: "Bursar Support Lead",
    slug: "brittany-m-spence",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Emma",
    lastName: "Spence",
    title: "Field Program Manager",
    slug: "emma-spence",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sheri Ann",
    lastName: "Spencer",
    title: "Human Resources Asst V",
    slug: "sheri-ann-spencer",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Julie L.",
    lastName: "Spencer",
    title: "Accounts Rep IV",
    slug: "julie-l-spencer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Courtney",
    lastName: "Spencer",
    title: "Manager of Finance & Business Performance",
    slug: "courtney-spencer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brittany Lee",
    lastName: "Spencer",
    title: "Admissions Assistant - CVM Office of Student & Academic Services",
    slug: "brittany-lee-spencer",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Susannah",
    lastName: "Spero",
    title: "Assistant Medical Director",
    slug: "susannah-spero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie M",
    lastName: "Spicciati",
    title: "Data Associate",
    slug: "stephanie-m-spicciati",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jason Douglas",
    lastName: "Spicer",
    title: "Clark Hall Building Coordinator",
    slug: "jason-douglas-spicer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hope Ann",
    lastName: "Spicer",
    title: "Multimedia Assistant IV",
    slug: "hope-ann-spicer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Angel Martinez",
    lastName: "Spielvogel",
    title: "ARC Tutor - BJM, AAP- IT solutions Cage Monitor",
    slug: "angel-martinez-spielvogel",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Andrea Lynn",
    lastName: "Spiezio",
    title: "Director, Enterprise Programs",
    slug: "andrea-lynn-spiezio",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Robyn N.",
    lastName: "Spind",
    title: "Enrollment Counselor",
    slug: "robyn-n-spind",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Hope",
    lastName: "Spithaler",
    title: "Events and Project Manager",
    slug: "hope-spithaler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Judith Ann",
    lastName: "Spitz",
    title: "Executive Director, Break Through Tech",
    slug: "judith-ann-spitz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel",
    lastName: "Splitgerber",
    title: "WCM Staff Appointment",
    slug: "daniel-splitgerber",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Penny Lane",
    lastName: "Spoonhower",
    title: "Associate Director, Annual Giving and Stewardship",
    slug: "penny-lane-spoonhower",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Donna",
    lastName: "Spotton",
    title: "Transition Associate",
    slug: "donna-spotton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel",
    lastName: "Sprague",
    title: "Field Coordinator",
    slug: "daniel-sprague",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jamie Lynn",
    lastName: "Sprague",
    title: "Associate Director, Federal Team",
    slug: "jamie-lynn-sprague",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather",
    lastName: "Spraker",
    title: "Regional Dairy Processing Specialist",
    slug: "heather-spraker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Beth",
    lastName: "Sprankle",
    title: "Conference & Event Planner",
    slug: "beth-sprankle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rob",
    lastName: "Sprankle",
    title: "Purchasing Assistant",
    slug: "rob-sprankle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elisa K.",
    lastName: "Springer",
    title: "Mgr Finance III",
    slug: "elisa-k-springer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ms Shari",
    lastName: "Sprole",
    title: "Assistant Director, Business Relationship Management",
    slug: "ms-shari-sprole",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Parker Elizabeth",
    lastName: "Sproule",
    title: "Todd - AAP Photo Lab Monitor",
    slug: "parker-elizabeth-sproule",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jodie H.",
    lastName: "Sprouse",
    title: "Systems Administrator III",
    slug: "jodie-h-sprouse",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Adam E.",
    lastName: "Spry",
    title: "Building Coordinator",
    slug: "adam-e-spry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tammy",
    lastName: "Sritecha",
    title: "Major Gift Associate, Johnson Museum of Art",
    slug: "tammy-sritecha",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mr Phil",
    lastName: "Sroka",
    title: "Thesis and Dissertation Coordinator",
    slug: "mr-phil-sroka",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Monique Naomi",
    lastName: "Staats",
    title: "Manager, Student Support",
    slug: "monique-naomi-staats",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Alyssa Pontes",
    lastName: "Stablein",
    title: "Compliance and Policy Specialist",
    slug: "alyssa-pontes-stablein",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Anna M.",
    lastName: "Stalter",
    title: "Collections Asst V",
    slug: "anna-m-stalter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Preslava",
    lastName: "Staneva",
    title: "Integration Developer",
    slug: "preslava-staneva",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joseph A.",
    lastName: "Stankaitis",
    title: "Executive in Residence",
    slug: "joseph-a-stankaitis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cassidy J.",
    lastName: "Stanley",
    title: "Program Assistant",
    slug: "cassidy-j-stanley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Grace",
    lastName: "Stanley",
    title: "Staff Writer/Editor",
    slug: "grace-stanley",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Pam",
    lastName: "Stansbury",
    title: "Cataloging Associate, Supervisor",
    slug: "pam-stansbury",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mike J.",
    lastName: "Stanyard",
    title: "Crop Management Specialist",
    slug: "mike-j-stanyard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary L",
    lastName: "Stapleton",
    title: "SSC Procure to Pay Director",
    slug: "mary-l-stapleton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aaron Matthew",
    lastName: "Stapleton",
    title: "Web Application Developer",
    slug: "aaron-matthew-stapleton",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jacinta Anne",
    lastName: "Stark",
    title: "Assistant Director, The Cornell Commitment",
    slug: "jacinta-anne-stark",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jason Michael",
    lastName: "Stark",
    title: "FSAP Counselor Therapist",
    slug: "jason-michael-stark",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jocelyn",
    lastName: "Stark",
    title: "Athletic Trainer",
    slug: "jocelyn-stark",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicholas Nathaniel",
    lastName: "Stark",
    title: "Audio Video Coordinator",
    slug: "nicholas-nathaniel-stark",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shalinn Nicole",
    lastName: "Starkey",
    title: "Event and Office Coordinator",
    slug: "shalinn-nicole-starkey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mark James",
    lastName: "Starkweather",
    title: "Desktop Support Admin",
    slug: "mark-james-starkweather",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily Rose",
    lastName: "Staros",
    title: "Assistant Director of Admissions",
    slug: "emily-rose-staros",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jennifer K.",
    lastName: "Starr",
    title: "Regional Agriculture Team Support Specialist",
    slug: "jennifer-k-starr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ruthie",
    lastName: "Starr",
    title: "Finance Specialist II",
    slug: "ruthie-starr",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elizabeth",
    lastName: "Starr",
    title: "Patrol Officer – Accreditation",
    slug: "elizabeth-starr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laurie Marie",
    lastName: "Starr",
    title: "Benefit Navigator",
    slug: "laurie-marie-starr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tiffany Marie",
    lastName: "Stauderman",
    title: "Accounts Rep IV",
    slug: "tiffany-marie-stauderman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Helen",
    lastName: "Stec",
    title: "Grad School Student Admin Asst IV",
    slug: "helen-stec",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Patrick Donovan",
    lastName: "Steele",
    title: "Stellic Degree Audit Administrator",
    slug: "patrick-donovan-steele",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Damien",
    lastName: "Steele",
    title: "Asset Program Manager",
    slug: "damien-steele",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Carolynn R.",
    lastName: "Steele-Law",
    title: "Research Administration Coordinator",
    slug: "carolynn-r-steele-law",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah Elizabeth",
    lastName: "Stefanik",
    title: "Financial Aid Counselor",
    slug: "sarah-elizabeth-stefanik",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Luanne M. Prosperi",
    lastName: "Stefanucci",
    title: "Associate Director, Engagement & Volunteer Management",
    slug: "luanne-m-prosperi-stefanucci",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Karen",
    lastName: "Steffy",
    title: "Administrative Asst IV",
    slug: "karen-steffy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Helen",
    lastName: "Steh",
    title: "Commuter Programs Administrator",
    slug: "helen-steh",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Teresa",
    lastName: "Steigerwalt",
    title: "Service Manager, AHDC Client Resource Team",
    slug: "teresa-steigerwalt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zoe Rebecca",
    lastName: "Stein",
    title: "Regional Gift Officer",
    slug: "zoe-rebecca-stein",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Melinda",
    lastName: "Stelick",
    title: "Director of Finance & Budget",
    slug: "melinda-stelick",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Paul",
    lastName: "Stemkoski",
    title: "Director of Project Management",
    slug: "paul-stemkoski",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lisa",
    lastName: "Stensland",
    title: "University Privacy Associate Director",
    slug: "lisa-stensland",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Max",
    lastName: "Stephenson",
    title: "Annual Fund Officer, Leadership Annual Giving",
    slug: "max-stephenson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rob",
    lastName: "Stergas",
    title: "Enrollment and Member Support",
    slug: "rob-stergas",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rafi",
    lastName: "Stern",
    title: "Director of Judicial Clerkships",
    slug: "rafi-stern",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Emily Nicole",
    lastName: "Stern",
    title: "IT Service Support Specialist",
    slug: "emily-nicole-stern",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dana (Burton)",
    lastName: "Stevens",
    title: "Assistant Director, SCL Human Resources",
    slug: "dana-burton-stevens",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Lindsay Ann",
    lastName: "Stevens",
    title: "Regional Gift Officer",
    slug: "lindsay-ann-stevens",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Axel",
    lastName: "Stevens",
    title: "Systems Data Integrator",
    slug: "axel-stevens",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Margaret",
    lastName: "Stevens",
    title: "Associate Director, Executive Education",
    slug: "margaret-stevens",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Patrick Joseph",
    lastName: "Stevens",
    title: "Curator, Fiske Icelandic Collection/Selector for Jewish Studies",
    slug: "patrick-joseph-stevens",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Laurie M.",
    lastName: "Stevens",
    title: "Approvals Coordinator / Department Administrative Support",
    slug: "laurie-m-stevens",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deirdre A.",
    lastName: "Stevenson",
    title: "Learning Consultant",
    slug: "deirdre-a-stevenson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah",
    lastName: "Stevenson-Peck",
    title: "Bulletin Fall 2024",
    slug: "sarah-stevenson-peck",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen M.",
    lastName: "Steward",
    title: "Enrollment Support Representative",
    slug: "karen-m-steward",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Nathan",
    lastName: "Stewart",
    title: "Regional Gift Officer",
    slug: "nathan-stewart",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Terrie",
    lastName: "Stewart",
    title: "Benefits Admin. Coordinator",
    slug: "terrie-stewart",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Becky S.",
    lastName: "Stewart",
    title: "Associate Director of Graduate Studies",
    slug: "becky-s-stewart",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Annie Elizabeth",
    lastName: "Stewart",
    title:
      " Program Assistant - The Center for Transformative Action - Christopherson Center (Gretchen Worth)",
    slug: "annie-elizabeth-stewart",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ricky R.",
    lastName: "Stewart",
    title: "Sr. IT Support Associate",
    slug: "ricky-r-stewart",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Crystal",
    lastName: "Stewart-Courtens",
    title: "Vegetable Specialist",
    slug: "crystal-stewart-courtens",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Clare",
    lastName: "Stich",
    title: "Major Gift Officer, West Coast",
    slug: "clare-stich",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert Patrick",
    lastName: "Stickel",
    title: "Manager Marketing",
    slug: "robert-patrick-stickel",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brad",
    lastName: "Stock",
    title: "Talent Acquisition Partner",
    slug: "brad-stock",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jenny",
    lastName: "Stockdale",
    title: "Director, Marketing and Communication",
    slug: "jenny-stockdale",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Luanne",
    lastName: "Stockdale",
    title: "Workflow Coordinator",
    slug: "luanne-stockdale",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Leah",
    lastName: "Stockholm",
    title: "Administrative Asst II",
    slug: "leah-stockholm",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyle Thomas",
    lastName: "Stocks",
    title: "Grant Contract Ofcr I",
    slug: "kyle-thomas-stocks",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kim A.",
    lastName: "Stockton",
    title: "Administrator III",
    slug: "kim-a-stockton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie",
    lastName: "Stoddard",
    title: "Salesforce Administrator",
    slug: "stephanie-stoddard",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Leon Christian",
    lastName: "Stoll",
    title: "Finance Specialist III",
    slug: "leon-christian-stoll",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Stacey",
    lastName: "Stone",
    title: "Chair's Assistant",
    slug: "stacey-stone",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Renee",
    lastName: "Storti",
    title: "Enrollment Counselor, Team Lead",
    slug: "renee-storti",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Olivia Shea",
    lastName: "Storz",
    title: "Pao-Student Acad Serv Asst III",
    slug: "olivia-shea-storz",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jeannine L.",
    lastName: "Stout",
    title: "Commitment and Budget Management Specialist",
    slug: "jeannine-l-stout",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Linda G",
    lastName: "Stout",
    title: "BASICS Provider",
    slug: "linda-g-stout",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nancy L",
    lastName: "Stout",
    title: "Budget and Finance Representative",
    slug: "nancy-l-stout",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tina",
    lastName: "Stover",
    title: "Data Associate",
    slug: "tina-stover",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Janet",
    lastName: "Strait",
    title: "Associate Director, Sponsored Financial Services",
    slug: "janet-strait",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "James E.",
    lastName: "Strait",
    title: "Manager of Technical Services",
    slug: "james-e-strait",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alexander Nick",
    lastName: "Stratakos",
    title: "Fire Protection Specialist - Lead",
    slug: "alexander-nick-stratakos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anna",
    lastName: "Stratton",
    title: "Major Gift Officer",
    slug: "anna-stratton",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Melissa Kay",
    lastName: "Straub",
    title: "Conference Planning Manager",
    slug: "melissa-kay-straub",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Allie",
    lastName: "Streeter",
    title: "Equity Data Analysis Specialist",
    slug: "allie-streeter",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Steven",
    lastName: "Streetman",
    title: "Reference Assistant & Public Services Technology Coordinator",
    slug: "steven-streetman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kristin",
    lastName: "Streicher",
    title: "Program Manager",
    slug: "kristin-streicher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William",
    lastName: "Streleckis",
    title: "Instructional Tech Spec III",
    slug: "william-streleckis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kelly Shawn",
    lastName: "Strickland",
    title: "Executive Staff Assistant for the Office of the CIO",
    slug: "kelly-shawn-strickland",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Frank L.",
    lastName: "Strickland",
    title: "Director - Information Technology",
    slug: "frank-l-strickland",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Samantha A.",
    lastName: "Strickland",
    title: "Multi Media Assistant",
    slug: "samantha-a-strickland",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kathleen E.",
    lastName: "Strickland",
    title: "Client Experience Coordinator",
    slug: "kathleen-e-strickland",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William E",
    lastName: "Stringer",
    title: "Senior Director",
    slug: "william-e-stringer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gretchen",
    lastName: "Strong",
    title: "Assistant to the Department Chair - Microbiology & Immunology",
    slug: "gretchen-strong",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Leah Lynn",
    lastName: "Strong",
    title: "Enrollment Team Lead",
    slug: "leah-lynn-strong",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Christian Michael",
    lastName: "Strub",
    title: "Project Associate for Entrepreneurship Programs",
    slug: "christian-michael-strub",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ami M.",
    lastName: "Stuart",
    title: "Tech Event Manager",
    slug: "ami-m-stuart",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ken",
    lastName: "Stuart",
    title: "Web Applications Developer",
    slug: "ken-stuart",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Abigail Mary",
    lastName: "Stuart",
    title: "Senior Admissions Manager, Break Through Tech",
    slug: "abigail-mary-stuart",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Braden",
    lastName: "Studelska",
    title: "Assistant Director, Volunteer Giving Initiatives",
    slug: "braden-studelska",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew F.",
    lastName: "Student",
    title: "Executive Assistant to the Dean",
    slug: "matthew-f-student",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Robert",
    lastName: "Stuessy",
    title: "Enrollment Pod Leader",
    slug: "robert-stuessy",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jeff",
    lastName: "Stulgis",
    title: "Accounting Manager",
    slug: "jeff-stulgis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Julie Marie",
    lastName: "Suarez",
    title:
      " Associate Dean of Governmental and Community Relations, Director of Translational Research Programs",
    slug: "julie-marie-suarez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jessica Alexandra",
    lastName: "Suarez",
    title: "Multimedia Specialist I",
    slug: "jessica-alexandra-suarez",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Isabella Corn",
    lastName: "Suffredini",
    title:
      " Dean's Assistant (Walsh) CA, Hotel Student Mentorship Program, HADM-3120/5120 (Silver) CA, HADM 1350 (Roberts) CA, HADM4115/6115 (Workman) CA",
    slug: "isabella-corn-suffredini",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Yumi Rosa",
    lastName: "Suh",
    title: "Graphic Design Coordinator",
    slug: "yumi-rosa-suh",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lyuda",
    lastName: "Sukhinenko",
    title: "Financial Transaction Representative",
    slug: "lyuda-sukhinenko",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elizabeth",
    lastName: "Sullivan",
    title: "Project and Administrative Manager",
    slug: "elizabeth-sullivan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sara CW",
    lastName: "Sullivan",
    title: "Associate University Registrar, Compliance",
    slug: "sara-cw-sullivan",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kelley A.",
    lastName: "Sullivan",
    title: "Associate Director of Business Services & Technology Innovation",
    slug: "kelley-a-sullivan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Oneka Pearl",
    lastName: "Sumter",
    title: "Enrollment Counselor, Team Lead",
    slug: "oneka-pearl-sumter",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Werner",
    lastName: "Sun",
    title: "Info Tech Asst Dir II",
    slug: "werner-sun",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Qi",
    lastName: "Sun",
    title: "Co-Director, BRC Bioinformatics Facility",
    slug: "qi-sun",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Linnea Titus",
    lastName: "Sunti",
    title: "Administrative Assistant for Cornell Outdoor Education",
    slug: "linnea-titus-sunti",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kate",
    lastName: "Supron",
    title: "Campus-Community Liaison",
    slug: "kate-supron",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Deborah J.",
    lastName: "Surine",
    title: "Alumni Affairs Assistant",
    slug: "deborah-j-surine",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carrie",
    lastName: "Susskind",
    title: "IT Project Manager IV",
    slug: "carrie-susskind",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Soontira",
    lastName: "Sutanont",
    title: "Lead Visual Designer",
    slug: "soontira-sutanont",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dustin",
    lastName: "Sutherland",
    title: "Manager of Projects",
    slug: "dustin-sutherland",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Donna E.",
    lastName: "Sutliff",
    title: "Project Management System Administrator",
    slug: "donna-e-sutliff",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessie",
    lastName: "Sutton",
    title:
      " Records Clerk - City of Ithaca - Ithaca Fire Department (Rob Covert)",
    slug: "jessie-sutton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole",
    lastName: "Svonavec",
    title: "Director of Student and Young Alumni Engagement",
    slug: "nicole-svonavec",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sabrina Jasmine",
    lastName: "Swansbrough",
    title: "Telecommunications Officer",
    slug: "sabrina-jasmine-swansbrough",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Miranda",
    lastName: "Swanson",
    title: "Associate Dean for Student Services",
    slug: "miranda-swanson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jane",
    lastName: "Swanson",
    title: "Director, Government & Community Relations",
    slug: "jane-swanson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Amanda L",
    lastName: "Swanson",
    title: "Financial Services Associate",
    slug: "amanda-l-swanson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ronda Sue",
    lastName: "Swartout",
    title: "Accounting Clerk",
    slug: "ronda-sue-swartout",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kim",
    lastName: "Swartwout",
    title: "Assistant Director, Workforce Planning and Compensation",
    slug: "kim-swartwout",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Tom",
    lastName: "Swartwout",
    title: "Multimedia Senior Producer",
    slug: "tom-swartwout",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kimberlee M.",
    lastName: "Swartz",
    title:
      " Associate Director, Employer Relations and Professional Readiness Programs",
    slug: "kimberlee-m-swartz",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kim",
    lastName: "Swartz",
    title: "Systems Support Consultant",
    slug: "kim-swartz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jocelyn Caimile",
    lastName: "Swavy",
    title:
      " Distance Learning Programs Co-Coordinator - Center for Transformative Action - Prisoner's Express (Gary Fine)",
    slug: "jocelyn-caimile-swavy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jeffrey Thomas",
    lastName: "Swayze",
    title: "Customer Srv. Rep",
    slug: "jeffrey-thomas-swayze",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sandy L.",
    lastName: "Sweazey",
    title: "Financial Services Manager",
    slug: "sandy-l-sweazey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Melinda S.",
    lastName: "Sweazey",
    title: "Purchasing Agent III",
    slug: "melinda-s-sweazey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erin King",
    lastName: "Sweeney",
    title: "Senior Associate Director",
    slug: "erin-king-sweeney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa",
    lastName: "Sweeney",
    title: "Lead Web Designer",
    slug: "melissa-sweeney",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Wendy L",
    lastName: "Sweeney",
    title: "Financial Transaction Representative",
    slug: "wendy-l-sweeney",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Heather Mistral",
    lastName: "Sweeney",
    title: "Applications Developer III",
    slug: "heather-mistral-sweeney",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christopher",
    lastName: "Sweet",
    title:
      " Technical Assistance & Outreach Specialist / Social Media Coordinator",
    slug: "christopher-sweet",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michael J.",
    lastName: "Swenson",
    title: "Project Manager",
    slug: "michael-j-swenson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Molly C.",
    lastName: "Swertfager",
    title: "Interim Benefits Liaison",
    slug: "molly-c-swertfager",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jackie",
    lastName: "Swift",
    title: "Communication Spec II",
    slug: "jackie-swift",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ellice",
    lastName: "Switzer",
    title: "Program Director, Inclusive Workplaces",
    slug: "ellice-switzer",
    dei: true,
    category: "Miscellaneous",
  },
  {
    firstName: "Bella Grace",
    lastName: "Swope",
    title: "Intramural Sports Student Supervisor",
    slug: "bella-grace-swope",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Shannon",
    lastName: "Sy",
    title: "Assistant Director, Asian & Asian America Resource Center",
    slug: "shannon-sy",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Celia",
    lastName: "Szczepura",
    title: "Department Manager– Cross-College Department of Psychology",
    slug: "celia-szczepura",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tivadar",
    lastName: "Szegletes",
    title: "Associate Dean for Finance and Administration",
    slug: "tivadar-szegletes",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kim A.",
    lastName: "Szpiro",
    title: "Associate Director of the Hanga Ahazaza Initiative",
    slug: "kim-a-szpiro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erika",
    lastName: "Talaba-Axe",
    title: "Assistant Director, Alumni Engagement",
    slug: "erika-talaba-axe",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Veronica Buezo",
    lastName: "Talavera",
    title: "Manager of Creative Content",
    slug: "veronica-buezo-talavera",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer L.",
    lastName: "Talcott",
    title: "Sr. Assistant Director, Funds Management",
    slug: "jennifer-l-talcott",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "William",
    lastName: "Talmadge",
    title: "Strategic Initiatives Lead",
    slug: "william-talmadge",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alyssa",
    lastName: "Talvi",
    title: "Associate Director, Tatkon Center for New Students",
    slug: "alyssa-talvi",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jeffrey",
    lastName: "Tamburo",
    title: "Training and Content Development Associate",
    slug: "jeffrey-tamburo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Pamela",
    lastName: "Tan",
    title: "Director, Undergraduate Admissions Office",
    slug: "pamela-tan",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "James",
    lastName: "Tanaka",
    title: "Lab Manager",
    slug: "james-tanaka",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adam Xianmei",
    lastName: "Tang",
    title: "ILR Course Assistant IV (Homrighouse)",
    slug: "adam-xianmei-tang",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kit Helene",
    lastName: "Tannenbaum",
    title: "Assistant Financial Specialist",
    slug: "kit-helene-tannenbaum",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christine Laurel",
    lastName: "Tanner",
    title: "Coord Program II",
    slug: "christine-laurel-tanner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wilson M.",
    lastName: "Tarbert",
    title: "Director of General Accounting",
    slug: "wilson-m-tarbert",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alison",
    lastName: "Taren",
    title: "Marketing Project Management and Communications Specialist",
    slug: "alison-taren",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elizabeth R",
    lastName: "Tarshis",
    title: "Associate Director, Product Management",
    slug: "elizabeth-r-tarshis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cindy",
    lastName: "Tarter",
    title: "Senior Associate Director of Education Abroad",
    slug: "cindy-tarter",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marybeth",
    lastName: "Tarzian",
    title: "Major GIft Officer IV",
    slug: "marybeth-tarzian",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Whitney",
    lastName: "Tassie",
    title: "Grants & Awards Program Lead",
    slug: "whitney-tassie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Megan",
    lastName: "Tate",
    title: "Radiation Therapist",
    slug: "megan-tate",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Justin",
    lastName: "Taveras",
    title:
      " SSAS Olivia Murray's Student Admin Asst I, Student Admin Asst I-OADI, Student Admin Asst I",
    slug: "justin-taveras",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Will",
    lastName: "Tay",
    title: "Program Assistant",
    slug: "will-tay",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marie A.",
    lastName: "Taylor",
    title: "Senior Associate General Counsel",
    slug: "marie-a-taylor",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Laura",
    lastName: "Taylor",
    title: "Director of International Services",
    slug: "laura-taylor",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jennifer Lynn",
    lastName: "Taylor",
    title: "Community Response Coordinator",
    slug: "jennifer-lynn-taylor",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kathryn T",
    lastName: "Taylor",
    title: "Associate Director of Advising",
    slug: "kathryn-t-taylor",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Aaliyah",
    lastName: "Taylor",
    title: "ACC Tutor",
    slug: "aaliyah-taylor",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "George",
    lastName: "Taylor",
    title: "Financial Transaction Representative",
    slug: "george-taylor",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Garrett C",
    lastName: "Taylor",
    title: "Bulletin 24/25",
    slug: "garrett-c-taylor",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sean C.",
    lastName: "Taylor",
    title: "AV Technology Specialist",
    slug: "sean-c-taylor",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cheryl",
    lastName: "Teare",
    title: "Senior Labor Relations Associate",
    slug: "cheryl-teare",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Emily Grace",
    lastName: "Teator",
    title: "Principal Gift Associate",
    slug: "emily-grace-teator",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Charlie Arthur",
    lastName: "Tebbutt",
    title: "GRA",
    slug: "charlie-arthur-tebbutt",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Camila Isabel",
    lastName: "Tedesco",
    title: "(Riccio) Art Studio Monitor",
    slug: "camila-isabel-tedesco",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Brenda S.",
    lastName: "Teeter",
    title: "Major Gifts Ofcr III",
    slug: "brenda-s-teeter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gavin",
    lastName: "Teeter",
    title:
      " Administrative Assistant for Student and Campus Life/Athletics and Physical Education",
    slug: "gavin-teeter",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kari",
    lastName: "Teeter",
    title: "Evening and Weekend Supervisor",
    slug: "kari-teeter",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nader",
    lastName: "Tehrani",
    title: "Gensler Visiting Critic",
    slug: "nader-tehrani",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anna Olegovna",
    lastName: "Temchenko",
    title: "Bulletin Fall 2024",
    slug: "anna-olegovna-temchenko",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Joyce",
    lastName: "Teng",
    title:
      " Administrative Assistant - Center for Transformative Action - NAFSN (Kim Hines)",
    slug: "joyce-teng",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacqulyn",
    lastName: "Teoh",
    title: "Acquisitions Editor",
    slug: "jacqulyn-teoh",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Marcus J",
    lastName: "Terry",
    title: "Video Producer, Live Streaming",
    slug: "marcus-j-terry",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Martin",
    lastName: "Teschl",
    title: "TEC Director, Physical Sciences",
    slug: "martin-teschl",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elizabeth",
    lastName: "Teskey",
    title: "Collections & Communications Associate",
    slug: "elizabeth-teskey",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kristin",
    lastName: "Tewksbury",
    title: "Assistant Registrar, Curriculum and Scheduling",
    slug: "kristin-tewksbury",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anthony Patrick",
    lastName: "Thai",
    title: "Senior Investment Officer",
    slug: "anthony-patrick-thai",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Peter David",
    lastName: "Thais",
    title: "CALS - AIISP Ambassador",
    slug: "peter-david-thais",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Verne",
    lastName: "Thalheimer",
    title: "Associate Director, Cornell Atkinson",
    slug: "verne-thalheimer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Theodore",
    lastName: "Thannhauser",
    title: "Scient Visit",
    slug: "theodore-thannhauser",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lynn M.",
    lastName: "Thitchener",
    title: "Research & Instruction Librarian and Liaison, Dept. of Government",
    slug: "lynn-m-thitchener",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jackson",
    lastName: "Thoby",
    title: "Administrative Assistant",
    slug: "jackson-thoby",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kim",
    lastName: "Tholen",
    title: "Billing Coordinator Specialist",
    slug: "kim-tholen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brandon",
    lastName: "Thomas",
    title: "Principal Gifts Associate",
    slug: "brandon-thomas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Bini",
    lastName: "Thomas",
    title: "Learning Systems and Project Manager",
    slug: "bini-thomas",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Luke",
    lastName: "Thomas",
    title: "Industrial Hygienist",
    slug: "luke-thomas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bez",
    lastName: "Thomas",
    title: "Network/Systems Administrator",
    slug: "bez-thomas",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michelle Sue",
    lastName: "Thomas",
    title: "Financial Transaction Representative",
    slug: "michelle-sue-thomas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kathleen",
    lastName: "Thomas",
    title: "Communications Assistant V",
    slug: "kathleen-thomas",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Benjamin W.",
    lastName: "Thomas",
    title: "Applications Developer IV",
    slug: "benjamin-w-thomas",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lucas Adam",
    lastName: "Thomas",
    title: "Mech Vehicle S10",
    slug: "lucas-adam-thomas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa Ann",
    lastName: "Thomas",
    title: "Special Events Coordinator",
    slug: "lisa-ann-thomas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joy A.",
    lastName: "Thomas",
    title: "ILS Borrowing Coordinator",
    slug: "joy-a-thomas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Malcolm",
    lastName: "Thomas",
    title: "Electron Microscopy Facility Manager",
    slug: "malcolm-thomas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristie",
    lastName: "Thompson",
    title: "Classification/Compensation Specialist",
    slug: "kristie-thompson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Cindy Lu",
    lastName: "Thompson",
    title: "Exec Staff Asst II",
    slug: "cindy-lu-thompson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tracey",
    lastName: "Thompson",
    title: "College Registrar",
    slug: "tracey-thompson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jennifer",
    lastName: "Thompson",
    title: "HMRU Manager",
    slug: "jennifer-thompson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Pilar A. Villablanca",
    lastName: "Thompson",
    title: "Director of International Affairs and Professional Services",
    slug: "pilar-a-villablanca-thompson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Terry",
    lastName: "Thompson",
    title: "College Registrar",
    slug: "terry-thompson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sherry L.",
    lastName: "Thompson",
    title: "Financial Services Manager",
    slug: "sherry-l-thompson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "E. Christine",
    lastName: "Thompson",
    title: "Associate Director for Diversity",
    slug: "e-christine-thompson",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Lesley D.",
    lastName: "Thompson",
    title: "Mgr Finance I",
    slug: "lesley-d-thompson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nina",
    lastName: "Thompson",
    title: "Educational Programs Manager",
    slug: "nina-thompson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Denise M.",
    lastName: "Thompson",
    title: "Assistant Director of Off-Campus Living",
    slug: "denise-m-thompson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Melaina M",
    lastName: "Thompson",
    title:
      " (Reiser) - AAP Office of Admissions Tour Guide, (Riccio) Art Studio Monitor",
    slug: "melaina-m-thompson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Lorie Ann",
    lastName: "Thompson",
    title: "IT Service Support Specialist",
    slug: "lorie-ann-thompson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tori",
    lastName: "Thompson",
    title: "IT Service Support Specialist",
    slug: "tori-thompson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nathan Christopher",
    lastName: "Thompson",
    title: "Milk Plant Worker S07",
    slug: "nathan-christopher-thompson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maggie",
    lastName: "Thompson",
    title: "Enrollment Counselor I",
    slug: "maggie-thompson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Wendy F.",
    lastName: "Thompson",
    title: "Reserves Coordinator and Signage Designer",
    slug: "wendy-f-thompson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eileen Mary Galinski",
    lastName: "Thrall",
    title: "Director of Development, Law",
    slug: "eileen-mary-galinski-thrall",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Teresa M.",
    lastName: "Thresher-Oplinger",
    title: "Senior Conference and Events Planner",
    slug: "teresa-m-thresher-oplinger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "NICOLE",
    lastName: "THRONE",
    title: "Greenhouse and Grounds Lead Coordinator",
    slug: "nicole-throne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julie L.",
    lastName: "Tibbits",
    title: "Budget and Reporting Manager",
    slug: "julie-l-tibbits",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Susan E.",
    lastName: "Tierney",
    title: "Associate Director, Prospect Research",
    slug: "susan-e-tierney",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brian Patrick",
    lastName: "Tierney",
    title: "Emergency Light / Fire Extinguisher Inspector",
    slug: "brian-patrick-tierney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer Sarah",
    lastName: "Tiffany",
    title: "Dir, Outreach & Commun Engagem",
    slug: "jennifer-sarah-tiffany",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kayla Michelle",
    lastName: "Tifft",
    title: "Client Experience Coordinator",
    slug: "kayla-michelle-tifft",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Robin",
    lastName: "Tilling",
    title: "Accounts Coordinator",
    slug: "robin-tilling",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kelly L.",
    lastName: "Tillotson",
    title: "Exec Staff Asst II",
    slug: "kelly-l-tillotson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nancy L.",
    lastName: "Tillotson",
    title: "Accounts Rep",
    slug: "nancy-l-tillotson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Anja I.G.",
    lastName: "Timm",
    title: "Administrative Assistant / Communications Coordinator",
    slug: "anja-i-g-timm",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Joshua William",
    lastName: "Tincher",
    title: "ACC Tutor - IYB (Johara Malcolm)",
    slug: "joshua-william-tincher",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jenny Marie",
    lastName: "Tindall",
    title: "Program Manager",
    slug: "jenny-marie-tindall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nazrin",
    lastName: "Tingstrom",
    title: "Web Developer",
    slug: "nazrin-tingstrom",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Aurora T.",
    lastName: "Tivey",
    title: "Mental Health Access & Referral Specialist",
    slug: "aurora-t-tivey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Janessa",
    lastName: "Tkachuk",
    title: "Casual Online Learning Technical Support Agent",
    slug: "janessa-tkachuk",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brooke L",
    lastName: "Tobey",
    title: "School Registrar, SC Johnson Graduate School of Management",
    slug: "brooke-l-tobey",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Starr",
    lastName: "Todd",
    title: "Associate Director for Strategic Communications",
    slug: "starr-todd",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer Gioffre",
    lastName: "Todd",
    title: "Manager of Art Studios",
    slug: "jennifer-gioffre-todd",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rhonda R",
    lastName: "Todd",
    title:
      " Director of Student Success Navigators and Pathway Development Programs",
    slug: "rhonda-r-todd",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Leigh Martino",
    lastName: "Toerper",
    title: "Manager of Innovation Communications",
    slug: "leigh-martino-toerper",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "David M.",
    lastName: "Tofano",
    title: "Manager of Training & Service Quality",
    slug: "david-m-tofano",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Marina",
    lastName: "Tokman",
    title: "Assistant Director for Learning Technologies",
    slug: "marina-tokman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Juleah Faye",
    lastName: "Tolosky",
    title: "NY FFA Director",
    slug: "juleah-faye-tolosky",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bruce",
    lastName: "Toman",
    title: "Technology Transactions Associate and MTA Coordinator",
    slug: "bruce-toman",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Robert Charles",
    lastName: "Tomasetti",
    title: "Equipment Tech V",
    slug: "robert-charles-tomasetti",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ryan M.",
    lastName: "Tomchick",
    title: "New York State Paid Family Leave Claims Associate",
    slug: "ryan-m-tomchick",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michael Andrew",
    lastName: "Tomlan",
    title: "Prof/Dir, Hist Preserv Prog",
    slug: "michael-andrew-tomlan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joseph",
    lastName: "Tompkins",
    title: "Ithaca Branch Store Manager",
    slug: "joseph-tompkins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melanie S.",
    lastName: "Toms",
    title: "Financial Aid Services Assistant IV",
    slug: "melanie-s-toms",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kaley",
    lastName: "Tomsic",
    title: "Email Marketing Specialist",
    slug: "kaley-tomsic",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Matt",
    lastName: "Toner",
    title: "Brand and Creative Specialist",
    slug: "matt-toner",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Wenfei",
    lastName: "Tong",
    title: "Science Editor",
    slug: "wenfei-tong",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Hannah Claire",
    lastName: "Toombs",
    title: "Engaged Learning Librarian, Olin & Uris Libraries",
    slug: "hannah-claire-toombs",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shayna Danielle",
    lastName: "Toomey",
    title: "Financial Transaction Representative",
    slug: "shayna-danielle-toomey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marike Bradford",
    lastName: "Toothaker",
    title: "Major Gifts Officer",
    slug: "marike-bradford-toothaker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sienna L.",
    lastName: "Torbitt",
    title: "Administrative Lead",
    slug: "sienna-l-torbitt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alix Hoffstaetter de",
    lastName: "Torquat",
    title: "Assistant Dean for Communications",
    slug: "alix-hoffstaetter-de-torquat",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Aleyda",
    lastName: "Toruno",
    title: "Work Incentives Associate",
    slug: "aleyda-toruno",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Melissa L.",
    lastName: "Totman",
    title: "Administrative Manager",
    slug: "melissa-l-totman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Monica A.",
    lastName: "Touesnard",
    title: "Executive Director, Center for Sustainable Global Enterprise",
    slug: "monica-a-touesnard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Liliana",
    lastName: "Tovar",
    title: "Enrollment Counselor I",
    slug: "liliana-tovar",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Molly A.",
    lastName: "Towne",
    title: "Project Manager",
    slug: "molly-a-towne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katelyn",
    lastName: "Towner",
    title: "CHESS User Office Manager",
    slug: "katelyn-towner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica E.",
    lastName: "Townley",
    title: "Human Resources Asst V",
    slug: "jessica-e-townley",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Mimi",
    lastName: "Townsend",
    title: "Project Manager, Staff and Labor Relations",
    slug: "mimi-townsend",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Dylan",
    lastName: "Townsend",
    title: "Enterprise Services – System Administrator",
    slug: "dylan-townsend",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mary",
    lastName: "Townson",
    title: "Emergency Services Specialist",
    slug: "mary-townson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mike",
    lastName: "Tracy",
    title: "Solutions Architect",
    slug: "mike-tracy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael A.",
    lastName: "Tracy",
    title: "Applications Developer III",
    slug: "michael-a-tracy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Fiona Rose",
    lastName: "Tracy",
    title: "Program Assistant, Upward Bound",
    slug: "fiona-rose-tracy",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Angela",
    lastName: "Tracy",
    title: "Associate Director of Annual Giving",
    slug: "angela-tracy",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Chris",
    lastName: "Tracy",
    title: "Multimedia Producer - Live Stream",
    slug: "chris-tracy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Devin E.",
    lastName: "Trammell",
    title: "Enrollment Manager",
    slug: "devin-e-trammell",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Aly",
    lastName: "Traore",
    title: "Mech Vehicle S05",
    slug: "aly-traore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lori",
    lastName: "Trask",
    title: "Administrative Manager",
    slug: "lori-trask",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen",
    lastName: "Trask",
    title: "Meal Plan Coordinator",
    slug: "karen-trask",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Carrie Ann",
    lastName: "Travers",
    title: "Client Service Representitive",
    slug: "carrie-ann-travers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paul",
    lastName: "Treadwell",
    title: "Instructional Tech Spec III",
    slug: "paul-treadwell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dominic",
    lastName: "Tribelli",
    title: "Associate Director of Advising",
    slug: "dominic-tribelli",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Antonella",
    lastName: "Triforo",
    title: "Director, Corporate Programs",
    slug: "antonella-triforo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julie",
    lastName: "Trimble",
    title: "Stewardship Officer, Donor Recognition",
    slug: "julie-trimble",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kylie",
    lastName: "Triolo",
    title: "Financial Transaction Representative",
    slug: "kylie-triolo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Denise Jean",
    lastName: "Trondsen",
    title: "Sr. Program Manager",
    slug: "denise-jean-trondsen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robin",
    lastName: "Tropper-Herbel",
    title: "Grant Coordinator",
    slug: "robin-tropper-herbel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anneliese M.",
    lastName: "Truame",
    title: "Administrative Manager",
    slug: "anneliese-m-truame",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Matthew Michael",
    lastName: "Trudeau",
    title: "Sheet Metal Worker",
    slug: "matthew-michael-trudeau",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brenda",
    lastName: "Truesdail",
    title: "Grant and Contract Officer",
    slug: "brenda-truesdail",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lisa L.",
    lastName: "Trust",
    title: "Visitor Services Coordinator",
    slug: "lisa-l-trust",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thomas I.",
    lastName: "Trutt",
    title: "FOLIO Application Manager",
    slug: "thomas-i-trutt",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Matthew",
    lastName: "Tsang",
    title: "Salesforce Technical Lead",
    slug: "matthew-tsang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tenzin",
    lastName: "Tsokyi",
    title: "Orders Specialist",
    slug: "tenzin-tsokyi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Albert Y",
    lastName: "Tsui",
    title: "Plant Portfolio Officer",
    slug: "albert-y-tsui",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nick",
    lastName: "Tubbs",
    title: "Applications and Web Development Manager",
    slug: "nick-tubbs",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael Thomas",
    lastName: "Tubbs",
    title: "Preventative Maintenance Planner",
    slug: "michael-thomas-tubbs",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leah Catherine",
    lastName: "Tuck",
    title: "Director of Development, Atkinson",
    slug: "leah-catherine-tuck",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cole M.",
    lastName: "Tucker",
    title: "Director of Utilities Distribution and Energy Management",
    slug: "cole-m-tucker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca",
    lastName: "Tucker",
    title: "Director of Administration, AEP/LPS",
    slug: "rebecca-tucker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peggy",
    lastName: "Tully",
    title: "Manager of Space and Long-Range Planning",
    slug: "peggy-tully",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sydni Lin",
    lastName: "Tung",
    title: "East Asia Program Administrative Assistant",
    slug: "sydni-lin-tung",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Trent",
    lastName: "Tunnicliff",
    title: "Senior PeopleSoft Developer",
    slug: "trent-tunnicliff",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kim",
    lastName: "Tunstall",
    title: "Enrollment Counselor II",
    slug: "kim-tunstall",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Daniela",
    lastName: "Turcanu",
    title: "Financial Transaction Representative",
    slug: "daniela-turcanu",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Andrew Ryan",
    lastName: "Turker",
    title: "Associate Athletics Director, Compliance",
    slug: "andrew-ryan-turker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrea J.",
    lastName: "Turnbull",
    title: "Program Manager",
    slug: "andrea-j-turnbull",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andy",
    lastName: "Turner",
    title: "Dean Assoc, 4-H Youth Development Director, Dir Acad",
    slug: "andy-turner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Wendy R.",
    lastName: "Turner",
    title: "Administrative Coordinator for Building Care",
    slug: "wendy-r-turner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ben Scott",
    lastName: "Turner",
    title: "Lifeguard",
    slug: "ben-scott-turner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dr Joshua E.",
    lastName: "Turse",
    title: "Director of Research Safety",
    slug: "dr-joshua-e-turse",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Krissia Raiann",
    lastName: "Tuzroyluk",
    title: "CALS - AIISP Ambassador",
    slug: "krissia-raiann-tuzroyluk",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lisa B.",
    lastName: "Tvaroha",
    title: "Director, CVM Accounting Service Center",
    slug: "lisa-b-tvaroha",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cindy",
    lastName: "Twardokus",
    title: "Administrator II",
    slug: "cindy-twardokus",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura Alliance",
    lastName: "Twizere",
    title: "CDP Facilitator",
    slug: "laura-alliance-twizere",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christina",
    lastName: "Twomey",
    title: "Administrative Assistant, Administration, Finance & HR",
    slug: "christina-twomey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeff",
    lastName: "Tyson",
    title: "Communications Strategist",
    slug: "jeff-tyson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "David de Rivera",
    lastName: "Tønnessen",
    title: "Merlin Datasets Coordinator",
    slug: "david-de-rivera-t-nnessen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anna-Marie",
    lastName: "U.",
    title: "Enrollment Counselor I",
    slug: "anna-marie-u",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Karen",
    lastName: "Uber",
    title: "Clery Compliance Associate",
    slug: "karen-uber",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "John Edward",
    lastName: "Uber",
    title: "Head Table Staff/Official",
    slug: "john-edward-uber",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Masayo",
    lastName: "Uchiyama",
    title: "Print Ordering Coordinator",
    slug: "masayo-uchiyama",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Timur",
    lastName: "Uckun",
    title: "Director, IT Audit",
    slug: "timur-uckun",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nneoma Sharon",
    lastName: "Udoyeh",
    title: "Admin Asst Dyson Dean's Office",
    slug: "nneoma-sharon-udoyeh",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Hassan",
    lastName: "Ukasha",
    title: "Translator - Clinics",
    slug: "hassan-ukasha",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Risa Noelle",
    lastName: "Ulinski",
    title: "Public Services Assistant",
    slug: "risa-noelle-ulinski",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Emily",
    lastName: "Ullrich",
    title: "Illustrator",
    slug: "emily-ullrich",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christina",
    lastName: "Ulrich",
    title: "AIS Project Coordinator",
    slug: "christina-ulrich",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tristan",
    lastName: "Umeda",
    title: "eCornell Casual Student Support Agent",
    slug: "tristan-umeda",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Beth M.",
    lastName: "Underwood",
    title: "Accounts Rep IV",
    slug: "beth-m-underwood",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Luke",
    lastName: "Urbain",
    title: "Program Manager, Latin American and Caribbean Studies",
    slug: "luke-urbain",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "ROXANA",
    lastName: "USTUROI",
    title: "SIPS Appointments Coordinator",
    slug: "roxana-usturoi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca M.",
    lastName: "Utz",
    title: "Electronic Resources Specialist",
    slug: "rebecca-m-utz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Erik",
    lastName: "Uy",
    title: "Integrations and Data Delivery Consultant",
    slug: "erik-uy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Judith Emetarom",
    lastName: "Uyanne",
    title: "Becker House Office Assistant",
    slug: "judith-emetarom-uyanne",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "John Lewis Dawson",
    lastName: "V",
    title: "Building Manager",
    slug: "john-lewis-dawson-v",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle Jennifer",
    lastName: "Vaeth",
    title: "Associate Vice President, Alumni Affairs",
    slug: "michelle-jennifer-vaeth",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Drew Aliyah",
    lastName: "Valentine",
    title: "DEIB Student Experience Specialist, e-Cornell Course Facilitator",
    slug: "drew-aliyah-valentine",
    dei: true,
    category: "Miscellaneous",
  },
  {
    firstName: "Justin A",
    lastName: "Valentine",
    title: "Athletic Trainer",
    slug: "justin-a-valentine",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Richard Paul",
    lastName: "Valetutto",
    title: "Systems Support Specialist",
    slug: "richard-paul-valetutto",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Larry Van De",
    lastName: "Valk",
    title: "Director, LEAD NY",
    slug: "larry-van-de-valk",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aiden John-Barak",
    lastName: "Vallecillo",
    title: "SCR Summer School Assistant IV (Bronfenbrenner)",
    slug: "aiden-john-barak-vallecillo",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Maria Leonor",
    lastName: "Vallejo-Nguyen",
    title: "Executive Director, Northeast Corridor and Discovery",
    slug: "maria-leonor-vallejo-nguyen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kim",
    lastName: "Vallequette",
    title: "Accounting Transaction Specialist",
    slug: "kim-vallequette",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rebecca",
    lastName: "Valli",
    title: "Senior Director of Media Relations",
    slug: "rebecca-valli",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ubaldo Dante",
    lastName: "Valli",
    title: "Stacks Management Assistant",
    slug: "ubaldo-dante-valli",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kimberly",
    lastName: "Vallée",
    title: "Administrative Coordinator, Cornell AAD",
    slug: "kimberly-vall-e",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Linda J. Le",
    lastName: "Van",
    title: "Executive Staff Assistant",
    slug: "linda-j-le-van",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer M.",
    lastName: "VanAtta",
    title: "Business Minors Manager",
    slug: "jennifer-m-vanatta",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sharon Marie",
    lastName: "VanDeMark",
    title: "HR Generalist II",
    slug: "sharon-marie-vandemark",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Curtis A.",
    lastName: "Vanderbilt",
    title: "Mason",
    slug: "curtis-a-vanderbilt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rob",
    lastName: "Vanderlan",
    title: "Executive Director of the Center for Teaching Innovation",
    slug: "rob-vanderlan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David",
    lastName: "Vanderpoorten",
    title: "Assistant Director of Facilites",
    slug: "david-vanderpoorten",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cynthia Lynn",
    lastName: "VandeWall",
    title: "Research Administration Assistant",
    slug: "cynthia-lynn-vandewall",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Steven A.",
    lastName: "VanDeWeert",
    title: "Drafter III",
    slug: "steven-a-vandeweert",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Patti L.",
    lastName: "VanDeWeert",
    title: "Housekeeping Manager",
    slug: "patti-l-vandeweert",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William R.",
    lastName: "VanDusen",
    title: "Sheet Metal Worker",
    slug: "william-r-vandusen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James I.",
    lastName: "Vanee",
    title: "Associate Director, Biotechnology Resource Center",
    slug: "james-i-vanee",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jana",
    lastName: "VanHouten",
    title: "Administrative Asst V",
    slug: "jana-vanhouten",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amelia Rose",
    lastName: "VanKing",
    title: "Division of Financial Affairs Receptionist/Administrative Support",
    slug: "amelia-rose-vanking",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kristen",
    lastName: "VanNoord",
    title: "Enrollment Counselor II",
    slug: "kristen-vannoord",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kimberly",
    lastName: "VanNorman",
    title: "Counselor Therapist, LGBTQ+ Community Liaison",
    slug: "kimberly-vannorman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amber Rafferty",
    lastName: "VanNostrand",
    title: "Educational Materials Specialist",
    slug: "amber-rafferty-vannostrand",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cindy S.",
    lastName: "Vanostrand",
    title: "Administrative Asst IV",
    slug: "cindy-s-vanostrand",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joyce",
    lastName: "Vansant",
    title: "Administrative Asst IV",
    slug: "joyce-vansant",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edgar E.",
    lastName: "VanScoy",
    title: "Senior Pre-award Specialist",
    slug: "edgar-e-vanscoy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lindsey",
    lastName: "Vargo",
    title: "Administrative Assistant, Dean's Office",
    slug: "lindsey-vargo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shan",
    lastName: "Varma",
    title: "SCL Director of Human Resources",
    slug: "shan-varma",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Donica Thomas",
    lastName: "Varner",
    title: "Vice President and General Counsel",
    slug: "donica-thomas-varner",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Alexa R.",
    lastName: "Varricchio",
    title: "Purchasing Agent II",
    slug: "alexa-r-varricchio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susi",
    lastName: "Varvayanis",
    title: "Executive Director, Careers Beyond Academia",
    slug: "susi-varvayanis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kacie L.",
    lastName: "Vasicek",
    title: "Program Assistant II",
    slug: "kacie-l-vasicek",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria",
    lastName: "Vasilkin",
    title: "Applications Developer III",
    slug: "maria-vasilkin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chris",
    lastName: "Vatland",
    title: "Data Associate",
    slug: "chris-vatland",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kim M",
    lastName: "Vaughan",
    title: "Gift Processing Assistant IV",
    slug: "kim-m-vaughan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Walt J.",
    lastName: "Vavra",
    title: "Training Specialist",
    slug: "walt-j-vavra",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Juan",
    lastName: "Vazquez-Leddon",
    title: "Communication Spec II",
    slug: "juan-vazquez-leddon",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Vico",
    lastName: "Vecchiotti",
    title: "Administrative Assistant III",
    slug: "vico-vecchiotti",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ana Karina",
    lastName: "Vega",
    title: "Human Resources Associate",
    slug: "ana-karina-vega",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Tina Elizabeth",
    lastName: "Vega",
    title: "Purchasing Agent II",
    slug: "tina-elizabeth-vega",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jon",
    lastName: "Velazquez",
    title: "Director of Instructional Labs",
    slug: "jon-velazquez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rhonda H.",
    lastName: "Velazquez",
    title: "Director, Student Activities & Special Events",
    slug: "rhonda-h-velazquez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Shawna",
    lastName: "Veldhuizen",
    title: "Gift Planning Associate",
    slug: "shawna-veldhuizen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Anahita",
    lastName: "Verahrami",
    title: "Leadership Communications Specialist",
    slug: "anahita-verahrami",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Daniela",
    lastName: "Vergara",
    title: "Emerging Crops Specialist",
    slug: "daniela-vergara",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "R. David",
    lastName: "Vernon",
    title: "Assistant VP and CTO",
    slug: "r-david-vernon",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Casandra",
    lastName: "Vernon",
    title:
      " Administrative Assistant, CAU, Alumni Travel and Alumni Wine Programs",
    slug: "casandra-vernon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather",
    lastName: "VerSchneider",
    title: "Salesforce Administrator",
    slug: "heather-verschneider",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ursula",
    lastName: "Vesala",
    title: "Director of Development, West Coast",
    slug: "ursula-vesala",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alex Cristian",
    lastName: "Vidinas",
    title: "PMA 2800",
    slug: "alex-cristian-vidinas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Luiz Paulo De Carvalho",
    lastName: "Vieira",
    title: "Lead Finance Specialist",
    slug: "luiz-paulo-de-carvalho-vieira",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lars",
    lastName: "Vilhuber",
    title: "Executive Director",
    slug: "lars-vilhuber",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dan",
    lastName: "Villanti",
    title: "IT Security Solutions Architect",
    slug: "dan-villanti",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jarrett C.",
    lastName: "Villines",
    title: "Public Services Assistant",
    slug: "jarrett-c-villines",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Seetharaman",
    lastName: "Vinayagam",
    title: "Building/Facility Coordinator",
    slug: "seetharaman-vinayagam",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael L.",
    lastName: "Vincent",
    title: "Director, Corporate Programs (Custom Live)",
    slug: "michael-l-vincent",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lisa Ann",
    lastName: "Vinson",
    title: "Associate Director of Alumni Affairs",
    slug: "lisa-ann-vinson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kina",
    lastName: "Viola",
    title: "Program Manager",
    slug: "kina-viola",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth Caughey",
    lastName: "Violette",
    title: "Associate Director of CPEP Student Services",
    slug: "elizabeth-caughey-violette",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Caroline",
    lastName: "Virani",
    title: "Program Manager, Break Through Tech",
    slug: "caroline-virani",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Megan Beth",
    lastName: "Vitale",
    title: "Administrative Assistant, Athletic Admissions",
    slug: "megan-beth-vitale",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sharon Catherine",
    lastName: "Vitello",
    title: "Project Administrative Assistant",
    slug: "sharon-catherine-vitello",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kate",
    lastName: "Vitti",
    title: "Associate Director of Project Solutions & Partnerships",
    slug: "kate-vitti",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica A",
    lastName: "Vitucci",
    title: "Major Gifts Officer, Cornell SC Johnson College of Business",
    slug: "jessica-a-vitucci",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elena E.",
    lastName: "Viviano",
    title: "Financial & Sponsored Award Administrator",
    slug: "elena-e-viviano",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christos A.",
    lastName: "Vlahos",
    title: "Financial Transaction Representative",
    slug: "christos-a-vlahos",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alexander John",
    lastName: "Vlahov",
    title: "Publicist for the Cornell University Press",
    slug: "alexander-john-vlahov",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Bryan R.",
    lastName: "Vliet",
    title: "Director of Financial Aid",
    slug: "bryan-r-vliet",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Rebecca",
    lastName: "Vliet",
    title: "Assistant to the Directors",
    slug: "rebecca-vliet",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stacey",
    lastName: "Vojtisek",
    title: "Admissions Event Manager",
    slug: "stacey-vojtisek",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kristina Marie",
    lastName: "Volkert",
    title: "Program Support Specialist, Institute of Biotechnology",
    slug: "kristina-marie-volkert",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jill A.",
    lastName: "vonHahmann",
    title: "Learning Consultant, Supervisor",
    slug: "jill-a-vonhahmann",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jaimie",
    lastName: "Voorhees",
    title: "Events Coordinator",
    slug: "jaimie-voorhees",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scott",
    lastName: "Voss",
    title: "Associate Director of Student Behavior & Support",
    slug: "scott-voss",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Heather L.",
    lastName: "Vreeland",
    title: "Accounts Representative",
    slug: "heather-l-vreeland",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joseph J",
    lastName: "Vrooman",
    title: "Telecommunications Officer",
    slug: "joseph-j-vrooman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Patrick",
    lastName: "Vrooman",
    title: "Mech Vehicle S10",
    slug: "patrick-vrooman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tolkyn Aidarova",
    lastName: "Vuong",
    title: "Senior Financial & HR Associate (Rome/NYC)",
    slug: "tolkyn-aidarova-vuong",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gerrit",
    lastName: "Vyn",
    title: "Multimedia Specialist III",
    slug: "gerrit-vyn",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lilly Elizabeth Van",
    lastName: "Wagenen",
    title: "IDP Facilitator",
    slug: "lilly-elizabeth-van-wagenen",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "KC",
    lastName: "Wagner",
    title: "Chair, Equity at Work Initiative",
    slug: "kc-wagner",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Debora",
    lastName: "Wagner",
    title: "Work Incentives Associate, Income Benefits Program",
    slug: "debora-wagner",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sarah Katherine",
    lastName: "Wagner",
    title: "Lead Educator for Public Programs",
    slug: "sarah-katherine-wagner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tamara J.",
    lastName: "Wagner",
    title: "Enrollment Counselor II",
    slug: "tamara-j-wagner",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Joshua R.",
    lastName: "Wakeman",
    title: "Hazardous Materials Associate",
    slug: "joshua-r-wakeman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Donna L",
    lastName: "Wakeman",
    title: "Administrative Asst",
    slug: "donna-l-wakeman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zoe",
    lastName: "Wakoff",
    title: "Communication Spec III",
    slug: "zoe-wakoff",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Anthony",
    lastName: "Walburger",
    title: "Material Handler S07",
    slug: "anthony-walburger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shara",
    lastName: "Walden",
    title: "Coord Program I",
    slug: "shara-walden",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patricia",
    lastName: "Waldron",
    title:
      " Science Writer in the Ann S. Bowers College of Computing and Information Science",
    slug: "patricia-waldron",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Martha",
    lastName: "Walker",
    title: "Architecture Librarian and Coordinator of Collections",
    slug: "martha-walker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kizer S.",
    lastName: "Walker",
    title: "Director of Collections",
    slug: "kizer-s-walker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristin",
    lastName: "Walker",
    title: "Manager of Acad. Prog Review",
    slug: "kristin-walker",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Julie P.",
    lastName: "Walker",
    title: "Major Gifts Officer",
    slug: "julie-p-walker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shawn E.",
    lastName: "Walker",
    title: "Manager, Field Services",
    slug: "shawn-e-walker",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chloe",
    lastName: "Walker",
    title: "Wagner-Student Admin Asst III",
    slug: "chloe-walker",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lorie B.",
    lastName: "Walker",
    title: "Administrative Asst IV",
    slug: "lorie-b-walker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Megan Elisabeth",
    lastName: "Walker",
    title: "Senior Architect",
    slug: "megan-elisabeth-walker",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dennis",
    lastName: "Walker",
    title: "ACRefrig Mech/Plumb - GFP",
    slug: "dennis-walker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica",
    lastName: "Walker",
    title: "Housing Manager",
    slug: "jessica-walker",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Gary",
    lastName: "Walker",
    title: "Systems Administrator III",
    slug: "gary-walker",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Camille R",
    lastName: "Wallace",
    title: "Program Facilitation Manager, DEI",
    slug: "camille-r-wallace",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Ashley Keyonna",
    lastName: "Wallace",
    title: "Recreational Services Administrative Asst",
    slug: "ashley-keyonna-wallace",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Pete",
    lastName: "Wallin",
    title: "IT Support Specialist (Level 2)",
    slug: "pete-wallin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Debra Susan",
    lastName: "Walls",
    title: "Central Support Systems Coordinator",
    slug: "debra-susan-walls",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ellen G.",
    lastName: "Walsh",
    title: "Sr. Principal Gifts Officer",
    slug: "ellen-g-walsh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sean D.",
    lastName: "Walsh",
    title: "Service Delivery Manager",
    slug: "sean-d-walsh",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chad",
    lastName: "Walsh",
    title: "Administrative Asst II",
    slug: "chad-walsh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan",
    lastName: "Walter",
    title:
      " Executive Assistant to the Executive Director of Cornell Career Services",
    slug: "susan-walter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda",
    lastName: "Walter",
    title: "CALS Professional Programs Coordinator",
    slug: "amanda-walter",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nancy E",
    lastName: "Walter",
    title: "Accounts Coordinator",
    slug: "nancy-e-walter",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "M Scott",
    lastName: "Walters",
    title: "Video Conferencing and Streaming Service Manager",
    slug: "m-scott-walters",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "David V.",
    lastName: "Walters",
    title: "Material Handler S04",
    slug: "david-v-walters",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily",
    lastName: "Walton",
    title: "Associate Director, Communications",
    slug: "emily-walton",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Justin Lin",
    lastName: "Wan",
    title: "Intramural Official",
    slug: "justin-lin-wan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rania",
    lastName: "Wanandi",
    title: "CALS - Research/Lab Assistant (L. Drinkwater Lab)",
    slug: "rania-wanandi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jackie Lynn",
    lastName: "Wandell",
    title: "Executive Staff Assistant",
    slug: "jackie-lynn-wandell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Suntao",
    lastName: "Wang",
    title: "Res Assoc",
    slug: "suntao-wang",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ryan",
    lastName: "Wang",
    title: "AAP NYC - Photography Assistant, EMBA Alumni Summit Photographer",
    slug: "ryan-wang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zilu",
    lastName: "Wang",
    title: "Computational Consultant",
    slug: "zilu-wang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bryan",
    lastName: "Wang",
    title: "Engaged Ambassador, Student Acad Serv Asst II",
    slug: "bryan-wang",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Yufei",
    lastName: "Wang",
    title: "(Riccio) Art Studio Monitor",
    slug: "yufei-wang",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jonathan",
    lastName: "Wang",
    title: "Career Services Asst.",
    slug: "jonathan-wang",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Yixuan",
    lastName: "Wang",
    title: "Urban Tech Coordinator",
    slug: "yixuan-wang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Amanda M.",
    lastName: "Ward",
    title: "EARN Project Manager",
    slug: "amanda-m-ward",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah Midori",
    lastName: "Ward",
    title: "Technology Licensing Professional I",
    slug: "sarah-midori-ward",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ryan",
    lastName: "Ward",
    title: "Procurement Manager",
    slug: "ryan-ward",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deborah Tenema",
    lastName: "Ward",
    title: "Admissions Counselor",
    slug: "deborah-tenema-ward",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Christine",
    lastName: "Ward",
    title: "Senior Financial Aid Counselor",
    slug: "christine-ward",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Marian Levy",
    lastName: "Ware",
    title: "Director of Sales & Marketing",
    slug: "marian-levy-ware",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert M.",
    lastName: "Warfield",
    title: "Project Manager - PSUR Database Group",
    slug: "robert-m-warfield",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "David James",
    lastName: "Waring",
    title: "Database Administrator III",
    slug: "david-james-waring",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dawn M.",
    lastName: "Warren",
    title: "Administrative Assistant IV",
    slug: "dawn-m-warren",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sophia S",
    lastName: "Warren",
    title: "Dean's Assistant (Walsh), Career Services Asst.",
    slug: "sophia-s-warren",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Columbia J.",
    lastName: "Warren",
    title: "Grant Contract Ofcr II",
    slug: "columbia-j-warren",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Allison",
    lastName: "Washburn",
    title: "Human Resources Coordinator",
    slug: "allison-washburn",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Casey",
    lastName: "Washburn",
    title: "Associate University Registrar, Academic Services",
    slug: "casey-washburn",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Miesha Janel",
    lastName: "Washington",
    title: "Casual Online Learning Technical Support Agent",
    slug: "miesha-janel-washington",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bethany",
    lastName: "Wasik",
    title: "Acquisitions Editor",
    slug: "bethany-wasik",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lauren Christine",
    lastName: "Wasson",
    title: "Associate Director of Graduate Legal Studies Admissions",
    slug: "lauren-christine-wasson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Patricia",
    lastName: "Wasyliw",
    title: "Senior Associate DIrector",
    slug: "patricia-wasyliw",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mark C.",
    lastName: "Waterman",
    title: "Swimming Pool Treatment System Specialist",
    slug: "mark-c-waterman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Arienne",
    lastName: "Watson",
    title: "Associate Director, Northeast Corridor Engagement",
    slug: "arienne-watson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Daniel",
    lastName: "Watson",
    title: "Director of Development, Arts & Sciences",
    slug: "daniel-watson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Qiana",
    lastName: "Watson",
    title: "Counselor Therapist, First Generation/Low Income Community Liaison",
    slug: "qiana-watson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Stephanie",
    lastName: "Watt",
    title: "Assistant Director, Email Marketing",
    slug: "stephanie-watt",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Victoria A.",
    lastName: "Watts",
    title: "Executive Assistant to the Vice Provost",
    slug: "victoria-a-watts",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Zachary Lee",
    lastName: "Watts",
    title: "Assistant Director of Admissions",
    slug: "zachary-lee-watts",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Hakim",
    lastName: "Weatherspoon",
    title:
      " Associate Dean for Diversity, Equity, and Inclusion, Dir Assoc, Professor",
    slug: "hakim-weatherspoon",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Russell",
    lastName: "Weaver",
    title: "Director of Research",
    slug: "russell-weaver",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shannon",
    lastName: "Weber",
    title: "Bursar Account Services Representative",
    slug: "shannon-weber",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Drew",
    lastName: "Weber",
    title: "IT Project Manager III",
    slug: "drew-weber",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John L.",
    lastName: "Webster",
    title: "Director Athletics Major Gifts and Special Projects",
    slug: "john-l-webster",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jasmin",
    lastName: "Wehner",
    title: "Post Doctoral Associate",
    slug: "jasmin-wehner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jonathan (Jay)",
    lastName: "Wehrung",
    title: "Boathouse Facility Manager and Boatman",
    slug: "jonathan-jay-wehrung",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Weidner",
    title: "Salesforce Administrator",
    slug: "jennifer-weidner",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rachel",
    lastName: "Weinert",
    title: "Director of Enrollment Communications",
    slug: "rachel-weinert",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mary",
    lastName: "Weis",
    title: "Payroll and Student Employment Assistant",
    slug: "mary-weis",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jake",
    lastName: "Weiskoff",
    title: "Project Manager, arXiv",
    slug: "jake-weiskoff",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nancy C.",
    lastName: "Weislogel",
    title: "Director, Product Management",
    slug: "nancy-c-weislogel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Andrew",
    lastName: "Weislogel",
    title: "Curator, Earlier European Art",
    slug: "andrew-weislogel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephen C.",
    lastName: "Weismore",
    title: "Bldg/Facil Coord V",
    slug: "stephen-c-weismore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Haley",
    lastName: "Weiss",
    title: "Assistant Dean, Brook's School of Public Policy",
    slug: "haley-weiss",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Laura",
    lastName: "Weiss",
    title: "Program Director, SHARE Office",
    slug: "laura-weiss",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Karen",
    lastName: "Weiss",
    title: "Major Gifts Officer",
    slug: "karen-weiss",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Juliet Rothschild",
    lastName: "Weissman",
    title: "Chief Administrative Officer, Cornell Tech",
    slug: "juliet-rothschild-weissman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katherine Elizabeth",
    lastName: "Welch",
    title: "Mgr Sales Mktg",
    slug: "katherine-elizabeth-welch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nikki",
    lastName: "Wells",
    title: "Associate Director, Health Professions Advising",
    slug: "nikki-wells",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lindsay E.",
    lastName: "Welsh",
    title: "Exec Staff Asst II",
    slug: "lindsay-e-welsh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ben B.",
    lastName: "Wendel",
    title: "Associate Video Producer II",
    slug: "ben-b-wendel",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nicole",
    lastName: "Wendel-Crowe",
    title: "Residence Hall Director",
    slug: "nicole-wendel-crowe",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Seth Robert",
    lastName: "Wenrich",
    title: "Audio-Visual Installation Project Manager",
    slug: "seth-robert-wenrich",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lucas Jeremiah",
    lastName: "Wentworth",
    title:
      " Administrative Assistant for the Office of the University Librarian",
    slug: "lucas-jeremiah-wentworth",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Janis K.",
    lastName: "Werner",
    title: "Research Supp Spec I",
    slug: "janis-k-werner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Madison",
    lastName: "Werthmann",
    title: "Administrative Assistant, Office of the Dean",
    slug: "madison-werthmann",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lisa A.",
    lastName: "Wesche",
    title: "Senior Academic HR Business Partner",
    slug: "lisa-a-wesche",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michelle",
    lastName: "Wescott",
    title: "Director, Instructional Design",
    slug: "michelle-wescott",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "F Robert",
    lastName: "Wesley",
    title: "Natural Areas Manager and Botanist",
    slug: "f-robert-wesley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brendan Thomas",
    lastName: "West",
    title: "Administrative Asst IV",
    slug: "brendan-thomas-west",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa",
    lastName: "West",
    title: "HR Associate",
    slug: "melissa-west",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Audrey",
    lastName: "West",
    title: "Payroll and Leave Management Assistant",
    slug: "audrey-west",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Zoë",
    lastName: "West",
    title: "Worker Rights & Equity Associate",
    slug: "zo-west",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Elaine L.",
    lastName: "Westbrooks",
    title: "Carl A. Kroch University Librarian",
    slug: "elaine-l-westbrooks",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lisa",
    lastName: "Westcott",
    title: "Chair's Assistant",
    slug: "lisa-westcott",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Megan Elizabeth",
    lastName: "Westerberg",
    title: "Financial Transaction Representative",
    slug: "megan-elizabeth-westerberg",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Wayne A.",
    lastName: "Westmiller",
    title: "Fire Protection Specialist",
    slug: "wayne-a-westmiller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jaclene",
    lastName: "Weston",
    title: "Administrative Asst III",
    slug: "jaclene-weston",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aubrey",
    lastName: "Wetmore",
    title: "Administrative Asst III",
    slug: "aubrey-wetmore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Janice",
    lastName: "Wetzel",
    title: "Point of Care Testing Lab Supervisor",
    slug: "janice-wetzel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bert E",
    lastName: "Whalen",
    title: "HR Generalist III",
    slug: "bert-e-whalen",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jenelle",
    lastName: "Whalon",
    title: "Senior Tax Associate",
    slug: "jenelle-whalon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lauri H.",
    lastName: "Whatley",
    title: "Administrative Asst IV",
    slug: "lauri-h-whatley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mark R.",
    lastName: "Wheeler",
    title: "IT Division Manager",
    slug: "mark-r-wheeler",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Hannah",
    lastName: "Wheeler",
    title: "Assistant Supervisor",
    slug: "hannah-wheeler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sam",
    lastName: "Wheelwright",
    title: "AAD Program Assistant",
    slug: "sam-wheelwright",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Belinda Ann",
    lastName: "Whisman",
    title: "Graduate Coordinator",
    slug: "belinda-ann-whisman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "James L.",
    lastName: "Whitaker",
    title: "Associate Director of Enrollment",
    slug: "james-l-whitaker",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Anthony Scott",
    lastName: "Whitaker",
    title: "Emergency Services Specialist",
    slug: "anthony-scott-whitaker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew",
    lastName: "Whitaker",
    title: "Emergency Services Specialist",
    slug: "matthew-whitaker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Victoria",
    lastName: "White",
    title: "Project Manager, Office of the President",
    slug: "victoria-white",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christie",
    lastName: "White",
    title: "Equity and Title IX Investigator",
    slug: "christie-white",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Bruce",
    lastName: "White",
    title: "Assistant Manager of Finance",
    slug: "bruce-white",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Leah",
    lastName: "White",
    title: "Critic Visiting",
    slug: "leah-white",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Indira",
    lastName: "White",
    title: "Administrative Asst V",
    slug: "indira-white",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessie",
    lastName: "White",
    title: "Assistant Director, Campus Activities",
    slug: "jessie-white",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "J'Frances",
    lastName: "White",
    title: "Human Resources Asst V",
    slug: "j-frances-white",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Thais N.",
    lastName: "White",
    title: "Enrollment Counselor, Team Lead",
    slug: "thais-n-white",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Mitchell Edward",
    lastName: "White",
    title: "Conference and Event Service Manager",
    slug: "mitchell-edward-white",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelly",
    lastName: "White",
    title: "Administrative Assistant for the Cornell Fitness Centers",
    slug: "kelly-white",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Megan",
    lastName: "Whitman",
    title: "Director of Administration",
    slug: "megan-whitman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer Anne",
    lastName: "Whittaker",
    title: "Senior Industrial Hygienist",
    slug: "jennifer-anne-whittaker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bradley James",
    lastName: "Whittemore",
    title: "Assistant Director of Admissions",
    slug: "bradley-james-whittemore",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kaelee",
    lastName: "Whittemore",
    title: "Accounting Clerk",
    slug: "kaelee-whittemore",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Samuel Brant",
    lastName: "Whittenberger",
    title: "Applications Developer III",
    slug: "samuel-brant-whittenberger",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer Fibbe",
    lastName: "Wickham",
    title: "Senior Assistant Director of Financial Aid and Admissions",
    slug: "jennifer-fibbe-wickham",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Paul John",
    lastName: "Wickizer",
    title: "Biomedical Equipment Integration Specialist",
    slug: "paul-john-wickizer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mitch",
    lastName: "Wiedemann",
    title: "Web Administrator",
    slug: "mitch-wiedemann",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Beth",
    lastName: "Wiederspiel",
    title: "Assistant Director, Events Management",
    slug: "beth-wiederspiel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alec",
    lastName: "Wierzbicki",
    title: "Generalist Counselor Therapist",
    slug: "alec-wierzbicki",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shai",
    lastName: "Wiesel",
    title: "Graduate/Undergraduate Coordinator, Linguistics",
    slug: "shai-wiesel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tyr",
    lastName: "Wiesner-Hanks",
    title: "Biometrics Coordinator",
    slug: "tyr-wiesner-hanks",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anson Teague",
    lastName: "Wigner",
    title: "Creative Producer",
    slug: "anson-teague-wigner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tracy Fuller",
    lastName: "Wiiki",
    title: "Principal Gifts Associate",
    slug: "tracy-fuller-wiiki",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Catherine",
    lastName: "Wiiki",
    title: "Accounts Rep V",
    slug: "catherine-wiiki",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Wendy Sue",
    lastName: "Wilcox",
    title: "Reference and Instruction Librarian",
    slug: "wendy-sue-wilcox",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Donna L.",
    lastName: "Wilczynski",
    title: "Executive Staff Assistant",
    slug: "donna-l-wilczynski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tammy L.",
    lastName: "Wildenstein",
    title: "Subaward Officer",
    slug: "tammy-l-wildenstein",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tara",
    lastName: "Wilder",
    title: "Assistant Director of Human Resources",
    slug: "tara-wilder",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Joe",
    lastName: "Wilensky",
    title: "Senior Editor",
    slug: "joe-wilensky",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jayla Greene",
    lastName: "Wilk",
    title: "Director of E&S Academic Advising Manager of Academic Advising",
    slug: "jayla-greene-wilk",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Karen",
    lastName: "Wilkins",
    title: "CVM Director of Budget & Planning",
    slug: "karen-wilkins",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brynn Weeks",
    lastName: "Wilkins",
    title: "Assistant Director of Creative Content",
    slug: "brynn-weeks-wilkins",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Greg",
    lastName: "Wilkins",
    title: "Senior Technical Learning Consultant",
    slug: "greg-wilkins",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Monti",
    lastName: "Wilkins",
    title: "Residence Hall Director",
    slug: "monti-wilkins",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Eleanor",
    lastName: "Willard",
    title: "Executive Assistant",
    slug: "eleanor-willard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tyler",
    lastName: "Willcox",
    title: "Manager of Data Strategy & Delivery",
    slug: "tyler-willcox",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cathy",
    lastName: "Williammee",
    title: "Administrator V",
    slug: "cathy-williammee",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Philip Steven",
    lastName: "Williammee",
    title: "Sr. Application Developer",
    slug: "philip-steven-williammee",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Katie Geers",
    lastName: "Williams",
    title:
      " Development Support Officer to the Associate Vice Presidents, Colleges and Units, Alumni Affairs and Development",
    slug: "katie-geers-williams",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Charlotte Wahl",
    lastName: "Williams",
    title: "SUMMIT Director",
    slug: "charlotte-wahl-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leslie R.",
    lastName: "Williams",
    title: "Administrative Asst III",
    slug: "leslie-r-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joe",
    lastName: "Williams",
    title: "Senior Web Designer--Lead Front End Developer",
    slug: "joe-williams",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kevin",
    lastName: "Williams",
    title: "Senior Associate Dean of Students",
    slug: "kevin-williams",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Scott Richard",
    lastName: "Williams",
    title: "Financial Services Manager",
    slug: "scott-richard-williams",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Scott R.",
    lastName: "Williams",
    title: "Industrial Control System (ICS) Manager",
    slug: "scott-r-williams",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Savannah James",
    lastName: "Williams",
    title: "College Registrar",
    slug: "savannah-james-williams",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Taylor J",
    lastName: "Williams",
    title: "Ambulatory Resident",
    slug: "taylor-j-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dalia Florea",
    lastName: "Williams",
    title: "Administrative Assistant, MSLS Program",
    slug: "dalia-florea-williams",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Karen Marie",
    lastName: "Williams",
    title: "Building Coordinator",
    slug: "karen-marie-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen N.",
    lastName: "Williams",
    title: "Generalist Counselor Therapist",
    slug: "karen-n-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Josh Anthony",
    lastName: "Williams",
    title: "Classroom AV Tester I",
    slug: "josh-anthony-williams",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sue",
    lastName: "Williams",
    title: "Front Office Manager",
    slug: "sue-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Keith E.",
    lastName: "Williams",
    title: "Learning Consultant",
    slug: "keith-e-williams",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Carson",
    lastName: "Williams",
    title:
      " Instruction & Research Librarian, Science and Agriculture Libraries",
    slug: "carson-williams",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jen R.",
    lastName: "Williams",
    title: "Graduate Field Funding & Special Projects Coordinator",
    slug: "jen-r-williams",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michael Duane",
    lastName: "Williamson",
    title: "Administrator V",
    slug: "michael-duane-williamson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marilyn Elaine",
    lastName: "Willkens",
    title: "Exec. Staff Asst. to VP of HR",
    slug: "marilyn-elaine-willkens",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Adrienne Ann",
    lastName: "Wilson",
    title: "College Registrar",
    slug: "adrienne-ann-wilson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mark E.",
    lastName: "Wilson",
    title: "Web Developer",
    slug: "mark-e-wilson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "JulieAnn LaReine",
    lastName: "Wilson",
    title: "Lab Processing Coordinator",
    slug: "julieann-lareine-wilson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caitlin M.",
    lastName: "Wilson",
    title: "Sr. Product Manager",
    slug: "caitlin-m-wilson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cammy Elise",
    lastName: "Wilson",
    title: "Program Assistant - Ithaca Children's Garden (Trey Ramsey)",
    slug: "cammy-elise-wilson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James",
    lastName: "Wilson",
    title: "ACRefrig Mech/Plumb",
    slug: "james-wilson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert L.",
    lastName: "Wilson",
    title: "Emergency Light / Fire Extinguisher Inspector",
    slug: "robert-l-wilson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah Brooks",
    lastName: "Wilson",
    title: "Nutritionist",
    slug: "sarah-brooks-wilson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather",
    lastName: "Wimmer-Haman",
    title: "Behavioral Health Consultant",
    slug: "heather-wimmer-haman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Puck",
    lastName: "Winchester",
    title: "Research Administration Specialist",
    slug: "puck-winchester",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Bennett M.",
    lastName: "Wineholt",
    title: "Systems Administrator IV",
    slug: "bennett-m-wineholt",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Linda Susan",
    lastName: "Wingerter",
    title: "Evening Senior Circulation Assistant",
    slug: "linda-susan-wingerter",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ten Van",
    lastName: "Winkle",
    title: "Multimedia Support Specialist",
    slug: "ten-van-winkle",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Travis F.",
    lastName: "Winter",
    title: "Generalist Counselor Therapist",
    slug: "travis-f-winter",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mike",
    lastName: "Winters",
    title: "Director of Campus Services",
    slug: "mike-winters",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sharifa",
    lastName: "Wip",
    title: "Associate Dean of Students & Director of Black Student Empowerment",
    slug: "sharifa-wip",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Kenneth L.",
    lastName: "Wise",
    title: "Associate Director Ag IPM",
    slug: "kenneth-l-wise",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Becky",
    lastName: "Wiseman",
    title: "Family Consultant Case Supervisor",
    slug: "becky-wiseman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Saorsa Ann",
    lastName: "Wissman",
    title:
      " Program Assistant for the Office of Spirituality and Meaning-Making, Spirituality Community Group Leader",
    slug: "saorsa-ann-wissman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Brian S.",
    lastName: "Witchey",
    title: "IT Support Specialist (Level 2)",
    slug: "brian-s-witchey",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessica E.",
    lastName: "Withers",
    title: "Director of the Office of the Assemblies",
    slug: "jessica-e-withers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher",
    lastName: "Wofford",
    title: "Senior Multimedia Producer",
    slug: "christopher-wofford",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tessa Scout",
    lastName: "Wogan",
    title: "Financial Aid Counselor",
    slug: "tessa-scout-wogan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Greg",
    lastName: "Wojcieszak",
    title: "Project Manager",
    slug: "greg-wojcieszak",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patti M.",
    lastName: "Wojcik",
    title: "Chairs Assistant",
    slug: "patti-m-wojcik",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Claudia R.",
    lastName: "Wojcinski",
    title: "Bowers CIS Director of Sponsored Research Administration Center",
    slug: "claudia-r-wojcinski",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Robert",
    lastName: "Wojtowicz",
    title: "General Manager",
    slug: "robert-wojtowicz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Conrad R",
    lastName: "Wolan",
    title: "Senior Associate General Counsel",
    slug: "conrad-r-wolan",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Meraf",
    lastName: "Woldemicael",
    title: "Sr. Administrative Assistant, Break Through Tech",
    slug: "meraf-woldemicael",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah Elizabeth",
    lastName: "Wolf",
    title: "HR Generalist III",
    slug: "sarah-elizabeth-wolf",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sarah Rose",
    lastName: "Wolfe",
    title: "Data Processor",
    slug: "sarah-rose-wolfe",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Carin",
    lastName: "Wolfe",
    title: "Assistant Preparator",
    slug: "carin-wolfe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caroline Vazquez",
    lastName: "Wolkoff",
    title: "Associate Director of Staff and Labor Relations",
    slug: "caroline-vazquez-wolkoff",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Suhui",
    lastName: "Won",
    title: "Director of Institutional Advancement, Cornell Tech",
    slug: "suhui-won",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katelin",
    lastName: "Wong",
    title: "LII - Wex",
    slug: "katelin-wong",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Tiffany A",
    lastName: "Wood",
    title: "Human Resource Director for eCornell",
    slug: "tiffany-a-wood",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Connor",
    lastName: "Wood",
    title: "BirdNET Ecology Team Leader",
    slug: "connor-wood",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samantha",
    lastName: "Wood",
    title: "Bulletin 24/25",
    slug: "samantha-wood",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William J.",
    lastName: "Woodams",
    title: "Chief Preparator",
    slug: "william-j-woodams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tara L.",
    lastName: "Woodard",
    title: "Graduate Student Services Coordinator",
    slug: "tara-l-woodard",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nicole",
    lastName: "Woodard",
    title: "Senior Associate Director, Executive MBA Career Management",
    slug: "nicole-woodard",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Theresa H.",
    lastName: "Woodhouse",
    title: "Executive Staff Assistant",
    slug: "theresa-h-woodhouse",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole",
    lastName: "Woodhull",
    title: "Executive Manager,  CVM Dean's Office",
    slug: "nicole-woodhull",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lisa A.",
    lastName: "Woodin",
    title: "Financial Transaction Representative",
    slug: "lisa-a-woodin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Chelsey Rae",
    lastName: "Woodin",
    title: "Health Records Representative",
    slug: "chelsey-rae-woodin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric",
    lastName: "Woods",
    title: "Web Developer",
    slug: "eric-woods",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Harlan",
    lastName: "Work",
    title: "Major Gifts Officer, ILR AAD",
    slug: "harlan-work",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily",
    lastName: "Workman",
    title: "Policy Director, Cornell Health Policy Center",
    slug: "emily-workman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Barbara M.",
    lastName: "Workman",
    title: "Financial Transaction Representative",
    slug: "barbara-m-workman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessica",
    lastName: "Worley",
    title: "ROTC Support Staff",
    slug: "jessica-worley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erin L.",
    lastName: "Worsell",
    title: "HR and Employee Relations Partner",
    slug: "erin-l-worsell",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Chloe L.",
    lastName: "Wray",
    title: "Administrative & Events Coordinator",
    slug: "chloe-l-wray",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer R.",
    lastName: "Wright",
    title: "College Registrar",
    slug: "jennifer-r-wright",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Chrissy J.",
    lastName: "Wright",
    title: "Accounts Rep IV",
    slug: "chrissy-j-wright",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Julie C.",
    lastName: "Wright",
    title: "Dean’s Office Coordinator",
    slug: "julie-c-wright",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah J.",
    lastName: "Wright",
    title: "Research Data and Life Sciences Librarian",
    slug: "sarah-j-wright",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Martin",
    lastName: "Wright",
    title: "Systems Administrator",
    slug: "martin-wright",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jackie",
    lastName: "Wright",
    title: "Administrative Asst IV",
    slug: "jackie-wright",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caleb E.",
    lastName: "Wright",
    title: "Coordinator, Physical Education",
    slug: "caleb-e-wright",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jocelyn Marie",
    lastName: "Wrisley",
    title: "Grant and Contract/Office Coordinator",
    slug: "jocelyn-marie-wrisley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joyce Leyi",
    lastName: "Wu",
    title: "ILR Course Assistant IV (Fitchette)",
    slug: "joyce-leyi-wu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Aurora",
    lastName: "Wulff",
    title: "Administrative Assistant to the Dean",
    slug: "aurora-wulff",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Patricia Ann",
    lastName: "Wynn",
    title: "Assistant Vice President for Student and Campus Life",
    slug: "patricia-ann-wynn",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jesse",
    lastName: "Wysong",
    title: "Desktop Support Technical Lead",
    slug: "jesse-wysong",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Denise F.",
    lastName: "Wyszkowski",
    title: "Office Coordinator for Residential Life",
    slug: "denise-f-wyszkowski",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Weiming",
    lastName: "Xie",
    title: "Program Manager, East Asia Program",
    slug: "weiming-xie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda Jiayue",
    lastName: "Xie",
    title: "LII 2025",
    slug: "amanda-jiayue-xie",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Xu",
    lastName: "Xin",
    title: "Dir Acad Interim, Mgr Program",
    slug: "xu-xin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jason",
    lastName: "Xiong",
    title: "Engaged Ambassador Student Manager, Student Admin Asst I",
    slug: "jason-xiong",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lin",
    lastName: "Xue",
    title: "Manager of Enterprise Systems and Architecture",
    slug: "lin-xue",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jeffrey",
    lastName: "Xue",
    title:
      " Administrative Assistant - Center for Transformative Action - NAFSN (Kim Hines)",
    slug: "jeffrey-xue",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Neta",
    lastName: "Yaari",
    title: "Associate Product Manager",
    slug: "neta-yaari",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lisa",
    lastName: "Yager",
    title: "Executive Staff Assistant",
    slug: "lisa-yager",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicki",
    lastName: "Yager",
    title: "Financial Services Associate",
    slug: "nicki-yager",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tanya A.",
    lastName: "Yanchuk",
    title: "Office Assistant",
    slug: "tanya-a-yanchuk",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Xiaolong",
    lastName: "Yang",
    title: "Director of MPS",
    slug: "xiaolong-yang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Micky",
    lastName: "Yang",
    title: "ILR Course Assistant IV (Homrighouse)",
    slug: "micky-yang",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Pa Nhia",
    lastName: "Yang",
    title:
      " Assistant Director for Student Empowerment, First- Generation & Low-Income Student Support",
    slug: "pa-nhia-yang",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Eric",
    lastName: "Yang",
    title: "Bulletin Fall 2024",
    slug: "eric-yang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Quinn",
    lastName: "Yang",
    title: "CALS - LA 2010 Course Asst (Gloria Kwan-Wai Lau)Lau)",
    slug: "quinn-yang",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amy",
    lastName: "Yanosh",
    title: "Exec Staff Asst to the Dean, AAP",
    slug: "amy-yanosh",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David A.",
    lastName: "Yantorno",
    title:
      " Assistant Dean of Communications and Marketing – School of Industrial and Labor Relations",
    slug: "david-a-yantorno",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Karim",
    lastName: "Yaport",
    title: "Assistant Director of Admissions",
    slug: "karim-yaport",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Shawn C",
    lastName: "Yarnes",
    title: "Breeding Insight Product Owner",
    slug: "shawn-c-yarnes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Geoffrey A.",
    lastName: "Yearwood",
    title: "Manager, IT Audit",
    slug: "geoffrey-a-yearwood",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lisa",
    lastName: "Yeier",
    title: "Finance Specialist III",
    slug: "lisa-yeier",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kim",
    lastName: "Yeoh",
    title: "Director of Finance and Administration",
    slug: "kim-yeoh",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Breana N.",
    lastName: "Yessman",
    title: "Administrative Specialist",
    slug: "breana-n-yessman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Raymond Y.",
    lastName: "Yeung",
    title: "Systems Administrator III",
    slug: "raymond-y-yeung",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jenna",
    lastName: "Yi",
    title: "Client Service Representative",
    slug: "jenna-yi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jiefu",
    lastName: "Yin",
    title: "Radiation Safety Officer (RSO)",
    slug: "jiefu-yin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scott K.",
    lastName: "Yoest",
    title: "Senior Director, ITSG",
    slug: "scott-k-yoest",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Judy",
    lastName: "Yonkin",
    title: "Undergraduate Coordinator",
    slug: "judy-yonkin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rosie",
    lastName: "You",
    title: "IDP Facilitator",
    slug: "rosie-you",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Catharine",
    lastName: "Young",
    title: "Senior Project Manager",
    slug: "catharine-young",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "T. Joshua",
    lastName: "Young",
    title: "Administrator V",
    slug: "t-joshua-young",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patricia T.",
    lastName: "Young",
    title:
      " Senior Program Manager, Institute for European Studies and Peace and Conflict Studies",
    slug: "patricia-t-young",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ryan",
    lastName: "Young",
    title: "Multimedia Specialist II",
    slug: "ryan-young",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brian Andrew",
    lastName: "Young",
    title: "Academic Materials Manager",
    slug: "brian-andrew-young",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Colin J.",
    lastName: "Young",
    title: "Sheet Metal Worker - FP",
    slug: "colin-j-young",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elias L.",
    lastName: "Young",
    title: "Senior Web Application Developer",
    slug: "elias-l-young",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Victor B.",
    lastName: "Younger",
    title:
      " Director of Diversity & Inclusion, The Nolan School of Hotel Administration",
    slug: "victor-b-younger",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Caleb",
    lastName: "Yu",
    title: "Human Resources Generalist",
    slug: "caleb-yu",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Yoshi",
    lastName: "Yuan",
    title: "Inside Director, Federal Programs",
    slug: "yoshi-yuan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "El",
    lastName: "Zager",
    title: "New Media Specialist",
    slug: "el-zager",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Dee",
    lastName: "Zajac",
    title: "SCL Compliance Administrator",
    slug: "dee-zajac",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Maria",
    lastName: "Zambos",
    title:
      " Assistant Director for Student Disability Services - Disability Access Consultant",
    slug: "maria-zambos",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Catherine",
    lastName: "Zandonella",
    title: "Executive Director, Research & Innovation Communications",
    slug: "catherine-zandonella",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Andrea Nicole",
    lastName: "Zarazua",
    title: "BSP Study Group Leader, Student Athletic Serv Asst I",
    slug: "andrea-nicole-zarazua",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nazanin",
    lastName: "Zarepour",
    title: "Riccio - AAP Print Media Studio Monitor",
    slug: "nazanin-zarepour",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jennifer",
    lastName: "Zawislak",
    title: "Central Support Specialist",
    slug: "jennifer-zawislak",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Allison L",
    lastName: "Zdunczyk",
    title: "NYC Manager of Infrastructure Services",
    slug: "allison-l-zdunczyk",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lauren",
    lastName: "Zehner",
    title: "Assistant Director, Student and Academic Affairs",
    slug: "lauren-zehner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lisa R.",
    lastName: "Zehr",
    title: "Senior Associate Athletics Director for Finance & Administration",
    slug: "lisa-r-zehr",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mrs Marcia Harding",
    lastName: "Zeller",
    title: "Senior Associate Director",
    slug: "mrs-marcia-harding-zeller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jenny",
    lastName: "Zeng",
    title: "Director, Market and Channels Development",
    slug: "jenny-zeng",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sophie",
    lastName: "Zeng",
    title: "AAP - Art Sculpture Monitor",
    slug: "sophie-zeng",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Domenick F.",
    lastName: "Zerilli",
    title: "Technical Lead",
    slug: "domenick-f-zerilli",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Yuchun",
    lastName: "Zhang",
    title: "Laser Monitor",
    slug: "yuchun-zhang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine Angel",
    lastName: "Zhang",
    title: "Wagner-Student Admin Asst II",
    slug: "christine-angel-zhang",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sheng",
    lastName: "Zhang",
    title: "Director, BRC Proteomics and Metabolomics Facility",
    slug: "sheng-zhang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric",
    lastName: "Zhang",
    title: "ACC Tutor - IYB (Johara Malcolm)",
    slug: "eric-zhang",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lyanna (Xiangyu)",
    lastName: "Zhang",
    title: "Administrative Coordinator, CLASSE & CBB",
    slug: "lyanna-xiangyu-zhang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Irina",
    lastName: "Zhankov",
    title: "IT Manager, Design & User Experience",
    slug: "irina-zhankov",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jinhua",
    lastName: "Zhao",
    title:
      " David J. Nolan Dean of the Charles H. Dyson School of Applied Economics and Management",
    slug: "jinhua-zhao",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jingbi",
    lastName: "Zhao",
    title: "Senior Auditor",
    slug: "jingbi-zhao",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Liren",
    lastName: "Zheng",
    title: "Curator, Wason E Asia Collection",
    slug: "liren-zheng",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jenny",
    lastName: "Zheng",
    title: "Career Services Asst.",
    slug: "jenny-zheng",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Alex",
    lastName: "ZhengFerrari",
    title: "Executive Staff Assistant",
    slug: "alex-zhengferrari",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zhixia",
    lastName: "Zhong",
    title: "Technology Licensing Professional II",
    slug: "zhixia-zhong",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hester",
    lastName: "Zhou",
    title: "ILR Course Assistant IV (Fitchette)",
    slug: "hester-zhou",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Pei",
    lastName: "Zhou",
    title: "Post Doctoral Associate",
    slug: "pei-zhou",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tina",
    lastName: "Zhu",
    title: "Manager, Cost and Capital Assets",
    slug: "tina-zhu",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lulu",
    lastName: "Zhu",
    title: "HPC Cluster and Cloud Specialist",
    slug: "lulu-zhu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kevin",
    lastName: "Zhu",
    title: "ACC Tutor - BJM (Stacy Nembhard)",
    slug: "kevin-zhu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shaylana Marie",
    lastName: "Ziegner",
    title: "Enrollment Manager",
    slug: "shaylana-marie-ziegner",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Joseph M",
    lastName: "Zielinski",
    title: "Associate Director of Student Services",
    slug: "joseph-m-zielinski",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mindy L.",
    lastName: "Ziembiec",
    title: "IT Project Manager",
    slug: "mindy-l-ziembiec",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Micky",
    lastName: "Zifchock",
    title: "Coord Program I",
    slug: "micky-zifchock",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah",
    lastName: "Zillmer",
    title: "Director, Enterprise Programs",
    slug: "sarah-zillmer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alexandra",
    lastName: "Zimmerman",
    title: "Flex Work Senior Consultant",
    slug: "alexandra-zimmerman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mina Wagih",
    lastName: "Zion",
    title: "Associate Director, Innovation and Commercialization",
    slug: "mina-wagih-zion",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily A.",
    lastName: "Zipprich",
    title: "Senior Financial Aid Counselor",
    slug: "emily-a-zipprich",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Alexia",
    lastName: "Zobel",
    title: "Department Manager - Microbiology & Immunology",
    slug: "alexia-zobel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Janet Elizabeth Van",
    lastName: "Zoeren",
    title: "Area Fruit Specialist",
    slug: "janet-elizabeth-van-zoeren",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scott Michael",
    lastName: "Zuchorski",
    title: "Executive in Residence",
    slug: "scott-michael-zuchorski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yael",
    lastName: "Zucker",
    title: "Cataloging and Ordering Associate, Hebrew",
    slug: "yael-zucker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jobe",
    lastName: "Zulu",
    title: "Assistant Director, Campus Activities",
    slug: "jobe-zulu",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Chloe",
    lastName: "Zureiqat",
    title: "Instructional Technology Specialist IV",
    slug: "chloe-zureiqat",
    dei: false,
    category: "Technology",
  },
];
export default people;
